export const ru = {
    addDatabase: {
        addDatabase: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        addFromFile: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¸Ð· ÑÐ°Ð¹Ð»Ð°",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "ÐÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        onePackage: "ÐÐ´Ð½Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        priceType: "Ð¢Ð¸Ð¿ ÑÐµÐ½Ñ",
        setPriceVatVisibility: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑÑ ÐÐÐ¡",
        setVisibilityAndOrder: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑÑ Ð¸ Ð¿Ð¾ÑÑÐ´Ð¾Ðº ÑÐµÐ½",
        withAndWithoutVat: "ÐÐ°Ðº Ñ ÐÐÐ¡, ÑÐ°Ðº Ð¸ Ð±ÐµÐ· ÐÐÐ¡",
        withVat: "Ð¢Ð¾Ð»ÑÐºÐ¾ Ñ ÐÐÐ¡",
        withoutVat: "Ð¢Ð¾Ð»ÑÐºÐ¾ Ð±ÐµÐ· ÐÐÐ¡"
    },
    barvis: {
        base: "ÐÐ°Ð·Ð¾Ð²Ð¾Ðµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ",
        bigCanSize: "ÐÐ¾Ð»ÑÑÐ°Ñ ÑÐ°ÑÐ°",
        coating: "ÐÐ¾ÐºÑÑÑÐ¸Ðµ",
        identifier: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ",
        laboratory: "ÐÐ°Ð±Ð¾ÑÐ°ÑÐ¾ÑÐ¸Ñ",
        orderOverview: "ÐÑÐ¾ÑÐ¼Ð¾ÑÑ Ð·Ð°ÐºÐ°Ð·Ð°",
        rank: "Ð Ð°Ð½Ð³",
        smallCanSize: "ÐÐ°Ð»ÐµÐ½ÑÐºÐ°Ñ ÑÐ°ÑÐ°"
    },
    basicSetup: {
        alreadyLoggedIn: "ÐÑ ÑÐ¶Ðµ Ð·Ð°ÑÐµÐ³Ð¸ÑÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ ÐºÐ°Ðº  %{login}",
        askSupplier: "ÐÐ¾Ð¿ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð¸ÑÑ Ð²Ð°Ð¼ Ð±Ð¾Ð»ÑÑÐµ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¹",
        asterisk: "ÐÐ¾Ð·Ð¸ÑÐ¸Ð¸, Ð¾ÑÐ¼ÐµÑÐµÐ½Ð½ÑÐµ Ð·Ð²ÐµÐ·Ð´Ð¾ÑÐºÐ¾Ð¹, Ð´Ð¾Ð»Ð¶Ð½Ñ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ",
        identificationKeys: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ ÐºÐ»ÑÑ",
        importCustomData:
            "ÐÑÐ¸ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÐ¸ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÑÐ¹ÑÐµ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ðµ Ð´Ð°Ð½Ð½ÑÐµ Ð¸Ð· Ð¿ÑÐµÐ´ÑÐ´ÑÑÐµÐ³Ð¾ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        learnIdentification: "ÐÐ·Ð½Ð°ÐºÐ¾Ð¼ÑÑÐµÑÑ Ñ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐ¼Ð¸ ÐºÐ»ÑÑÐ°Ð¼Ð¸ Ñ Ð²Ð°ÑÐµÐ³Ð¾ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ",
        login: "Ð¡Ð»ÐµÐ´ÑÑÑÐ¸Ðµ ÑÐ°Ð³Ð¸ Ð½Ð°ÑÐ°Ð»ÑÐ½Ð¾Ð¹ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ ÑÑÐµÐ±ÑÑÑ Ð¿ÑÐ°Ð² Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÐ°",
        noDatabase: "ÐÐ°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ ÐµÑÐµ Ð½Ðµ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð°, Ð¿Ð¾ ÐºÑÐ°Ð¹Ð½ÐµÐ¹ Ð¼ÐµÑÐµ, Ð¾Ð´Ð½Ð° Ð¸Ð· Ð½Ð¸Ñ Ð´Ð¾Ð»Ð¶Ð½Ð° Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð°",
        offlineLicensing: "ÐÑÑÐ»Ð°Ð¹Ð½ Ð»Ð¸ÑÐµÐ½Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        productSelection: "ÐÑÐ±Ð¾Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        registrationForm: "Ð¤Ð¾ÑÐ¼Ð° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸",
        seeQuestionMark: "Ð¡Ð¼. Ð¼Ð°Ð»ÐµÐ½ÑÐºÐ¸Ðµ Ð²Ð¾Ð¿ÑÐ¾ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐµ Ð·Ð½Ð°ÐºÐ¸, ÑÑÐ¾Ð±Ñ ÑÐ·Ð½Ð°ÑÑ Ð±Ð¾Ð»ÑÑÐµ Ð¾Ð± ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐµ",
        selectDefaultPrinter: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¿ÑÐ¸Ð½ÑÐµÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð¸ ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÑ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ  ",
        selectDefaultTemplate:
            "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ°Ð±Ð»Ð¾Ð½Ñ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð¸Ð· ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÑÑÐ¸Ñ, ÑÐ¾Ð·Ð´Ð°Ð¹ÑÐµ Ð½Ð¾Ð²ÑÐ¹ ÑÐ°Ð±Ð»Ð¾Ð½ Ð¸Ð»Ð¸ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÐµ ÑÐ²Ð¾Ð¹ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐ¹",
        selectDispenser: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¸Ð¿ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°, ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÐÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÐµ",
        selectLanguage: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ²Ð¾Ð¹ ÑÐ·ÑÐº",
        selectProducts: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¾Ð´Ð¸Ð½ Ð¸Ð· Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð²Ñ ÑÐ¾ÑÐ¸ÑÐµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        selectSpectroType: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¸Ð¿ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÐ¼Ð¾Ð³Ð¾ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÐ°",
        setAdditionalPrinterOptions: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸ Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
        setAutomaticUpdates: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ",
        setCustomItems:
            "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ðµ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ Ð¸ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑÑ Ð´Ð°Ð½Ð½ÑÑ. ÐÑÐ¾ÐºÑÑÑÐ¸ÑÐµ Ð²Ð½Ð¸Ð·, ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸",
        setEnvironment:
            "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð²ÑÐµ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÑ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ. ÐÑÐ¾ÐºÑÑÑÐ¸ÑÐµ Ð²Ð½Ð¸Ð·, ÑÑÐ¾Ð±Ñ ÑÐ²Ð¸Ð´ÐµÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸",
        setFormulaRepresentation:
            "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ. ÐÑÐ¾ÐºÑÑÑÐ¸ÑÐµ Ð²Ð½Ð¸Ð·, ÑÑÐ¾Ð±Ñ ÑÐ²Ð¸Ð´ÐµÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ",
        summary:
            "ÐÑ Ð¼Ð¾Ð¶ÐµÑÐµ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ ÑÑÐ¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð² Ð»ÑÐ±Ð¾Ðµ Ð²ÑÐµÐ¼Ñ Ð¸ Ð½Ð°Ð¹ÑÐ¸ ÐµÑÐµ Ð±Ð¾Ð»ÑÑÐµ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ¾Ð² ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸. ÐÐ°ÑÐ»Ð°Ð¶Ð´Ð°Ð¹ÑÐµÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸ÐµÐ¼ %{name}!",
        summarySuccess: "ÐÑÐµ Ð³Ð¾ÑÐ¾Ð²Ð¾!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "ÐÐ¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸: %{batchNumber}",
        colorantIsDefective: "ÐÐ°Ð½Ð¸ÑÑÑÐ° Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð° Ð´ÐµÑÐµÐºÑÐ½Ð¾Ð¹ Ð¿Ð°ÑÑÐ¸ÐµÐ¹ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð². ÐÐµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐ¹ÑÐµ ÑÑÑ Ð¿Ð°ÑÑÐ¸Ñ.",
        defectiveInfoLine1: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð½Ðµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐ¹ÑÐµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        defectiveInfoLine2: "c ÑÑÐ¸Ð¼ Ð½Ð¾Ð¼ÐµÑÐ¾Ð¼ Ð¿Ð°ÑÑÐ¸Ð¸.",
        emptyQuickTint: "ÐÐ¿ÑÑÑÐ¾ÑÐ¸ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÑ Ð±ÑÑÑÑÑÑ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÑ.",
        warningInfoLine1: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        warningInfoLine2: "Ñ ÑÑÐ¸Ð¼ Ð½Ð¾Ð¼ÐµÑÐ¾Ð¼ Ð¿Ð°ÑÑÐ¸Ð¸ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¸ÑÐ¿Ð¾ÑÑÐµÐ½."
    },
    canisterLevel: {
        canisterLevel: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÑÐ¾Ð²ÐµÐ½Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
        criticalLevelCanister: "ÐÑÐ¸ÑÐ¸ÑÐµÑÐºÐ¸Ðµ ÑÑÐ¾Ð²Ð½Ð¸ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
        fillToMax: "ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð´Ð¾ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¼ÐµÑÐºÐ¸",
        maxDispenseLevel: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð°Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²ÐºÐ°",
        otherCanisters: "ÐÑÑÐ³Ð¸Ðµ ÑÑÐ¾Ð²Ð½Ð¸ ÐºÐ°Ð½Ð¸ÑÑÑ",
        warningLevelCanister: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð¾Ð± ÑÑÐ¾Ð²Ð½Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "ÐÐ¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ Ð½Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÐµÐ¹",
        ufiCodeStatus: "UFI code ÑÑÐ°ÑÑÑ"
    },
    canistersTab: {
        availableServiceActions: "ÐÐ¾ÑÑÑÐ¿Ð½ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ",
        canisterInformation: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÐºÐ°Ð½Ð¸ÑÑÑÐµ",
        canisterPreview: "ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        currentLevel: "Ð¢ÐµÐºÑÑÐ¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ",
        errors: "ÐÑÐ¸Ð±ÐºÐ¸",
        fillState: "Ð£ÑÐ¾Ð²ÐµÐ½Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
        fillToMax: "ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð´Ð¾ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¼ÐµÑÐºÐ¸",
        fillingAmount: "ÐÐ±ÑÐµÐ¼ Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
        finalLevel: "Ð¤Ð¸Ð½Ð°Ð»ÑÐ½ÑÐ¹ ÑÑÐ¾Ð²ÐµÐ½Ñ",
        minimumAmount: "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ Ð¾Ð±ÑÐµÐ¼",
        minimumLevel: "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ ÑÑÐ¾Ð²ÐµÐ½Ñ",
        moveTableToRefill: "ÐÐ²Ð¸Ð³Ð°ÑÑ ÑÑÐ¾Ð» Ð´Ð»Ñ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
        refillNoAmount: "ÐÐ±ÑÐµÐ¼ Ð½Ðµ ÑÐºÐ°Ð·Ð°Ð½",
        refillOverLimit: "Ð£ÐºÐ°Ð·Ð°Ð½Ð½ÑÐ¹ Ð¾Ð±ÑÐµÐ¼ Ð¿ÑÐµÐ²ÑÑÐ°ÐµÑ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½ÑÑ Ð²Ð¼ÐµÑÑÐ¸Ð¼Ð¾ÑÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        refillSummary: "%{amount} %{unit} ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° %{colorant} Ð±ÑÐ´ÐµÑ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½ Ð² ÐºÐ°Ð½Ð¸ÑÑÑÑ %{canisterId}",
        systemWarningAmount: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÑÑÐ¸Ðµ ÑÑÐ¾Ð²Ð½Ð¸ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
        warningAmount: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÑÑÐ¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ"
    },
    changeDatabase: {
        changeDatabase: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        databaseWarning: "ÐÐ°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ %{databaseName} Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð° Ð¸Ð·-Ð·Ð°"
    },
    changelog: {
        allVersion: "ÐÑÐµ Ð²ÐµÑÑÐ¸Ð¸",
        changelog: "ÐÑÑÐ½Ð°Ð» Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹",
        link: "Ð¡ÑÑÐ»ÐºÐ°",
        links: "Ð¡ÑÑÐ»ÐºÐ¸",
        version: "ÐÐµÑÑÐ¸Ñ",
        versionFilter: "Ð¤Ð¸Ð»ÑÑÑ Ð²ÐµÑÑÐ¸Ð¹"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "ÐÑÐ¸ÑÑÐ¸ÑÑ Ð²ÑÐµ ÑÐ¾Ð¿Ð»Ð°",
        cleanChannels: "ÐÑÐ¸ÑÑÐ¸ÑÑ ÑÐ¾Ð¿Ð»Ð°",
        cleaningTime: "ÐÑÐµÐ¼Ñ Ð¾ÑÐ¸ÑÑÐºÐ¸",
        selectChannels: "ÐÑÐ±ÑÐ°ÑÑ ÑÐ¾Ð¿Ð»Ð°",
        startCleaning: "ÐÐ°ÑÐ°ÑÑ Ð¾ÑÐ¸ÑÑÐºÑ"
    },
    clientServerSettings: {
        activeServer: "ÐÐºÑÐ¸Ð²Ð½ÑÐ¹ ÑÐµÑÐ²ÐµÑ",
        addNewServer: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²ÑÐ¹ ÑÐµÑÐ²ÐµÑ",
        availableServers: "ÐÑÑÐ³Ð¸Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÐµ ÑÐµÑÐ²ÐµÑÑ",
        clientIdentifier: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        clientServerSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ/ÑÐµÑÐ²ÐµÑÐ°",
        disabledStatus: "Ð¾ÑÐºÐ»ÑÑÐµÐ½Ð¾",
        editServer: "ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÑ ÑÐµÑÐ²ÐµÑ",
        fillRequiredFields: "Ð¢ÑÐµÐ±ÑÐµÐ¼ÑÐµ Ð¿Ð¾Ð»Ñ Ð´Ð¾Ð»Ð¶Ð½Ñ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ",
        noOtherServers: "ÐÐ¾Ð»ÑÑÐµ Ð½ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ ÑÐµÑÐ²ÐµÑÐ¾Ð²",
        offlineStatus: "Ð¾ÑÐ»Ð°Ð¹Ð½",
        onlineStatus: "Ð¾Ð½Ð»Ð°Ð¹Ð½",
        port: "ÐÐ¾ÑÑ",
        serverName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐµÑÐ²ÐµÑÐ°",
        serverNameMissing: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐµÑÐ²ÐµÑÐ° Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¾",
        stabileConnection: "ÐÐ»Ñ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ ÑÑÐ°Ð±Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐ¹ÑÐµ ÑÑÐ°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ IP-Ð°Ð´ÑÐµÑ",
        wrongFormatIp: "ÐÐµÐ²ÐµÑÐ½ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ IP-Ð°Ð´ÑÐµÑÐ°"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Ð¦Ð²ÐµÑÐ¾Ð²Ð¾Ð¹ Ð¾ÑÑÐµÐ½Ð¾Ðº",
        fandeckPosition: "Ð Ð°ÑÐ¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð°",
        moreInfoIcons: "ÐÐºÐ¾Ð½ÐºÐ¸ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸",
        notExistingFormula: "ÐÐµÑÑÑÐµÑÑÐ²ÑÑÑÐ°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        orderBy: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾",
        selectYourGrid: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ²Ð¾Ñ ÑÐµÑÐºÑ",
        showInPanel: "ÐÑÐ¾Ð±ÑÐ°Ð·Ð¸ÑÑ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸",
        warningIcon: "ÐÐ½Ð°ÑÐ¾Ðº Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ñ Ð½ÐµÑÑÑÐµÑÑÐ²ÑÑÑÐµÐ¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ Ð² Ð¿ÑÐ¾ÑÐµÐ½ÑÐ°Ñ",
        batchNumberFromLastFilling: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ Ñ Ð¿ÑÐ¾ÑÐ»Ð¾Ð³Ð¾ Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
        defectiveBatchOfColorant: "ÐÑÐ¿Ð¾ÑÑÐµÐ½Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸",
        enableBatchNumber: "ÐÐºÐ»ÑÑÐ¸ÑÑ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ Ð´Ð»Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        possibleDamagedBatchOfColorant: "ÐÐ¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿Ð¾Ð²ÑÐµÐ¶Ð´ÑÐ½Ð½Ð°Ñ Ð¿Ð°ÑÑÐ¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        scanOrTypeBatchNumber: "ÐÑÑÐºÐ°Ð½Ð¸ÑÑÐ¹ÑÐµ Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸"
    },
    colorantPanel: {
        manualMachine: "Ð°Ð¿Ð¿Ð°ÑÐ°Ñ"
    },
    colorantsTable: {
        numberOfColorants: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²:",
        preview: "ÐÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ",
        prices: "Ð¦ÐµÐ½Ð°"
    },
    currencySettings: {
        addNewCurrency: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²ÑÑ Ð²Ð°Ð»ÑÑÑ",
        codePlaceholder: "ÐÐ¾Ð´",
        currencySettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð²Ð°Ð»ÑÑÑ",
        namePlaceholder: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ",
        ratePlaceholder: "ÐÑÑÑ",
        setDecimalPlaces: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð·Ð½Ð°ÐºÐ¾Ð² Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð¿ÑÑÐ¾Ð¹",
        setMainCurrency: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¾ÑÐ½Ð¾Ð²Ð½ÑÑ Ð²Ð°Ð»ÑÑÑ",
        setRounding: "ÐÐºÑÑÐ³Ð»ÐµÐ½Ð¸Ðµ",
        symbolPlaceholder: "Ð¡Ð¸Ð¼Ð²Ð¾Ð»"
    },
    customFandecks: {
        customFandecks: "Ð¡Ð¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐµ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð¸",
        deleteButtonWarning: "ÐÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð¸Ð· ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸ Ð±ÑÐ´ÑÑ ÑÐ°ÐºÐ¶Ðµ ÑÐ´Ð°Ð»ÐµÐ½Ñ",
        deleteCustomFandeck:
            "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÑÑ ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ? ÐÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð¸Ð· ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸ ÑÐ°ÐºÐ¶Ðµ Ð±ÑÐ´ÑÑ ÑÐ´Ð°Ð»ÐµÐ½Ñ ",
        disableStandardFandecks: "ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ðµ fandecks",
        enableStandardFandecks: "ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÑÑÐ°Ð½Ð´Ð°ÑÑÐ½ÑÐµ fandecks",
        fandeckName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸"
    },
    customRedlike: {
        addColorantFromBrand: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ Ð±ÑÐµÐ½Ð´Ð° %{brandName}",
        addNewCustomer: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²Ð¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        addNewNote: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ ",
        addedDate: "ÐÐ½ÐµÑÐµÐ½Ð½Ð°Ñ Ð´Ð°ÑÐ°",
        addedQuantity: "ÐÐ½ÐµÑÐµÐ½Ð½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        availableMachine: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½",
        brand: "ÐÑÐµÐ½Ð´",
        brandPlease: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð±ÑÐµÐ½Ð´",
        cancelCustomer: "Ð£Ð´Ð°Ð»Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        colorPlease: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ²ÐµÑ",
        confirmCustomerData: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        confirmNoteData: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ",
        confirmSelectedUser: "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° %{customerName} Ð´Ð»Ñ ÑÑÐ¾Ð³Ð¾ Ð·Ð°ÐºÐ°Ð·Ð°.",
        confirmed: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°Ñ",
        controlData: "ÐÐºÐ¾Ð½ÑÐ°ÑÐµÐ»ÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð´Ð°Ð½Ð½ÑÑ",
        customerCellNumber: "ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÐ¹ ÑÐµÐ»ÐµÑÐ¾Ð½ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerFilter: "Ð¤Ð¸Ð»ÑÑÑ Ð¿Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°Ð¼",
        customerName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerPhone: "Ð¢ÐµÐ»ÐµÑÐ¾Ð½ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerPlease: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        dateFilter: "Ð¤Ð¸Ð»ÑÑÑ Ð¿Ð¾ Ð´Ð°ÑÐµ",
        enterPin: "ÐÐ²ÐµÐ´Ð¸ÑÐµ ÑÐ²Ð¾Ð¹ Ð¿Ð¸Ð½-ÐºÐ¾Ð´",
        enterTheNumberOfPackages: "Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº",
        existingCustomer: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ",
        fandeckPlease: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ°ÑÐ°Ð»Ð¾Ð³",
        fillCanisterHistory: "ÐÐ½ÐµÑÐ¸ÑÐµ Ð¸ÑÑÐ¾ÑÐ¸Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        findCustomer:
            "ÐÑÑÐºÐ°Ð½Ð¸ÑÑÐ¹ÑÐµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´ Ð¸Ð»Ð¸ Ð½Ð°Ð¹Ð´Ð¸ÑÐµ Ð°Ð´ÑÐµÑ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÑ, ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¸ÑÐ²Ð¾Ð¸ÑÑ ÐºÐ°ÑÑÑ Ð»Ð¾ÑÐ»ÑÐ½Ð¾ÑÑÐ¸ ÑÑÐ¾Ð¼Ñ Ð·Ð°ÐºÐ°Ð·Ñ",
        findCustomerByEmail: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð² Ð¿Ð¾ Ð°Ð´ÑÐµÑÑ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÑ Ð¸Ð»Ð¸ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ",
        finishPreviousStep: "(ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð·Ð°Ð²ÐµÑÑÐ¸ÑÐµ Ð¿ÑÐµÐ´ÑÐ´ÑÑÐµÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ)",
        formulaUnit: "ÐÐ´Ð¸Ð½Ð¸ÑÐ° Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ Ð² ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
        getBackToList: "ÐÐµÑÐ½ÑÑÑÑÑ Ðº ÑÐ¿Ð¸ÑÐºÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð²",
        historyOfOrders: "ÐÑÑÐ¾ÑÐ¸Ñ Ð·Ð°ÐºÐ°Ð·Ð¾Ð²",
        insertNote: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ Ð·Ð°Ð¿Ð¸ÑÐ¸",
        loadHistoryOrder: "ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ Ð·Ð°ÐºÐ°Ð·?",
        loyaltyCards: "ÐÐ°ÑÑÑ Ð»Ð¾ÑÐ»ÑÐ½Ð¾ÑÑÐ¸",
        machineIsAvailable: "ÐÐÐÐÐ¢ÐÐ  ÐÐÐ¡Ð¢Ð£ÐÐÐ",
        machineIsUnavailable: "ÐÐÐÐÐ¢ÐÐ  ÐÐÐÐÐ¡Ð¢Ð£ÐÐÐ",
        newLoyaltyCard: "ÐÐ¾Ð²Ð°Ñ ÐºÐ°ÑÑÐ° Ð»Ð¾ÑÐ»ÑÐ½Ð¾ÑÑÐ¸",
        noAvailableMachine: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½",
        noCustomerSelected: "ÐÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð½, Ð²Ñ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ?",
        notePlease: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð´Ð¾Ð±Ð°Ð²ÑÑÐµ Ð¿ÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ðµ",
        openHistory: "ÐÑÐºÑÑÑÑ Ð¸ÑÑÐ¾ÑÐ¸Ñ",
        orAdd: "Ð¸Ð»Ð¸ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        orSelect: "Ð¸Ð»Ð¸ Ð²ÑÐ±ÑÐ°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        orderModification: "ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð·Ð°ÐºÐ°Ð· Ð±ÑÐ´ÐµÑ Ð¸Ð·Ð¼ÐµÐ½ÑÐ½. ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ?",
        orderOverview: "ÐÑÐ¾ÑÐ¼Ð¾ÑÑ Ð·Ð°ÐºÐ°Ð·Ð°",
        orderToMachine: "ÐÐ¢ÐÐ ÐÐÐÐ¢Ð¬ ÐÐÐ ÐÐÐÐÐ ÐÐ ÐÐÐÐÐ¢ÐÐ ",
        ordersHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð·Ð°ÐºÐ°Ð·Ð¾Ð²",
        packagePlease: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        pleaseSelectBrand: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð±ÑÐµÐ½Ð´",
        previewImage: "ÐÑÐ¾ÑÐ¼Ð¾ÑÑ ÐºÐ°ÑÑÐ¸Ð½ÐºÐ¸",
        previewPackage: "ÐÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        productPlease: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑ",
        resetFilters: "Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ Ð²ÑÐµ ÑÐ¸Ð»ÑÑÑÑ",
        searchForHistoricalOrders: "ÐÐ»Ð¸ Ð¸ÑÐºÐ°ÑÑ Ð·Ð°ÐºÐ°Ð·Ñ Ð² Ð¸ÑÑÐ¾ÑÐ¸Ð¸",
        selectBrand: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð±ÑÐµÐ½Ð´",
        selectColor: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð²ÑÐ±Ð¾ÑÑ ÑÐ²ÐµÑÐ°",
        selectCustomer: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð²ÑÐ±Ð¾ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        selectExistingCustomer: "ÐÑÐ±ÑÐ°ÑÑ ÑÑÑÐµÑÑÐ²ÑÑÑÐµÐ³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        selectFandeck: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð²ÑÐ±Ð¾ÑÑ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð°",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð²ÑÐ±Ð¾ÑÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        selectProduct: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð²ÑÐ±Ð¾ÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        shotsCoefficient: "ÐÐ¾ÑÑÑÐ¸ÑÐ¸ÐµÐ½Ñ ÑÐ¾ÑÐ¾Ð²",
        showDetail: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð´ÐµÑÐ°Ð»Ð¸",
        showHideEshopName: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ / ÑÐºÑÑÑÑ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ²ÐµÑÐ° Ð² Ð¸Ð½ÑÐµÑÐ½ÐµÑ-Ð¼Ð°Ð³Ð°Ð·Ð¸Ð½Ðµ Ð² Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾Ð¼ ÑÑÐ¾Ð»Ð±ÑÐµ",
        showKeyboard: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÑ",
        skipCustomerButton: "ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ Ð²ÑÐ±Ð¾Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        skipCustomerText: "ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÐµ, ÐµÑÐ»Ð¸ ÐÑ Ð½Ðµ ÑÐ¾ÑÐ¸ÑÐµ Ð²Ð½ÐµÑÑÐ¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        skipNote: "ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ Ð¸ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ Ð¸ÑÐ¾Ð³",
        spectroBrand: "ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ Ð±ÑÐµÐ½Ð´Ñ %{brandName}",
        statusAccepted: "Ð¿ÑÐ¸Ð½ÑÑÐ¾",
        statusCanceled: "Ð¾ÑÐ¼ÐµÐ½ÐµÐ½Ð¾",
        statusCreated: "ÑÐ¾Ð·Ð´Ð°Ð½Ð¾",
        statusDone: "Ð³Ð¾ÑÐ¾Ð²Ð¾",
        statusPartlyDone: "ÑÐ°ÑÑÐ¸ÑÐ½Ð¾ Ð³Ð¾ÑÐ¾Ð²Ð¾",
        statusPreparing: "Ð¿Ð¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ°",
        summaryChosenBase: "Ð±Ð°Ð·Ð°",
        summaryChosenBrand: "Ð±ÑÐµÐ½Ð´",
        summaryChosenCanSize: "ÑÐ°Ð·Ð¼ÐµÑ ÑÐ°ÑÑ",
        summaryChosenColor: "ÑÐ²ÐµÑ",
        summaryChosenColorCard: "ÐÐ°ÑÐ°Ð»Ð¾Ð³",
        summaryChosenProduct: "Ð¿ÑÐ¾Ð´ÑÐºÑ",
        summaryChosenQuantity: "ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        summaryColorPreview: "ÐÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ°",
        summaryCustomNote: "ÐÐ°Ð¿Ð¸ÑÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        summaryCustomerNumber: "Ð½Ð¾Ð¼ÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        summaryFormula: "ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        summaryFormulaNote: "ÐÐ°Ð¼ÐµÑÐºÐ° Ðº ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
        summaryNote: "Ð·Ð°Ð¼ÐµÑÐºÐ°",
        sureAboutSend: "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð·Ð°ÐºÐ°Ð·?",
        useCustomerInOrder: "ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð½Ð°Ð·Ð½Ð°ÑÐ¸ÑÑ %{customerName} Ð´Ð»Ñ ÑÐ»ÐµÐ´ÑÑÑÐµÐ³Ð¾ Ð·Ð°ÐºÐ°Ð·Ð°?",
        uuid: "UUID",
        viewSummary: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð¸ÑÐ¾Ð³",
        volume: "ÐÐ±ÑÑÐ¼"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "ÐÐ¸Ð½-ÐºÐ¾Ð´ Ð´Ð»Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ Ð·Ð°ÐºÐ°Ð·Ð°",
        pinScreenSaverConfirmation: "ÐÐ¸Ð½-ÐºÐ¾Ð´ Ð´Ð»Ñ ÑÐ°Ð·Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²ÐºÐ¸ ÑÐºÑÐ°Ð½Ð°",
        pinSettingsConfirmation: "ÐÐ¸Ð½-ÐºÐ¾Ð´ Ð´Ð»Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð½Ð°ÑÑÑÐ¾ÐµÐº",
        printAuto: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿ÐµÑÐ°ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸",
        printerSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
        selectColorWithFandeck: "ÐÑÐ±Ð¾Ñ ÑÐ²ÐµÑÐ° Ð¸ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð°",
        setKeyboard: "ÐÑÐ±ÑÐ°ÑÑ ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÑ",
        setKioskMode: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐµÐ¶Ð¸Ð¼ ÐºÐ¸Ð¾ÑÐºÐ°",
        setLanguage: "ÐÑÐ±ÑÐ°ÑÑ ÑÐ·ÑÐº",
        setModule: "ÐÑÐ±ÑÐ°ÑÑ Ð¼Ð¾Ð´ÑÐ»Ñ",
        setQuickSelect: "ÐÐ°Ð´Ð°ÑÑ Ð±ÑÑÑÑÑÐ¹ Ð²ÑÐ±Ð¾Ñ",
        setScreensaverTimeout: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð²ÑÐµÐ¼Ñ Ð¾Ð¶Ð¸Ð´Ð°Ð½Ð¸Ñ",
        setUnit: "ÐÑÐ±ÑÐ°ÑÑ ÐµÐ´Ð¸Ð½Ð¸ÑÑ"
    },
    customRedlikeMachine: {
        action: "ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ",
        additionalPrint: "ÐÐµÑÐ°ÑÐ°ÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÑ ÑÑÐ¸ÐºÐµÑÐºÑ",
        brand: "ÐÑÐµÐ½Ð´",
        brandAccess: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ '%{userName}' Ð½Ðµ Ð¸Ð¼ÐµÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð° Ðº Ð±ÑÐµÐ½Ð´Ñ '%{brandName}'",
        can: "Ð¢Ð°ÑÐ° ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð°",
        canistersLevel: "ÐÐ±Ð·Ð¾Ñ ÑÑÐ¾Ð²Ð½Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
        closeDetailInformation: "ÐÐ°ÐºÑÑÑÑ Ð¿Ð¾Ð´ÑÐ¾Ð±Ð½ÑÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        colorantsAmount: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        confirmRefill: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð¼",
        deleteOrder: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð·Ð°ÐºÐ°Ð·",
        dialogNoMachine: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½",
        dialogNoRcc: "RCC Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÑÐ½",
        dispense: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        dispenserInErrorState: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð² ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ð¸ Ð¾ÑÐ¸Ð±ÐºÐ¸",
        dispensingIsOk: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ Ð² ÑÑÐ°ÑÐ½Ð¾Ð¼ ÑÐµÐ¶Ð¸Ð¼Ðµ",
        emergencyButtonPressed: "ÐÐ°Ð¶Ð°Ñ Ð°Ð²Ð°ÑÐ¸Ð¹Ð½ÑÐ¹ Ð²ÑÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ",
        errorCode: "ÐÐ¾Ð´ Ð¾ÑÐ¸Ð±ÐºÐ¸",
        errorEvents: "ÐÑÐ¸Ð±ÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        errorReset: "ÐÐµÑÐµÐ·Ð°Ð¿ÑÑÐº Ð¾ÑÐ¸Ð±ÐºÐ¸ ÑÐ¸ÑÑÐµÐ¼Ñ",
        explanation: "ÐÐ±ÑÑÑÐ½ÐµÐ½Ð¸Ðµ",
        imageNotAvailable: "ÐÐ°ÑÑÐ¸Ð½ÐºÐ° Ð½Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð°",
        incorrectCanister: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð° Ð½ÐµÐ¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð°Ñ ÐºÐ°Ð½Ð¸ÑÑÑÐ°",
        incorrectColorant: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½ Ð½ÐµÐ¿ÑÐ°Ð²Ð¸Ð»ÑÐ½ÑÐ¹ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        lastEvents: "ÐÐ¾ÑÐ»ÐµÐ´Ð½Ð¸Ðµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ",
        machineActions: "ÐÐ°ÑÑÐ¸ÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        machineConfiguration: "ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        machineError: "ÐÑÐ¸Ð±ÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        machineIsBusy: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½",
        machineNotAvailable: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½",
        machineTinting: "ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¸Ð´ÐµÑ Ð¿ÑÐ¾ÑÐµÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        manualScan: "Ð ÑÑÐ½Ð¾Ðµ ÑÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        notEnoughSpace: "ÐÐ¨ÐÐÐÐ: Ð´Ð»Ñ Ð´Ð°Ð½Ð½Ð¾Ð³Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð½Ðµ ÑÐ²Ð°ÑÐ°ÐµÑ Ð¼ÐµÑÑÐ°",
        numberOfCanistersUnderCriticalLevel: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ°Ð½Ð¸ÑÑÑ Ñ ÐºÑÐ¸ÑÐ¸ÑÐµÑÐºÐ¸Ð¼ ÑÑÐ¾Ð²Ð½ÐµÐ¼ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ - %{0}",
        numberOfCanistersUnderWarningLevel: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ°Ð½Ð¸ÑÑÑ Ñ ÑÑÐ¾Ð²Ð½ÐµÐ¼ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ Ð½Ð¸Ð¶Ðµ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÑÑÐµÐ³Ð¾ - %{0} ",
        offlinePressed: "ÐÐ°Ð¶Ð°ÑÐ° Ð¾ÑÐ»Ð°Ð¹Ð½-ÐºÐ½Ð¾Ð¿ÐºÐ°",
        orderSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¾Ð² Ð·Ð°ÐºÐ°Ð·Ð°",
        otherOrderInformation: "ÐÐµÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð·Ð°ÐºÐ°Ð·Ð°",
        packageCount: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº",
        packageWithSeparator: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        received: "ÐÐ¾Ð»ÑÑÐµÐ½Ð¾",
        receivedOrders: "ÐÐ¾Ð»ÑÑÐµÐ½Ð½ÑÐµ Ð·Ð°ÐºÐ°Ð·Ñ",
        receivedTime: "ÐÐ¾Ð»ÑÑÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ",
        recirculation: "Ð ÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ",
        refillInformation: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ: %{0}, Ð£ÑÐ¾Ð²ÐµÐ½Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ: %{1}, ÐÐ°Ð½Ð¸ÑÑÑÐ°: %{2}",
        resetErrors: "Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸",
        scanCanister: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°ÑÑ ÑÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        scanColorantPackage: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½ÑÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        selectedOrder: "ÐÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ Ð·Ð°ÐºÐ°Ð·",
        shelfMovingDown: "ÐÐ¾Ð»ÐºÐ° Ð¾ÑÐ¿ÑÑÐºÐ°ÐµÑÑÑ",
        shelfMovingUp: "ÐÐ¾Ð»ÐºÐ° Ð¿Ð¾Ð´Ð½Ð¸Ð¼Ð°ÐµÑÑÑ",
        solution: "Ð ÐµÑÐµÐ½Ð¸Ðµ",
        startDispensing: "ÐÐ°ÑÐ°ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        stirring: "ÐÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ðµ",
        touchToStartFilling: "ÐÐ°Ð¶Ð¼Ð¸ÑÐµ Ð´Ð»Ñ Ð·Ð°Ð¿ÑÑÐºÐ° Ð·Ð°Ð»Ð¸Ð²ÐºÐ¸ Ð¿Ð°ÑÑ",
        unknownBrand: "ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½ÑÐ¹ Ð±ÑÐµÐ½Ð´"
    },
    customRedlikeSettings: {
        addPos: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ¾ÑÐºÐµ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        addServer: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÑÐµÑÐ²ÐµÑ",
        adminOperations: "ÐÐ´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¸Ð²Ð½ÑÐµ Ð¾Ð¿ÐµÑÐ°ÑÐ¸Ð¸",
        adminSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÐ°",
        another: "ÐÑÑÐ³Ð¾Ðµ",
        aslOrService: "ASL Ð¸Ð»Ð¸ ÑÐµÑÐ²Ð¸Ñ",
        availableMachines: "ÐÐ¾ÑÑÑÐ¿Ð½ÑÐµ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÑ",
        barcode: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´",
        basicOperations: "ÐÑÐ½Ð¾Ð²Ð½ÑÐµ Ð¾Ð¿ÐµÑÐ°ÑÐ¸Ð¸",
        canisterBarcodes: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
        canisterLevels: "Ð£ÑÐ¾Ð²Ð½Ð¸ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
        closeConnection: "ÐÐ°ÐºÑÑÑÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ",
        closeRedlike: "ÐÐ°ÐºÑÑÑÑ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ñ %{name}",
        databaseList: "ÐÐ°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        disabledStatus: "Ð¾ÑÐºÐ»ÑÑÐµÐ½Ð¾",
        dispenseLogicType: "Ð¢Ð¸Ð¿ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        dropServers: "Ð£Ð´Ð°Ð»Ð¸ÑÑ ÑÐµÑÐ²ÐµÑÐ°",
        editServer: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐµÑÐ²ÐµÑ",
        lastEvent: "ÐÐ¾ÑÐ»ÐµÐ´Ð½ÐµÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ",
        logOut: "ÐÑÑÐ¾Ð´",
        machineConfiguration: "ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ",
        maxDispenseAmount: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ Ð¾Ð±ÑÐµÐ¼",
        offlineStatus: "Ð¾ÑÐ»Ð°Ð¹Ð½",
        onlineStatus: "Ð¾Ð½Ð»Ð°Ð¹Ð½",
        openFrondesk: "ÐÑÐºÑÐ¾Ð¹ÑÐµ Ð¿ÐµÑÐµÐ´Ð½ÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ",
        print: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿ÐµÑÐ°ÑÐ¸",
        rebootPC: "ÐÐµÑÐµÐ·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑ",
        restartRedlike: "ÐÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÑ %{name}",
        restoreConnection: "ÐÐ¾ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ",
        scanCanisterBarcode: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°ÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        scanOrDeleteCanisterBarcode: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð¸Ð»Ð¸ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´",
        setCanisterBarcode: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        swVersion: "ÐÐµÑÑÐ¸Ñ ÐÐ",
        systemFunctions: "Ð¤ÑÐ½ÐºÑÐ¸Ð¸ ÑÐ¸ÑÑÐµÐ¼Ñ",
        userSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ²ÐµÑ",
        editColorant: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        emptyColorant: "ÐÑÑÑ Ð¿ÑÑÑÐ°Ñ ÐºÐ°Ð½Ð¸ÑÑÑÐ°",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð´Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°-ÑÐ¾Ð´Ð¸ÑÐµÐ»Ñ",
        formulaForMasterProductWithParam: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð´Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°-ÑÐ¾Ð´Ð¸ÑÐµÐ»Ñ %{productName}",
        isNotAvailable: "Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½",
        noBaseSelected: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð±Ð°Ð·Ð°",
        noColorantsSelected: "ÐÐµ Ð²ÑÐ±ÑÐ°Ð½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
        noFandeckSelected: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ ÐºÐ°ÑÐ°Ð»Ð¾Ð³",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑ",
        productPreview: "ÐÑÐ¾ÑÐ¼Ð¾ÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        saveCustomRecipe: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        saveIsNotAvailable: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾",
        showSiblingProducts: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ ÑÐ¾Ð´ÑÑÐ²ÐµÐ½Ð½ÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑÑ",
        siblingProducts: "Ð Ð¾Ð´ÑÑÐ²ÐµÐ½Ð½ÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑÑ Ð¾Ñ Ð³Ð»Ð°Ð²Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°"
    },
    customersTab: {
        addCustomer: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        additionalSettings: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        adress: "ÐÐ´ÑÐµÑ",
        createAndSelect: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¸ Ð²ÑÐ±ÑÐ°ÑÑ",
        createNewCustomer: "Ð¡Ð¾Ð·Ð´Ð°ÑÑ Ð½Ð¾Ð²Ð¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        editCustomer: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ",
        information: "ÐÐ¾Ð½ÑÐ°ÐºÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        listOfCustomers: "Ð¡Ð¿Ð¸ÑÐ¾Ðº ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð²",
        rabat: "Ð¡ÐºÐ¸Ð´ÐºÐ°",
        selectCustomer: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        spentLastMonth: "Ð Ð°ÑÑÐ¾Ð´ Ð·Ð° Ð¿ÑÐ¾ÑÐ»ÑÐ¹ Ð¼ÐµÑÑÑ",
        spentMoney: "ÐÐ°ÑÑÐ°ÑÑ",
        typeOfMargin: "Ð¢Ð¸Ð¿ Ð¼Ð°ÑÐ¶Ð¸",
        zipCode: "ÐÐ½Ð´ÐµÐºÑ"
    },
    dialog: {
        cheaperColorSearch: "ÐÐ¾Ð¸ÑÐº Ð±Ð¾Ð»ÐµÐµ Ð´ÐµÑÑÐ²ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¹",
        competitiveColorSearch: "ÐÐµÐ´ÐµÑÑÑ ÑÑÐ°Ð²Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹ ÑÐ²ÐµÑÐ¾Ð²Ð¾Ð¹ Ð¿Ð¾Ð¸ÑÐº",
        reallyChangeModule: "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð¼ÐµÐ½ÑÑÑ ÑÑÐ¾Ñ Ð¼Ð¾Ð´ÑÐ»Ñ?",
        reallyCloseRedlike:
            "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð·Ð°ÐºÑÑÑÑ %{name}? ÐÑÐµ %{name} Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð±ÑÐ´ÑÑ Ð·Ð°ÐºÑÑÑÑ, Ð½ÐµÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð½ÑÐµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð±ÑÐ´ÑÑ Ð¿Ð¾ÑÐµÑÑÐ½Ñ.",
        reallyDeleteOrder: "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÑÐ¾Ñ Ð·Ð°ÐºÐ°Ð·? ÐÑÐµ Ð´Ð°Ð½Ð½ÑÐµ, ÑÐ²ÑÐ·Ð°Ð½Ð½ÑÐµ Ñ Ð½Ð¸Ð¼, Ð±ÑÐ´ÑÑ Ð¿Ð¾ÑÐµÑÑÐ½Ñ.",
        reallyRebootPC:
            "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÑ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑ? ÐÑÐµ Ð¾ÐºÐ½Ð° Ð±ÑÐ´ÑÑ Ð·Ð°ÐºÑÑÑÑ, Ð½ÐµÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð½ÑÐµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð±ÑÐ´ÑÑ Ð¿Ð¾ÑÐµÑÑÐ½Ñ.",
        reallyRestartRedlike:
            "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÑ %{name}? ÐÑÐµ Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð±ÑÐ´ÑÑ Ð·Ð°ÐºÑÑÑÑ, Ð½ÐµÑÐ¾ÑÑÐ°Ð½Ð½ÑÐ½Ð½ÑÐµ Ð¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð±ÑÐ´ÑÑ Ð¿Ð¾ÑÐµÑÑÐ½Ñ.",
        reallyShutdownPc:
            "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð²ÑÐºÐ»ÑÑÐ¸ÑÑ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑ? ÐÑÐµ %{name} Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð±ÑÐ´ÑÑ Ð·Ð°ÐºÑÑÑÑ, Ð½ÐµÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð½ÑÐµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð±ÑÐ´ÑÑ Ð¿Ð¾ÑÐµÑÑÐ½Ñ.",
        unlockComputer: "ÐÐ¾Ð¼Ð¿ÑÑÑÐµÑ Ð±ÑÐ´ÐµÑ ÑÐ°Ð·Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²Ð°Ð½."
    },
    dispenseLogicTypes: {
        1: "ÐÐ¾Ð»ÐµÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        2: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÑÑÐ½Ð¾Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸ÐµÐ¼ Ð²ÐµÑÐ¾Ð² Ð´Ð»Ñ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹, Ð¿ÑÐµÐ²ÑÑÐ°ÑÑÐ¸Ñ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        3: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ Ð²Ð¾ Ð²ÑÐµÐ¼Ñ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ (ÑÐ°Ð·Ð´ÐµÐ»Ð¸ÑÑ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð½Ð° Ð±Ð¾Ð»ÐµÐµ Ð¼ÐµÐ»ÐºÐ¸Ðµ ÑÐ°ÑÑÐ¸)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "ÐÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ"
    },
    editFormulaRgbModal: {
        apply: "ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ",
        blue: "ÐÐ¾Ð»ÑÐ±Ð¾Ð¹",
        green: "ÐÐµÐ»ÑÐ½ÑÐ¹",
        modalLabel: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ²ÐµÑ",
        red: "ÐÑÐ°ÑÐ½ÑÐ¹",
        tryGenerateRgb: "Ð¡Ð³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°ÑÑ RGB"
    },
    environmentsSettings: {
        allowAutoCloseTab: "ÐÐ°ÐºÑÑÐ²Ð°ÑÑ Ð¾ÐºÐ½Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸",
        allowBarcodes: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð²",
        allowDeleteConfirmation: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ",
        allowDiskSpaceNotification: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ðµ Ð´Ð¸ÑÐºÐ¾Ð²Ð¾Ð³Ð¾ Ð¿ÑÐ¾ÑÑÑÐ°Ð½ÑÑÐ²Ð°",
        allowDispensing: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        allowFileTransfer: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ ÑÑÐ°Ð½ÑÑÐµÑ ÑÐ°Ð¹Ð»Ð¾Ð²",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ ÑÐ¾ÑÐ¼ÑÐ»",
        allowInternalNotes: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð²Ð½ÑÑÑÐµÐ½Ð½Ð¸Ðµ Ð·Ð°Ð¼ÐµÑÐºÐ¸",
        allowLight: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ %{name}",
        allowOrderNotificationModal: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð½Ð¾Ð²ÑÐµ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ñ Ð¾ Ð·Ð°ÐºÐ°Ð·Ð°Ñ",
        allowOrdering: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð·Ð°ÐºÐ°Ð·",
        allowPricing: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÐµÐ½Ð¾Ð¾Ð±ÑÐ°Ð·Ð¾Ð²Ð°Ð½Ð¸Ðµ",
        allowPrint: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿ÐµÑÐ°ÑÑ",
        allowProductPreviewImage: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð²Ð¾ Ð²ÑÐµÐ¼Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿Ð¾Ð¸ÑÐº Ð±Ð¾Ð»ÐµÐµ Ð´ÐµÑÑÐ²ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¹",
        allowSound: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð·Ð²ÑÐºÐ¾Ð²Ð¾Ðµ Ð¾Ð¿Ð¾Ð²ÐµÑÐµÐ½Ð¸Ðµ",
        allowSpectro: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ",
        allowTabs: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸",
        applyZoom: "Ð£Ð²ÐµÐ»Ð¸ÑÐ¸ÑÑ",
        automaticLogout: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ Ð²ÑÑÐ¾Ð´ Ð¸Ð· ÑÐ¸ÑÑÐµÐ¼Ñ",
        barcodeScan: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð°",
        canisterBarcode: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
        canisterLevel: "Ð£ÑÐ¾Ð²ÐµÐ½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð² ÐºÐ°Ð½Ð¸ÑÑÑÐµ",
        changelog: "ÐÑÑÐ½Ð°Ð» Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹",
        closeTab: "ÐÐ°ÐºÑÑÑÑ Ð²ÐºÐ»Ð°Ð´ÐºÑ",
        colorDifference: "Color difference",
        colorPanelNavItem: "Ð¦Ð²ÐµÑÐ¾Ð²Ð°Ñ Ð¿Ð°Ð»Ð¸ÑÑÐ°",
        competitiveColorSearch: "Ð¡ÑÐ°Ð²Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹ ÑÐ²ÐµÑÐ¾Ð²Ð¾Ð¹ Ð¿Ð¾Ð¸ÑÐº",
        customBanner: "ÐÐ°Ð½Ð½ÐµÑ Ð·ÐºÐ°Ð·ÑÐ¸ÐºÐ°",
        customCurrencyFormat: "Ð¤Ð¾ÑÐ¼Ð°Ñ Ð²Ð°Ð»ÑÑÑ",
        customDateFormat: "Ð¤Ð¾ÑÐ¼Ð°Ñ Ð´Ð°ÑÑ",
        customNumberFormat: "Ð¤Ð¾ÑÐ¼Ð°Ñ ÑÐ¸ÑÐµÐ»",
        customTimeFormat: "Ð¤Ð¾ÑÐ¼Ð°Ñ Ð²ÑÐµÐ¼ÐµÐ½Ð¸",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ ÑÐºÐ¸Ð´ÐºÑ",
        dispensingHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        dispensingNotes: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿ÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ñ Ð¿ÑÐ¸ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸",
        enableCustomers: "ÐÐºÐ»ÑÑÐ¸ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð²",
        enableDeleteConfirmation: "ÐÐºÐ»ÑÑÐ¸ÑÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ñ",
        enableDispensing: "ÐÐºÐ»ÑÑÐ¸ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        enableLight: "ÐÐºÐ»ÑÑÐ¸ÑÑ %{name}",
        enableMarginMarkup: "ÐÐºÐ»ÑÑÐ¸ÑÑ Ð¼Ð°ÑÐ¶Ñ Ð¸Ð»Ð¸ Ð½Ð°ÑÐµÐ½ÐºÑ",
        enableNotes: "ÐÐºÐ»ÑÑÐ¸ÑÑ Ð¿ÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ñ",
        enableOrdering: "ÐÐºÐ»ÑÑÐ¸ÑÑ Ð¿ÑÐ¸ÐµÐ¼ Ð·Ð°ÐºÐ°Ð·Ð¾Ð²",
        enableProductPreviewImage: "ÐÐºÐ»ÑÑÐ¸ÑÑ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        enableSpectro: "ÐÐºÐ»ÑÑÐ¸ÑÑ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ",
        enableVirtualKeyboard: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð²Ð¸ÑÑÑÐ°Ð»ÑÐ½ÑÑ ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÑ",
        environmentsSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐ¸ÑÑÐµÐ¼Ñ",
        exportTranslationKeys: "ÐÐ»Ð°Ð²Ð¸ÑÐ¸ ÑÐºÑÐ¿Ð¾ÑÑÐ° Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð°",
        formulaNotes: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿ÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ñ Ðº ÑÐ¾ÑÐ¼ÑÐ»Ð°Ð¼",
        hintTooltips: "ÐÐ¾Ð´ÑÐºÐ°Ð·ÐºÐ¸",
        image: "Ð¦Ð²ÐµÑ + Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ/Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        keyboardShortcuts: "ÐÐ¾ÑÑÑÐ¸Ðµ ÐºÐ»Ð°Ð²Ð¸ÑÐ¸",
        languageBased: "Ð¯Ð·ÑÐºÐ¾Ð²Ð°Ñ Ð¾ÑÐ½Ð¾Ð²Ð°",
        lockYourComputer: "ÐÐ°Ð±Ð»Ð¾ÐºÐ¸ÑÑÐ¹ÑÐµ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑ",
        machineReset: "Ð¡Ð±ÑÐ¾Ñ Ð½Ð°ÑÑÑÐ¾ÐµÐº Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        manageTranslations: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð°Ð¼Ð¸",
        margin: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð¼Ð°ÑÐ¶Ñ",
        markup: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð½Ð°ÑÐµÐ½ÐºÑ",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð²ÐºÐ»Ð°Ð´Ð¾Ðº Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°Ð¼Ð¸",
        memoryTabs: "Ð¡Ð¾ÑÑÐ°Ð½ÑÑÑ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ðµ Ð¾ÑÐºÑÑÑÑÐµ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸",
        moreInfo: "Ð¦Ð²ÐµÑ + Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ + Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        navigationItems: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ¾Ð² Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¸",
        newTab: "ÐÐ¾Ð²Ð°Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ°",
        numberOfPriceGroups: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÑÐµÐ½Ð¾Ð²ÑÑ Ð³ÑÑÐ¿Ð¿",
        order: "ÐÐ°ÐºÐ°Ð·",
        orderId: "ÐÐ¾Ð¼ÐµÑ Ð·Ð°ÐºÐ°Ð·Ð°",
        ordersHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð·Ð°ÐºÐ°Ð·Ð¾Ð²",
        overwriteLastTab: "ÐÐ°Ð¼ÐµÐ½Ð¸ÑÑ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐµ Ð¾ÐºÐ½Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        priceCalculation: "Ð Ð°ÑÑÑÑ ÑÐµÐ½Ñ",
        priceDefBothPurchasePrimary: "ÐÐ±Ðµ, Ð·Ð°ÐºÑÐ¿ÐºÐ° Ð² Ð¿ÐµÑÐ²ÑÑ Ð¾ÑÐµÑÐµÐ´Ñ",
        priceDefBothSellPrimary: "ÐÐ±Ðµ, ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð² Ð¿ÐµÑÐ²ÑÑ Ð¾ÑÐµÑÐµÐ´Ñ",
        priceDefPurchaseOnly: "Ð¡ÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð·Ð°ÐºÑÐ¿ÐºÐ¸ ÑÐ¾Ð»ÑÐºÐ¾",
        priceDefSellOnly: "Ð¡ÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ ÑÐ¾Ð»ÑÐºÐ¾",
        priceDefinition: "ÐÐ¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸Ðµ ÑÐµÐ½",
        priceGroupsEnabled: "ÐÐºÐ»ÑÑÐ¸ÑÑ ÑÐµÐ½Ð¾Ð²ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ",
        runLightAtStartUp: "ÐÐºÐ»ÑÑÐ°ÑÑ %{light} Ð¿ÑÐ¸ Ð·Ð°Ð¿ÑÑÐºÐµ",
        screenSaverTimeout: "ÐÐ°ÑÑÐ°Ð²ÐºÐ° ÑÐ°Ð¹Ð¼-Ð°ÑÑ",
        selectedSpectro: "ÐÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ %{spectro} spectro.",
        selectedSpectroNone: "ÐÐµ Ð²ÑÐ±ÑÐ°Ð½ spectro.",
        setAutomaticClientStart: "ÐÐ°Ð¿ÑÑÐºÐ°ÑÑ %{name} Ð¿ÑÐ¸ Ð²ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        setCustomHomeButton: "ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ ÐºÐ½Ð¾Ð¿ÐºÐ¸ 'ÐÐ¾Ð¼Ð¾Ð¹'",
        setDecimalPlaces: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð·Ð½Ð°ÐºÐ¾Ð² Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð¿ÑÑÐ¾Ð¹",
        setFormulaPreview: "ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        setFormulaUnit: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        setFts: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð¿Ð¾Ð»Ð½Ð¾ÑÐµÐºÑÑÐ¾Ð²ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº",
        setInfoItemInRgb: "Ð´Ð°Ð½Ð½ÑÐµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ° ÑÐ²ÐµÑÐ°",
        setKeyboardShortcuts: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ 'Ð³Ð¾ÑÑÑÐ¸Ðµ ÐºÐ»Ð°Ð²Ð¸ÑÐ¸'",
        setKioskMode: "ÐÐ°ÑÑÑÐ¾Ð¸ÑÑ ÑÐµÐ¶Ð¸Ð¼ ÐºÐ¸Ð¾ÑÐºÐ°",
        setKioskModeOff: "ÐÑÐºÐ»ÑÑÐ¸ÑÑ ÑÐµÐ¶Ð¸Ð¼ ÐºÐ¸Ð¾ÑÐºÐ°",
        setKioskModeOn: "ÐÐºÐ»ÑÑÐ¸ÑÑ ÑÐµÐ¶Ð¸Ð¼ ÐºÐ¸Ð¾ÑÐºÐ°",
        setNavigationItems: "ÐÐ°ÑÑÑÐ¾Ð¸ÑÑ ÑÐ»ÐµÐ¼ÐµÐ½ÑÑ ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ñ",
        setNavigationItemsList: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑÑ Ð¸ Ð¿Ð¾ÑÑÐ´Ð¾Ðº ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ¾Ð² Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¸",
        setOrderSearchItems: "ÐÐ°ÑÑÑÐ¾Ð¸ÑÑ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ Ð¿Ð¾Ð¸ÑÐºÐ° Ð·Ð°ÐºÐ°Ð·Ð°",
        setRounding: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¾ÐºÑÑÐ³Ð»ÐµÐ½Ð¸Ðµ",
        setSearchParameters: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ Ð¿Ð¾Ð¸ÑÐºÐ° ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        setTabLimit: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð¸Ðµ Ð¿Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ñ Ð¾ÑÐºÑÑÑÑÑ Ð²ÐºÐ»Ð°Ð´Ð¾Ðº",
        setYourLanguage: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð²Ð°Ñ ÑÐ·ÑÐº",
        setZoom: "ÐÐ°ÑÑÑÐ¾Ð¸ÑÑ ÑÐ²ÐµÐ»Ð¸ÑÐµÐ½Ð¸Ðµ",
        showLocalPrices: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð¿ÑÐµÐ´Ð»Ð°Ð³Ð°ÐµÐ¼ÑÐµ ÑÐµÐ½Ñ",
        skipPlaceCanDialogEnabled:
            "Ð­ÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð½ÐµÐ»ÑÐ·Ñ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ, Ñ.Ðº. Ð´Ð¸Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ðµ Ð¾ÐºÐ½Ð¾ Ð±ÑÐ»Ð¾ Ð´ÐµÐ°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        sortItems: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ»ÐµÐ¼ÐµÐ½ÑÑ Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¸",
        startDispensing: "ÐÐ°ÑÐ°ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        stir: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÑÑ"
    },
    error: {
        errorDetail: "ÐÐµÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð¾ÑÐ¸Ð±ÐºÐ¸",
        errorOccurred:
            "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ° ÐÐ±ÑÐ°ÑÐ¸ÑÐµÑÑ Ð² ÑÐ»ÑÐ¶Ð±Ñ Ð¿Ð¾Ð´Ð´ÐµÑÐ¶ÐºÐ¸ Ð¿Ð¾  %{0}, Ð¸ Ð¼Ñ ÑÐ²ÑÐ¶ÐµÐ¼ÑÑ Ñ ÐÐ°Ð¼Ð¸ Ð² Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ ÐºÐ¾ÑÐ¾ÑÐºÐ¸Ð¹ ÑÑÐ¾Ðº",
        hideDetail: "Ð¡ÐºÑÑÑÑ Ð´ÐµÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ"
    },
    favoritesTab: {
        addFolder: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¿Ð°Ð¿ÐºÑ",
        closeTabToLoadFormula:
            "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð·Ð°ÐºÑÐ¾Ð¹ÑÐµ Ð¾Ð´Ð½Ñ Ð¸Ð· Ð²ÐºÐ»Ð°Ð´Ð¾Ðº, ÑÑÐ¾Ð±Ñ Ð¾ÑÐºÑÑÑÑ Ð½Ð¾Ð²ÑÑ ÐÑ Ð¾ÑÐºÑÑÐ»Ð¸ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð²ÐºÐ»Ð°Ð´Ð¾Ðº",
        deleteFolder: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¿Ð°Ð¿ÐºÑ",
        editFolder: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð¿Ð°Ð¿ÐºÑ",
        favoriteFormulas: "ÐÐ·Ð±ÑÐ°Ð½Ð½ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        formulaNotes: "ÐÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ñ Ðº ÑÐ¾ÑÐ¼ÑÐ»Ð°Ð¼",
        message: {
            formulasFromFolder: "Ð¤Ð¾ÑÐ¼ÑÐ»Ñ Ð¸Ð· Ð¿Ð°Ð¿ÐºÐ¸",
            moveAllFormulas: "ÐÐµÑÐµÐ¼ÐµÑÑÐ¸ÑÑ Ð²ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð¸Ð· ÑÑÐ¾Ð¹ Ð¿Ð°Ð¿ÐºÐ¸ Ð² ÑÐ¾Ð´Ð¸ÑÐµÐ»ÑÑÐºÑÑ Ð¿Ð°Ð¿ÐºÑ",
            removeAllFormulas: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð²ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð¸Ð· ÑÑÐ¾Ð¹ Ð¿Ð°Ð¿ÐºÐ¸",
            wantToDeleteFolder: "ÐÑ ÑÐ²ÐµÑÐµÐ½Ñ, ÑÑÐ¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÑÑ Ð¿Ð°Ð¿ÐºÑ?"
        },
        newFolder: "ÐÐ¾Ð²Ð°Ñ Ð¿Ð°Ð¿ÐºÐ°",
        packages: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        pricePerPackage: "Ð¦ÐµÐ½Ð° Ð·Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        regularPrice: "Ð¡ÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð°Ñ ÑÐµÐ½Ð°",
        removeFromFavorites: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¸Ð· Ð¸Ð·Ð±ÑÐ°Ð½Ð½ÑÑ",
        specialPriceOff: "Ð¡Ð¿ÐµÑÐ¸Ð°Ð»ÑÐ½Ð°Ñ ÑÐµÐ½Ð° %{number}%",
        specialPriceVIP: "Ð¡Ð¿ÐµÑÐ¸Ð°Ð»ÑÐ½Ð°Ñ VIP ÑÐµÐ½Ð°"
    },
    fileTransfer: {
        afterImport: "ÐÐ¾ÑÐ»Ðµ Ð¸Ð¼Ð¿Ð¾ÑÑÐ°",
        alreadyExists: "ÐÐ°Ð´Ð°ÑÐ° Ð´Ð»Ñ ÑÐ°ÐºÐ¾Ð³Ð¾ ÑÐ¸Ð¿Ð° Ð¸ ÑÐ¾ÑÐ¼Ð°ÑÐ° ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ",
        customFormulaSimple: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        direction: "ÐÑÑÑ",
        exportTask: "Ð­ÐºÑÐ¿Ð¾ÑÑ ÑÐ°Ð¹Ð»Ð¾Ð²",
        fileTransferNotification: "Ð£Ð²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ñ Ð´Ð»Ñ Ð¿ÐµÑÐµÐ½Ð¾ÑÐ° ÑÐ°Ð¹Ð»Ð¾Ð²",
        flashMessage: "Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ",
        importTask: "ÐÐ¼Ð¿Ð¾ÑÑ ÑÐ°Ð¹Ð»Ð¾Ð²",
        noInformation: "ÐÐµÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸",
        protocol: {
            folder: "ÐÐ°Ð¿ÐºÐ°",
            ftp: "FTP Ð¿ÑÐ¾ÑÐ¾ÐºÐ¾Ð»",
            ftps: "FTPS Ð¿ÑÐ¾ÑÐ¾ÐºÐ¾Ð»",
            redlikeStorage: "%{softwareName} FTP Ð¿ÑÐ¾ÑÐ¾ÐºÐ¾Ð» ÑÑÐ°Ð½Ð¸Ð»Ð¸ÑÐ°",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "ÐÑÐ¾ÑÐ¾ÐºÐ¾Ð» Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÑÐ°Ð¹Ð»Ð¾Ð² Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ð¹ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ Ð¿Ð°Ð¿ÐºÐµ.",
            ftp: "ÐÑÐ¾ÑÐ¾ÐºÐ¾Ð» Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÑÐ°Ð¹Ð»Ð¾Ð² Ð² ÑÐ´Ð°Ð»ÐµÐ½Ð½Ð¾Ð¹ FTP-Ð¿Ð°Ð¿ÐºÐµ Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸ÐµÐ¼ ÑÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð¾Ð³Ð¾ FTP-ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ.",
            ftps: "ÐÑÐ¾ÑÐ¾ÐºÐ¾Ð» Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÑÐ°Ð¹Ð»Ð¾Ð² Ð½Ð° ÑÐ´Ð°Ð»ÐµÐ½Ð½Ð¾Ð¼ ÑÐµÑÐ²ÐµÑÐµ FTPS (FTP-SSL / FTP Secure) Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸ÐµÐ¼ ÑÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð¾Ð³Ð¾ FTP-ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ.",
            redlikeStorage: "ÐÑÐ¾ÑÐ¾ÐºÐ¾Ð» Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÑÐ°Ð¹Ð»Ð¾Ð² Ð² ÑÑÐ°Ð½Ð¸Ð»Ð¸ÑÐµ %{softwareName}."
        },
        remoteFolder: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¿Ð°Ð¿ÐºÑ",
        startType: "ÐÐ°ÑÐ½Ð¸ÑÐµ Ð¿ÐµÑÐ°ÑÐ°ÑÑ",
        statusbar: "Ð¡ÑÑÐ¾ÐºÐ° ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ",
        testConnection: "Ð¢ÐµÑÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Ð¢Ð¸Ð¿ Ð¿Ð¾ÑÑÐµÐ±Ð»ÐµÐ½Ð¸Ñ",
        filter: "Ð¤Ð¸Ð»ÑÑÑ",
        from: "ÐÑ",
        to: "ÐÐ¾"
    },
    findText: {
        findTextTitle: "ÐÐ°Ð¹ÑÐ¸ ÑÐµÐºÑÑ",
        removeMarks: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð·Ð°Ð¼ÐµÑÐ°Ð½Ð¸Ñ",
        search: "ÐÑÐºÐ°ÑÑ ÑÐ»Ð¾Ð²Ð¾"
    },
    flashMessage: {
        VMNotAllowed: "ÐÐ¸ÑÑÑÐ°Ð»ÑÐ½Ð°Ñ Ð¼Ð°ÑÐ¸Ð½Ð° Ð½Ðµ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð°",
        addedToStock: "Ð¢Ð¾Ð²Ð°ÑÑ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ñ Ð½Ð° ÑÐºÐ»Ð°Ð´",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "ÐÑÐ¸Ð±ÐºÐ° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ Ð²ÑÐ¾Ð´Ð° Ð² Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        autotaskDuplicateName:
            "ÐÑÐ¸Ð±ÐºÐ° ÑÐµÐ»Ð¾ÑÑÐ½Ð¾ÑÑÐ¸ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ: %{0} ÑÐ»ÐµÐ¼ÐµÐ½Ñ Ñ %{1} %{2} ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐ¹ÑÐµ Ð´ÑÑÐ³Ð¾Ð¹ %{3}",
        barcodeIsUsed: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´ ÑÐ¶Ðµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ",
        barcodeNotFound: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½",
        bugReportSent: "ÐÐ°ÑÐµ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾Ð± Ð¾ÑÐ¸Ð±ÐºÐµ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾",
        cannoctConnectToServer: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Ñ ÑÐµÑÐ²ÐµÑÐ¾Ð¼",
        cannotWriteLicense: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð½Ð°Ð¿Ð¸ÑÐ°ÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ",
        clientConnectionRejected: "Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Ð¾ÑÐºÐ»Ð¾Ð½ÐµÐ½Ð¾",
        clientNotLoggedIn: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð½Ðµ Ð°Ð²ÑÐ¾ÑÐ¸Ð·Ð¸ÑÐ¾Ð²Ð°Ð½",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð±ÑÐ» ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¸ÑÐºÐ»ÑÑÐµÐ½ Ð¸Ð· Ð·Ð°Ð¿Ð°ÑÐ¾Ð².",
        competitiveSearchEmpty:
            "Ð¡Ð¾Ð²Ð¼ÐµÑÑÐ¸Ð¼ÑÐ¹ ÑÐ²ÐµÑ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð½Ð°Ð¹Ð´ÐµÐ½. ÐÐ·Ð¼ÐµÐ½Ð¸ÑÐµ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ Ð¿Ð¾Ð¸ÑÐºÐ° Ð¸Ð»Ð¸ Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð´ÑÑÐ³Ð¾Ð¹ ÑÐ²ÐµÑ",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "ÐÐ¾Ð¼Ð¿ÑÑÑÐµÑ Ð´Ð°ÑÐ¸ÑÐ¾Ð²Ð°Ð½ Ð·Ð°Ð´Ð½Ð¸Ð¼ ÑÐ¸ÑÐ»Ð¾Ð¼",
        connectionFailed: "Ð¢ÐµÑÑ ÑÐ¾ÐµÐ´Ð½Ð¸Ð½ÐµÐ½Ð¸Ñ Ð½ÐµÑÐ´Ð°ÑÐ½ÑÐ¹: %{0}",
        connectionSuccess: "Ð¢ÐµÑÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ Ð±ÑÐ» ÑÑÐ¿ÐµÑÐµÐ½.",
        corruptedLicenseFile: "ÐÐ¾Ð²ÑÐµÐ¶Ð´ÐµÐ½ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¾Ð½Ð½ÑÐ¹ ÑÐ°Ð¹Ð»",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "ÐÐ»Ð¸ÐµÐ½Ñ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½",
        dataNotAvailable: "Ð¡ÐµÑÐ²ÐµÑ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ¸ÑÑÑÑ Ðº Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "ÐÐ¾ Ð²ÑÐµÐ¼Ñ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ ÑÐµÑÐ²ÐµÑÐ° Ð²Ð¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°",
        deleteAll: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð²ÑÐµ",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin: "ÐÑ Ð¼Ð¾Ð¶ÐµÑÐµ Ð²ÑÐºÐ»ÑÑÐ¸ÑÑ winter Ð¿Ð»Ð°Ð³Ð¸Ð½ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÑ Ð²ÑÐ¿Ð°Ð´Ð°ÑÑÐµÐµ Ð¾ÐºÐ½Ð¾ Ð² Ð¿ÑÐ°Ð²Ð¾Ð¹ ÑÐ°ÑÑÐ¸ Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¸.",
        duplicateBarcode: "ÐÐ½Ð°Ð»Ð¾Ð³Ð¸ÑÐ½ÑÐ¹ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´ ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ",
        duplicateName: "ÐÐ½Ð°Ð»Ð¾Ð³Ð¸ÑÐ½Ð¾Ðµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "ÐÐµÑ Ð·Ð°Ð¿Ð¸ÑÐµÐ¹.",
        expiredLicense: "Ð¡ÑÐ¾Ðº Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸ Ð¸ÑÑÐµÐº",
        exportSuccess: "ÐÐ°Ð½Ð½ÑÐµ Ð±ÑÐ»Ð¸ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐºÑÐ¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ",
        fandeckExist: "ÐÐ½Ð°Ð»Ð¾Ð³Ð¸ÑÐ½Ð¾Ðµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸ ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ",
        featureNotAutorized: "Ð¤ÑÐ½ÐºÑÐ¸Ñ Ð½Ðµ Ð°Ð²ÑÐ¾ÑÐ¸Ð·Ð¾Ð²Ð°Ð½Ð°",
        fileExportComplete: "Ð¤Ð°Ð¹Ð» Ð±ÑÐ» ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐºÑÐ¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "Ð¤Ð°Ð¹Ð» Ð¿ÑÑÑÐ¾Ð¹ Ð¸Ð»Ð¸ Ð½Ðµ ÑÐºÐ°Ð·Ð°Ð½ Ð½ÐµÐ²ÐµÑÐ½Ð¾.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐ°ÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ð² ÑÐ°Ð¹Ð»Ðµ.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ Ð²ÐµÑÑÐ¸Ñ ÑÐ°Ð¹Ð»Ð°.",
        filetransferNoData: "ÐÐµÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ Ñ Ð±Ð°Ð·Ð¾Ð¹ Ð´Ð°Ð½Ð½ÑÑ, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        formulaDataUnavailable: "ÐÐ°Ð½Ð½ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ñ",
        helperDefaultMessage: "ÐÐ¾ Ð²ÑÐµÐ¼Ñ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð²ÑÐ¿Ð¾Ð¼Ð¾Ð³Ð°ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ ÑÐµÑÐ²ÐµÑÐ° Ð²Ð¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°",
        helperServerError: "ÐÑÐ¸Ð±ÐºÐ° Ð²ÑÐ¿Ð¾Ð¼Ð¾Ð³Ð°ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ ÑÐµÑÐ²ÐµÑÐ°",
        importAborted: "ÐÑÐ¾ÑÐµÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑÐ° Ð±ÑÐ» Ð¿ÑÐµÑÐ²Ð°Ð½",
        importSuccess: "ÐÐ°Ð½Ð½ÑÐµ Ð±ÑÐ»Ð¸ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ",
        incompatibleBaseCan: "Ð¢Ð°ÑÐ° Ð½Ðµ ÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼Ð° Ñ ÑÐºÐ°Ð·Ð°Ð½Ð½ÑÐ¼Ð¸ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð¼, Ð±Ð°Ð·Ð¾Ð¹ Ð¸ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¾Ð¹",
        incorrectPassword: "ÐÐ°Ñ Ð¿Ð°ÑÐ¾Ð»Ñ Ð½Ðµ ÐºÐ¾ÑÑÐµÐºÑÐµÐ½, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²Ð²ÐµÐ´Ð¸ÑÐµ Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½ÑÐ¹",
        invalidCurrency: "ÐÐ¾Ð´ Ð²Ð°Ð»ÑÑÑ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÐµÐ½. ÐÐ²ÑÐ¾ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ Ð² ÐºÐ°ÑÐµÑÑÐ²Ðµ Ð²Ð°Ð»ÑÑÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
        invalidDatabaseName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾",
        invalidEmail: "ÐÐ°Ñ Ð°Ð´ÑÐµÑ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÑ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÐµÐ½",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ð¹ ÐºÐ»ÑÑ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÐµÐ½",
        invalidLicenseFile: "ÐÐ¸ÑÐµÐ½Ð·Ð¸Ð¾Ð½Ð½ÑÐ¹ ÑÐ°Ð¹Ð» Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÐµÐ½",
        invalidLicenseIdentificationKeys: "ÐÐ°ÑÐ¸ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¾Ð½Ð½ÑÐµ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐµ ÐºÐ»ÑÑÐ¸ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ñ",
        invalidLicenseKey: "ÐÐ°ÑÐ° Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð°",
        invalidLicenseProduct: "ÐÐ¸ÑÐµÐ½Ð·Ð¸Ð¾Ð½Ð½ÑÐ¹ ÑÐ°Ð¹Ð» Ð½Ðµ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²ÑÐµÑ Ð¿ÑÐ¾Ð´ÑÐºÑÑ",
        invalidRccResponse: "ÐÐ¾ Ð²ÑÐµÐ¼Ñ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÐ¸ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð¾ÑÐ²ÐµÑÐ° RCC Ð²Ð¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°",
        invalidServerResponse: "ÐÐ¾ Ð²ÑÐµÐ¼Ñ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÐ¸ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð¾ÑÐ²ÐµÑÐ° ÑÐµÑÐ²ÐµÑÐ° Ð²Ð¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°",
        invalidUrl: "URL Ð°Ð´ÑÐµÑ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÐµÐ½",
        itemNotFound: "ÐÑÑÐ¸ÐºÑÐ» Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½",
        keyboardShortcutUsedInModal:
            "Ð­ÑÐ¾ ÑÐ¾ÑÐµÑÐ°Ð½Ð¸Ðµ ÐºÐ»Ð°Ð²Ð¸Ñ Ð½ÐµÐ»ÑÐ·Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð²Ð¾ Ð²ÑÐ¿Ð»ÑÐ²Ð°ÑÑÐµÐ¼ Ð¾ÐºÐ½Ðµ ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð·Ð°ÐºÑÐ¾Ð¹ÑÐµ Ð²ÑÐ¿Ð»ÑÐ²Ð°ÑÑÐµÐµ Ð¾ÐºÐ½Ð¾",
        keyboardShortcutValidation: "ÐÑ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑÐµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð¾Ð´Ð½Ñ Ð¸ ÑÑ Ð¶Ðµ ÐºÐ¾Ð¼Ð±Ð¸Ð½Ð°ÑÐ¸Ñ ÐºÐ»Ð°Ð²Ð¸Ñ Ð´Ð»Ñ Ð´Ð²ÑÑ ÑÐ°Ð·Ð½ÑÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹",
        licenseHasBeenRevoked:
            "ÐÐ°ÑÐ° Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ Ð±ÑÐ»Ð° Ð¾ÑÐ¾Ð·Ð²Ð°Ð½Ð° Ð§ÑÐ¾Ð±Ñ Ð¿ÑÐ¾Ð´Ð»Ð¸ÑÑ ÐµÐµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, ÑÐ²ÑÐ¶Ð¸ÑÐµÑÑ Ñ Ð²Ð°ÑÐ¸Ð¼ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ¾Ð¼ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ",
        licenseProlongationNeeded:
            "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¿ÑÐ¾Ð´Ð»ÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸ ( Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ¸ÑÑ ÐÐ Ðº ÐÐ½ÑÐµÑÐ½ÐµÑÑ Ð´Ð»Ñ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ñ Ð½Ð¾Ð²Ð¾Ð¹ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸)",
        licenseUpToDate: "ÐÐ°ÑÐ° Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð°. ÐÐµÑ Ð½Ð¾Ð²ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹.",
        licenseUpdateUnsuccessful: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ.",
        licenseUpdated: "ÐÐ¸ÑÐµÐ½Ð·Ð¸Ñ Ð±ÑÐ»Ð° ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð°.",
        licensedOnDifferentComputer: "ÐÑÐ¾Ð´ÑÐºÑ ÑÐ¶Ðµ Ð»Ð¸ÑÐµÐ½Ð·Ð¸ÑÐ¾Ð²Ð°Ð½ Ð½Ð° Ð´ÑÑÐ³Ð¾Ð¼ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐµ",
        logFileArchiveDownloadComplete: "ÐÐ°Ð³ÑÑÐ·ÐºÐ° Ð°ÑÑÐ¸Ð²Ð½Ð¾Ð³Ð¾ Ð¶ÑÑÐ½Ð°Ð»Ð° ÑÑÐ¿ÐµÑÐ½Ð¾ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð°",
        loginError: "ÐÑÐ¸ Ð²ÑÐ¾Ð´Ðµ Ð² ÑÐ¸ÑÑÐµÐ¼Ñ Ð²Ð¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°",
        logoutError: "ÐÑÐ¸ Ð²ÑÑÐ¾Ð´Ðµ Ð¸Ð· ÑÐ¸ÑÑÐµÐ¼Ñ Ð²Ð¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°",
        machineIsConnecting: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ°ÐµÑÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        machineIsNotConnected: "ÐÐ°Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ ÐÐ ÐÐÐÐÐÐ®Ð§ÐÐ Ðº RCC ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ RCC.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "ÐÑÐºÑÑÑÐ¾ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð²ÐºÐ»Ð°Ð´Ð¾Ðº, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð·Ð°ÐºÑÐ¾Ð¹ÑÐµ Ð¾Ð´Ð½Ñ.",
        noTemplate: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸ÑÑ Ð¿ÐµÑÐ°ÑÑ, ÑÐ°Ðº ÐºÐ°Ðº Ð½ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ ÑÐ°Ð±Ð»Ð¾Ð½Ð¾Ð².",
        openNewTab: "ÐÑÐºÑÐ¾Ð¹ÑÐµ Ð½Ð¾Ð²Ð¾Ðµ Ð¾ÐºÐ½Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ñ, ÑÑÐ¾Ð±Ñ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ñ Ð¿Ð¾Ð¼Ð¾ÑÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð° ",
        orderAlreadyAcquired: "ÐÐ°ÐºÐ°Ð· ÑÐ¶Ðµ Ð¿Ð¾Ð»ÑÑÐµÐ½, ÐµÐ³Ð¾ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸ÑÑ Ð² Ð¿ÐµÑÐ²ÑÑ Ð¾ÑÐµÑÐµÐ´Ñ.",
        orderCreated: "ÐÐ°Ð¿ÑÐ¾Ñ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½.",
        passwordIsNotUnique: "ÐÐ¾Ð²ÑÐ¹ Ð¿Ð°ÑÐ¾Ð»Ñ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð¾ÑÐ»Ð¸ÑÐ°ÑÑÑÑ Ð¾Ñ Ð¿ÑÐµÐ´ÑÐ´ÑÑÐµÐ³Ð¾.",
        printCannotBeCarriedOut: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸ÑÑ Ð¿ÐµÑÐ°ÑÑ, ÑÐ°Ðº ÐºÐ°Ðº Ð¸Ð¼Ñ Ð¿ÑÐ¸Ð½ÑÐµÑÐ° Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾.",
        problemWithFileExport: "Ð ÑÐ¾Ð¶Ð°Ð»ÐµÐ½Ð¸Ñ, Ð²Ð¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ð° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸ Ð°ÑÑÐ¸Ð²Ð½Ð¾Ð³Ð¾ Ð¶ÑÑÐ½Ð°Ð»Ð°.",
        productFileWarning: "Ð¤Ð°Ð¹Ð» Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ ÑÐ¾Ð»ÑÐºÐ¾ Ð¾Ð½Ð»Ð°Ð¹Ð½.",
        productNotLicensed: "ÐÑÐ¾Ð´ÑÐºÑ Ð½Ðµ Ð»Ð¸ÑÐµÐ½Ð·Ð¸ÑÐ¾Ð²Ð°Ð½",
        rccDefaultMessage: "ÐÑÐ¸ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ¼ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¸ RCC Ð²Ð¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°",
        rccError: "ÐÑÐ¸Ð±ÐºÐ° RCC",
        rccNeedRestart: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÐµ RCC",
        restoredSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð²Ð¾ÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ñ",
        revokedLicense: "ÐÐ¸ÑÐµÐ½Ð·Ð¸Ñ Ð±ÑÐ»Ð° Ð¾ÑÐ¾Ð·Ð²Ð°Ð½Ð°",
        runningOutOfSpace: "ÐÐµÑÐ²Ð°ÑÐ°ÐµÑ Ð¼ÐµÑÑÐ° Ð½Ð° Ð´Ð¸ÑÐºÐµ.",
        savedFormulaToHistory: "Ð¤Ð¾ÑÑÐ»Ð° ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð° Ð² Ð¸ÑÑÐ¾ÑÐ¸Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        savedLogArchive: "ÐÑÑÐ¸Ð²Ð½ÑÐ¹ Ð¶ÑÑÐ½Ð°Ð» Ð±ÑÐ» ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÑÐ½ Ð² Ð²Ð°ÑÐµÐ¹ Ð´Ð¸ÑÐµÐºÑÐ¾ÑÐ¸Ð¸",
        scanning: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð² Ð¿ÑÐ¾ÑÐµÑÑÐµ",
        serverError: "ÐÑÐ¸Ð±ÐºÐ° ÑÐµÑÐ²ÐµÑÐ°",
        setClientIdentifier: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, ÑÐºÐ°Ð¶Ð¸ÑÐµ ÐÐ°Ñ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        showLess: "Ð¡ÐºÑÑÑÑ",
        showMore: "ÐÐ¾Ð´ÑÐ¾Ð±Ð½ÐµÐµ",
        spectroIsDisconnecting: "Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ Ð¾ÑÐºÐ»ÑÑÐ°ÐµÑÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        spectroIsNotConnected: "ÐÐ°Ñ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ ÑÐµÐ¹ÑÐ°Ñ ÐÐ ÐÐÐÐÐÐ®Ð§ÐÐ ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ RCC",
        spectroIsNotSelected: "ÐÐ°Ñ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ ÑÐµÐ¹ÑÐ°Ñ ÐÐ ÐÐ«ÐÐ ÐÐ ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ RCC",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°: %{0}",
        userAlreadyLoggedIn: "ÐÑ ÑÐ¶Ðµ Ð²Ð¾ÑÐ»Ð¸ Ð² ÑÐ¸ÑÑÐµÐ¼Ñ!",
        versionNotAllowedByLicense: "ÐÐµÑÑÐ¸Ñ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ ÑÐ»Ð¸ÑÐºÐ¾Ð¼ Ð½Ð¾Ð²Ð°Ñ Ð¸ Ð½Ðµ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð° Ð´Ð»Ñ Ð²Ð°ÑÐµÐ¹ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸.",
        webApiConnectionError: "ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ¸ÑÑÑÑ Ðº ÑÐµÑÐ²ÐµÑÑ Web Api",
        webApiInternalError: "ÐÐ½ÑÑÑÐµÐ½Ð½ÑÑ Ð¾ÑÐ¸Ð±ÐºÐ° ÑÐµÑÐ²ÐµÑÐ° Web Api",
        webApiInvalidUser: "ÐÐµÐ´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÐµÑÐ²ÐµÑÐ° Web Api",
        webApiNoLicenseAvailable: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾Ð¹ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸ Ð´Ð»Ñ ÑÐµÑÐ²ÐµÑÐ° Web Api",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "ÐÐµÐ¿ÑÐ°Ð²Ð¸Ð»ÑÐ½ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ Ð²Ð²Ð¾Ð´Ð° %{0}",
        wrongRccVersion: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ Ð²ÐµÑÑÐ¸Ñ ÐÐ°ÑÐµÐ³Ð¾ RCC ÐÐ°Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼ ÑÐ¾Ð»ÑÐºÐ¾ Ñ RCC %{0}"
    },
    footer: {
        aboutApplication: "Ð Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸",
        activeUser: "ÐÐºÑÐ¸Ð²Ð½ÑÐ¹ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        logOut: "ÐÑÐ¹ÑÐ¸",
        machineErrors: "ÐÑÐ¸Ð±ÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "ÐÑÐµ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ Ð´Ð¾ÑÑÑÐ¿Ð½Ñ Ð² Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ",
        allowCustomFormulas: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        allowCustomPackageSize: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ ÑÐ°Ð·Ð¼ÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        allowFormulaAutomaticNaming: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ðµ Ð½Ð°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ",
        automaticNaming: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ðµ Ð½Ð°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»",
        basePanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð±Ð°Ð·Ð¾Ð²Ð¾Ð¹ Ð¿Ð°Ð½ÐµÐ»Ð¸",
        bippPanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð±Ð°Ð·Ñ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ ÑÐ¾Ð²Ð°ÑÐ°",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "ÐÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ",
        colorPreviewAsImage: "ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ° Ð² Ð²Ð¸Ð´Ðµ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ñ",
        colorPreviewResizable: "ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ° Ñ Ð¸Ð·Ð¼ÐµÐ½ÑÐµÐ¼ÑÐ¼ ÑÐ°Ð·Ð¼ÐµÑÐ¾Ð¼",
        competitiveColorSearch: "Ð¡ÑÐ°Ð²Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº ÑÐ²ÐµÑÐ°",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Ð¡Ð¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        customPackageSettingsUnitGrav: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ðµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð°ÐºÐµÑÐ° gravimetric ÐµÐ´Ð¸Ð½Ð¸Ñ",
        customPackageSettingsUnitVol: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ðµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð°ÐºÐµÑÐ° volumetric ÐµÐ´Ð¸Ð½Ð¸Ñ",
        customPackageSize: "Ð¡Ð¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ ÑÐ°Ð·Ð¼ÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        customUnits: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐµ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        dropDownCalculate: "Ð Ð°Ð·Ð²ÐµÑÐ½ÑÑÑ Ð²ÑÐ¿Ð°Ð´Ð°ÑÑÐµÐµ Ð¼ÐµÐ½Ñ Ð½Ð° Ð²ÑÑÐ¾ÑÑ Ð¾ÐºÐ½Ð°",
        editColorants: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
        editColorantsAllowed: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        fandeckPanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»",
        favoriteFormulas: "ÐÐ·Ð±ÑÐ°Ð½Ð½ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        formulaColorPreview: "ÐÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ° Ð¿Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
        formulaDataSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð´Ð°Ð½Ð½ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        formulaPanel: "ÐÐ°Ð½ÐµÐ»Ñ ÑÐ¾ÑÐ¼ÑÐ»",
        formulaPanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»",
        formulaSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»",
        generateColorPreview: "Ð¡Ð³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿ÑÐµÐ²ÑÑ ÑÐ²ÐµÑÐ°",
        gravimetricOnly: "Ð¢Ð¾Ð»ÑÐºÐ¾ Ð³ÑÐ°Ð²Ð¸Ð¼ÐµÑÑÐ¸ÑÐµÑÐºÐ¸Ðµ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ñ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        imagesOnline: "ÐÑÐµÐ¶Ð´Ðµ Ð²ÑÐµÐ³Ð¾, Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð¾ÑÐºÑÑÑÑ Ð¾Ð½Ð»Ð°Ð¹Ð½-Ð¾Ð±ÑÐ°Ð·, ÐµÑÐ»Ð¸ ÑÑÐ¾ Ð½Ðµ ÑÐ´Ð°ÐµÑÑÑ, Ð¾ÑÐºÑÐ¾Ð¹ÑÐµ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÐ¹ Ð¾Ð±ÑÐ°Ð·.",
        infoPanelResizable: "ÐÐ°Ð½ÐµÐ»Ñ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸ Ñ Ð¸Ð·Ð¼ÐµÐ½ÑÐµÐ¼ÑÐ¼ ÑÐ°Ð·Ð¼ÐµÑÐ¾Ð¼",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "ÐÐ´Ð¸Ð½Ð¸ÑÐ° Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ Ð·Ð°Ð²Ð¸ÑÐ¸Ñ Ð¾Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        productFilesDialog: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð´Ð¸Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ðµ Ð¾ÐºÐ½Ð¾ Ð´Ð»Ñ Ð¾ÑÐºÑÑÑÐ¸Ñ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð³Ð¾ ÑÐ°Ð¹Ð»Ð° Ð¸Ð»Ð¸ Ð¾Ð½Ð»Ð°Ð¹Ð½-ÑÐ°Ð¹Ð»Ð°",
        productFilesLocal: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð¹Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð² Ð¸Ð· Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        productFilesOnline:
            "ÐÑÐµÐ¶Ð´Ðµ Ð²ÑÐµÐ³Ð¾, Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð¾ÑÐºÑÑÑÑ Ð¾Ð½Ð»Ð°Ð¹Ð½-ÑÐ°Ð¹Ð» Ð¿ÑÐ¾Ð´ÑÐºÑÐ°, ÐµÑÐ»Ð¸ ÑÑÐ¾ Ð½Ðµ ÑÐ´Ð°ÐµÑÑÑ, Ð¾ÑÐºÑÐ¾Ð¹ÑÐµ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÐ¹ ÑÐ°Ð¹Ð».",
        productPanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        searchPanelQuickSelect: "ÐÑÑÑÑÑÐ¹ Ð²ÑÐ±Ð¾Ñ",
        setAdditionalFormulaPanel: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ ÑÐ¾ÑÐ¼ÑÐ»",
        setCompetitiveColorSearch: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÑÐ°Ð²Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº ÑÐ²ÐµÑÐ°",
        setInitialFormulaPanel: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        setMaxToleranceForCompetitiveColors:
            "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ Ð´Ð¸Ð°Ð¿Ð°Ð·Ð¾Ð½ ÑÐ¾ÑÐ½Ð¾ÑÑÐ¸ Ð´Ð»Ñ ÑÑÐ°Ð²Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ ÑÐ²ÐµÑÐ¾Ð²Ð¾Ð³Ð¾ Ð¿Ð¾Ð¸ÑÐºÐ°",
        setNumberOfCompetitiveColors: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¿ÑÐµÐ´Ð»Ð°Ð³Ð°ÐµÐ¼ÑÑ ÑÐ²ÐµÑÐ¾Ð²",
        setSearchPanel: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ð¿Ð¾Ð¸ÑÐºÐ°",
        setVisibilityAndOrder: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑÑ Ð¸ Ð¿Ð¾ÑÑÐ´Ð¾Ðº Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸Ñ Ð´Ð°Ð½Ð½ÑÑ Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
        setVisibleUnit: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð²Ð¸Ð´Ð¸Ð¼ÑÐµ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        showColorPreview: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ ÑÐ²ÐµÑ",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²ÐºÐ° Ð¿Ð°Ð½ÐµÐ»ÐµÐ¹ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        useBase: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÑÐ»ÐµÐ¼ÐµÐ½Ñ Ð²ÑÐ±Ð¾ÑÐ° Ð´Ð»Ñ Ð±Ð°Ð·Ñ",
        useBaseInProductPackage: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÑÐ»ÐµÐ¼ÐµÐ½Ñ Ð²ÑÐ±Ð¾ÑÐ° Ð´Ð»Ñ Ð±Ð°Ð·Ñ Ð² ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐµ",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÑÐ»ÐµÐ¼ÐµÐ½Ñ Ð²ÑÐ±Ð¾ÑÐ° Ð´Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        useProductCode: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÐºÐ¾Ð´ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        useProductGroups: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð³ÑÑÐ¿Ð¿Ñ ÑÐ¾Ð²Ð°ÑÐ¾Ð²",
        volumetricOnly: "Ð¢Ð¾Ð»ÑÐºÐ¾ Ð¾Ð±ÑÐµÐ¼Ð½ÑÐµ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ"
    },
    general: {
        accepted: "Accepted",
        active: "ÐÐ¾ÑÐ»ÐµÐ´Ð½ÐµÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ",
        actual: "ÐÐ° Ð´Ð°Ð½Ð½ÑÐ¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ",
        actualLevel: "Ð¢ÐµÐºÑÑÐ¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ",
        add: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ",
        addColorant: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        addColorantForPackage: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ Ð² ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        addFile: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÑÐ°Ð¹Ð»",
        all: "ÐÑÐµ",
        amount: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        applyNow: "Apply now",
        attachments: "ÐÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ",
        automaticCorrection: "Automatic correction",
        automatically: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸",
        available: "ÐÐ¾ÑÑÑÐ¿Ð½Ð¾",
        back: "ÐÐ°Ð·Ð°Ð´",
        base: "ÐÐ°Ð·Ð°",
        baseInProductPackage: "ÐÐ°Ð·Ð° Ð² Ð¿ÑÐ¾Ð´ÑÐºÑÐµ Ð¸ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐµ",
        batchNumber: "Ð¡ÐµÑÐ¸Ð¹Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ",
        bottom: "ÐÐ¸Ð¶Ð½Ð¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ",
        buildingSite: "Building site",
        calculate: "ÐÐ¾ÑÑÐ¸ÑÐ°ÑÑ",
        can: "Ð¢Ð°ÑÐ°",
        canSize: "Ð Ð°Ð·Ð¼ÐµÑ ÑÐ°ÑÑ",
        cancel: "ÐÑÐ¼ÐµÐ½Ð°",
        canister: "ÐÐ°Ð½Ð¸ÑÑÑÐ°",
        canisterId: "ID ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        canisterIndex: "ÐÐ½Ð´ÐµÐºÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        canisters: "ÐÐ°Ð½Ð¸ÑÑÑÑ",
        cap: "ÐÑÑÑÐºÐ°",
        capacity: "ÐÐ¼ÐµÑÑÐ¸Ð¼Ð¾ÑÑÑ",
        channels: "Ð¡Ð¾Ð¿Ð»Ð°",
        choose: "ÐÑÐ±ÐµÑÐ¸ÑÐµ",
        city: "ÐÐ¾ÑÐ¾Ð´",
        clean: "Ð§Ð¸ÑÑÑÐ¹",
        clear: "ÐÑÐ¸ÑÑÐ¸ÑÑ",
        client: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        close: "ÐÐ°ÐºÑÑÑÑ",
        closeAll: "ÐÐ°ÐºÑÑÑÑ Ð²ÑÑ",
        collapseAll: "Ð¡Ð²ÐµÑÐ½ÑÑÑ Ð²ÑÑ",
        color: "Ð¦Ð²ÐµÑ",
        colorCode: "ÐÐ¾Ð´ ÑÐ²ÐµÑÐ°",
        colorFile: "Colorfile",
        colorName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ²ÐµÑÐ°",
        colorPreview: "ÐÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ°",
        colorant: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        colorantBatchNumber: "ÐÐ¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        colorantPackage: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        colorants: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
        colors: "Colors",
        company: "ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ",
        competitiveColor: "Competitive color",
        confirm: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ",
        confirmDeletion: "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÑÑÐ¾Ñ ÑÐ»ÐµÐ¼ÐµÐ½Ñ Ð½Ð°Ð²ÑÐµÐ³Ð´Ð°?",
        confirmHelpSettings: "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ ÑÐ¾ÑÐ¼Ñ Ð¸ Ð¾ÑÑÐ°Ð²Ð¸ÑÑ Ð¿Ð¾Ð»Ñ Ð¿ÑÑÑÑÐ¼Ð¸?",
        connect: "Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸ÑÑ",
        continue: "ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        correction: "Correction",
        country: "Ð¡ÑÑÐ°Ð½Ð°",
        created: "Ð¡Ð¾Ð·Ð´Ð°Ð½Ð¾",
        creationDateOf: "ÐÐ°ÑÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ",
        criticalLevel: "ÐÑÐ¸ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ",
        currency: "ÐÐ°Ð»ÑÑÐ°",
        currentBatchNumber: "Ð¢ÐµÐºÑÑÐ¸Ð¹ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸",
        currentUfiCode: "Ð¢ÐµÐºÑÑÐ¸Ð¹ UFI ÐºÐ¾Ð´",
        custom: "Ð¡Ð¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        customData: "Custom data",
        customFandeck: "ÐÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customFormula: "ÐÐ½Ð´Ð¸Ð²Ð¸Ð´ÑÐ°Ð»ÑÐ½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        customPackage: "ÐÐ»Ð¸ÐµÐ½ÑÑÐºÐ¸Ð¹",
        customPackageSettings: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ðµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        customer: "ÐÐ»Ð¸ÐµÐ½Ñ",
        customerVersion: "ÐÐµÑÑÐ¸Ñ  ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customers: "ÐÐ»Ð¸ÐµÐ½ÑÑ",
        database: "ÐÐ°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ",
        date: "ÐÐ°ÑÐ°",
        default: "ÐÐ¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
        delete: "Ð£Ð´Ð°Ð»Ð¸ÑÑ",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "ÐÐ¿Ð¸ÑÐ°Ð½Ð¸Ðµ",
        disconnect: "ÐÑÐºÐ»ÑÑÐ¸ÑÑ",
        discount: "Ð¡ÐºÐ¸Ð´ÐºÐ°",
        discover: "Ð Ð°ÑÐ¿Ð¾Ð·Ð½Ð°ÑÑ",
        dispense: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        dispensing: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        doNotShowAgain: "ÐÐµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÑÑÐ¾ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ ÑÐ½Ð¾Ð²Ð°.",
        downloadingFile: "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ°Ð¹Ð»Ñ",
        edit: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ",
        email: "Ð­Ð»ÐµÐºÑÑÐ¾Ð½Ð½Ð°Ñ Ð¿Ð¾ÑÑÐ°",
        enabled: "ÐÐºÐ»ÑÑÐµÐ½Ð¾",
        error: "ÐÑÐ¸Ð±ÐºÐ° ",
        expandAll: "Ð Ð°Ð·Ð²ÐµÑÐ½ÑÑÑ Ð²ÑÑ",
        exportData: "Ð­ÐºÑÐ¿Ð¾ÑÑ Ð´Ð°Ð½Ð½ÑÑ",
        exportPdf: "Ð­ÐºÑÐ¿Ð¾ÑÑ Ð² PDF",
        fan: "ÐÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ",
        fandeck: "ÐÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ",
        fandeckCode: "Fandeck code",
        fandeckName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸",
        fandecks: "ÐÐ°ÑÐ°Ð»Ð¾Ð³",
        favorite: "ÐÐ·Ð±ÑÐ°Ð½Ð½Ð¾Ðµ",
        fileTransfer: "ÐÐµÑÐµÐ´Ð°ÑÐ° ÑÐ°Ð¹Ð»Ð¾Ð²",
        filling: "ÐÐ°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ",
        fillingDate: "ÐÐ°ÑÐ° Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
        find: "ÐÐ°Ð¹ÑÐ¸",
        finish: "ÐÐ°Ð²ÐµÑÑÐ¸ÑÑ",
        finishedCorrection: "Finished correction",
        formula: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°",
        formulas: "Formulas",
        frontdesk: "Ð¡ÑÐ¾Ð¹ÐºÐ° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸",
        getQrCode: "ÐÐ¾Ð»ÑÑÐ¸ÑÑ QR ÐºÐ¾Ð´",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "ÐÑÑÐ¾ÑÐ¸Ñ",
        hours: "Ð§Ð°ÑÑ",
        id: "ID",
        images: "ÐÐ·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ñ",
        in: "Ð",
        index: "ÐÐ½Ð´ÐµÐºÑ",
        insertBarcode: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÑÐ°Ð²ÑÑÐµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´",
        install: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ",
        installed: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾",
        instructions: "ÐÐ½ÑÑÑÑÐºÑÐ¸Ð¸",
        internalNote: "ÐÐ½ÑÑÑÐµÐ½Ð½ÑÑ Ð·Ð°Ð¼ÐµÑÐºÐ°",
        interval: "ÐÐ½ÑÐµÑÐ²Ð°Ð»",
        ip: "IP Ð°Ð´ÑÐµÑ",
        itemNumber: "ÐÑÐµÐ´Ð¼ÐµÑ Ð½Ð¾Ð¼ÐµÑ.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "ÐÐ¸Ð¼Ð¸Ñ",
        load: "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ",
        loadFormula: "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        localVersion: "ÐÐ¾ÐºÐ°Ð»ÑÐ½Ð°Ñ Ð²ÐµÑÑÐ¸Ñ",
        machine: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ",
        manualCorrection: "Manual correction",
        manually: "ÐÑÑÑÐ½ÑÑ",
        margin: "ÐÐ°ÑÐ¶Ð°",
        markup: "ÐÐ°ÑÐµÐ½ÐºÐ°",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ ÑÑÐ¾Ð²ÐµÐ½Ñ",
        maxValue: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ",
        maximum: "ÐÐ°ÐºÑÐ¸Ð¼ÑÐ¼",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "ÐÐ¸Ð½Ð¸Ð¼ÑÐ¼",
        minutes: "ÐÐ¸Ð½.",
        missingItem: "ÐÑÑÑÑÑÑÐ²ÑÑÑÐ¸Ð¹ ÑÐ»ÐµÐ¼ÐµÐ½Ñ",
        missingRequiredItems: "ÐÑÐµ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼ÑÐµ Ð¿ÑÐ½ÐºÑÑ (Ð¾ÑÐ¼ÐµÑÐµÐ½Ð½ÑÐµ Ð·Ð²ÐµÐ·Ð´Ð¾ÑÐºÐ¾Ð¹) Ð´Ð¾Ð»Ð¶Ð½Ñ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "ÐÐ¾Ð»ÑÑÐµ",
        moreInfo: "ÐÐ¾Ð»ÑÑÐµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸",
        moveDown: "ÐÐ½Ð¸Ð·",
        moveUp: "ÐÐ²ÐµÑÑ",
        myOrders: "ÐÐ¾Ð¸ Ð·Ð°ÐºÐ°Ð·Ñ",
        name: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ",
        nameTitle: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ",
        new: "ÐÐ¾Ð²ÑÐ¹",
        next: "Ð¡Ð»ÐµÐ´ÑÑÑÐ¸Ð¹",
        no: "ÐÐµÑ",
        noColorantsAvailable: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ Ð¾ÑÑÑÑÑÑÐ²ÑÑÑ",
        noFormulas: "Ð¤Ð¾ÑÐ¼ÑÐ» Ð¿Ð¾ÐºÐ° Ð½ÐµÑ",
        noPricesAvailable: "Ð¦ÐµÐ½Ñ Ð¾ÑÑÑÑÑÑÐ²ÑÑÑ",
        nominalAmount: "ÐÐ¾Ð¼Ð¸Ð½Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        notAvailable: "ÐÐµÑ Ð² Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸",
        note: "ÐÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ðµ",
        numberOfCanisters: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ°Ð½Ð¸ÑÑÑ",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÑÑÐ¸ÐºÐµÑÐ¾Ðº",
        numberOfPackages: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº",
        off: "ÐÑÐºÐ»ÑÑÐµÐ½",
        ok: "ÐÐ",
        on: "ÐÐºÐ»ÑÑÐµÐ½",
        onFocus: "Ð ÑÐ¾ÐºÑÑÐµ",
        open: "ÐÑÐºÑÑÑÑ",
        operator: "Operator",
        options: "ÐÐ¿ÑÐ¸Ð¸",
        order: "Order",
        other: "ÐÑÑÐ³Ð¸Ðµ",
        otherError: "ÐÑÑÐ³Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°",
        out: "ÐÐ·",
        overwrite: "Overwrite",
        package: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        packagePreview: "ÐÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        partialUpdates: "Partial updates",
        phone: "Ð¢ÐµÐ»ÐµÑÐ¾Ð½",
        pleaseWait: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        previous: "ÐÑÐµÐ´ÑÐ´ÑÑÐ¸Ð¹",
        price: "Ð¦ÐµÐ½Ð°",
        priceGroup: "Ð¦ÐµÐ½Ð¾Ð²Ð°Ñ Ð³ÑÑÐ¿Ð¿Ð°",
        print: "ÐÐµÑÐ°ÑÑ",
        printTask: "ÐÐ°Ð´Ð°Ð½Ð¸Ðµ Ð½Ð° Ð¿ÐµÑÐ°ÑÑ",
        processingStep: "Processing %{step}",
        product: "ÐÑÐ¾Ð´ÑÐºÑ",
        productCode: "ÐÐ¾Ð´ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        productName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        products: "ÐÑÐ¾Ð´ÑÐºÑÑ",
        pump1: "ÐÐ°ÑÐ¾Ñ 1",
        pump2: "ÐÐ°ÑÐ¾Ñ 2",
        purchasePrice: "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð°",
        purge: "ÐÑÐ¾Ð´ÑÐ²ÐºÐ°",
        qualityControl: "Quality control",
        quantity: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        quantityQty: "QTY",
        quickTint: "ÐÑÑÑÑÐ¾Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        rccIsNotAvailable: "RCC Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½",
        rccIsNotConnected: "RCC Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½",
        rccNotLicensed: "RCC Ð½Ðµ Ð»Ð¸ÑÐµÐ½Ð·Ð¸ÑÐ¾Ð²Ð°Ð½",
        reconnect: "ÐÐµÑÐµÐ¿Ð¾Ð´ÐºÐ»ÑÑÐ¸ÑÑÑÑ",
        refill: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÑ",
        refillManualLevelCorrection: "Ð ÑÑÐ½Ð°Ñ ÐºÐ¾ÑÑÐµÐºÑÐ¸Ñ",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Ð¡Ð±ÑÐ¾Ñ",
        restart: "ÐÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÑ",
        restore: "ÐÐ¾ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ",
        retint: "Retint",
        revision: "ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ",
        safetySheet: "ÐÐ°ÑÐ¿Ð¾ÑÑ Ð±ÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÐ¸",
        save: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ",
        saveAs: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ ÐºÐ°Ðº",
        saveToDispensingHistory: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð² Ð¸ÑÑÐ¾ÑÐ¸Ð¸",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "CÐµÐº.",
        select: "Select",
        selectAll: "ÐÑÐ±ÑÐ°ÑÑ Ð²ÑÐµ",
        selectChannels: "ÐÑÐ±ÑÐ°ÑÑ ÑÐ¾Ð¿Ð»Ð°",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸",
        settings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        shelf: "ÐÐ¾Ð»ÐºÐ°",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Ð Ð°Ð·Ð¼ÐµÑ",
        skip: "ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ",
        smartPurge: "ÐÐ½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ",
        standardFormula: "Ð¡ÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        status: "Ð¡ÑÐ°ÑÑÑ",
        street: "Ð£Ð»Ð¸ÑÐ°",
        sum: "Ð¡ÑÐ¼Ð¼Ð°",
        summary: "Ð¡ÑÐ¼Ð¼Ð°",
        sync: "Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ",
        technicalSheet: "Ð¢ÐµÑÐ½Ð¸ÑÐµÑÐºÐ¾Ðµ Ð¾Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ",
        templates: "Ð¨Ð°Ð±Ð»Ð¾Ð½Ñ",
        threshold: "ÐÐ¾ÑÐ¾Ð³",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        top: "ÐÐµÑÑÐ½ÑÑ ÑÑÑÐ¾ÐºÐ°",
        total: "ÐÑÐ¾Ð³Ð¾",
        totalAmount: "ÐÑÐ¾Ð³Ð¾",
        totalBaseAmount: "ÐÑÐ¾Ð³Ð¾",
        totalColorantAmount: "ÐÑÐ¾Ð³Ð¾",
        type: "Ð¢Ð¸Ð¿",
        ufiCode: "UFI ÐºÐ¾Ð´",
        ufiThreshold: "UFI Ð¿Ð¾ÑÐ¾Ð³Ð¾Ð²Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "ÐÐ´ÐµÐ½Ð¸ÑÐ°",
        units: "ÐÐ´Ð¸Ð½Ð¸ÑÑ",
        unknown: "Unknown",
        update: "ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ",
        updated: "ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾",
        user: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        value: "ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ",
        vat: "ÐÐÐ¡",
        verified: "Verified",
        version: "ÐÐµÑÑÐ¸Ñ",
        versionId: "ID Ð²ÐµÑÑÐ¸Ð¸",
        versionStructure: "Ð¡ÑÑÑÐºÑÑÑÐ° Ð²ÐµÑÑÐ¸Ð¸",
        volumetric: "ÐÐ±ÑÐµÐ¼Ð½ÑÐ¹",
        warning: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ",
        warningLevel: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÑÑÐ¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ",
        withoutName: "(Ð±ÐµÐ· Ð¸Ð¼ÐµÐ½Ð¸)",
        workingProperly: "Working properly",
        yes: "ÐÐ°",
        zoom: "Ð£Ð²ÐµÐ»Ð¸ÑÐ¸ÑÑ"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ %{name} Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð´Ð»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° ÑÐµÑÐºÐ¸ Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ÐÐ¿ÐµÑÐ°ÑÐ¾ÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÑÑÐ½ÑÑ ÑÐ½ÑÑÑ, Ð¾ÑÐ¸ÑÑÐ¸ÑÑ Ð¸ Ð²ÐµÑÐ½ÑÑÑ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð´Ð»Ñ ÑÐµÑÐºÐ¸ ",
            capMaintenance:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ %{name}  Ð·Ð°Ð¿ÑÐ¾ÑÐ¸Ð» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð´Ð»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸ ÐºÑÑÑÐºÐ¸ Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ÐÐ¿ÐµÑÐ°ÑÐ¾ÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¾ÑÐ¸ÑÑÐ¸ÑÑ Ð°Ð²ÑÐ¾ÐºÐ¾Ð»Ð¿Ð°ÑÐ¾Ðº Ð²ÑÑÑÐ½ÑÑ Ð¿Ð¾ÑÐ»Ðµ ÐµÐ³Ð¾ Ð¾ÑÐºÑÑÑÐ¸Ñ ",
            cleanAll:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐµ Ð²ÑÐµÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            cleanChannels:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð¾ÑÐ¸ÑÑÐºÐµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½ÑÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ",
            computerReboot:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð´Ð»Ñ ÑÑÐ¾Ð¹ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ Ð·Ð°Ð´Ð°ÑÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÑ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ° Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            computerShutdown:
                "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð´Ð»Ñ ÑÑÐ¾Ð¹ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ Ð·Ð°Ð´Ð°ÑÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ðµ Ð²ÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ° Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            dispenserCleaning:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ %{name} Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð´Ð»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ÐÐ¿ÐµÑÐ°ÑÐ¾ÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÑÑÐ½ÑÑ Ð¿ÑÐ¾ÑÐµÑÐµÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ ÑÐºÐ°Ð½ÑÑ ",
            humidifierWaterLevelMaintenance:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ %{name} Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¼Ñ Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÑÐ²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»Ñ Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ÐÐ¿ÐµÑÐ°ÑÐ¾ÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ Ð¸ Ð´Ð¾Ð»Ð¸ÑÑ Ð²Ð¾Ð´Ñ Ð² ÑÐ²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»Ñ Ð²ÑÑÑÐ½ÑÑ ",
            purgeAll:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐµ Ð²ÑÐµÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            purgeChannels:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð¾ÑÐ¸ÑÑÐºÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½ÑÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            recirculateAll:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ð¸ Ð²ÑÐµÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            recirculateChannels:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ð¸ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½ÑÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            refillAll:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ %{name} Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð´Ð»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ Ð²ÑÐµÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ. ÐÐ¿ÐµÑÐ°ÑÐ¾ÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÑÑÐ½ÑÑ Ð·Ð°Ð¿ÑÐ°Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ Ð²Ð¾ Ð²ÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ.",
            refillCanisters:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ %{name} Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð´Ð»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½ÑÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ. ÐÐ¿ÐµÑÐ°ÑÐ¾ÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÑÑÐ½ÑÑ Ð´Ð¾Ð»Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ Ð² ÐºÐ°Ð½Ð¸ÑÑÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ðµ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²ÑÑÑ ÐºÑÐ¸ÑÐµÑÐ¸Ñ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ.",
            smartPurgeAll:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð¸Ð½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐµ Ð²ÑÐµÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ÐÑÐ¸ÑÑÐºÐ° Ð±ÑÐ´ÐµÑ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÑÑÑÑ, ÐµÑÐ»Ð¸ Ð½Ðµ Ð±ÑÐ´ÑÑ ÑÐ¾Ð±Ð»ÑÐ´ÐµÐ½Ñ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¸Ð½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸ ",
            smartPurgeChannels:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð¸Ð½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½ÑÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ÐÑÐ¸ÑÑÐºÐ° Ð±ÑÐ´ÐµÑ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÑÑÑÑ, ÐµÑÐ»Ð¸ Ð½Ðµ Ð±ÑÐ´ÑÑ ÑÐ¾Ð±Ð»ÑÐ´ÐµÐ½Ñ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¸Ð½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸ ",
            stirAll:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð·Ð°Ð¿ÑÐ¾Ñ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð´Ð»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ñ Ð²ÑÐµÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            stirCanisters:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐ» Ð·Ð°Ð¿ÑÐ¾Ñ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð´Ð»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½ÑÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ",
            switchPlateMaintenance:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð·Ð°Ð´Ð°ÑÑ, ÑÑÐ¾Ð±Ñ %{name} Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð¿Ð¾ Ð¾ÑÐ¸ÑÑÐºÐµ Ð¿Ð»Ð°ÑÑÐ¸Ð½Ñ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ ÐÐ¿ÐµÑÐ°ÑÐ¾ÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÑÑÐ½ÑÑ ÑÐ½ÑÑÑ, Ð¾ÑÐ¸ÑÑÐ¸ÑÑ Ð¸ Ð²ÐµÑÐ½ÑÑÑ Ð¿Ð»Ð°ÑÑÐ¸Ð½Ñ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ "
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "ÐÑÐµÐ¾Ð±Ð»Ð°Ð´Ð°ÑÑÐ¸Ð¹ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸ Ñ ÑÑÐµÑÐ¾Ð¼ ÐµÐ³Ð¾ ÑÐ°ÐºÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð° Ð² ÐºÐ°Ð½Ð¸ÑÑÑÐµ. ÐÐµÑÐµÐ¹Ð´Ð¸ÑÐµ Ðº Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ð¼ Ð½Ð°ÐºÐ¾Ð¿Ð¸ÑÐµÐ»Ñ, ÑÑÐ¾Ð±Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ Ð¿Ð¾ÑÐ¾Ð³Ð¾Ð²Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ Ð½Ð°ÐºÐ¾Ð¿Ð¸ÑÐµÐ»Ñ.",
            batchNumberFromLastFilling:
                "ÐÑÐ´Ð°Ð½Ð½Ð°Ñ Ð¾Ð¿ÐµÑÐ°ÑÐ¾ÑÐ¾Ð¼ Ð¿Ð°ÑÑÐ¸Ñ Ñ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ¹ Ð·Ð°Ð¿ÑÐ°Ð²ÐºÐ¸ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸ Ð²Ð½Ðµ Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÐ¸ Ð¾Ñ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð° Ð·Ð°Ð¿ÑÐ°Ð²ÐºÐ¸.",
            enableBatchNumber: "ÐÑÐ»Ð¸ ÑÑÐ° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð²ÐºÐ»ÑÑÐµÐ½Ð°, Ð¾ÑÑÐ»ÐµÐ¶Ð¸Ð²Ð°ÑÑÑÑ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾ Ð·Ð°Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð½ÑÐµ Ð¿Ð°ÑÑÐ¸Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°."
        },
        connection: {
            add: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²ÑÐ¹ ÑÐµÑÐ²ÐµÑ Ð²ÑÑÑÐ½ÑÑ, ÐµÑÐ»Ð¸ Ð¾Ð½ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¾Ð±Ð½Ð°ÑÑÐ¶ÐµÐ½ Ñ Ð¿Ð¾Ð¼Ð¾ÑÑÑ ÑÑÐ½ÐºÑÐ¸Ð¸ Â«ÐÐ±Ð½Ð°ÑÑÐ¶ÐµÐ½Ð¸ÐµÂ» ",
            clientIdentifier:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÑÐ¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°, ÐµÑÐ»Ð¸ Ðº Ð¾Ð´Ð½Ð¾Ð¼Ñ ÑÐµÑÐ²ÐµÑÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¾ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð² ",
            disconnect:
                "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐµÐºÑÑÐµÐ¼ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÐ¼Ð¾Ð¼ ÑÐµÑÐ²ÐµÑÐµ ÐÐ½Ð¾Ð¿ÐºÐ° Ð¾ÑÐºÐ»ÑÑÐµÐ½Ð¸Ñ Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¿Ð¾ÐºÐ¸Ð½ÑÑÑ ÑÑÐ¾Ñ ÑÐµÑÐ²ÐµÑ Ð¸ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ¸ÑÑÑÑ Ð½Ð° Ð´ÑÑÐ³Ð¾Ð¹, ÐµÑÐ»Ð¸ Ð¾Ð½ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ ",
            discover: "ÐÐ±Ð½Ð°ÑÑÐ¶Ð¸Ð²Ð°ÐµÑ, ÐµÑÑÑ Ð»Ð¸ Ð² ÑÐµÑÐ¸ ÐºÐ°ÐºÐ¸Ðµ-Ð»Ð¸Ð±Ð¾ Ð´ÑÑÐ³Ð¸Ðµ ÑÐµÑÐ²ÐµÑÑ ",
            dropServers: "Ð£Ð´Ð°Ð»ÑÐµÑ Ð²ÑÐµ ÑÐ°Ð½ÐµÐµ Ð¾Ð±Ð½Ð°ÑÑÐ¶ÐµÐ½Ð½ÑÐµ ÑÐµÑÐ²ÐµÑÑ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ° ",
            dropServersNotAvailable: "Ð¡ÐµÑÐ²ÐµÑ Ð½Ðµ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½",
            edit: "ÐÐ¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð²ÑÑÑÐ½ÑÑ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¶Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ð½ÑÐ¹ ÑÐµÑÐ²ÐµÑ ",
            editDisabled: "Ð¡ÐµÑÐ²ÐµÑ Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð½ "
        },
        continue: "ÐÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ?",
        driverSettings: {
            alfaRestApi: {
                host: "ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð¸Ð¼Ñ ÑÐ¾ÑÑÐ° Ð¸Ð»Ð¸ IP-Ð°Ð´ÑÐµÑ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
                machineType: "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¼Ð°ÑÐ¸Ð½ ÐÐ»ÑÑÐ° ÐÐ°Ðº Ð´Ð»Ñ Windows, ÑÐ°Ðº Ð¸ Ð´Ð»Ñ Linux"
            },
            corobDsProxy: {
                machineType:
                    "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ð¹ Slave (D200, D600), 4G (ÐÐµÑÐ²ÑÐ¹) Ð¸ 5G (EvoFlx) ÐÐ¾Ð»Ð¶Ð½Ð° Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð° DspProxy Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Windows"
            },
            corobEvoDriver: {
                machineType:
                    "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ñ 5G (EvoFlx) EVOservice Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ ÐÐ°Ðº Ð´Ð»Ñ Windows, ÑÐ°Ðº Ð¸ Ð´Ð»Ñ Linux"
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ°Ð¹Ð» ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°  Ð£ÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
                hldRootDir: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð³Ð»Ð°Ð²Ð½ÑÑ Ð¿Ð°Ð¿ÐºÑ HLD Ð£ÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
                machineType:
                    "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Corob Flex (500, 520, 540) = Ð±ÑÐ²ÑÐ¸Ð¹ Lenteq HLD Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Windows"
            },
            corobNextDriver: {
                machineType:
                    "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ð¹ Slave (D200, D600), 4G (ÐÐµÑÐ²ÑÐ¹) Ð¸ 5G (EvoFlx) ÐÐ¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ NextDriver Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Linux"
            },
            dromontDDrv: {
                databasePath: "ÐÑÑÑ Ðº ÑÐ°Ð¹Ð»Ñ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ñ Ð´Ð°Ð½Ð½ÑÐ¼Ð¸ ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÐ¸ ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð°Ñ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
                driverPath: "ÐÑÑÑ Ðº Ð´ÑÐ°Ð¹Ð²ÐµÑÑ (D_DRVexe) ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð°Ñ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
                machineType:
                    "ÐÐ¾ÑÐ²ÐµÐ½Ð½Ð°Ñ ÑÐ²ÑÐ·Ñ Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ¾Ð¼ Ð¿Ð¾ Ð½Ð°ÑÑÑÐ¾ÐµÐ½Ð½ÑÐ¼ Ð´Ð»Ñ ÑÑÐ¾Ð³Ð¾ ÐºÐ°Ð½Ð°Ð»Ð°Ð¼ ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ð¹ V1 Ð¸ V2 D_SET Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ ÐÐ°Ðº Ð´Ð»Ñ Windows, ÑÐ°Ðº Ð¸ Ð´Ð»Ñ Linux",
                resultPath: "ÐÑÑÑ Ðº ÑÐ°Ð¹Ð»Ñ ÑÐµÐ·ÑÐ»ÑÑÐ°ÑÐ°, ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ð¼Ñ Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¸Ñ Ð¾Ð¿ÐµÑÐ°ÑÐ¸Ð¸ ÐÐ°Ð´Ð°Ð½Ð½ÑÐ¹ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
                serviceSoftwarePath:
                    "ÐÑÑÑ Ðº ÑÐµÑÐ²Ð¸ÑÐ½Ð¾Ð¼Ñ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð¼Ñ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Dromont (D_SETexe) ÐÑÐµÐ´ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½Ð°Ñ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ"
            },
            dromontDirect: {
                machineType:
                    "ÐÑÑÐ¼Ð°Ñ ÑÐ²ÑÐ·Ñ Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ¾Ð¼ ÐÐµÐ¹ÑÑÐ²ÑÐµÑ Ð½Ð° Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸ÑÑ V1 Ð¸ V2 D_SET Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ ÐÐ°Ðº Ð´Ð»Ñ Windows, ÑÐ°Ðº Ð¸ Ð´Ð»Ñ Linux",
                rootDir: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð³Ð»Ð°Ð²Ð½ÑÑ Ð¿Ð°Ð¿ÐºÑ Dromont"
            },
            dromontMisura: {
                driverPath:
                    "ÐÑÑÑ Ðº Ð´ÑÐ°Ð¹Ð²ÐµÑÑ (MisuraRetailexe) Ð¼Ð¾Ð¶ÐµÑ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑÑÑ Ð² Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÐ¸ Ð¾Ñ Ð²ÐµÑÑÐ¸Ð¸ Misura Retail ÐÑÐµÐ´ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
                extensionPath: "ÐÑÑÑ Ðº ÑÐ°Ð¹Ð»Ñ ÐºÐ¾Ð¼Ð¼ÑÐ½Ð¸ÐºÐ°ÑÐ¸Ð¸ Ð´Ð»Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÑÐµÑÐ²Ð¸ÑÐ½ÑÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹",
                formulaPath: "ÐÑÑÑ Ðº ÑÐ°Ð¹Ð»Ñ ÐºÐ¾Ð¼Ð¼ÑÐ½Ð¸ÐºÐ°ÑÐ¸Ð¸ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
                machineType: "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ñ V3 ÐÑÐ¾Ð¼Ð¾Ð½ ÐÐ¸ÑÑÑÐ° Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Windows"
            },
            fastAndFluidIDD: {
                machineType: "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¼Ð°ÑÐ¸Ð½ F&F Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Windows",
                path: "ÐÐ¾Ð´Ð´ÐµÑÐ¶Ð¸Ð²Ð°ÑÑÑÑ IDD2 (HA 450, HA 650, X-smart Ð¸ ÑÐ´) - Ð´Ð¾Ð»Ð¶Ð½Ñ Ð±ÑÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ñ, IDD3 (HP 500 Ð¸ ÑÐ´), IDD4 (HA 180, HA 480, HA 680, Xprotint Ð¸ ÑÐ´)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¼Ð°ÑÐ¸Ð½ F&F ÐÐ°Ðº Ð´Ð»Ñ Windows, ÑÐ°Ðº Ð¸ Ð´Ð»Ñ Linux",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¼Ð°ÑÐ¸Ð½ HERO Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Windows"
            },
            italtinto: {
                machineType:
                    "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¼Ð°ÑÐ¸Ð½ Italtinto Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Windows Ð´Ð¾Ð»Ð¶Ð½Ñ Ð±ÑÑÑWcal Ð¸Ð»Ð¸ ItaltintoCal",
                path: "ÐÑÑÑ Ðº Ð½Ð°ÑÑÑÐ¾ÐµÐ½Ð½Ð¾Ð¼Ñ ÑÐ°Ð¹Ð»Ñ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸ Italtinto"
            },
            manualAdvanced: {
                machineType: "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð²ÑÐµÑ ÑÑÑÐ½ÑÑ Ð¼Ð°ÑÐ¸Ð½, Ð¿Ð¾Ð´Ð´ÐµÑÐ¶ÐºÐ° ÐºÐ°Ð½Ð¸ÑÑÑ Ð²ÐºÐ»ÑÑÐµÐ½Ð° Windows, Ð° ÑÐ°ÐºÐ¶Ðµ Linux",
                path: "ÐÑÑÑ Ðº ÑÐ°Ð¹Ð»Ñ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸ Ñ Ð´Ð°Ð½Ð½ÑÐ¼Ð¸ Ð¾ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐµ Ð¸ ÐºÐ°Ð½Ð¸ÑÑÑÐ°Ñ"
            },
            manualSimple: {
                machineType: "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð²ÑÐµÑ ÑÑÑÐ½ÑÑ Ð¼Ð°ÑÐ¸Ð½ ÐÐ°Ðº Windows, ÑÐ°Ðº Ð¸ Linux",
                path: "ÐÑÑÑ Ðº ÑÐ°Ð¹Ð»Ñ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸ Ñ Ð´Ð°Ð½Ð½ÑÐ¼Ð¸ Ð¾ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐµ"
            },
            none: {
                machineType: "ÐÑÐ°Ð¹Ð²ÐµÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð½"
            },
            santintColorLink3: {
                machineType: "ÐÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¼Ð°ÑÐ¸Ð½ SANTINT. Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Windows"
            },
            simulation: {
                machineType: "ÐÐ¾Ð´ÑÐ¾Ð´Ð¸Ñ Ð´Ð»Ñ Ð¸Ð¼Ð¸ÑÐ°ÑÐ¸Ð¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°, ÐµÑÐ»Ð¸ Ðº ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÑ Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½ Ð½Ð°ÑÑÐ¾ÑÑÐ¸Ð¹ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ",
                path: "ÐÑÑÑ Ðº ÑÐ°Ð¹Ð»Ñ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ, ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¾Ð²Ð°ÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½Ð¾Ð¹ Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ"
            },
            udcp: {
                machineType: "UDCP ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾"
            }
        },
        environment: {
            activeServerPlugins: "ÐÐ±Ð·Ð¾Ñ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÑ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½ÑÑ Ð¿Ð»Ð°Ð³Ð¸Ð½Ð¾Ð²",
            allowAutoCloseTab:
                "ÐÑÐ»Ð¸ ÑÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð²ÐºÐ»ÑÑÐµÐ½, ÐºÐ°Ð¶Ð´Ð°Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ° Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð¾Ð¹ Ð±ÑÐ´ÐµÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð·Ð°ÐºÑÑÑÐ° Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¸Ñ Ð¿ÑÐ¾ÑÐµÑÑÐ° Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            allowAutomaticClientStart:
                "ÐÑÐ»Ð¸ ÑÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð²ÐºÐ»ÑÑÐµÐ½, %{name} Ð±ÑÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐºÐ°ÑÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð¿ÑÑÐºÐ° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
            allowAutomaticPrint:
                "Ð­ÑÐ¸ÐºÐµÑÐºÐ° Ð±ÑÐ´ÐµÑ ÑÐ°ÑÐ¿ÐµÑÐ°ÑÐ°Ð½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸, ÑÑÐµÐ±ÑÐµÑÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¾Ð² Ð¿ÐµÑÐ°ÑÐ¸ Ð¿ÐµÑÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼, Ð¿Ð¾ÑÐ»Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð¸Ð»Ð¸ Ð² Ð¾Ð±Ð¾Ð¸Ñ ÑÐ»ÑÑÐ°ÑÑ",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "Ð Ð°Ð·Ð´ÐµÐ» 'ÐÐ»Ð¸ÐµÐ½ÑÑ' Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»",
            allowDispensing: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð±ÑÐ´ÐµÑ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð° ÐºÐ½Ð¾Ð¿ÐºÐ° 'ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ'",
            allowFileTransfer:
                "ÐÑÐ»Ð¸ ÑÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð²ÐºÐ»ÑÑÐµÐ½, Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ Ð¸Ð¼Ð¿Ð¾ÑÑ Ð¸ ÑÐºÑÐ¿Ð¾ÑÑ Ð´Ð°Ð½Ð½ÑÑ Ð¿ÑÑÐµÐ¼ Ð¿ÐµÑÐµÐ´Ð°ÑÐ¸ ÑÐ°Ð¹Ð»Ð¾Ð².",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð°ÐºÑÐ¸Ð²Ð¸ÑÑÐµÑÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ñ.",
            allowLight: "%{name} Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾",
            allowOrdering: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð±ÑÐ´ÐµÑ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð° ÐºÐ½Ð¾Ð¿ÐºÐ° 'ÐÐ°ÐºÐ°Ð·'",
            allowPricing:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¤Ð¾ÑÐ¼ÑÐ»Ñ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÑÐµÐ½Ñ. ÐÐ¸Ð´Ð¸Ð¼Ð¾ÑÑÑ ÑÐµÐ½ ÑÐºÐ°Ð·Ð°Ð½Ð° Ð² ÑÐ°Ð·Ð´ÐµÐ»Ðµ: 'ÐÐ¾ÑÑÑÐ¿Ð½ÑÐµ ÑÐµÐ½Ñ' Ð¦ÐµÐ½Ñ ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÑÑÑÑ Ð² ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ ÑÐµÐ½.",
            allowProductPreviewImage: "ÐÐ·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾ Ð±ÑÐ´ÐµÑ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð¾ Ð²Ð¾ Ð²ÑÐµÐ¼Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð° ÑÑÐ½ÐºÑÐ¸Ñ Ð¿Ð¾Ð¸ÑÐºÐ° Ð±Ð¾Ð»ÐµÐµ Ð´ÐµÑÐµÐ²ÑÑ ÑÐ²ÐµÑÐ¾Ð².",
            allowSoundNotification: "ÐÐ²ÑÐºÐ¾Ð²Ð¾Ðµ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð·Ð°ÐºÐ°Ð·Ðµ Ð²Ð¾ÑÐ¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸Ñ Ð¼ÐµÐ»Ð¾Ð´Ð¸Ñ Ð¿ÑÐ¸ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ð¸ Ð·Ð°ÐºÐ°Ð·Ð°",
            allowSpectro: "Ð Ð°Ð·Ð´ÐµÐ» ÑÐ¿ÐµÐºÑÑÐ¾ÑÐºÐ¾Ð¿Ð¸Ð¸ Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½",
            allowTabs: "ÐÑÐ»Ð¸ ÑÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð²ÐºÐ»ÑÑÐµÐ½, Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð° Ð¾Ð´Ð½Ð¾Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð°Ñ ÑÐ°Ð±Ð¾ÑÐ° Ñ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ð¼Ð¸ Ð²ÐºÐ»Ð°Ð´ÐºÐ°Ð¼Ð¸",
            applyZoom: "ÐÑÐ¼ ÑÐ²ÐµÐ»Ð¸ÑÐ¸Ð²Ð°ÐµÑ Ð¸Ð»Ð¸ ÑÐ¼ÐµÐ½ÑÑÐ°ÐµÑ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸Ðµ. Ð¡Ð¾ÑÐµÑÐ°Ð½Ð¸Ñ ÐºÐ»Ð°Ð²Ð¸Ñ CTRL + Ð¸ CTRL - ÑÐ°ÐºÐ¶Ðµ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸Ð¼Ñ.",
            automaticLogout: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ, ÑÐµÑÐµÐ· ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼Ð¸Ð½ÑÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ Ð²ÑÑÐ¾Ð´ Ð¸Ð· ÑÐ¸ÑÑÐµÐ¼Ñ.",
            availableDatabases: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÑÑ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÑÑÑ Ð¼ÐµÐ¶Ð´Ñ Ð±Ð°Ð·Ð°Ð¼Ð¸ Ð´Ð°Ð½Ð½ÑÑ, ÐµÑÐ»Ð¸ Ð¸Ñ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Ð¡Ð¸ÑÑÐµÐ¼Ð° ÑÐµÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð¾Ð² ÑÐ»ÑÐ¶Ð¸Ñ Ð´Ð»Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÐºÐ¾ÑÑÐµÐºÑÐ½Ð¾ÑÑÐ¸ ÑÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð½Ð¾Ð³Ð¾ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð° Ð¿ÑÑÐµÐ¼ ÑÑÐ°Ð²Ð½ÐµÐ½Ð¸Ñ ÐµÐ³Ð¾ ÑÐ¾ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð°Ð¼Ð¸, Ð²Ð½ÐµÑÐµÐ½Ð½ÑÐ¼Ð¸ Ð² Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
            customBanner: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÐ²Ð¾Ð¹ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿ Ð¸Ð»Ð¸ Ð±Ð°Ð½Ð½ÐµÑ Ð¸ ÐµÐ³Ð¾ ÑÐ°ÑÐ¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ",
            customCurrencyFormat:
                "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ð¹ ÑÐ¾ÑÐ¼Ð°Ñ Ð²Ð°Ð»ÑÑÑ Ð¼Ð¾Ð¶ÐµÑ Ð¿ÐµÑÐµÐ¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ ÑÐ¾ÑÐ¼Ð°Ñ Ð²Ð°Ð»ÑÑÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð² Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÐ¸ Ð¾Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÑÐ·ÑÐºÐ°.",
            customDateFormat:
                "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ð¹ ÑÐ¾ÑÐ¼Ð°Ñ Ð´Ð°ÑÑ Ð¼Ð¾Ð¶ÐµÑ Ð¿ÐµÑÐµÐ¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ ÑÐ¾ÑÐ¼Ð°Ñ Ð´Ð°ÑÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð² Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÐ¸ Ð¾Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÑÐ·ÑÐºÐ°.",
            customNumberFormat:
                "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ð¹ ÑÐ¸ÑÐ»Ð¾Ð²Ð¾Ð¹ ÑÐ¾ÑÐ¼Ð°Ñ Ð¼Ð¾Ð¶ÐµÑ Ð¿ÐµÑÐµÐ¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ ÑÐ¸ÑÐ»Ð¾Ð²Ð¾Ð¹ ÑÐ¾ÑÐ¼Ð°Ñ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð² Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÐ¸ Ð¾Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÑÐ·ÑÐºÐ°.",
            customTimeFormat:
                "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ð¹ ÑÐ¾ÑÐ¼Ð°Ñ Ð²ÑÐµÐ¼ÐµÐ½Ð¸ Ð¼Ð¾Ð¶ÐµÑ Ð¿ÐµÑÐµÐ¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ ÑÐ¾ÑÐ¼Ð°Ñ Ð²ÑÐµÐ¼ÐµÐ½Ð¸ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð² Ð·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ÑÑÐ¸ Ð¾Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÑÐ·ÑÐºÐ°.",
            defaultPrinter:
                "ÐÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ Ð¿ÑÐ¸Ð½ÑÐµÑ Ð±ÑÐ´ÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑÑÑ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸ ÑÑÐ¸ÐºÐµÑÐ¾Ðº, Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ ÐµÐ³Ð¾ Ð¼Ð¾Ð¶Ð½Ð¾ Ð² Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ°Ñ Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
            defaultTemplate:
                "ÐÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ ÑÐ°Ð±Ð»Ð¾Ð½ Ð±ÑÐ´ÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑÑÑ Ð¿ÑÐ¸ Ð¿ÐµÑÐ°ÑÐ¸ ÑÑÐ¸ÐºÐµÑÐ¾Ðº, Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ ÐµÐ³Ð¾ Ð¼Ð¾Ð¶Ð½Ð¾ Ð² Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ°Ñ Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
            deleteImportedData:
                "Ð£Ð´Ð°Ð»ÑÐµÑ ÑÐ°Ð½ÐµÐµ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ. ÐÐ°Ð½Ð½ÑÐµ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾ Ð¿Ð¾ÑÐ»Ðµ ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ñ",
            diskSpaceNotification: "ÐÑÐ¾Ð²ÐµÑÑÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾Ðµ Ð¼ÐµÑÑÐ¾ Ð½Ð° Ð´Ð¸ÑÐºÐµ Ð¸ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÑÐµÑ Ð² ÑÐ»ÑÑÐ°Ðµ Ð½ÐµÑÐ²Ð°ÑÐºÐ¸ Ð¼ÐµÑÑÐ°.",
            dispensingNotes: "Ð Ð°Ð·Ð´ÐµÐ» Ñ Ð¿ÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸ÑÐ¼Ð¸ Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "ÐÐ¸ÑÑÑÐ°Ð»ÑÐ½Ð°Ñ ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÐ° Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð° Ð² %{name}",
            exportLocalSettings: "Ð­ÐºÑÐ¿Ð¾ÑÑÐ¸ÑÑÐµÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÑÐ¾Ð³Ð¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ° ",
            exportStaticSql:
                "Ð­ÐºÑÐ¿Ð¾ÑÑÐ¸ÑÑÐµÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÑÐ¾Ð³Ð¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°. Ð­ÐºÑÐ¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐ¹ ÑÐ°Ð¹Ð» Ð¼Ð¾Ð¶Ð½Ð¾ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð´Ð»Ñ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ñ ÑÑÐ¾Ð¹ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¾Ð¹. ",
            exportTranslationKeys:
                "Ð­ÐºÑÐ¿Ð¾ÑÑÐ¸ÑÑÐ¹ÑÐµ Ð½Ð¾Ð²ÐµÐ¹ÑÐ¸Ðµ Ð¿ÐµÑÐµÐ²Ð¾Ð´Ñ Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð° Ð¾ÑÐ¿ÑÐ°Ð²ÑÑÐµ Ð¸Ñ Ð¿Ð¾ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÐµ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÑ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ, ÑÑÐ¾Ð±Ñ Ð¾Ð½Ð¸ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð»Ð¸. ",
            favoriteButton: "Ð©ÐµÐ»ÐºÐ½Ð¸ÑÐµ, ÑÑÐ¾Ð±Ñ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð² Ð¸Ð·Ð±ÑÐ°Ð½Ð½Ð¾Ðµ",
            formulaNotes: "Ð Ð°Ð·Ð´ÐµÐ» Ñ Ð·Ð°Ð¿Ð¸ÑÑÐ¼Ð¸ Ðº ÑÐ¾ÑÐ¼ÑÐ»Ð°Ð¼ Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»",
            helpSettings: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÐµÑÑÑ Ð² ÑÐ°Ð·Ð´ÐµÐ»Ðµ: 'Ð¡Ð¿ÑÐ°Ð²ÐºÐ¸' Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð±ÑÑÑÑÐ¾Ð³Ð¾ Ð´Ð¾ÑÑÑÐ¿Ð°",
            importCustomData: "ÐÐ¼Ð¿Ð¾ÑÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ Ð½Ð° Ð¾ÑÐ½Ð¾Ð²Ðµ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÑÐ¾ÑÐ¼Ð°ÑÐ°",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÑÐµÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÑÐ¾Ð³Ð¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
            internalNote: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ Ð²Ð½ÑÑÑÐµÐ½Ð½Ð¸Ð¹ ÑÐ°Ð·Ð´ÐµÐ» Ð·Ð°Ð¼ÐµÑÐ¾Ðº.",
            lockComputer:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÑÑÑ, ÑÑÐ¾ Ð¿ÐµÑÐµÑÐµÑÐ¸Ñ %{name} Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ ÑÐ´Ð°Ð»ÐµÐ½Ð° - ÑÑÐ¾ Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¿Ð¾Ð»ÑÑÐ¸ÑÑ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ Ð¾Ð¿ÑÑ ÑÐ°Ð±Ð¾ÑÑ Ð² ÑÐµÐ¶Ð¸Ð¼Ðµ ÐºÐ¸Ð¾ÑÐºÐ°. ÐÑÐ¸Ð¼ÐµÐ½ÑÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Windows",
            maxNumberTabs: "ÐÑÐµÐ´ÐµÐ» Ð²ÐºÐ»Ð°Ð´Ð¾Ðº ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑ, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð²ÐºÐ»Ð°Ð´Ð¾Ðº ÑÐ¾ÑÐ¼ÑÐ» Ð¼Ð¾Ð¶Ð½Ð¾ Ð¾ÑÐºÑÑÑÑ Ð¾Ð´Ð½Ð¾Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾",
            memoryTabs: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾Ðµ Ð¾ÑÐºÑÑÑÐ¸Ðµ Ð½ÐµÐ´Ð°Ð²Ð½Ð¾ Ð¾ÑÐºÑÑÑÑÑ Ð²ÐºÐ»Ð°Ð´Ð¾Ðº Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð¿ÑÑÐºÐ° Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ.",
            printAfterDispensing:
                "ÐÐ»Ñ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÑÐµÐ±ÑÐµÑÑÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ¾Ð¼, ÑÐºÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð¿Ð¸Ð¹ ÑÑÐ¸ÐºÐµÑÐ¾Ðº Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð±ÑÑÑ ÑÐ°ÑÐ¿ÐµÑÐ°ÑÐ°Ð½Ð¾ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÑÐ¾ÑÐµÑÑÐ° Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            printAsImage:
                "ÐÐµÑÐ°ÑÑ Ð² Ð²Ð¸Ð´Ðµ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ñ Ð¿Ð¾Ð¼Ð¾Ð³Ð°ÐµÑ ÑÐµÑÐ¸ÑÑ Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ñ, Ð²Ð¾Ð·Ð½Ð¸ÐºÐ°ÑÑÐ¸Ðµ Ð¿ÑÐ¸ ÑÐ±Ð¾Ðµ ÑÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð¾Ð³Ð¾ ÑÐ¿Ð¾ÑÐ¾Ð±Ð° Ð¿ÐµÑÐ°ÑÐ¸. ÐÐµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐ¹ÑÐµ ÐµÐ³Ð¾, ÐµÑÐ»Ð¸ ÑÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð°Ñ Ð¿ÐµÑÐ°ÑÑ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾. Ð¡Ð¾Ð²Ð¼ÐµÑÑÐ¸Ð¼Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ñ Linux",
            printBeforeDispensing:
                "ÐÐ»Ñ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÑÐµÐ±ÑÐµÑÑÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ¾Ð¼, ÑÐºÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð¿Ð¸Ð¹ ÑÑÐ¸ÐºÐµÑÐ¾Ðº Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð±ÑÑÑ ÑÐ°ÑÐ¿ÐµÑÐ°ÑÐ°Ð½Ð¾ Ð´Ð¾ Ð¿ÑÐ¾ÑÐµÑÑÐ° Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            printEnabled:
                "Ð­ÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð¿ÑÐ¸Ð½ÑÐµÑ Ñ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½ÑÐ¼ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸ÐµÐ¼. ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ Ð½Ð°ÑÐ¾Ð´ÑÑÑÑ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ Ð¿ÐµÑÐ°ÑÐ¸",
            printOnRequest: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð±ÑÐ´ÐµÑ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð° ÐºÐ½Ð¾Ð¿ÐºÐ° 'ÐÐµÑÐ°ÑÑ'",
            printTaskVariable:
                "ÐÐ°Ð´Ð°ÑÐ° Ð¿ÐµÑÐ°ÑÐ¸ Ð¾Ð±ÑÐ°Ð±Ð°ÑÑÐ²Ð°ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÐ¾Ð¼ ÑÐ»ÑÑÐ°Ðµ, ÐµÑÐ»Ð¸ Ð·Ð°Ð´Ð°Ð½Ð½Ð°Ñ Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½Ð°Ñ Ð¿ÐµÑÐ°ÑÐ¸ Ð´Ð¾ÑÑÑÐ¿Ð½Ð° Ð² Ð´Ð°Ð½Ð½ÑÑ Ð¿ÐµÑÐ°ÑÐ¸.",
            quickTintTemplate: "ÐÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ ÑÐ°Ð±Ð»Ð¾Ð½ Ð±ÑÐ´ÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸ ÑÑÐ¸ÐºÐµÑÐ¾Ðº Ð¿ÑÐ¸ Ð±ÑÑÑÑÐ¾Ð¹ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐµ",
            restoreLocalSettings: "ÐÐ¾ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÑÐ¾Ð³Ð¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ° ",
            runLightAtStartUp: "%{light} Ð±ÑÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐµÐ½ Ð²Ð¼ÐµÑÑÐ¾ %{name}.",
            screenSaverTimeout: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ, ÑÐµÑÐµÐ· ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼Ð¸Ð½ÑÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð·Ð°Ð¿ÑÑÐºÐ°ÑÑÑÑ 'ÑÑÐ°Ð½Ð¸ÑÐµÐ»Ñ ÑÐºÑÐ°Ð½Ð°'",
            selectCustomDataFormat:
                "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¾ÑÐ¼Ð°Ñ Ð¸ÑÑÐ¾Ð´Ð½ÑÑ Ð´Ð°Ð½Ð½ÑÑ Ð´Ð»Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ°. ÐÐ»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ ÑÐ¾ÑÐ¼Ð°ÑÐ° Ð¼Ð¾Ð³ÑÑ Ð¿Ð¾ÑÑÐµÐ±Ð¾Ð²Ð°ÑÑÑÑ ÑÐ°Ð·Ð»Ð¸ÑÐ½ÑÐµ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÑÐ°Ð¹Ð»Ñ Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
            setCustomHomeButton: "ÐÐ½Ð¾Ð¿ÐºÐ° Â«ÐÐ¾Ð¼Ð¾Ð¹Â» Ð² %{name} Ð±ÑÐ´ÐµÑ Ð¿ÐµÑÐµÐ½Ð°Ð¿ÑÐ°Ð²Ð»ÑÑÑ Ð½Ð° Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ",
            setFts: "ÐÐ¾Ð»Ð½Ð¾ÑÐµÐºÑÑÐ¾Ð²ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¾ÑÑÑÐµÑÑÐ²Ð»ÑÑÑ Ð¿Ð¾Ð»Ð½Ð¾ÑÐµÐºÑÑÐ¾Ð²ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ð°Ð¼ (ÑÐ°ÐºÐ¶Ðµ Ð¸Ð· ÑÐµÑÐµÐ´Ð¸Ð½Ñ ÑÐ»Ð¾Ð²Ð° Ð¸ ÑÐ´)",
            setKeyboardShortcuts: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¾Ð´Ð½Ð¾ Ð¸ ÑÐ¾ Ð¶Ðµ ÑÐ¾ÑÐµÑÐ°Ð½Ð¸Ðµ ÐºÐ»Ð°Ð²Ð¸Ñ Ð´Ð»Ñ Ð´Ð²ÑÑ ÑÐ°Ð·Ð½ÑÑ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹",
            setNumberOfDecimalPlaces:
                "ÐÐºÑÑÐ³Ð»ÐµÐ½Ð¸Ðµ ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑ, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð´ÐµÑÑÑÐ¸ÑÐ½ÑÑ ÑÐ°Ð·ÑÑÐ´Ð¾Ð² ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð±ÑÐ´ÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑÑÑ Ð² ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
            setOrderSearchParameters:
                "ÐÐ¾Ð¸ÑÐº Ð·Ð°ÐºÐ°Ð·Ð° Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÐºÐ°ÐºÐ¸Ðµ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÑÑÑÑ Ð¿ÑÐ¸ Ð¿Ð¾Ð¸ÑÐºÐµ ÑÑÐµÐ´Ð¸ Ð·Ð°ÐºÐ°Ð·Ð¾Ð². ÐÐ¾ÑÑÑÐ¿Ð½Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð² %{name}",
            setOverwriteLastTab:
                "ÐÑÐ¸ Ð²ÑÐ±Ð¾ÑÐµ Ð½Ð¾Ð²Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ ÑÐµÑÐµÐ· Ð³Ð»Ð¾Ð±Ð°Ð»ÑÐ½ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº, ÐºÐ¾Ð³Ð´Ð° Ð´Ð¾ÑÑÐ¸Ð³Ð½ÑÑ Ð¿ÑÐµÐ´ÐµÐ» Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ», Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÑÑ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½Ð°Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ° ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð±ÑÐ´ÐµÑ Ð¿ÐµÑÐµÐ·Ð°Ð¿Ð¸ÑÐ°Ð½Ð° Ð½Ð¾Ð²ÑÐ¼ Ð²ÑÐ±Ð¾ÑÐ¾Ð¼ ÑÐ¾ÑÐ¼ÑÐ»Ñ ",
            setSearchPanel: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÐ²Ð¾Ñ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑÑ Ð¸ Ð¿Ð¾ÑÑÐ´Ð¾Ðº ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ¾Ð², Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÐ¼ÑÑ Ð¿ÑÐ¸ Ð¿Ð¾Ð¸ÑÐºÐµ Ð½Ð¾Ð²Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            setVisibilityAndOrder:
                "ÐÑÐ±ÑÐ°Ð½Ð½ÑÐµ ÑÐ»ÐµÐ¼ÐµÐ½ÑÑ Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¸ Ð±ÑÐ´ÑÑ Ð²Ð¸Ð´Ð½Ñ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð±ÑÑÑÑÐ¾Ð³Ð¾ Ð´Ð¾ÑÑÑÐ¿Ð°. ÐÐ´ÐµÑÑ ÑÐ°Ð¼Ð°Ñ Ð²ÑÑÐ¾ÐºÐ°Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ ÐºÑÐ°Ð¹Ð½ÑÑ Ð»ÐµÐ²ÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸. ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ¾Ð² Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¸ - 6",
            setYourLanguage: "ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ·ÑÐºÐ° ÑÑÐµÐ±ÑÐµÑ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÐºÐ° Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ",
            settingsSearch: "ÐÐ¾Ð¸ÑÐ¸ÑÐµ ÑÐ°Ð·Ð»Ð¸ÑÐ½ÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸, ÐµÑÐ»Ð¸ Ð½Ðµ Ð·Ð½Ð°ÐµÑÐµ, Ð³Ð´Ðµ Ð¸Ñ Ð½Ð°Ð¹ÑÐ¸",
            showNewOrderNotifications:
                "Ð£Ð²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ðµ Ð¾ Ð·Ð°ÐºÐ°Ð·Ðµ - ÑÑÐ¾ Ð²ÑÐ¿Ð»ÑÐ²Ð°ÑÑÐµÐµ Ð¾ÐºÐ½Ð¾ Ñ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸ÐµÐ¼ Ð¾ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ð¸ Ð½Ð¾Ð²Ð¾Ð³Ð¾ Ð·Ð°ÐºÐ°Ð·Ð°",
            sorting:
                "ÐÐ»Ñ Ð±ÑÑÑÑÐ¾Ð¹ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð¼Ð¾Ð¶Ð½Ð¾ Ð·Ð°ÐºÐ°Ð·Ð°ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ Ð² ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ð¸ Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸ÑÐ¼Ð¸ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹ Ð¸Ð»Ð¸ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾ÑÐ°Ð¼Ð¸ ÐºÐ°Ð½Ð¸ÑÑÑ",
            turnOnKioskMode: "ÐÐ¾Ð»Ð½Ð¾ÑÐºÑÐ°Ð½Ð½ÑÐ¹ ÑÐµÐ¶Ð¸Ð¼ Ð½Ð° ÑÐºÑÑÑÐ¾Ð¹ Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð·Ð°Ð´Ð°Ñ",
            windowClosingRules:
                "Ð­ÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, Ð±ÑÐ´ÐµÑ Ð»Ð¸ Ð¾ÐºÐ½Ð¾ Ð±ÑÑÑÑÐ¾Ð¹ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð·Ð°ÐºÑÑÐ²Ð°ÑÑÑÑ Ð´Ð¾ Ð¸Ð»Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð½Ð°ÑÐ°Ð»Ð° Ð¿ÑÐ¾ÑÐµÑÑÐ° Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ"
        },
        formulaSettings: {
            additionalFormulaTab:
                "Ð­ÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÐºÐ°ÐºÐ°Ñ Ð¿Ð°Ð½ÐµÐ»Ñ Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ Ð¿ÑÐ¸ Ð¾ÑÐºÑÑÑÐ¸Ð¸ Ð½Ð¾Ð²Ð¾Ð¹ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ñ. ",
            allowCustomFormulas: "ÐÑÐ´ÐµÑ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ðµ Ð¸ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ñ ÑÐ¾ÑÐ¼ÑÐ»",
            allowCustomPackageSize:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð±ÑÐ´ÐµÑ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð° Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð° Ð¾Ð¿ÑÐ¸Ñ Ð½ÐµÑÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð¾Ð³Ð¾ ÑÐ°Ð·Ð¼ÐµÑÐ° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
            allowEditingColorants:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð±ÑÐ´ÐµÑ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð° ÐºÐ½Ð¾Ð¿ÐºÐ° Â«Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÂ» (Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÐµÑÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±Ð¾ÑÐ° ÑÐ²ÐµÑÐ°)",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð±Ð°Ð·Ñ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¤Ð¾ÑÐ¼ÑÐ»Ð°",
            bippPanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð±Ð°Ð·Ñ Ð² ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¤Ð¾ÑÐ¼ÑÐ»Ð°",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ° Ð±ÑÐ´ÐµÑ ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½Ð¾Ð¹ Ð²Ð¸Ð´Ð¸Ð¼Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÐµÐ¹",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ Â«Ð¤Ð¾ÑÐ¼ÑÐ»Ð°Â» Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ° Ð±ÑÐ´ÐµÑ Ð¿ÑÐµÐ´ÑÑÐ°Ð²Ð»ÐµÐ½ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸ÐµÐ¼.",
            colorPreviewResizable: "ÐÐ¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¸Ð·Ð¼ÐµÐ½ÑÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ° ÑÐ²ÐµÑÐ°.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ ÑÐ¿Ð¾ÑÑÐ´Ð¾ÑÐµÐ½Ñ Ð¿Ð¾ Ð½Ð°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ñ Ð¸Ð»Ð¸ Ð¿Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ñ.",
            customCanOption:
                "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð´Ð»Ñ Ð½ÐµÑÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð¾Ð¹ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Â«Ð¤Ð¾ÑÐ¼ÑÐ»Ð°Â». ",
            customCanSettingsUnit:
                "ÐÑÐ±ÐµÑÐ¸ÑÐµ, ÐºÐ°ÐºÑÑ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð´Ð»Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ñ Ð½Ð°ÑÑÑÐ¾ÐµÐº Ð¿Ð°ÐºÐµÑÐ° Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Â«Ð¤Ð¾ÑÐ¼ÑÐ»Ð°Â».",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "ÐÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÑÑÐ¾Ð³Ð¾ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ° Ð¿ÑÐ¸Ð²ÐµÐ´ÐµÑ Ðº Ð¿Ð¾ÑÐ²Ð»ÐµÐ½Ð¸Ñ Ð²ÑÐ¿Ð»ÑÐ²Ð°ÑÑÐ¸Ñ Ð¾ÐºÐ¾Ð½ Ð´Ð»Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ñ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ°",
            dropDownCalculate:
                "Ð Ð°ÑÐºÑÑÐ²Ð°ÑÑÐµÐµÑÑ Ð¼ÐµÐ½Ñ Ð´Ð»Ñ Ð²ÑÐ±Ð¾ÑÐ° ÑÐ¾ÑÐ¼ÑÐ»Ñ, ÐºÐ¾ÑÐ¾ÑÑÑ Ð²Ñ Ð¸ÑÐµÑÐµ, Ð±ÑÐ´ÐµÑ Ð¿ÑÐ¾ÑÑÐ¸ÑÐ°ÑÑÑÑ Ð´Ð¾ Ð½Ð¸Ð¶Ð½ÐµÐ¹ ÑÐ°ÑÑÐ¸ Ð¾ÐºÐ½Ð°.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ ÑÐ°Ð·Ð¼ÐµÑ ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¤Ð¾ÑÐ¼ÑÐ»Ð°",
            favoriteFormulasInitial: "ÐÑÐ¸ Ð·Ð°Ð¿ÑÑÐºÐµ %{name} Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ð¸Ð·Ð±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾",
            formulaAutomaticNaming:
                "ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð±ÑÐ´ÐµÑ Ð½Ð°Ð·Ð²Ð°Ð½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð½Ð° Ð¾ÑÐ½Ð¾Ð²Ðµ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð½ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
            formulaPanel: "ÐÑÐ¸ Ð¾ÑÐºÑÑÑÐ¸Ð¸ Ð½Ð¾Ð²Ð¾Ð¹ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ ÑÐ¾ÑÐ¼ÑÐ»",
            formulaPanelInitial: "ÐÑÐ¸ Ð·Ð°Ð¿ÑÑÐºÐµ %{name} Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ ÑÐ¾ÑÐ¼ÑÐ»",
            formulaPanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "ÐÑÐ»Ð¸ ÑÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð²ÐºÐ»ÑÑÐµÐ½, Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ° Ð±ÑÐ´ÐµÑ ÑÐ¾Ð·Ð´Ð°Ð½ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸. ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ Ð½Ðµ ÑÐ¾ÑÐµÐ½.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ ÑÑÐ´Ð¾Ð¼ Ñ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¼ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ¾Ð¼ ÑÐ²ÐµÑÐ° Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð¾ÑÐºÑÑÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ñ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÐµÐ¹",
            images: "ÐÐ°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ Ð¸ÑÑÐ¾ÑÐ½Ð¸Ðº ÑÐ°Ð¹Ð»Ð¾Ð² Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ð¹.",
            infoPanelResizable: "ÐÐ¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¾Ð½Ð½Ð¾Ð¹ Ð¿Ð°Ð½ÐµÐ»Ð¸.",
            initialFormulaTab: "Ð­ÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÐºÐ°ÐºÐ°Ñ Ð¿Ð°Ð½ÐµÐ»Ñ Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð¿ÑÑÐºÐ° %{0}. ",
            moreInfo:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¾Ð½Ð½Ð°Ñ Ð¿Ð°Ð½ÐµÐ»Ñ Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ ÑÑÐ´Ð¾Ð¼ Ñ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¼ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ¾Ð¼ ÑÐ²ÐµÑÐ° Ð¸ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¼ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ¾Ð¼ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "ÐÐ°ÑÐ°Ð¼ÐµÑÑ Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÐºÐ¾Ð´Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð² Ð²Ð¼ÐµÑÑÐµ Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸ÑÐ¼Ð¸ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð², ÐµÑÐ»Ð¸ Ð¾Ð½Ð¸ ÐµÑÑÑ Ð² Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ",
            productFiles: "ÐÐ°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ Ð¸ÑÑÐ¾ÑÐ½Ð¸Ðº ÑÐ°Ð¹Ð»Ð¾Ð² Ð¿ÑÐ¾Ð´ÑÐºÑÐ°, Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ».",
            productGroups: "ÐÐ°ÑÐ°Ð¼ÐµÑÑ Ð²ÐºÐ»ÑÑÐ°ÐµÑ Ð¸ÐµÑÐ°ÑÑÐ¸Ñ Ñ Ð³ÑÑÐ¿Ð¿Ð°Ð¼Ð¸ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð², ÐµÑÐ»Ð¸ Ð¾Ð½Ð¸ Ð´Ð¾ÑÑÑÐ¿Ð½Ñ Ð² Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ.",
            productPanelSize: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð·Ð¼ÐµÑ Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¤Ð¾ÑÐ¼ÑÐ»Ð°",
            searchNewFormula:
                "ÐÑÐ¸ Ð¾ÑÐºÑÑÑÐ¸Ð¸ Ð½Ð¾Ð²Ð¾Ð¹ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð½Ð¾Ð²Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð¿Ð¾Ð¸ÑÐºÐ° (ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÐ°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ð°Ñ Ð¸ Ð»ÑÐ±Ð¸Ð¼ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ð°Ñ)",
            searchNewFormulaInitial:
                "ÐÑÐ¸ Ð·Ð°Ð¿ÑÑÐºÐµ %{name} Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð½Ð¾Ð²Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð¿Ð¾Ð¸ÑÐºÐ° (ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ñ Ð²ÑÐ´Ð°Ð½Ð½ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ð°Ñ Ð¸ Ð»ÑÐ±Ð¸Ð¼ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ð°Ñ)",
            searchPanelFormulaItems: "ÐÐ¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð²ÑÐ±ÑÐ°Ð½ ÑÐ¾ÑÑ Ð±Ñ Ð¾Ð´Ð¸Ð½ Ð¸Ð· ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ¾Ð² ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            searchPanelProductItems: "ÐÐ¾Ð¶ÐµÑ Ð±ÑÑÑ Ð²ÑÐ±ÑÐ°Ð½ ÑÐ¾Ð»ÑÐºÐ¾ Ð¾Ð´Ð¸Ð½ ÑÐ¾Ð²Ð°Ñ",
            searchPanelQuickSelect:
                "ÐÐµÑ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸ Ð½Ð°Ð¶Ð¸Ð¼Ð°ÑÑ ÐºÐ½Ð¾Ð¿ÐºÑ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ñ. ÐÑ Ð±ÑÐ´ÐµÑÐµ Ð¿ÐµÑÐµÐ½Ð°Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ñ Ð½ÐµÐ¿Ð¾ÑÑÐµÐ´ÑÑÐ²ÐµÐ½Ð½Ð¾ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÑ Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ ÑÑÐ°Ð·Ñ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±Ð¾ÑÐ° ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            setCompetitiveColorSearch:
                "Ð¡ ÑÑÐ¾Ð³Ð¾ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ° Ð´Ð¾ÑÑÑÐ¿Ð½Ð° ÑÑÐ½ÐºÑÐ¸Ñ ÐºÐ¾Ð½ÐºÑÑÐµÐ½ÑÐ½Ð¾Ð³Ð¾ ÑÐ²ÐµÑÐ¾Ð²Ð¾Ð³Ð¾ Ð¿Ð¾Ð¸ÑÐºÐ° Ð² Ð¦Ð²ÐµÑÐ½Ð¾Ð¹ Ð¿Ð°Ð½ÐµÐ»Ð¸",
            setFormulaInfoInPreview:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ Â«Ð¤Ð¾ÑÐ¼ÑÐ»Ð°Â» Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ ÑÐ¸Ð¿ Ð´Ð°Ð½Ð½ÑÑ Ð²ÑÐµÐ³Ð´Ð° Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ Ð² Ð¾ÐºÐ½Ðµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ° ÑÐ²ÐµÑÐ°",
            setFormulaPreview:
                "ÐÐ°ÑÐ°Ð¼ÐµÑÑ Ð¸Ð·Ð¼ÐµÐ½ÑÐµÑ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð¸ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ° ÑÐ²ÐµÑÐ°, Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ð¸ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¾Ð½Ð½ÑÑ Ð´Ð°Ð½Ð½ÑÑ Ð¾ ÑÐ²ÐµÑÐµ",
            setFormulaRGBPreviewVisibleInformation:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ ÑÐ¸Ð¿ Ð´Ð°Ð½Ð½ÑÑ Ð±ÑÐ´ÐµÑ Ð²ÑÐµÐ³Ð´Ð° Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ Ð² ÑÐµÐ¶Ð¸Ð¼Ðµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ° ÑÐ²ÐµÑÐ°",
            setFormulaUnit:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» ÑÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÐºÐ°ÐºÐ¾Ð¹ Ð±Ð»Ð¾Ðº ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑÑÑ Ð¿ÐµÑÐ²ÑÐ¼ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±Ð¾ÑÐ° ÑÐ²ÐµÑÐ° Ð¢Ð°ÐºÐ¶Ðµ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸Ð¼Ð¾ Ð² Quick Tint",
            setFormulaVisibilityAndOrder:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ Ð±ÑÐ´ÑÑ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ Ð² ÑÐ°Ð·Ð´ÐµÐ»Ðµ Â«ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÑÂ» (Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸Ð¼Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð² ÑÐ¾Ð¼ ÑÐ»ÑÑÐ°Ðµ, ÐµÑÐ»Ð¸ Ð´Ð»Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ° Â«ÐÐ°Ð´Ð°ÑÑ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ ÑÐ¾ÑÐ¼ÑÐ»ÑÂ» Ð²ÑÐ±ÑÐ°Ð½Ð¾ Â«ÐÐ·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸ÐµÂ» Ð¸Ð»Ð¸ Â«ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÑÂ»)",
            setMaxToleranceForCompetitiveColors:
                "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ Ð´Ð¾Ð¿ÑÑÐº Delta E (CIA 2000) Ð´Ð»Ñ ÑÑÐ°Ð²Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¿Ð¾Ð¸ÑÐºÐ° ÑÐ²ÐµÑÐ° ",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» ÑÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÐºÐ°ÐºÐ¸Ðµ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð²Ð¸Ð´Ð½Ñ Ð¿Ð¾ÑÐ»Ðµ Ð²ÑÐ±Ð¾ÑÐ° ÑÐ²ÐµÑÐ°. Ð¢Ð°ÐºÐ¶Ðµ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸Ð¼Ð¾ Ð² Quick Tint",
            showColorPreview:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ» Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÐµÑÑÑ Ð½ÐµÐ±Ð¾Ð»ÑÑÐ¾Ð¹ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ²ÐµÑÐ° ÑÑÐ´Ð¾Ð¼ Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸ÐµÐ¼ ÑÐ²ÐµÑÐ° Ð¿ÑÐ¸ Ð¿Ð¾Ð¸ÑÐºÐµ Ð½Ð¾Ð²Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "ÐÐ°Ð½Ð¸ÑÑÑÐ° (%{colorants}) Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð° Ð±ÑÐ°ÐºÐ¾Ð²Ð°Ð½Ð½Ð¾Ð¹ Ð¿Ð°ÑÑÐ¸ÐµÐ¹ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð².",
            batchNumberWarning: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ (%{colorants}) Ñ ÑÑÐ¸Ð¼ Ð½Ð¾Ð¼ÐµÑÐ¾Ð¼ Ð¿Ð°ÑÑÐ¸Ð¸ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¿Ð¾Ð²ÑÐµÐ¶Ð´ÐµÐ½.",
            bellowBaseLimit: "Ð¡ÑÐ¼Ð¼Ð° ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ² ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð½Ð¸Ð¶Ðµ Ð±Ð°Ð·Ð¾Ð²Ð¾Ð³Ð¾ Ð¿ÑÐµÐ´ÐµÐ»Ð°.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»ÐµÑÐ¸ÑÑÐµÐ¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ â ÑÑÐ¾ Ð½Ð°Ð¸Ð¼ÐµÐ½ÑÑÐµÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°, ÐºÐ¾ÑÐ¾ÑÐ¾Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¾ Ð² ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ð¸ Ñ ÑÐµÐºÐ¾Ð¼ÐµÐ½Ð´Ð°ÑÐ¸ÑÐ¼Ð¸ Ð»Ð°Ð±Ð¾ÑÐ°ÑÐ¾ÑÐ¸Ð¸.",
            checkOverfill:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ, Ð´Ð¾ÑÑÐ°ÑÐ¾ÑÐ½Ð¾ Ð»Ð¸ Ð¼ÐµÑÑÐ° Ð² Ð±Ð°Ð½ÐºÐµ Ð´Ð»Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² ÑÑÐ°Ð·Ñ Ð¿Ð¾ÑÐ»Ðµ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð°.",
            checkTotalCntAmounts:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ Ð¿ÑÐµÐ²ÑÑÐµÐ½Ð¸Ðµ Ð»Ð¸Ð¼Ð¸ÑÐ¾Ð² Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð¸ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð³Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð² Ð±Ð°Ð·Ð¾Ð²Ð¾Ð¹ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°. Ð­ÑÐ¸ Ð¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð¸Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ñ Ð² Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð½Ð¸Ð¶Ðµ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð³Ð¾ ÐºÐ¾Ð»ÐµÑÐ¸ÑÑÐµÐ¼Ð¾Ð³Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð°.",
            dispensingWithErrorsEnabled:
                "ÐÑÐ»Ð¸ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¾, Ð² ÑÐ»ÑÑÐ°Ðµ Ð½Ð°ÑÑÑÐµÐ½Ð¸Ñ Ð²Ð°Ð»Ð¸Ð´Ð°ÑÐ¸Ð¸ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÑÑÐµÐµ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ, Ð½Ð¾ ÑÐµÐ¼ Ð½Ðµ Ð¼ÐµÐ½ÐµÐµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ´ÐµÑ Ð¿ÐµÑÐµÐ¹ÑÐ¸ Ðº Ð²ÑÐ´Ð°ÑÐµ.",
            invalidBatchNumber: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ Ð¸Ð¼ÐµÐµÑ Ð½ÐµÐ²ÐµÑÐ½ÑÐ¹ Ð¸Ð»Ð¸ Ð´ÐµÑÐµÐºÑÐ½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸",
            overBaseLimit: "Ð¡ÑÐ¼Ð¼Ð° ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ² ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹ Ð¿ÑÐµÐ²ÑÑÐ°ÐµÑ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»ÐµÑÐ¸ÑÑÐµÐ¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾.",
            overfill: "ÐÐ±Ð½Ð°ÑÑÐ¶ÐµÐ½Ð¾ Ð¿ÐµÑÐµÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "Ð¯ Ð¾ÑÐ¾Ð·Ð½Ð°Ñ ÑÐ¸ÑÐºÐ¸, Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ"
        },
        help: "ÐÐ¾Ð¼Ð¾ÑÑ",
        helpLink: "Ð¦ÐµÐ½ÑÑ Ð¿Ð¾Ð¼Ð¾ÑÐ¸",
        helper: {
            automaticallyCheckForUpdates:
                "ÐÑÐ´ÐµÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð¿ÑÐ¾Ð²ÐµÑÑÑÑÑÑ Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ Ð´Ð»Ñ %{name} Ð¸Ð»Ð¸ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ð² Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ð¼ Ð¸Ð½ÑÐµÑÐ²Ð°Ð»Ðµ Ð²ÑÐµÐ¼ÐµÐ½Ð¸",
            automaticallyDownloadUpdates:
                "ÐÑÐ»Ð¸ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ ÐµÑÑÑ Ð² Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸, Ð¾Ð½Ð¾ Ð±ÑÐ´ÐµÑ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð±ÐµÐ· Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾Ð³Ð¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ",
            automaticallyInstallNewDatabases:
                "ÐÑÐ»Ð¸ Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½ ÑÐ°Ð½ÐµÐµ Ð¾ÑÑÑÑÑÑÐ²ÑÑÑÐ¸Ð¹ Ð±Ð°Ð½Ðº Ð´Ð°Ð½Ð½ÑÑ, ÑÐ¾ Ð¾Ð½ Ð±ÑÐ´ÐµÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ ÐºÐ°Ðº Ð½Ð¾Ð²ÑÐ¹ Ð±Ð°Ð½Ðº Ð´Ð°Ð½Ð½ÑÑ ÐÐ¾ÑÐ»Ðµ ÑÑÐ¾Ð³Ð¾ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ´ÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð½Ð¾Ð²ÑÐ¹ Ð±Ð°Ð½Ðº Ð´Ð°Ð½Ð½ÑÑ",
            automaticallyInstallUpdates:
                "ÐÑÐ»Ð¸ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð±ÑÐ»Ð¾ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾, Ð¾Ð½Ð¾ Ð±ÑÐ´ÐµÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð±ÐµÐ· Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ",
            canBrowseChangeLog:
                "ÐÑÐ¸ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¸ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ, Ð¾ÑÐ¸ÑÐ¸Ð°Ð»ÑÐ½ÑÐ¹ Ð¶ÑÑÐ½Ð°Ð» Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ %{name} Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½ Ð´Ð»Ñ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ°",
            forceInstall: "ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð±ÑÐ´ÐµÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½Ð¾ Ð¿ÑÐ¸Ð½ÑÐ´Ð¸ÑÐµÐ»ÑÐ½Ð¾.",
            installDuringNight: "ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð±ÑÐ´ÐµÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾ Ð½Ð¾ÑÑÑ, ÐµÑÐ»Ð¸ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ."
        },
        licensing: {
            collect:
                "Ð¤Ð°Ð¹Ð»Ñ Ð¶ÑÑÐ½Ð°Ð»Ð¾Ð² Ð±ÑÐ´ÑÑ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ñ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ðµ Ð¼ÐµÑÑÐ¾. Ð¤Ð°Ð¹Ð»Ñ Ð¶ÑÑÐ½Ð°Ð»Ð¾Ð² ÑÑÐµÐ±ÑÑÑÑÑ Ð¿ÑÐ¸Ð»Ð°Ð³Ð°ÐµÐ¼Ð¾Ð¼Ñ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð¼Ñ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Ð´Ð»Ñ Ð°Ð½Ð°Ð»Ð¸Ð·Ð° Ð¾ÑÐ¸Ð±Ð¾Ðº",
            company: "ÐÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ñ, Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð¸Ð²ÑÐ°Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ.",
            computerID:
                "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸, ÑÑÐ¾Ð±Ñ Ð¿Ð¾Ð¼Ð¾ÑÑ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÑ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Ð² ÑÐ»ÑÑÐ°Ðµ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸.",
            email: "Ð­Ð»ÐµÐºÑÑÐ¾Ð½Ð½ÑÐ¹ Ð°Ð´ÑÐµÑ Ð´ÐµÑÐ¶Ð°ÑÐµÐ»Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸.",
            licenseUuid:
                "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸, ÑÑÐ¾Ð±Ñ Ð¿Ð¾Ð¼Ð¾ÑÑ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÑ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Ð² ÑÐ»ÑÑÐ°Ðµ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸.",
            name: "ÐÐ¼Ñ Ð´ÐµÑÐ¶Ð°ÑÐµÐ»Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸.",
            openBugreport: "Ð¡Ð¾Ð¾Ð±ÑÐ¸ÑÐµ Ð½Ð°Ð¼, ÐµÑÐ»Ð¸ Ð² Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ðµ ÐµÑÑÑ Ð¾ÑÐ¸Ð±ÐºÐ°, Ð¸ Ð¾ÑÐ¿ÑÐ°Ð²ÑÑÐµ Ð½Ð°Ð¼ Ð¾ÑÑÐµÑ Ñ Ð¾Ð¿Ð¸ÑÐ°Ð½Ð¸ÐµÐ¼ Ð¾ÑÐ¸Ð±ÐºÐ¸",
            posInfoContactperson: "POS-Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐµ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸ Ð½Ð° ÑÑÐ¸ÐºÐµÑÐºÐµ",
            posInfoMachineInformation:
                "POS-Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐµ, ÐºÐ¾ÑÐ¾ÑÐ°Ñ Ð±ÑÐ´ÐµÑ Ð½Ð°Ð¿ÐµÑÐ°ÑÐ°Ð½Ð° Ð½Ð° ÑÑÐ¸ÐºÐµÑÐºÐµ Ð¸Ð»Ð¸ ÑÐ°ÑÐ¿Ð¾Ð·Ð½Ð°Ð½Ð° Ð² ÑÐµÑÐ¸ ",
            posInfoPos: "POS-Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð¼ÐµÑÑÐ¾Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸, ÐºÐ¾ÑÐ¾ÑÐ°Ñ Ð±ÑÐ´ÐµÑ Ð½Ð°Ð¿ÐµÑÐ°ÑÐ°Ð½Ð° Ð½Ð° ÑÑÐ¸ÐºÐµÑÐºÐµ ",
            reactivation: "ÐÐ¾Ð²ÑÐ¾ÑÐ½Ð°Ñ Ð°ÐºÑÐ¸Ð²Ð°ÑÐ¸Ñ Ð¸Ð»Ð¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð´ÐµÐ¹ÑÑÐ²ÑÑÑÐµÐ¹ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸ ",
            refresh: "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð½Ð¾Ð²ÐµÐ¹ÑÑÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸.",
            refreshUnavailable: "ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð¾, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð²Ñ Ð¾ÑÑÐ»Ð°Ð¹Ð½.",
            registrationContactperson: "Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð´Ð»Ñ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¸ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸ ",
            registrationMachineInformation: "Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð´Ð»Ñ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¸ Ð²ÑÐ´Ð°ÑÑÐµÐ³Ð¾ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ ",
            registrationPos: "Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð´Ð»Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸Ñ Ð¼ÐµÑÑÐ¾Ð½Ð°ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸ ",
            versionScope: "ÐÑÐµÐ´ÐµÐ»Ñ ÑÑÐ¾ÐºÐ° Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ ",
            versionType: "Ð¢Ð¸Ð¿ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°"
        },
        machineIsBusy: "ÐÑÐ¸Ð±ÐºÐ¸ Ð½Ðµ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ Ð¾Ð±Ð½ÑÐ»ÐµÐ½Ñ, ÑÐ°Ðº ÐºÐ°Ðº Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð·Ð°Ð½ÑÑ",
        machineSettings: {
            allowManualColorantAddition:
                "ÐÑÐ»Ð¸ ÑÑÐµÐ±ÑÐµÐ¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð¿ÑÐµÐ²ÑÑÐ°ÐµÑ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ, Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÐ³Ð¾ Ð²ÑÑÑÐ½ÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            autotasks:
                "ÐÐ²ÑÐ¾Ð·Ð°Ð´Ð°ÑÐ¸ - ÑÑÐ¾ ÑÐ¾Ð±ÑÑÐ¸Ñ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¾Ð² Ð¸ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ¾Ð², ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð½Ð°ÑÑÑÐ¾Ð¸ÑÑ Ð½Ð° Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð²ÑÐµÐ¼Ñ Ð¸Ð»Ð¸ ÑÐµÑÐµÐ· Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½ÑÐ¹ Ð¸Ð½ÑÐµÑÐ²Ð°Ð» Ð²ÑÐµÐ¼ÐµÐ½Ð¸",
            barcodeRefillValidation: "ÐÐ°ÑÐ°Ð¼ÐµÑÑ Ð²ÐºÐ»ÑÑÐ°ÐµÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð° Ð¿ÑÐ¸ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ð¸.",
            barcodeRefillValidationBaseAndColorant:
                "ÐÑÐ¾Ð²ÐµÑÐºÐ° ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð° Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÑÑ Ð¿ÑÐ¸ Ð·Ð°Ð¿ÑÐ°Ð²ÐºÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ Ð¸ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ.",
            barcodeRefillValidationColorant: "ÐÑÐ¾Ð²ÐµÑÐºÐ° ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð° Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÑÑ Ð¿ÑÐ¸ Ð·Ð°Ð¿ÑÐ°Ð²ÐºÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¼.",
            canisterBarcode:
                "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´ Ð¿ÑÐ¸ÑÐ²Ð°Ð¸Ð²Ð°ÐµÑÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÐµ, Ð² ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ Ð½Ð°ÑÐ¾Ð´Ð¸ÑÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ. Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼ Ð´Ð»Ñ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾Ð¹ Ð·Ð°Ð¿ÑÐ°Ð²ÐºÐ¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°.",
            checkCanBeforeDispense: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½Ð° ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ ÑÐ¸Ð¼ÑÐ»ÑÑÐ¸Ð¸ Fast & Fluid",
            checkOverfill: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑ, Ð´Ð¾ÑÑÐ°ÑÐ¾ÑÐ½Ð¾ Ð»Ð¸ Ð¼ÐµÑÑÐ° Ð² ÑÐ°ÑÐµ Ð´Ð»Ñ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹ Ð¿ÐµÑÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼",
            currentlySelectedMachine: "ÐÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð»ÑÐµÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¼ Ð² Ð´Ð°Ð½Ð½ÑÐ¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐµ ",
            dispenseInvalidColorants:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ðµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ñ Ð² ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸ Ð¼Ð°ÑÐ¸Ð½Ñ, Ñ Ð¿Ð¾Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð¼Ð°Ð½Ð´Ñ ÑÑÑÐ½Ð¾Ð³Ð¾ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
            dispenserConfigurationBackup:
                "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ Ð¸ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÐµ ÑÐµÐºÑÑÑÑ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ Ð¼Ð°ÑÐ¸Ð½Ñ Ð´Ð»Ñ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ ÑÐµÐ·ÐµÑÐ²Ð½Ð¾Ð¹ ÐºÐ¾Ð¿Ð¸Ð¸",
            dispensingLogic:
                "ÐÐ¾Ð³Ð¸ÑÐµÑÐºÐ¸Ðµ ÑÐ¸Ð¿Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð¼Ð¾Ð³ÑÑ Ð¾Ð±ÐµÑÐ¿ÐµÑÐ¸ÑÑ ÑÐ°Ð·Ð»Ð¸ÑÐ½Ð¾Ðµ Ð¿Ð¾Ð²ÐµÐ´ÐµÐ½Ð¸Ðµ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð¹ ÐºÐ°Ð½Ð¸ÑÑÑÑ, ÐºÐ¾Ð³Ð´Ð° Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð±Ð¾Ð»ÑÑÐµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°, ÑÐµÐ¼ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¾ Ð¸Ð»Ð¸ Ð¶ÐµÐ»Ð°ÑÐµÐ»ÑÐ½Ð¾. ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÑÐ¸Ð¿Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð·Ð°Ð´Ð°ÑÑÑÑ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ",
            enableTmc: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ð² TMC",
            enableUserIdentification: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð²Ð¾Ð¹ÑÐ¸ Ð² ÑÐ¸ÑÑÐµÐ¼Ñ, Ð¿ÑÐµÐ¶Ð´Ðµ ÑÐµÐ¼ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²ÐºÐ° Ð±ÑÐ´ÐµÑ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð°",
            machineUnit: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð² ÐºÐ°Ð½Ð¸ÑÑÑÐ°Ñ",
            minDispensedAmount:
                "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ Ð´Ð¾Ð·Ð¸ÑÑÐµÐ¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑ, ÑÐºÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð±ÑÑÑ Ð¾ÑÐ´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾, ÑÑÐ¾Ð±Ñ ÑÑÐ¸ÑÐ°ÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð½Ð¾Ð¹ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÑ (ÑÑÐ¾Ð±Ñ Ð¸Ð·Ð±ÐµÐ¶Ð°ÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸)",
            minimalDispenseAmount:
                "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²ÐºÐ¸ - ÑÑÐ¾ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÑÐµÐºÐ¾Ð¼ÐµÐ½Ð´ÑÐµÐ¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°, ÐºÐ¾ÑÐ¾ÑÐ¾Ðµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð ÑÐ»ÑÑÐ°Ðµ Ð½Ð°ÑÑÑÐµÐ½Ð¸Ñ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ (ÐÐ¾Ð·Ð¸ÑÐ¾Ð²ÐºÐ° Ð²ÑÐµ ÐµÑÐµ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð°)",
            missingAutotaskCanisters: "ÐÐ¾Ð»Ð¶Ð½Ð° Ð±ÑÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð° ÐºÐ°Ðº Ð¼Ð¸Ð½Ð¸Ð¼ÑÐ¼ 1 ÐºÐ°Ð½Ð¸ÑÑÑÐ°",
            missingAutotaskChannels: "ÐÐ¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð²ÑÐ±ÑÐ°Ð½ ÐºÐ°Ðº Ð¼Ð¸Ð½Ð¸Ð¼ÑÐ¼ 1 ÐºÐ°Ð½Ð°Ð»",
            missingAutotaskChannelsValue: "ÐÐ±ÑÐµÐ¼ Ð²ÑÐµÑ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð² Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½",
            missingAutotaskCleanTime: "ÐÑÐµÐ¼Ñ ÐºÐ»Ð¸Ð½Ð¸Ð½Ð³Ð° Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¾",
            missingAutotaskName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ Ð·Ð°Ð´Ð°Ð½Ð¸Ñ Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¾",
            missingAutotaskRecirculation: "Ð¡Ð»ÐµÐ´ÑÐµÑ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð²ÑÐµÐ¼Ñ Ð¸ ÑÐºÐ¾ÑÐ¾ÑÑÑ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ð¸",
            missingAutotaskStirring: "ÐÑÐµÐ¼Ñ Ð¸ ÑÐºÐ¾ÑÐ¾ÑÑÑ Ð¿ÑÐ¾ÑÐµÑÑÐ° Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ñ Ð´Ð¾Ð»Ð¶Ð½Ñ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ",
            missingAutotaskVolume: "ÐÐ±ÑÐµÐ¼ Ð¾ÑÐ¸ÑÑÐºÐ¸ Ð²ÐµÐ½ÑÐ¸Ð»ÐµÐ¹ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½",
            placeCanSensor:
                "Ð­ÑÐ° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð°ÐºÑÐ¸Ð²Ð¸ÑÑÐµÑ Ð´Ð°ÑÑÐ¸Ðº Ð´Ð»Ñ ÑÐ°Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ ÑÐ°ÑÑ - Ð²ÑÐ´Ð°ÑÐ° Ð½Ðµ Ð½Ð°ÑÐ½ÐµÑÑÑ, ÐµÑÐ»Ð¸ ÑÐ°ÑÐ° Ð½Ðµ Ð±ÑÐ´ÐµÑ Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð°",
            placeCanSensorDelay:
                "Ð ÐµÐºÐ¾Ð¼ÐµÐ½Ð´ÑÐµÐ¼Ð°Ñ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° ÑÐ²ÑÐ·Ð°Ð½Ð° Ñ Ð´Ð°ÑÑÐ¸ÐºÐ¾Ð¼ Ð¼ÐµÑÑÐ° ÑÐ°ÑÑ Ð­ÑÐ¾ Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÑÐµÑ, ÑÑÐ¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð½Ð°ÑÐ¸Ð½Ð°ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¿ÐµÑÐ¸Ð¾Ð´Ð° Ð²ÑÐµÐ¼ÐµÐ½Ð¸, Ð² ÑÐµÑÐµÐ½Ð¸Ðµ ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ ÑÐ°ÑÐ° Ð±ÑÐ»Ð° Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾ ÑÐ°Ð·Ð¼ÐµÑÐµÐ½Ð°",
            purgeVolume:
                "ÐÐ±ÑÐµÐ¼ Ð¾ÑÐ¸ÑÑÐºÐ¸ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÑÐºÐ¾Ð»ÑÐºÐ¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ ÑÐ´Ð°Ð»ÑÐµÑÑÑ Ð¿ÑÐ¸ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ð¸ Ð¸Ð½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸",
            rccUrl: "Redlike Control Center (RCC) Ð¾ÑÐ²ÐµÑÐ°ÐµÑ Ð·Ð° ÑÐ²ÑÐ·Ñ Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ¾Ð¼",
            refillThreshold:
                "ÐÑÐ»Ð¸ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð² ÐºÐ°Ð½Ð¸ÑÑÑÐµ Ñ Ð´Ð°Ð½Ð½ÑÐ¼ UFI Ð¸Ð»Ð¸ Ð½Ð¾Ð¼ÐµÑÐ¾Ð¼ Ð¿Ð°ÑÑÐ¸Ð¸ ÑÐ¿Ð°Ð´ÐµÑ Ð½Ð¸Ð¶Ðµ ÑÑÐ¾Ð³Ð¾ Ð¿ÑÐµÐ´ÐµÐ»Ð°, ÑÐ°ÐºÐ¾Ð¹ UFI Ð¸Ð»Ð¸ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ Ð±ÑÐ´ÑÑ ÑÑÐ¸Ð»Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ñ.",
            refillThresholdBatch:
                "ÐÑÐ»Ð¸ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð² ÐºÐ°Ð½Ð¸ÑÑÑÐµ Ñ Ð´Ð°Ð½Ð½ÑÐ¼ Ð½Ð¾Ð¼ÐµÑÐ¾Ð¼ Ð¿Ð°ÑÑÐ¸Ð¸ ÑÐ¿Ð°Ð´ÐµÑ Ð½Ð¸Ð¶Ðµ ÑÑÐ¾Ð³Ð¾ Ð¿ÑÐµÐ´ÐµÐ»Ð°, ÑÐ°ÐºÐ¾Ð¹ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ Ð±ÑÐ´ÐµÑ Ð²ÑÐ±ÑÐ¾ÑÐµÐ½.",
            refillThresholdUfi:
                "ÐÑÐ»Ð¸ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð² ÐºÐ°Ð½Ð¸ÑÑÑÐµ Ñ Ð´Ð°Ð½Ð½ÑÐ¼ UFI ÑÐ¿Ð°Ð´ÐµÑ Ð½Ð¸Ð¶Ðµ ÑÑÐ¾Ð³Ð¾ Ð¿ÑÐµÐ´ÐµÐ»Ð°, ÑÐ°ÐºÐ¾Ð¹ UFI Ð±ÑÐ´ÐµÑ ÑÑÐ¸Ð»Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°Ð½.",
            removeCanSensor:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð°ÐºÑÐ¸Ð²Ð¸ÑÑÐµÑ Ð´Ð°ÑÑÐ¸Ðº Ð´Ð»Ñ ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ñ ÑÐ°ÑÑ - Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð½Ðµ ÑÑÐ¸ÑÐ°ÐµÑÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð½ÑÐ¼, ÐµÑÐ»Ð¸ ÑÐ°ÑÐ° Ð½Ðµ Ð±ÑÐ»Ð° ÑÐ´Ð°Ð»ÐµÐ½Ð°",
            removeCanSensorDelay:
                "Ð ÐµÐºÐ¾Ð¼ÐµÐ½Ð´ÑÐµÐ¼Ð°Ñ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° ÑÐ²ÑÐ·Ð°Ð½Ð° Ñ ÑÐ´Ð°Ð»ÐµÐ½Ð¸ÐµÐ¼ Ð´Ð°ÑÑÐ¸ÐºÐ° ÑÐ°ÑÑ Ð­ÑÐ¾ Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÑÐµÑ, ÑÑÐ¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð±ÑÐ»Ð¾ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¿ÐµÑÐ¸Ð¾Ð´Ð° Ð²ÑÐµÐ¼ÐµÐ½Ð¸, Ð² ÑÐµÑÐµÐ½Ð¸Ðµ ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ ÑÐ°ÑÐ° Ð±ÑÐ»Ð° ÑÐ´Ð°Ð»ÐµÐ½Ð°",
            skipPlaceCanDialog:
                "ÐÑÐ»Ð¸ ÑÑÐ° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð²ÐºÐ»ÑÑÐµÐ½Ð°, Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ Ð±ÑÐ´ÐµÑ Ð¶Ð´Ð°ÑÑ, Ð¿Ð¾ÐºÐ° Ð±ÑÐ´ÐµÑ Ð½Ð°Ð¶Ð°ÑÐ° ÐºÐ½Ð¾Ð¿ÐºÐ° ÐÐ Ð¿Ð¾ÑÐ»Ðµ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ ÑÐ°ÑÑ, Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð½Ð°ÑÐ½ÐµÑ Ð¿ÑÐ¾ÑÐµÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            skipRemoveCanDialog:
                "ÐÑÐ»Ð¸ ÑÑÐ° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð²ÐºÐ»ÑÑÐµÐ½Ð°, Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ Ð±ÑÐ´ÐµÑ Ð¶Ð´Ð°ÑÑ, Ð¿Ð¾ÐºÐ° Ð±ÑÐ´ÐµÑ Ð½Ð°Ð¶Ð°ÑÐ° ÐºÐ½Ð¾Ð¿ÐºÐ° ÐÐ Ð¿Ð¾ÑÐ»Ðµ ÑÐ½ÑÑÐ¸Ñ ÑÐ°ÑÑ, Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð¿Ð¾ÑÑÐ¸ÑÐ°ÐµÑ Ð¿ÑÐ¾ÑÐµÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð½ÑÐ¼",
            smartPurgeType:
                "Ð¢Ð¸Ð¿ Ð¾ÑÐ¸ÑÑÐºÐ¸ Ð¼Ð¾Ð¶ÐµÑ Ð¿ÑÐµÐ´ÑÑÐ¼Ð°ÑÑÐ¸Ð²Ð°ÑÑ Ð»Ð¸Ð±Ð¾ Ð´Ð¾Ð·ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ, Ð»Ð¸Ð±Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¿Ð»ÑÑ Ð´ÑÑÐ³Ð¸Ðµ ÑÐ¾Ð±ÑÑÐ¸Ñ Ð¾ÑÐ¸ÑÑÐºÐ¸ Ð¿ÑÐ¸ Ð¿ÑÐ¾Ð²ÐµÑÐºÐµ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸ ÑÐ¼Ð½Ð¾Ð¹ Ð¾ÑÐ¸ÑÑÐºÐ¸",
            splitFormula:
                "ÐÑÐ»Ð¸ ÑÑÐµÐ±ÑÐµÐ¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð¿ÑÐµÐ²ÑÑÐ°ÐµÑ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð´Ð¾Ð·Ð¸ÑÑÐµÐ¼Ð¾Ð³Ð¾ Ð²ÐµÑÐµÑÑÐ²Ð°, Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾ÑÑÐ¸Ñ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ, ÑÐ½Ð¾Ð²Ð° Ð½Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ, Ð° Ð·Ð°ÑÐµÐ¼ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "ÐÐ°Ð·Ð° Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐµÐ½Ð° Ñ Ð¿Ð¾Ð¼Ð¾ÑÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð°, Ð¿ÑÐµÐ¶Ð´Ðµ ÑÐµÐ¼ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¾ ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÑÐµÑ, ÑÑÐ¾ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð°Ñ Ð±Ð°Ð·Ð°",
            validateColorantsDuringInit:
                "ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð±ÑÐ´ÐµÑ ÑÑÐ°Ð²Ð½Ð¸Ð²Ð°ÑÑÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹ Ð´Ð°Ð½Ð½ÑÑ ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐ°Ð· Ð¿ÑÐ¸ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÐºÐµ RCC. Ð ÑÐ»ÑÑÐ°Ðµ Ð½ÐµÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ñ Ð²ÑÐ´Ð°ÐµÑÑÑ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ðµ. "
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð²Ð²Ð¾Ð´Ð° ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð° Ð²ÑÑÑÐ½ÑÑ.",
            canisterBarcodes:
                "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð¾Ð±Ð·Ð¾ÑÐ¾Ð¼ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð¾Ð² ÐºÐ°Ð½Ð¸ÑÑÑ Ð¸ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð° ÐºÐ°Ð½Ð¸ÑÑÑÑ",
            canisterLevel:
                "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð¾Ð±Ð·Ð¾ÑÐ¾Ð¼ ÑÑÐ¾Ð²Ð½ÐµÐ¹ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ Ð¸ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ ÑÑÐ¾Ð²Ð½Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
            canisters: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ñ Ð¾Ð±Ð·Ð¾ÑÐ¾Ð¼ ÑÑÐ¾Ð²Ð½ÐµÐ¹ ÐºÐ°Ð½Ð¸ÑÑÑ Ð¸ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¾Ð² Ð¸Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð¿Ð¾Ð¸ÑÐºÐ° Ð½Ð¾Ð²Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ Ð² ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¼ ÑÐ°Ð¹Ð»Ðµ",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð¾Ð±Ð·Ð¾ÑÐ¾Ð¼ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð½ÑÑ Ð´Ð¾Ð»Ð¸Ð²Ð°Ð½Ð¸Ð¹ ÐºÐ°Ð½Ð¸ÑÑÑ",
            customFormula: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð½Ð¾Ð²Ð¾Ð¹ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            customers: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ñ Ð¾Ð±Ð·Ð¾ÑÐ¾Ð¼ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð² Ð¸ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð¸Ñ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ/ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ/ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ñ",
            dispensingHistory: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ñ Ð¾Ð±Ð·Ð¾ÑÐ¾Ð¼ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð½ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð¾Ðº",
            favorites: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð²ÑÐ±Ð¾ÑÐ° Ð¿Ð¾Ð´ÑÐ¾Ð´ÑÑÐµÐ¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            help: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÐµÐ¹ Ð¾Ð± ÑÑÐ¾Ð²Ð½Ðµ ÑÐµÑÐ²Ð¸ÑÐ°, ÐµÑÐ»Ð¸ Ð¾Ð½Ð° Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð° Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ¾Ð¼",
            hideItems: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð¿Ð¾Ð¼ÐµÑÐ¸ÑÑ ÑÐ¾Ð²Ð°ÑÑ Ð¸ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð¸ ÐºÐ°Ðº ÑÐºÑÑÑÑÐµ.",
            historyOfOrders: "ÐÐµÐ¹ÑÑÐ²ÑÐµÑ Ð¸ÑÐºÐ»ÑÑÐ¸ÑÐµÐ»ÑÐ½Ð¾ Ð´Ð»Ñ %{name}, Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ Ð¿Ð°Ð½ÐµÐ»Ñ Ñ Ð¾Ð±Ð·Ð¾ÑÐ¾Ð¼ Ð²ÑÐ´Ð°Ð½Ð½ÑÑ Ð·Ð°ÐºÐ°Ð·Ð¾Ð².",
            machineReset: "ÐÐ°Ð¿ÑÑÐºÐ°ÐµÑ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÑ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "ÐÐ°ÐºÐ°Ð·Ñ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð±ÑÐ»Ð¸ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ñ Ñ ÑÑÐ¾Ð³Ð¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
            purge: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð²ÑÐ±Ð¾ÑÐ° ÑÐµÐ¶Ð¸Ð¼Ð° Ð¾ÑÐ¸ÑÑÐºÐ¸ ÐºÐ°Ð½Ð¸ÑÑÑ",
            quickTint: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÑÑÑÐ½Ð¾Ð³Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            searchFormula: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÑ Ð¿Ð¾Ð¸ÑÐºÐ° Ð½Ð¾Ð²Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            spectro: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ ÑÑÐ½ÐºÑÐ¸ÐµÐ¹ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ Ñ Ð¿Ð¾Ð¼Ð¾ÑÑÑ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾Ð½Ð°",
            stir: "ÐÑÐºÑÑÐ²Ð°ÐµÑ Ð¾ÐºÐ½Ð¾ Ñ ÑÑÐ½ÐºÑÐ¸ÐµÐ¹ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "ÐÐ°ÐºÐ·Ð°Ð·Ñ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð±ÑÐ»Ð¸ Ð¿Ð¾Ð»ÑÑÐµÐ½Ñ ÑÑÐ¸Ð¼ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ¾Ð¼"
        },
        noHelpForLicense: "Ð¡Ð¾Ð³Ð»Ð°ÑÐ½Ð¾ ÐÐ°ÑÐµÐ¹ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸, Ð¿Ð¾Ð¼Ð¾ÑÑ Ð½Ðµ Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð»ÑÐµÑÑÑ, Ð¿Ð¾Ð¿ÑÐ¾ÑÐ¸ÑÐµ ÐÐ°ÑÐµÐ³Ð¾ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ° Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÐµ",
        posInfo: {
            sync: "Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÑÐµÑ Ð´Ð°Ð½Ð½ÑÐµ Ñ ÑÑÐ±ÑÐ¸ÐºÐ¾Ð¹ Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ"
        },
        poweredByDeso: "ÐÐ° Ð¾ÑÐ½Ð¾Ð²Ðµ %{name}",
        priceSettings: {
            VatPrice: "Ð£ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÐ¼Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ ÐÐÐ¡ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð±ÑÐ´ÐµÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¼ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¹, ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² %",
            VatPriceProduct:
                "Ð£ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÐ¼Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ ÐÐÐ¡ Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð±ÑÐ´ÐµÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¼ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¹, ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² %",
            basePurchase: "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð° Ð´Ð»Ñ Ð±Ð°Ð·Ñ ÑÐ°ÑÑÑÐ¸ÑÑÐ²Ð°ÐµÑÑÑ Ð·Ð° Ð»Ð¸ÑÑ (Ð²ÐºÐ»ÑÑÐ°Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð±Ð°Ð·Ð¾Ð²ÑÑ Ð¿Ð»Ð°ÑÑ).",
            basePurchasePriceProduct: "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ Ð±Ð°Ð·Ñ. Ð£ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ. ",
            baseSell: "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ Ð·Ð° Ð±Ð°Ð·Ñ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð±Ð°Ð·Ð¾Ð²ÑÑ Ð¼Ð°ÑÐ¶Ñ / Ð½Ð°ÑÐµÐ½ÐºÑ / ÑÐºÐ¸Ð´ÐºÑ). ",
            baseSellFull: "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð° Ð´Ð»Ñ Ð±Ð°Ð·Ñ (Ð²ÐºÐ»ÑÑÐ°Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð±Ð°Ð·Ñ) Ð±ÐµÐ· ÑÐºÐ¸Ð´ÐºÐ¸",
            cntName: "ÐÐ¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, Ðº ÐºÐ°ÐºÐ¾Ð¼Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ ÑÐµÐ½Ð°. ",
            cntPurchase: "Ð¦ÐµÐ½Ð° Ð½Ð° ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¸ÑÐºÐ»ÑÑÐ¸ÑÐµÐ»ÑÐ½Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸)",
            cntPurchaseByName:
                "Ð¦ÐµÐ½Ð°  ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹ ÑÐ°ÑÑÑÐ¸ÑÑÐ²Ð°ÐµÑÑÑ Ð¸Ð½Ð´Ð¸Ð²Ð¸Ð´ÑÐ°Ð»ÑÐ½Ð¾ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¸ÑÐºÐ»ÑÑÐ¸ÑÐµÐ»ÑÐ½Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸)",
            cntPurchasePricePerLiter: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð·Ð° Ð»Ð¸ÑÑ (Ð±ÐµÐ· Ð¼Ð°ÑÐ¶Ð¸ Ð¸Ð»Ð¸ Ð½Ð°ÑÐµÐ½ÐºÐ¸)",
            cntSell: "Ð¦ÐµÐ½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹ (Ð²ÐºÐ»ÑÑÐ°Ñ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸ Ð¸ Ð¼Ð°ÑÐ¶Ñ / Ð½Ð°ÑÐµÐ½ÐºÑ)",
            cntSellByName:
                "Ð¦ÐµÐ½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÐ¼ÑÑ Ð² Ð¿ÑÐ¾Ð´ÑÐºÑÐµ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹ ÑÐ°ÑÑÑÐ¸ÑÑÐ²Ð°ÐµÑÑÑ Ð¸Ð½Ð´Ð¸Ð²Ð¸Ð´ÑÐ°Ð»ÑÐ½Ð¾ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ (Ð²ÐºÐ»ÑÑÐ°Ñ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸ Ð¸ Ð¼Ð°ÑÐ¶Ñ / Ð½Ð°ÑÐµÐ½ÐºÑ)",
            cntSellFull: "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð° Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
            cntSellFullByName:
                "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð², ÑÐ°ÑÑÑÐ¸ÑÑÐ²Ð°ÐµÑÑÑ Ð¸Ð½Ð´Ð¸Ð²Ð¸Ð´ÑÐ°Ð»ÑÐ½Ð¾ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¸ÑÐºÐ»ÑÑÐ¸ÑÐµÐ»ÑÐ½Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ) Ð±ÐµÐ· ÑÐºÐ¸Ð´ÐºÐ¸",
            cntSellPricePerLiter:
                "Ð¦ÐµÐ½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð·Ð° Ð»Ð¸ÑÑ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¸ÑÐºÐ»ÑÑÐ¸ÑÐµÐ»ÑÐ½Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ) ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð° Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ",
            cntVat: "ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ ÐÐÐ¡ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾ Ð²%",
            colorants:
                "Ð¦ÐµÐ½Ñ Ð½Ð° Ð½ÐµÐ¿Ð°ÑÐµÐ½ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸ Ð±ÑÐ´ÑÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¼Ð¸ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð­ÑÐ° ÑÑÐ½ÐºÑÐ¸Ñ Ð¾ÑÐ¾Ð±ÐµÐ½Ð½Ð¾ Ð¿Ð¾Ð»ÐµÐ·Ð½Ð° Ð´Ð»Ñ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÐÐÐ¡",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "Ð¦ÐµÐ½Ñ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ Ð±ÑÐ´ÑÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¼Ð¸ Ð´Ð»Ñ Ð²ÑÐµÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¹. Ð ÐµÐºÐ¾Ð¼ÐµÐ½Ð´ÑÐµÐ¼Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð° Ñ ÑÑÐµÑÐ¾Ð¼ ÑÐºÐ¸Ð´ÐºÐ¸. Ð£ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ. ",
            currencyCodeNew: "ÐÐ¾Ð´ Ð²Ð°Ð»ÑÑÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð² Ð¾ÑÐ¸ÑÐ¸Ð°Ð»ÑÐ½Ð¾Ð¹ ÑÐ¾ÑÐ¼Ðµ Ð¸Ð· ÑÑÐµÑ Ð±ÑÐºÐ², Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ, EUR",
            currencyNameNew: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð²Ð°Ð»ÑÑÑ, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ, ÐµÐ²ÑÐ¾",
            currencyRateNew:
                "ÐÐ°Ð»ÑÑÐ½ÑÐ¹ ÐºÑÑÑ Ð¿Ð¾ Ð¾ÑÐ½Ð¾ÑÐµÐ½Ð¸Ñ Ðº Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ 25,855 ÐºÑÐ¾Ð½ Ð·Ð° 1 â¬ ÐÑÑÑ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾ÑÑÐ¾ÑÐ½Ð½Ð¾",
            currencyRoundingNew:
                "ÐÐºÑÑÐ³Ð»ÐµÐ½Ð¸Ðµ ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑ Ð½Ð°Ð¸Ð¼ÐµÐ½ÑÑÑÑ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½ÑÑ ÑÑÐ¼Ð¼Ñ Ð¿Ð»Ð°ÑÐµÐ¶Ð° Ð´Ð»Ñ Ð²Ð°Ð»ÑÑÑ, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ, ÐµÐ²ÑÐ¾ Ð¸Ð¼ÐµÐµÑ Ð¾ÐºÑÑÐ³Ð»ÐµÐ½Ð¸Ðµ 0,01, Ð¿Ð¾ÑÐºÐ¾Ð»ÑÐºÑ Ð½Ð°Ð¸Ð¼ÐµÐ½ÑÑÐµÐµ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ ÑÐ¾ÑÑÐ°Ð²Ð»ÑÐµÑ 1 ÑÐµÐ½Ñ",
            currencySymbolNew: "ÐÑÐ¸ÑÐ¸Ð°Ð»ÑÐ½ÑÐ¹ ÑÐ¸Ð¼Ð²Ð¾Ð» Ð²Ð°Ð»ÑÑÑ, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ, â¬ Ð·Ð° ÐµÐ²ÑÐ¾",
            defaultPrice: "Ð¦ÐµÐ½Ð° ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð±Ð°Ð·Ðµ (Ð±ÐµÐ· ÐÐÐ¡)",
            defaultPriceGroup: "Ð¦ÐµÐ½Ð° ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð´Ð»Ñ ÑÐµÐ½Ð¾Ð²Ð¾Ð¹ Ð³ÑÑÐ¿Ð¿Ñ ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ (Ð±ÐµÐ· ÐÐÐ¡)",
            defaultVatPrice: "ÐÐÐ¡ Ð½Ð° ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ",
            discountHeader: "Ð¡ÐºÐ¸Ð´ÐºÐ° Ð²ÑÑÐ¸ÑÐ°ÐµÑ ÑÐºÐ°Ð·Ð°Ð½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð¸Ð· Ð·Ð°ÐºÑÐ¿Ð¾ÑÐ½Ð¾Ð¹ ÑÐµÐ½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°, ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½Ð° Ð² % ",
            discountHeaderProduct:
                "Ð¡ÐºÐ¸Ð´ÐºÐ° Ð²ÑÑÐ¸ÑÐ°ÐµÑ ÑÐºÐ°Ð·Ð°Ð½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð¸Ð· ÑÐµÐ½Ñ ÐºÐ¾Ð»ÐµÑÐ¾Ð²Ð°Ð½Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°, ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½Ð° Ð²% ",
            export: "Ð­ÐºÑÐ¿Ð¾ÑÑ ÑÐ°Ð¹Ð»Ð° Ñ ÑÐµÐºÑÑÐ¸Ð¼Ð¸ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½ÑÐ¼Ð¸ ÑÐµÐ½Ð°Ð¼Ð¸. ÐÐ³Ð¾ Ð¼Ð¾Ð¶Ð½Ð¾ ÑÐ½Ð¾Ð²Ð° Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ ÑÐµÐ½. ",
            import: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÑÐ¹ÑÐµ ÑÐ°Ð¹Ð» Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ ÑÐ¾ÑÐ¼Ð°ÑÐ° (ÑÐºÑÐ¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐ¹), ÑÑÐ¾Ð±Ñ Ð²ÑÑÐ°Ð²Ð¸ÑÑ Ð¸Ð»Ð¸ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ ÑÐµÐ½Ñ ",
            localPrices:
                "ÐÑÐµÐ´Ð»Ð°Ð³Ð°ÐµÐ¼ÑÐµ ÑÐµÐ½Ñ Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð»ÑÑÑÑÑ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÐ¾Ð¼ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ. ÐÑÐ»Ð¸ ÑÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð²ÐºÐ»ÑÑÐµÐ½, ÑÑÐ¸ ÑÐµÐ½Ñ Ð¼Ð¾Ð¶Ð½Ð¾ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾ Ð½Ð° ÑÑÐ¾Ð¼ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐµ. ",
            margin: "ÐÑÐ±ÐµÑÐ¸ÑÐµ, ÐºÐ°ÐºÐ¾Ð¹ ÑÐ°ÑÑÐµÑ ÑÐµÐ½Ñ ÑÐ»ÐµÐ´ÑÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ Ð´Ð»Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸Ñ Ð¾ÐºÐ¾Ð½ÑÐ°ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾Ð¹ ÑÐµÐ½Ñ. Ð¡ÑÐ¼Ð¼Ð° Ð¼Ð°ÑÐ¶Ð¸ Ð¸ Ð½Ð°ÑÐµÐ½ÐºÐ¸, Ð² ÑÐ¾ Ð²ÑÐµÐ¼Ñ ÐºÐ°Ðº ÑÐºÐ¸Ð´ÐºÐ° Ð²ÑÑÐ¸ÑÐ°ÐµÑÑÑ Ð¸Ð· Ð·Ð°Ð´Ð°Ð½Ð½Ð¾Ð¹ ÑÐµÐ½Ñ Ð¿ÑÐ¾Ð´Ð°Ð¶Ð¸. ",
            marginAll: "Ð Ð°Ð·Ð¼ÐµÑ Ð¼Ð°ÑÐ¶Ð¸/Ð½Ð°ÑÐµÐ½ÐºÐ¸ Ð·Ð° Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¼Ð°ÑÐ¶Ñ/Ð½Ð°ÑÐµÐ½ÐºÑ)",
            marginHeader: "ÐÐ°ÑÐ¶Ð° Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ðº Ð·Ð°ÐºÑÐ¿Ð¾ÑÐ½Ð¾Ð¹ ÑÐµÐ½Ðµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°, ÑÑÑÐ°Ð½Ð¾Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð²% ",
            marginHeaderProduct:
                "ÐÐ°ÑÐ¶Ð° Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ðº Ð·Ð°ÐºÑÐ¿Ð¾ÑÐ½Ð¾Ð¹ ÑÐµÐ½Ðµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°, ÑÑÑÐ°Ð½Ð¾Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² % ",
            marginPerPkg: "Ð Ð°Ð·Ð¼ÐµÑ Ð¼Ð°ÑÐ¶Ð¸/Ð½Ð°ÑÐµÐ½ÐºÐ¸ Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¼Ð°ÑÐ¶Ñ/Ð½Ð°ÑÐµÐ½ÐºÑ)",
            markupHeader: "ÐÐ°ÑÐµÐ½ÐºÐ° Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ðº Ð·Ð°ÐºÑÐ¿Ð¾ÑÐ½Ð¾Ð¹ ÑÐµÐ½Ðµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°, ÑÑÑÐ°Ð½Ð¾Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² % ",
            markupHeaderProduct:
                "ÐÐ°ÑÐµÐ½ÐºÐ° Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ðº Ð·Ð°ÐºÑÐ¿Ð¾ÑÐ½Ð¾Ð¹ ÑÐµÐ½Ðµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°, ÑÑÑÐ°Ð½Ð¾Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² %",
            packagePricing: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð½Ð°ÑÐµÐ½ÐºÐ° ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð¸Ð½Ð´Ð¸Ð²Ð¸Ð´ÑÐ°Ð»ÑÐ½Ð¾ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ ÑÐ°Ð·Ð¼ÐµÑÐ° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°Ð°",
            packageSurcharge:
                "Ð¦ÐµÐ½Ñ Ð½Ð° ÑÐ¿Ð°Ð²ÐºÑ Ð±ÑÐ´ÑÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¼Ð¸ Ñ ÑÑÑÑÐ¾Ð¼ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð½Ð¾Ð¹ Ð½Ð°ÑÐµÐ½ÐºÐ¸, ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð¼ÐµÑÑÐ½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ",
            priceDefinition: "ÐÐ°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÐºÐ°ÐºÐ¸Ðµ ÑÐ¸Ð¿Ñ ÑÐµÐ½ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÑÑÑÑ Ð¿ÑÐ¸ ÑÐ°ÑÑÐµÑÐµ Ð¾ÐºÐ¾Ð½ÑÐ°ÑÐµÐ»ÑÐ½ÑÑ ÑÐµÐ½. ",
            priceGroupNumber:
                "Ð­ÑÐ¾Ñ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐµÐ½Ð¾Ð²ÑÑ Ð³ÑÑÐ¿Ð¿ Ð±ÑÐ´ÐµÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑÑÑ. ÐÐ¸Ð°Ð¿Ð°Ð·Ð¾Ð½ Ð´Ð»Ñ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÑ ÑÐµÐ½Ð¾Ð²ÑÑ Ð³ÑÑÐ¿Ð¿ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ Ð² ÐÐ½Ð°ÑÐµÐ½Ð¸ÑÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ. ",
            priceGroupPricePerLiter: "Ð¦ÐµÐ½Ð° ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ, Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÐ¼Ð°Ñ Ð¿ÑÐ¸ ÑÐ°ÑÑÐµÑÐµ ÑÐµÐ½Ñ Ð³ÑÑÐ¿Ð¿Ñ ÑÐµÐ½",
            priceGroups:
                "Ð ÑÐµÐ½Ð¾Ð²ÑÑ Ð³ÑÑÐ¿Ð¿Ð°Ñ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÐµÑÑÑ Ð½Ð¾Ð¼ÐµÑ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²ÑÑÑÐµÐ¹ ÑÐµÐ½Ð¾Ð²Ð¾Ð¹ Ð³ÑÑÐ¿Ð¿Ñ (Ð³ÑÐ°Ð½Ð¸ÑÑ Ð·Ð°Ð´Ð°ÑÑÑÑ Ð² Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ Ð¸Ð»Ð¸ Ð² Ð¾Ð±ÑÐ¸Ñ ÑÐµÐ½Ð°Ñ)",
            priceGroupsEnabled:
                "Ð­ÑÐ° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð²Ð°Ð¼ ÑÐ°Ð±Ð¾ÑÐ°ÑÑ Ñ ÑÐµÐ½Ð¾Ð²ÑÐ¼Ð¸ Ð³ÑÑÐ¿Ð¿Ð°Ð¼Ð¸. ÐÐ¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ Ð´Ð¸Ð°Ð¿Ð°Ð·Ð¾Ð½ Ð² Ð·Ð½Ð°ÑÐµÐ½Ð¸ÑÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð¸ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐµ ÑÐµÐ½Ñ Ð² ÑÐ°ÑÑÐµÐ½ÐºÐ°Ñ Ð½Ð° ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ. ",
            priceGroupsGeneric:
                "Ð¦ÐµÐ½Ð¾Ð²ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ - ÑÑÐ¾ Ð¸Ð½ÑÐµÑÐ²Ð°Ð»Ñ ÑÐµÐ½ Ð½Ð° ÐºÐ¾Ð½ÐµÑÐ½ÑÑ ÐºÑÐ°ÑÐºÑ Ð½Ð° Ð¾ÑÐ½Ð¾Ð²Ðµ ÑÐµÐ½ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹ Ð² ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
            productBasePackageSellPrice: "Ð¦ÐµÐ½Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ð´Ð°Ð½Ð½Ð¾Ð¹ Ð±Ð°Ð·Ñ. Ð£ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ. ",
            productBaseSellPrice:
                "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° Ð»Ð¸ÑÑ Ð±Ð°Ð·Ñ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð±Ð°Ð·Ð¾Ð²ÑÑ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ), ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ",
            productBaseVat: "Ð Ð°Ð·Ð¼ÐµÑ ÐÐÐ¡ Ð·Ð° Ð±Ð°Ð·Ñ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐµ, ÑÐºÐ°Ð·Ð°Ð½Ð° Ð² %. ",
            productName: "ÐÐ¿ÑÐµÐ´ÐµÐ»Ð¸ÑÐµ Ðº ÐºÐ°ÐºÐ¾Ð¹ ÑÐ¾Ð²Ð°ÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ðµ Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ ÑÐµÐ½Ð° ",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing:
                "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð° Ð´Ð»Ñ Ð²ÑÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ Ð¿ÑÐ¸ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ð¸ Ð² Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÑÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
            productSize: "ÐÐ¿ÑÐµÐ´ÐµÐ»Ð¸ÑÐµ, Ðº ÐºÐ°ÐºÐ¾Ð¹ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐµ Ð±Ð°Ð·Ñ Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ ÑÐµÐ½Ð°",
            productVat: "Ð Ð°Ð·Ð¼ÐµÑ ÐÐÐ¡ Ð·Ð° Ð±Ð°Ð·Ñ, ÑÐºÐ°Ð·ÑÐ²Ð°ÐµÑÑÑ Ð² %",
            products:
                "Ð¡Ð³ÐµÐ½ÐµÐ½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ ÑÐµÐ½Ñ  Ð±ÑÐ´ÑÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¼Ð¸ Ð´Ð»Ñ Ð²ÑÐµÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð². Ð Ð·Ð°ÐºÑÐ¿Ð¾ÑÐ½Ð¾Ð¹ ÑÐµÐ½Ðµ ÑÐµÐºÐ¾Ð¼ÐµÐ½Ð´ÑÐµÑÑÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð°ÑÐµÐ½ÐºÑ Ð¸Ð»Ð¸ Ð¼Ð°ÑÐ¶Ñ. Ð£ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ.",
            productsSellPrice:
                "Ð¡Ð³ÐµÐ½ÐµÐ½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ ÑÐµÐ½Ñ  Ð±ÑÐ´ÑÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¼Ð¸ Ð´Ð»Ñ Ð²ÑÐµÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð². Ð ÑÐµÐ½Ñ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ ÑÐµÐºÐ¾Ð¼ÐµÐ½Ð´ÑÐµÑÑÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÑÐºÐ¸Ð´ÐºÑ. Ð£ÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð²Ð°Ð»ÑÑÐµ. ",
            sellPriceAll: "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ñ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº (Ð² ÑÐ¾Ð¼ ÑÐ¸ÑÐ»Ðµ Ð±Ð°Ð·Ð°, ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ, Ð¼Ð°ÑÐ¶Ð° / Ð½Ð°ÑÐµÐ½ÐºÐ°)",
            sellPricePerKg: "Ð¦ÐµÐ½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼Ð¼ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¾ÑÐ½Ð¾Ð²Ñ, ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸, Ð´Ð¾Ð¿Ð»Ð°ÑÑ Ð¸ Ð¼Ð°ÑÐ¶Ñ / Ð½Ð°ÑÐµÐ½ÐºÑ)",
            sellPricePerL: "Ð¦ÐµÐ½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° Ð»Ð¸ÑÑ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¾ÑÐ½Ð¾Ð²Ñ, ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸, Ð´Ð¾Ð¿Ð»Ð°ÑÑ Ð¸ Ð¼Ð°ÑÐ¶Ñ / Ð½Ð°ÑÐµÐ½ÐºÑ)",
            sellPricePerPkg: "Ð¦ÐµÐ½Ð° Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð±Ð°Ð·Ñ, ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸, Ð´Ð¾Ð¿Ð»Ð°ÑÑ Ð¸ Ð¼Ð°ÑÐ¶Ñ / Ð½Ð°ÑÐµÐ½ÐºÑ)",
            setPriceTypesVisibilityAndOrder:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ Â«Ð¤Ð¾ÑÐ¼ÑÐ»Ð°Â» Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐµ ÑÐµÐ½Ñ Ð±ÑÐ´ÑÑ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ Ð² ÑÐ°Ð·Ð´ÐµÐ»Ðµ ÑÐµÐ½ ÐÐ´ÐµÑÑ ÑÐ°Ð¼Ð°Ñ Ð²ÑÑÐ¾ÐºÐ°Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ ÐºÑÐ°Ð¹Ð½ÑÑ Ð»ÐµÐ²ÑÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð² ÑÐ°Ð·Ð´ÐµÐ»Ðµ",
            surchargeAll: "Ð¦ÐµÐ½Ð° Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð¿Ð»Ð°ÑÑ Ð·Ð° Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº (Ð²ÐºÐ» ÐÐ¾Ð¿Ð»Ð°ÑÑ)",
            surchargePerPkg: "ÐÐ°ÑÐµÐ½ÐºÐ° Ð½Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
            tintPurchaseAll: "Ð¦ÐµÐ½Ð° Ð½Ð° Ð²ÐµÑÑ Ð¿ÑÐ¾ÑÐµÑÑ ÑÐ¾Ð½Ð¸ÑÐ¾Ð²ÐºÐ¸ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ñ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº (Ð²ÐºÐ»ÑÑÐ°Ñ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð¸ Ð´Ð¾Ð¿Ð»Ð°ÑÑ)",
            tintPurchasePerPkg: "Ð¦ÐµÐ½Ð° Ð·Ð° Ð²ÐµÑÑ Ð¿ÑÐ¾ÑÐµÑÑ Ð¾ÐºÑÐ°ÑÐ¸Ð²Ð°Ð½Ð¸Ñ Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ (Ð²ÐºÐ»ÑÑÐ°Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ Ð¸ Ð´Ð¾Ð¿Ð»Ð°ÑÑ)",
            tintSellFullAll: "Ð¡ÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð´Ð»Ñ Ð²ÑÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº",
            tintlSellFullAllPerPackage: "Ð¡ÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð´Ð»Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
            totalPurchaseAll:
                "ÐÐ±ÑÐ°Ñ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð¿Ð¾ÐºÑÐ¿ÐºÐ¸ Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð´Ð»Ñ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ñ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº (Ð² ÑÐ¾Ð¼ ÑÐ¸ÑÐ»Ðµ Ð±Ð°Ð·Ñ Ð¸ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹)",
            totalPurchasePerKg: "ÐÐ±ÑÐ°Ñ ÑÐµÐ½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼Ð¼ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¾ÑÐ½Ð¾Ð²Ñ Ð¸ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸)",
            totalPurchasePerL: "ÐÐ±ÑÐ°Ñ ÑÐµÐ½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° Ð»Ð¸ÑÑ (Ð²ÐºÐ»ÑÑÐ°Ñ Ð¾ÑÐ½Ð¾Ð²Ñ Ð¸ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸)",
            totalPurchasePerPkg: "ÐÐ±ÑÐ°Ñ ÑÐµÐ½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ (Ð² ÑÑ Ð¾ÑÐ½Ð¾Ð²Ð° Ð¸ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ð¸)",
            totalSellFullAll: "ÐÑÐ¾Ð³Ð¾Ð²Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð´Ð»Ñ Ð²ÑÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº",
            totalSellFullPerKg: "ÐÑÐ¾Ð³Ð¾Ð²Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° ÐºÐ³",
            totalSellFullPerLiter: "ÐÑÐ¾Ð³Ð¾Ð²Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° 1 Ð»Ð¸ÑÑ",
            totalSellFullPerPackage: "Ð¢Ð¾Ð³Ð¾Ð²Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
            withAndWithoutVat:
                "ÐÐ° ÑÑÑÐ°Ð½Ð¸ÑÐµ 'Ð¤Ð¾ÑÐ¼ÑÐ»Ð°' ÑÐµÐ½Ð° Ð±ÑÐ´ÐµÑ Ð²Ð¸Ð´Ð½Ð° Ð¾Ð´Ð½Ð¾Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾ Ð² Ð¾Ð±Ð¾Ð¸Ñ Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ°Ñ, Ñ ÐÐÐ¡ Ð¸ Ð±ÐµÐ· Ð½ÐµÐ³Ð¾",
            withVat: "ÐÐ°  ÑÑÑÐ°Ð½Ð¸ÑÐµ 'Ð¤Ð¾ÑÐ¼ÑÐ»Ð°' Ð²ÑÐµ ÑÐµÐ½Ñ Ð±ÑÐ´ÑÑ Ð²Ð¸Ð´Ð½Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÐÐÐ¡",
            withoutVat: "ÐÐ°  ÑÑÑÐ°Ð½Ð¸ÑÐµ 'Ð¤Ð¾ÑÐ¼ÑÐ»Ð°' Ð²ÑÐµ ÑÐµÐ½Ñ Ð±ÑÐ´ÑÑ Ð²Ð¸Ð´Ð½Ñ ÑÐ¾Ð»ÑÐºÐ¾  Ð±ÐµÐ· ÐÐÐ¡"
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÑÐµÑ Ð´Ð°Ð½Ð½ÑÐµ Ñ ÑÐ°Ð·Ð´ÐµÐ»Ð¾Ð¼ POS Info"
        },
        searchingPleaseWait: "ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ, Ð¸Ð´ÐµÑ Ð¿Ð¾Ð¸ÑÐº Ð»ÑÑÑÐµÐ³Ð¾ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ñ",
        setupSteps: {
            customData: "ÐÐ°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
            machineType: "Ð¢Ð¸Ð¿ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
            userPreferences: "ÐÑÐµÐ´Ð¿Ð¾ÑÑÐµÐ½Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð²"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "ÐÑÐ¸ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸Ð¸ Ð¿ÑÐ¾ÑÐ¸Ð»Ð¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ð¹ ÑÐµÐ·ÑÐ»ÑÑÐ°ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ð¹ Ð¿ÐµÑÐµÑÑÐ¸ÑÑÐ²Ð°ÑÑÑÑ Ð´Ð»Ñ ÑÑÑÑÐ°Ð½ÐµÐ½Ð¸Ñ ÑÑÑÐµÐºÑÐ° ÑÐ¸Ð»ÑÑÑÐ°. Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÑÑ Ð¾Ð¿ÑÐ¸Ñ Ð´Ð»Ñ ÑÐ½Ð¸Ð²ÐµÑÑÐ°Ð»ÑÐ½ÑÑ ÑÐ¿ÐµÐºÑÑÐ°Ð»ÑÐ½ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ð¹. ",
            XRiteModelRM400: "ÐÐµÑ ÑÑÐµÐ±ÑÐµÐ¼Ð¾Ð³Ð¾ Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°",
            datacolorDiagnosticTile: "Datacolor Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑ Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐµÑÐºÑÑ Ð¿Ð»Ð°ÑÑÐ¸Ð½Ñ",
            datacolorSilent: "Datacolor ÑÐ¸ÑÐ¸Ð¹",
            measureModes: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¿Ð¾Ð´Ð´ÐµÑÐ¶Ð¸Ð²Ð°ÐµÐ¼ÑÐµ ÑÑÐ¾Ð²Ð½Ð¸ Ð±Ð»ÐµÑÐºÐ°.",
            model: "ÐÐ¾Ð´ÐµÐ»Ñ",
            simulationPath: "ÐÑÑÑ Ðº ÑÐ°Ð¹Ð»Ñ ÑÐ¸Ð¼ÑÐ»ÑÑÐ¸Ð¸ ÐÑÐµÐ´ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ ",
            spectroType: "ÐÑÐ¸ÑÐ¸Ð°Ð»ÑÐ½ÑÐ¹ Ð´ÑÐ°Ð¹Ð²ÐµÑ Spectro Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ ÑÐ¾Ð»ÑÐºÐ¾ Ð² Windows ",
            spectroTypeCom:
                "ÐÐ¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ Ð¾ÑÐ¸ÑÐ¸Ð°Ð»ÑÐ½ÑÐ¹ Ð´ÑÐ°Ð¹Ð²ÐµÑ Spectro. ÐÑÑÐµÑÐµÐ³Ð°Ð¹ÑÐµÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÐ¼Ð¾Ð³Ð¾ COM-Ð¿Ð¾ÑÑÐ° ÐºÐ°Ðº Ð² Windows, ÑÐ°Ðº Ð¸ Ð² Linux. ",
            spectroTypeDataColorReader:
                "ÐÐ¾Ð¼Ð¿ÑÑÑÐµÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð¸Ð¼ÐµÑÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Bluetooth. Spectro Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÐ¾Ð¿ÑÑÐ¶ÐµÐ½ Ñ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ¾Ð¼. Ð¢ÑÐµÐ±ÑÐµÑÑÑ Windows 10 Ñ Ð¾ÑÐµÐ½Ð½Ð¸Ð¼ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸ÐµÐ¼ 2018 Ð³Ð¾Ð´Ð°.",
            spectroTypeMinolta2XXXd:
                "ÐÐ¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½ Ð¾ÑÐ¸ÑÐ¸Ð°Ð»ÑÐ½ÑÐ¹ Ð´ÑÐ°Ð¹Ð²ÐµÑ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÐ°. ÐÑÑÐµÑÐµÐ³Ð°Ð¹ÑÐµÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÐ¼Ð¾Ð³Ð¾ COM-Ð¿Ð¾ÑÑÐ° ÐºÐ°Ðº Ð² Windows, ÑÐ°Ðº Ð¸ Ð² Linux. ",
            spectroTypeNotSelected: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ñ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÐ°",
            spectroTypeRM400: "ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼ÑÐ¹ Ð´ÑÐ°Ð¹Ð²ÐµÑ Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ",
            spectroTypeSimulation:
                "ÐÐ°Ð±Ð¾ÑÐ°ÑÐ¾ÑÐ½ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ, Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼ÑÐµ Ð´Ð»Ñ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ñ ÑÐµÐ·ÑÐ»ÑÑÐ°ÑÐ¾Ð² Ð¼Ð¾Ð´ÐµÐ»Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ. Windows, Ð° ÑÐ°ÐºÐ¶Ðµ Linux. ",
            spectroTypeXRite: "Windows ÑÐ¾Ð»ÑÐºÐ¾"
        },
        ufiCode: {
            baseUfiCodeValidation:
                "ÐÐ¾Ð´ UFI Ð´Ð»Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ Ð±Ð°Ð·Ð¾Ð¹ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½ Ñ Ð¿Ð¾Ð¼Ð¾ÑÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð°, Ð¿ÑÐµÐ¶Ð´Ðµ ÑÐµÐ¼ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²ÐºÐ° Ð±ÑÐ´ÐµÑ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð° ",
            enableUfiCodes:
                "ÐÐ¾Ð´Ñ UFI Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÑÑÑÑ Ð² ÐÐ¡ Ð¸ Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð»ÑÑÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ¾Ð¼, Ð½Ð°ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¾Ð´ÑÐºÑ Ð¾Ð¿Ð°ÑÐµÐ½ Ð´Ð»Ñ Ð¾ÐºÑÑÐ¶Ð°ÑÑÐµÐ¹ ÑÑÐµÐ´Ñ. ",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "ÐÑÐ»Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ Ð² ÑÐ¾ÑÐ¼ÑÐ»Ðµ Ð¿ÑÐµÐ²ÑÑÐ°ÐµÑ ÑÐºÐ°Ð·Ð°Ð½Ð½ÑÐ¹ Ð¿ÑÐµÐ´ÐµÐ», ÐµÐ³Ð¾ ÐºÐ¾Ð´ UFI Ð±ÑÐ´ÐµÑ Ð½Ð°Ð¿ÐµÑÐ°ÑÐ°Ð½ Ð½Ð° ÑÑÐ¸ÐºÐµÑÐºÐµ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸. ",
            printUfiCodePercentage:
                "ÐÑÐ»Ð¸ ÐºÑÐ°ÑÐ¸ÑÐµÐ»Ñ Ð² ÑÐ¾ÑÐ¼ÑÐ»Ðµ Ð¿ÑÐµÐ²ÑÑÐ°ÐµÑ Ð·Ð°Ð´Ð°Ð½Ð½ÑÐ¹ Ð¿ÑÐµÐ´ÐµÐ», ÐµÐ³Ð¾ ÐºÐ¾Ð´ UFI Ð±ÑÐ´ÐµÑ Ð½Ð°Ð¿ÐµÑÐ°ÑÐ°Ð½ Ð½Ð° ÑÑÐ¸ÐºÐµÑÐºÐµ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸ Ð²Ð¼ÐµÑÑÐµ Ñ ÐµÐ³Ð¾ Ð¿ÑÐ¾ÑÐµÐ½ÑÐ½ÑÐ¼ Ð¿ÑÐµÐ´ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸ÐµÐ¼. ",
            ufiCodesByPercentage:
                "ÐÑÐµÐ²Ð°Ð»Ð¸ÑÑÑÑÐ¸Ð¹ ÐºÐ¾Ð´ UFI Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸ Ñ ÑÑÐµÑÐ¾Ð¼ ÐµÐ³Ð¾ ÑÐ°ÐºÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð° Ð² ÐºÐ°Ð½Ð¸ÑÑÑÐµ. ÐÐµÑÐµÐ¹Ð´Ð¸ÑÐµ Ðº Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ð¼ ÐºÐ°Ð½Ð¸ÑÑÑÑ, ÑÑÐ¾Ð±Ñ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ Ð¿Ð¾ÑÐ¾Ð³Ð¾Ð²Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð´Ð»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð¹ ÐºÐ°Ð½Ð¸ÑÑÑÑ. ",
            ufiCodesFromDatabase:
                "ÐÐ»Ñ Ð¿ÐµÑÐ°ÑÐ¸ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ ÐºÐ¾Ð´ UFI Ð¸Ð· Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ, Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð½ÑÐ¹ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÐ¾Ð¼ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ. ",
            ufiCodesFromLastFilling:
                "ÐÐ¾Ð´ UFI Ð¾Ñ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ, Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¾Ð¿ÐµÑÐ°ÑÐ¾ÑÐ¾Ð¼, Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÑÑ Ð´Ð»Ñ Ð¿ÐµÑÐ°ÑÐ¸ Ð½ÐµÐ·Ð°Ð²Ð¸ÑÐ¸Ð¼Ð¾ Ð¾Ñ ÑÑÐ¼Ð¼Ñ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ. "
        },
        userManagement: {
            add: "ÐÐ°ÑÐ°Ð¼ÐµÑÑ Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐµÑ Ð½Ð¾Ð²Ð¾Ð³Ð¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ, ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð¼Ð¾Ð¶ÐµÑ Ð²Ð¾Ð¹ÑÐ¸ Ð² Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ðµ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ðµ.ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð½Ð°Ð·Ð½Ð°ÑÐµÐ½ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´, Ð¸ ÐµÐ³Ð¾ Ð¼Ð¾Ð¶Ð½Ð¾ Ð½Ð°ÑÑÑÐ¾Ð¸ÑÑ Ð½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ Ð²ÑÐ¾Ð´ Ð¿Ð¾ÑÐ»Ðµ Ð·Ð°Ð¿ÑÑÐºÐ° Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ. ",
            assignedGroups:
                "Ð­ÑÐ¾ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, Ðº ÐºÐ°ÐºÐ¸Ð¼ Ð³ÑÑÐ¿Ð¿Ð°Ð¼ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹ Ð¿ÑÐ¸Ð½Ð°Ð´Ð»ÐµÐ¶Ð¸Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ. Ð Ð°Ð·Ð»Ð¸ÑÐ½ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹ ÑÐ°ÑÐ¿ÑÐµÐ´ÐµÐ»ÑÑÑ ÑÐ°Ð·Ð»Ð¸ÑÐ½ÑÐµ Ð¿ÑÐ¸Ð²Ð¸Ð»ÐµÐ³Ð¸Ð¸. ",
            availableGroups:
                "Ð­ÑÐ¾ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐµÑ, ÐºÐ°ÐºÐ¸Ðµ Ð³ÑÑÐ¿Ð¿Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹ Ð´Ð¾ÑÑÑÐ¿Ð½Ñ Ð´Ð»Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ. Ð Ð°Ð·Ð»Ð¸ÑÐ½ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹ ÑÐ°ÑÐ¿ÑÐµÐ´ÐµÐ»ÑÑÑ ÑÐ°Ð·Ð»Ð¸ÑÐ½ÑÐµ Ð¿ÑÐ¸Ð²Ð¸Ð»ÐµÐ³Ð¸Ð¸. ",
            loggedUserDelete: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ, Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸Ð²ÑÐ¸Ð¹ Ð²ÑÐ¾Ð´, Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ ÑÐ´Ð°Ð»ÐµÐ½ "
        },
        visit: "Ð£Ð·Ð½Ð°ÑÑ",
        visitNoLicense: "Ð¿Ð¾Ð´ÑÐ¾Ð±Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ"
    },
    helpSettings: {
        customHelpLink: "Ð¡ÑÑÐ»ÐºÐ° Ð½Ð° Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ð¹ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½ÑÐ¹ ÑÐµÐ½ÑÑ",
        helpSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐ¿ÑÐ°Ð²ÐºÐ¸",
        message: "Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ"
    },
    helper: {
        automaticallyCheckForUpdates: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð¿ÑÐ¾Ð²ÐµÑÑÑÑ Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹",
        automaticallyDownloadUpdates: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð·Ð°Ð³ÑÑÐ¶Ð°ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ",
        automaticallyInstallNewDatabases: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ Ð·Ð°Ð³ÑÑÐ¶Ð°ÑÑ Ð½Ð¾Ð²ÑÐµ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        automaticallyInstallUpdates: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ",
        bugReport: "Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾Ð± Ð¾ÑÐ¸Ð±ÐºÐµ",
        canBrowseChangeLog: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð¾Ð½-Ð»Ð°Ð¹Ð½ Ð¶ÑÑÐ½Ð°Ð» Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ %{name} ",
        collect: "Ð¡Ð¾Ð±ÑÐ°ÑÑ",
        collectLogFiles: "Ð¡Ð¾Ð±ÑÐ°ÑÑ ÑÐ°Ð¹Ð»Ñ Ð¶ÑÑÐ½Ð°Ð»Ð°",
        component: "ÐÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½Ñ",
        content: "Ð¡Ð¾Ð´ÐµÑÐ¶Ð°Ð½Ð¸Ðµ",
        contentSize: "Ð Ð°Ð·Ð¼ÐµÑ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ð¼Ð¾Ð³Ð¾",
        download: "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ",
        downloadLogFiles: "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ°Ð¹Ð»Ñ Ð¶ÑÑÐ½Ð°Ð»Ð°",
        downloadingData: "ÐÐ°Ð½Ð½ÑÐµ Ð·Ð°Ð³ÑÑÐ¶Ð°ÑÑÑÑ",
        everyHours: "ÐºÐ°Ð¶Ð´ÑÐµ %{interval} ÑÐ°ÑÐ¾Ð²",
        forceInstall: "ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ",
        installDuringNight: "ÐÐ¾ÑÑÑ (%{start} - %{end}) ÐºÐ°Ð¶Ð´ÑÐ¹ %{interval} ÑÐ°Ñ",
        newVersion: "ÐÐ¾Ð²Ð°Ñ Ð²ÐµÑÑÐ¸Ñ",
        notConnected: "ÐÐ¾Ð¼Ð¾ÑÐ½Ð¸Ðº Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½",
        openBugReport: "ÐÑÐºÑÑÑÑ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾Ð± Ð¾ÑÐ¸Ð±ÐºÐµ",
        packageSize: "Ð Ð°Ð·Ð¼ÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ ",
        pleaseWait: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ, ÑÑÐ¾ Ð¼Ð¾Ð¶ÐµÑ Ð·Ð°Ð½ÑÑÑ Ð½ÐµÐºÐ¾ÑÐ¾ÑÐ¾Ðµ Ð²ÑÐµÐ¼Ñ",
        send: "ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ",
        sendBugReportToCustomerService: "ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾Ð± Ð¾ÑÐ¸Ð±ÐºÐµ Ð² ÑÐ»ÑÐ¶Ð±Ñ Ð¿Ð¾Ð´Ð´ÐµÑÐ¶ÐºÐ¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð²",
        sendingReport: "ÐÑÐ¿ÑÐ°Ð²ÐºÐ°",
        subject: "Ð¢ÐµÐ¼Ð°"
    },
    helperDialog: {
        1: "ÐÑ Ð¼Ð¾Ð¶ÐµÑÐµ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Ð¸ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        2: "ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ Ð·Ð°Ð³ÑÑÐ·ÐºÑ Ð¿Ð°ÐºÐµÑÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹?",
        3: "ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½ÑÑ Ð¿Ð°ÐºÐµÑÐ¾Ð² Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹?",
        10: "ÐÐ´ÐµÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð°Ð»Ð¸ÑÐ¸Ñ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ Ð¸ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        11: "ÐÐ°Ð¹Ð´ÐµÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ, Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾Ðµ Ð´Ð»Ñ ÐÐ°ÑÐµÐ³Ð¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ° ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÐµÐ³Ð¾?",
        12: "ÐÐµÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹, Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð´Ð»Ñ ÐÐ°ÑÐµÐ³Ð¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ° ",
        14: "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿ÑÐ¾Ð²ÐµÑÐºÐµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ %{0}",
        15: "ÐÐ´ÐµÑ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ Ð±Ð°Ð· Ð´Ð°Ð½Ð½ÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        20: "ÐÐ°Ð³ÑÑÐ¶Ð°ÐµÑÑÑ Ð¿Ð°ÐºÐµÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        21: "ÐÐ°Ð³ÑÑÐ¶ÐµÐ½Ð½ÑÐ¹ Ð¿Ð°ÐºÐµÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ ÑÐµÐ¹ÑÐ°Ñ Ð¿ÑÐ¾Ð²ÐµÑÑÐµÑÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        22: "ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð¿Ð°ÐºÐµÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹, Ð²Ñ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ?",
        23: "ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð¿Ð°ÐºÐµÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ (ÑÐ°Ð¹Ð» Ð¿Ð¾Ð²ÑÐµÐ¶Ð´ÐµÐ½), Ð²Ñ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ?",
        24: "ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ?",
        25: "Ð£ÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ Ð½Ð°ÑÐ½ÑÑÑÑ ÑÐµÑÐµÐ· %{0}",
        26: "ÐÐ°Ð¹Ð´ÐµÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ, Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾Ðµ Ð´Ð»Ñ ÐÐ°ÑÐµÐ³Ð¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ° ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÐµÐ³Ð¾? ",
        27: "ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ?",
        40: "ÐÐ´ÐµÑ Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¹ Ð¸ ÑÐµÑÐ²Ð¸ÑÐ¾Ð², Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ° Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        41: "ÐÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð½Ð¾Ð²ÑÑ ÑÐ°Ð¹Ð»Ð¾Ð², Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        42: "ÐÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐº Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¹ Ð¸ ÑÐµÑÐ²Ð¸ÑÐ¾Ð², Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ° Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        43: "ÐÐ°Ð²ÐµÑÑÐ°ÐµÑÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        44: "ÐÐ°ÑÐµ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ðµ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ðµ Ð±ÑÐ»Ð¾ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾ ",
        45: "ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÑ?  ÐÑÐ»Ð¸ Ð²Ñ ÑÐµÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ, ÑÐ±ÐµÐ´Ð¸ÑÐµÑÑ, ÑÑÐ¾ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½ÑÐµ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÑ Ð² Ð´Ð°Ð½Ð½ÑÐ¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð½Ðµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÑÑÑÑ",
        46: "ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð° Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°, ÑÑÐ¾Ð±Ñ Ð²Ð½ÐµÑÑÐ¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ ÐÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ° Ð½Ð°ÑÐ½ÑÑÑÑ ÑÐµÑÐµÐ· %{0}",
        999: "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð²Ð½ÑÑÑÐµÐ½Ð½ÑÑ Ð¾ÑÐ¸Ð±ÐºÐ°: %{0}",
        automaticInstallation: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ°Ñ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ",
        btnAbort: "ÐÑÐµÐºÑÐ°ÑÐ¸ÑÑ ",
        btnCancel: "ÐÑÐ¼ÐµÐ½Ð¸ÑÑ ",
        btnCheckUpdate: "ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑ Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ ",
        btnContinue: "ÐÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ ",
        btnDownloadUpdate: "ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ ",
        btnInstallUpdate: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ",
        btnOk: "ÐÐ",
        btnRetry: "ÐÐ¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ ",
        btnSkip: "ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ ",
        checkingForUpdates: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ ",
        downloadingFailed: "ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ",
        downloadingPackage: "ÐÐ´ÐµÑ Ð·Ð°Ð³ÑÑÐ·ÐºÐ° Ð¿Ð°ÐºÐµÑÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        finishingUpdate: "ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð·Ð°Ð²ÐµÑÑÐ°ÐµÑÑÑ ",
        installingUpdate: "ÐÐ´ÐµÑ ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ",
        internalError: "ÐÐ½ÑÑÑÐµÐ½Ð½ÑÑ Ð¾ÑÐ¸Ð±ÐºÐ° ",
        rebootRequired: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ° ",
        startingComponents: "ÐÐ°Ð¿ÑÑÐº Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½ÑÑ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ¾Ð²",
        stoppingComponents: "ÐÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½ÑÑ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ¾Ð²",
        synchronizingDatabases: "ÐÐ´ÐµÑ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ñ Ð±Ð°Ð· Ð´Ð°Ð½Ð½ÑÑ ",
        updateAvailable: "ÐÐ¾ÑÑÑÐ¿Ð½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ ÐÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ ÑÐ¾ÑÐ¸ÑÐµ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ",
        updateDownloaded: "ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾ ",
        updateFailed: "ÐÑÐ¾ÑÐµÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ Ð½Ðµ ÑÐ´Ð°Ð»ÑÑ",
        updateInstalled: "ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¾ ",
        verificationFailed: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð¿Ð°ÐºÐµÑÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ Ð½Ðµ ÑÐ¾ÑÑÐ¾ÑÐ»Ð°ÑÑ",
        verifyingPackage: "ÐÐ´ÐµÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¿Ð°ÐºÐµÑÐ° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ ",
        yourSoftwareIsUpToDate: "ÐÐµÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¹ Ð´Ð»Ñ ÐÐ°ÑÐµÐ³Ð¾ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ ",
        yourSoftwareVersion: "ÐÐµÑÑÐ¸Ñ ÐÐ°ÑÐµÐ³Ð¾ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ: %{0}"
    },
    importData: {
        abortImportingData: "ÐÑÐ¼ÐµÐ½Ð° Ð¸Ð¼Ð¿Ð¾ÑÑÐ°",
        aborted: "ÐÐ¼Ð¿Ð¾ÑÑ Ð±ÑÐ» Ð¿ÑÐµÑÐ²Ð°Ð½",
        backupLocalDB: "Backup local database",
        confirmRestore: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð² ÐÐ½ÑÐµÑÐ½ÐµÑÐµ Ð¶ÑÑÐ½Ð°Ð» Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ %{name} ",
        dataMissing: "ÐÐ¼Ð¿Ð¾ÑÑ Ð½Ðµ ÑÐ¾ÑÑÐ¾ÑÐ»ÑÑ, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð¸ÑÑÐ¾Ð´Ð½ÑÐ¹ ÑÐ°Ð¹Ð» Ð½Ðµ ÑÐ¾Ð´ÐµÑÐ¶Ð°Ð» Ð½Ð¸ÐºÐ°ÐºÐ¸Ñ Ð´Ð°Ð½Ð½ÑÑ",
        deleteImportedData: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ",
        encodingFile: "ÐÐ¾Ð´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÐ°Ð¹Ð»Ð°",
        exportLocalSettings: "Ð­ÐºÑÐ¿Ð¾ÑÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÑ Ð½Ð°ÑÑÑÐ¾ÐµÐº ",
        exportStaticSql: "Ð­ÐºÑÐ¿Ð¾ÑÑ ÑÑÐ°ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾ SQL ",
        fileDamaged: "ÐÐ¼Ð¿Ð¾ÑÑ Ð½Ðµ ÑÐ¾ÑÑÐ¾ÑÐ»ÑÑ, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð¸ÑÑÐ¾Ð´Ð½ÑÐ¹ ÑÐ°Ð¹Ð», ÐºÐ°Ð¶ÐµÑÑÑ, Ð¿Ð¾Ð²ÑÐµÐ¶Ð´ÐµÐ½",
        fileMissing: "ÐÐ¼Ð¿Ð¾ÑÑ Ð½Ðµ ÑÐ¾ÑÑÐ¾ÑÐ»ÑÑ, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð¸ÑÑÐ¾Ð´Ð½Ð¾Ð³Ð¾ ÑÐ°Ð¹Ð»Ð° Ð½Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ",
        format: "Ð¤Ð¾ÑÐ¼Ð°Ñ",
        formatPath: "ÐÑÑÑ ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        headerMissing: "ÐÐ¼Ð¿Ð¾ÑÑ Ð½Ðµ ÑÐ¾ÑÑÐ¾ÑÐ»ÑÑ Ð¸Ð·-Ð·Ð° Ð¾ÑÑÑÑÑÑÐ²Ð¸Ñ Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²ÐºÐ° ÑÐ°Ð¹Ð»Ð°",
        import: "ÐÐ¼Ð¿Ð¾ÑÑ",
        importAborted: "ÐÐ¼Ð¿Ð¾ÑÑ Ð¿ÑÐµÑÐ²Ð°Ð½",
        importAborting: "ÐÐ¼Ð¿Ð¾ÑÑ Ð¿ÑÐµÑÐ²Ð°ÑÑ",
        importFailed: "ÐÐ¼Ð¿Ð¾ÑÑ Ð½Ðµ ÑÐ¾ÑÑÐ¾ÑÐ»ÑÑ Ð¸Ð·-Ð·Ð° Ð½ÐµÐ¾Ð¶Ð¸Ð´Ð°Ð½Ð½Ð¾Ð¹ Ð¾ÑÐ¸Ð±ÐºÐ¸",
        importLocalSettings: "ÐÐ¼Ð¿Ð¾ÑÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÑ Ð½Ð°ÑÑÑÐ¾ÐµÐº",
        importPrices: "Ð¦ÐµÐ½Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ",
        imported: "ÐÐ¼Ð¿Ð¾ÑÑ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð·Ð°Ð²ÐµÑÑÑÐ½",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "ÐÐ¼Ð¿Ð¾ÑÑ",
        noFormatAvailable: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾Ð³Ð¾ ÑÐ¾ÑÐ¼Ð°ÑÐ°",
        processing: "ÐÐ±ÑÐ°Ð±Ð¾ÑÐºÐ°",
        processingCustomFormulas: "ÐÐ±ÑÐ°Ð±Ð¾ÑÐºÐ° Ð¸Ð½Ð´Ð¸Ð²Ð¸Ð´ÑÐ°Ð»ÑÐ½ÑÑ ÑÐ¾ÑÐ¼ÑÐ»",
        processingCustomers: "ÐÐ±ÑÐ°Ð±Ð¾ÑÐºÐ° ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð²",
        productsFile: "Ð¤Ð°Ð¹Ð» Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð²",
        restoreLocalSettings: "ÐÐ¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÑ Ð½Ð°ÑÑÑÐ¾ÐµÐº",
        underProgress: "ÐÐ¼Ð¿Ð¾ÑÑ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð°ÐµÑÑÑ",
        unknownFormat: "ÐÐ¼Ð¿Ð¾ÑÑ Ð½Ðµ ÑÐ¾ÑÑÐ¾ÑÐ»ÑÑ, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð¸ÑÑÐ¾Ð´Ð½ÑÐ¹ ÑÐ°Ð¹Ð» Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð¾Ð³Ð¾ ÑÐ¾ÑÐ¼Ð°ÑÐ°",
        userFormulasFile: "Ð¤Ð°Ð¹Ð» Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ñ ÑÐ¾ÑÐ¼ÑÐ»"
    },
    infoType: {
        baseDensity: "ÐÐ»Ð¾ÑÐ½Ð¾ÑÑÑ Ð±Ð°Ð·Ñ",
        baseMass: "ÐÐ°ÑÑÐ° Ð±Ð°Ð·Ñ",
        baseUfiCode: "UFI ÐºÐ¾Ð´ Ð±Ð°Ð·Ñ",
        baseVolume: "ÐÐ±ÑÐµÐ¼ Ð±Ð°Ð·Ñ",
        batchNumbersTable: "Ð¢Ð°Ð±Ð»Ð¸ÑÐ° Ð½Ð¾Ð¼ÐµÑÐ¾Ð² Ð¿Ð°ÑÑÐ¸Ð¸",
        bfsGrade: "ÐÐ»Ð°ÑÑ BFS",
        colorLab: "ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ Lab",
        colorRgb: "ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ RGB",
        colorRgbHex: "ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ RGB Hex",
        colorXyz: "ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ xyz",
        colorantBatchNumbers: "ÐÐ¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        colorantMass: "ÐÐ°ÑÑÐ° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        colorantUfiCodes: "UFI ÐºÐ¾Ð´Ñ Ð´Ð»Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        colorantVolume: "ÐÐ±ÑÐµÐ¼ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        formulaDate: "ÐÐ°ÑÐ° ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        formulaDatetime: "ÐÐ°ÑÐ°/Ð²ÑÐµÐ¼Ñ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        formulaMoreInfo: "ÐÐ¾Ð»ÑÑÐµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸ Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
        formulaMoreInfoInternal: "ÐÐ¾Ð»ÑÑÐµ Ð²Ð½ÑÑÑÐµÐ½Ð½ÐµÐ¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸ Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
        formulaMoreInfoPrint: "ÐÐµÑÐ°ÑÑ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸ Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ðµ",
        hbw: "ÐÐ½Ð´ÐµÐºÑ Ð±ÐµÐ»Ð¸Ð·Ð½Ñ HBW",
        isPackageGravimetric: "Ð¯Ð²Ð»ÑÐµÑÑÑ Ð»Ð¸ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð³ÑÐ°Ð²Ð¸Ð¼ÐµÑÑÐ¸ÑÐµÑÐºÐ¾Ð¹",
        maxColorantMass: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼Ð°Ñ Ð¼Ð°ÑÑÐ° Ð¿Ð¸Ð³Ð¼ÐµÐ½ÑÐ°",
        maxColorantVolume: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ Ð¾Ð±ÑÐµÐ¼ Ð¿Ð¸Ð³Ð¼ÐµÐ½ÑÐ°",
        nominalMass: "ÐÐ¾Ð¼Ð¸Ð½Ð°Ð»ÑÐ½Ð°Ñ Ð¼Ð°ÑÑÐ° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        nominalVolume: "ÐÐ¾Ð¼Ð¸Ð½Ð°Ð»ÑÐ½ÑÐ¹ Ð¾Ð±ÑÐµÐ¼ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        overfillDetected: "ÐÐ±Ð½Ð°ÑÑÐ¶ÐµÐ½Ð¾ Ð¿ÐµÑÐµÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "ÐÐ±ÑÐ°Ñ Ð¼Ð°ÑÑÐ° ÐºÑÐ°ÑÐºÐ¸",
        totalPaintVolume: "ÐÐ±ÑÐ¸Ð¹ Ð¾Ð±ÑÐµÐ¼ ÐºÑÐ°ÑÐºÐ¸",
        ufiCodesTable: "Ð¢Ð°Ð±Ð»Ð¸ÑÐ° UFI ÐºÐ¾Ð´Ð¾Ð²",
        verifiedFormula: "Ð£ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        yValue: "ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ Y"
    },
    initialTab: {
        favoriteFormulas: "ÐÐ·Ð±ÑÐ°Ð½Ð½ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        lastDispensedFormulas: "ÐÐ¾ÑÐ»ÐµÐ´Ð½Ð¸Ðµ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð½ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        searchNewFormula: "ÐÐ¾Ð¸ÑÐº Ð½Ð¾Ð²Ð¾Ð¹ ÑÐ¾ÑÐ¼ÑÐ»Ñ"
    },
    invalidBatchNumbersModal: {
        header: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð½Ð¾Ð¼ÐµÑ Ð¿Ð°ÑÑÐ¸Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        info: "ÐÐ´Ð½Ð° Ð¸Ð· ÐºÐ°Ð½Ð¸ÑÑÑ Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð° Ð¸ÑÐ¿Ð¾ÑÑÐµÐ½Ð½ÑÐ¼Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°Ð¼Ð¸. ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð½Ðµ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐ¹ÑÐµ ÑÑÑ Ð¿Ð°ÑÑÐ¸Ñ. ÐÐ¿ÑÑÑÐ¾ÑÐ¸ÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÑ Quick Tint.",
        unknownStatus: "ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½ÑÐ¹ ÑÑÐ°ÑÑÑ Ð¿Ð°ÑÑÐ¸Ð¸"
    },
    keyWords: {
        action: "Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ",
        add: "Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ",
        addition: "Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ðµ",
        additional: "Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹",
        address: "Ð°Ð´ÑÐµÑ",
        admin: "Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾Ñ",
        advanced: "Ð£Ð»ÑÑÑÐµÐ½Ð½ÑÐ¹",
        after: "Ð¿Ð¾ÑÐ»Ðµ",
        afterDispensing: "Ð¿Ð¾ÑÐ»Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        alfa: "ÐÐ»ÑÑÐ°",
        all: "Ð²ÑÐµ",
        allow: "Ð¿Ð¾Ð·Ð²Ð¾Ð»Ð¸ÑÑ",
        alphabetically: "Ð² Ð°Ð»ÑÐ°ÑÐ¸ÑÐ½Ð¾Ð¼ Ð¿Ð¾ÑÑÐ´ÐºÐµ",
        amount: "ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        api: "api",
        ask: "ÑÐ¿ÑÐ¾ÑÐ¸ÑÑ",
        autocap: "Ð°Ð²ÑÐ¾ÐºÑÑÑÐºÐ°",
        autotask: "Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°ÑÐ°",
        availablePrice: "Ð´Ð¾ÑÑÑÐ¿Ð½Ð°Ñ ÑÐµÐ½Ð°",
        backup: "ÑÐµÐ·ÐµÑÐ²Ð½Ð¾Ðµ ÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        banner: "Ð±Ð°Ð½Ð½ÐµÑ",
        barcode: "ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´",
        barcodes: "ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ",
        base: "Ð±Ð°Ð·Ð°",
        before: "Ð¿ÐµÑÐµÐ´",
        begin: "Ð½Ð°ÑÐ¸Ð½ÑÐµ",
        bfs: "bfs",
        bottom: "Ð´Ð½Ð¾",
        brand: "Ð±ÑÐµÐ½Ð´",
        brush: "ÑÑÑÐºÐ°",
        bug: "ÑÐ±Ð¾Ð¹",
        button: "ÐºÐ½Ð¾Ð¿ÐºÐ°",
        buy: "ÐºÑÐ¿Ð¸ÑÑ",
        cC3: "CC3",
        cM: "CM",
        calibration: "ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÐ°",
        can: "ÑÐ°ÑÐ°",
        canHandling: "Ð¾Ð±ÑÐ°Ð±Ð¾ÑÑÐ¸Ðº ÑÐ°ÑÑ",
        canister: "ÐºÐ°Ð½Ð¸ÑÑÑÐ°",
        canisterFilling: "Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        canisterLevels: "ÑÑÐ¾Ð²ÐµÐ½Ñ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        canisters: "ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        cap: "ÐºÑÑÑÐºÐ°",
        center: "Ð¦ÐµÐ½ÑÑ",
        centre: "Ð¡ÐµÑÐµÐ´Ð¸Ð½Ð°",
        change: "ÑÐ¼ÐµÐ½Ð¸ÑÑ",
        changelog: "Ð¶ÑÑÐ½Ð°Ð» Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹",
        channels: "ÐºÐ°Ð½Ð°Ð»Ñ",
        check: "Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ",
        chunk: "Ð±Ð»Ð¾Ðº",
        chunks: "Ð±Ð»Ð¾ÐºÐ¸",
        city: "Ð³Ð¾ÑÐ¾Ð´",
        clean: "Ð¾ÑÐ¸ÑÑÐ¸ÑÑ",
        cleaning: "ÑÐ¸ÑÑÐºÐ°",
        clientIdentifier: "Ð¸Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        close: "Ð·Ð°ÐºÑÑÑÑ",
        closest: "Ð·Ð°ÐºÑÑÑÑÐ¹",
        code: "ÐºÐ¾Ð´",
        collect: "Ð½Ð°ÐºÐ¾Ð¿Ð¸ÑÑ",
        color: "ÑÐ²ÐµÑ",
        colorLink3: "ColorLink3",
        colorPanel: "ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ ÑÐ²ÐµÑÐ¾Ð²",
        colorReader: "ColorReader",
        colorant: "ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        colorantConsumption: "Ð¿Ð¾ÑÑÐµÐ±Ð»ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        colorantPrice: "ÑÐµÐ½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        colorants: "ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
        colorix: "Colorix",
        colour: "ÑÐ²ÐµÑ",
        communication: "ÐºÐ¾Ð¼Ð¼ÑÐ½Ð¸ÐºÐ°ÑÐ¸Ñ",
        compare: "ÑÑÐ°Ð²Ð½Ð¸ÑÑ",
        competitive: "ÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼ÑÐ¹",
        computer: "ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑ",
        config: "Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°",
        configuration: "ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ",
        confirm: "Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ",
        confirmation: "Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ",
        connection: "ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ",
        contactPerson: "ÐºÐ¾Ð½ÑÐ°ÐºÑÐ½Ð¾Ðµ Ð»Ð¸ÑÐ¾",
        control: "ÐÐ¾Ð½ÑÑÐ¾Ð»Ñ",
        copies: "ÐºÐ¾Ð¿Ð¸Ð¸",
        corob: "Corob",
        cost: "ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ",
        country: "ÑÑÑÐ°Ð½Ð°",
        create: "ÑÐ¾Ð·Ð´Ð°ÑÑ",
        currency: "Ð²Ð°Ð»ÑÑÐ°",
        current: "ÑÐµÐºÑÑÐ¸Ð¹",
        custom: "ÐºÐ»Ð¸ÐµÐ½Ñ",
        customers: "ÐºÐ»Ð¸ÐµÐ½ÑÑ",
        daily: "ÐµÐ¶ÐµÐ´Ð½ÐµÐ²Ð½Ð¾",
        dark: "Dark",
        data: "Ð´Ð°ÑÐ°",
        database: "Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ",
        datacolor: "Datacolor",
        date: "Ð´Ð°ÑÐ°",
        decimals: "ÑÐ°Ð·ÑÑÐ´Ñ",
        default: "Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
        delay: "Ð¾ÑÑÑÐ¾ÑÐºÐ°",
        delete: "ÑÐ´Ð°Ð»Ð¸ÑÑ",
        deletion: "ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ðµ",
        deltaE: "delta e",
        device: "ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾",
        devices: "ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð°",
        diagnosticTile: "ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð¾ÑÐ½Ð°Ñ Ð¿Ð»Ð°ÑÑÐ¸Ð½Ð°",
        dialog: "Ð´Ð¸Ð°Ð»Ð¾Ð³",
        direct: "Ð´Ð¸ÑÐµÐºÑÐ¾ÑÐ¸Ñ",
        disconnect: "Ð¾ÑÐºÐ»ÑÑÐ¸ÑÑÑÑ",
        discount: "ÑÐºÐ¸Ð´ÐºÐ°",
        dispense: "Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        dispenser: "Ð´Ð¾Ð·Ð°ÑÐ¾Ñ",
        dispensing: "Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        down: "Ð²Ð½Ð¸Ð·",
        download: "Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ",
        driver: "Ð´ÑÐ°Ð¹Ð²ÐµÑ",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ",
        editor: "ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        email: "ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð°Ñ Ð¿Ð¾ÑÑÐ°",
        error: "Ð¾ÑÐ¸Ð±ÐºÐ°",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "Ð¸ÑÑÐµÑÐµÐ½Ð¸Ðµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ",
        export: "ÑÐºÑÐ¿Ð¾ÑÑ",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ",
        fastFluid: "Fast & Fluid",
        file: "ÑÐ°Ð¹Ð»",
        fill: "Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÑÑ",
        fillToMax: "Ð·Ð°Ð¿Ð¾Ð»Ð½ÑÑÑ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾",
        find: "Ð½Ð°Ð¹ÑÐ¸",
        first: "Ð¿ÐµÑÐ²ÑÐ¹",
        flex: "Flex",
        folder: "Ð¿Ð°Ð¿ÐºÐ°",
        formula: "ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        formulas: "ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        from: "Ð¸Ð·",
        fts5: "fts5",
        fullScreen: "Ð¿Ð¾Ð»Ð½Ð¾ÑÐºÑÐ°Ð½Ð½ÑÐ¹",
        fullText: "Ð¿Ð¾Ð»Ð½Ð¾ÑÐµÐºÑÑÐ¾Ð²ÑÐ¹",
        fulltext: "Ð¿Ð¾Ð»Ð½Ð¾ÑÐµÐºÑÑÐ¾Ð²ÑÐ¹",
        g: "Ð³",
        genericPricing: "Ð¾Ð±ÑÐµÐµ ÑÐµÐ½Ð¾Ð¾Ð±ÑÐ°Ð·Ð¾Ð²Ð°Ð½Ð¸Ðµ",
        hLD: "HLD",
        hard: "ÑÑÐ¶ÑÐ»ÑÐ¹",
        hbw: "hbw",
        help: "Ð¿Ð¾Ð¼Ð¾ÑÑ",
        helpCenter: "ÑÐµÐ½ÑÑ Ð¿Ð¾Ð¼Ð¾ÑÐ¸",
        hero: "Hero",
        history: "Ð¸ÑÑÐ¾ÑÐ¸Ñ",
        home: "Ð´Ð¾Ð¼Ð¾Ð¹",
        host: "ÑÐ¾ÑÑ",
        humidifier: "ÑÐ²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»Ñ",
        iDD: "IDD",
        identification: "Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ",
        image: "Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ",
        impGallon: "Ð¸Ð¼Ð¿ÐµÑÑÐºÐ¸Ð¹ Ð³Ð°Ð»Ð»Ð¾Ð½",
        impQuart: "Ð¸Ð¼Ð¿ÐµÑÑÐºÐ°Ñ ÐºÐ²Ð°ÑÑÐ°",
        import: "Ð¸Ð¼Ð¿Ð¾ÑÑ",
        individually: "Ð¸Ð½Ð´Ð¸Ð²Ð¸Ð´ÑÐ°Ð»ÑÐ½ÑÐ¹",
        info: "Ð¸Ð½ÑÐ¾",
        information: "Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        initial: "Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹",
        initialization: "Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ",
        initialize: "ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÑÑ Ð¸ÑÑÐ¾Ð´Ð½Ð¾Ðµ ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ðµ",
        insert: "Ð²ÑÑÐ°Ð²Ð¸ÑÑ",
        install: "ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ",
        intellyPurge: "Ð¸Ð½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°",
        invalid: "Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹",
        ipAddress: "IP Ð°Ð´ÑÐµÑ",
        italtinto: "Italtinto",
        items: "Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÑ",
        keyboard: "ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÐ°",
        kg: "ÐºÐ³",
        kiosk: "ÐºÐ¸Ð¾ÑÐº",
        kioskMode: "ÑÐµÐ¶Ð¸Ð¼ ÐºÐ¸Ð¾ÑÐºÐ°",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "ÑÑÐ¸ÐºÐµÑÐºÐ°",
        labels: "ÑÑÐ¸ÐºÐµÑÐºÐ¸",
        language: "ÑÐ·ÑÐº",
        largo: "largo",
        last: "Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¹",
        lenteq: "Lenteq",
        levels: "ÑÑÐ¾Ð²Ð½Ð¸",
        license: "Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
        light: "Ð¾Ð±Ð»ÐµÐ³ÑÑÐ½Ð½ÑÐ¹",
        limit: "Ð»Ð¸Ð¼Ð¸Ñ",
        link: "ÑÑÑÐ»ÐºÐ°",
        linux: "Linux",
        load: "Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ",
        lock: "Ð·Ð°Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²Ð°ÑÑ",
        logFiles: "Ð¶ÑÑÐ½Ð°Ð»ÑÐ½ÑÐµ ÑÐ°Ð¹Ð»Ñ",
        logic: "Ð»Ð¾Ð³Ð¸ÑÐµÑÐºÐ¸Ð¹",
        logo: "Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿",
        lower: "Ð·Ð°ÐºÐ¾Ð½",
        machine: "Ð´Ð¾Ð·Ð°ÑÐ¾Ñ",
        machineConfiguration: "ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        machineManagement: "ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ¾Ð¼",
        machineName: "Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        main: "Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹",
        maintenance: "Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ",
        manual: "ÑÑÑÐ½Ð¾Ð¹",
        manualAddition: "ÑÑÑÐ½Ð¾Ðµ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ðµ",
        manualDispensing: "ÑÑÑÐ½Ð¾Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        manualScan: "ÑÑÑÐ½Ð¾Ðµ ÑÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        margins: "Ð¼Ð°ÑÐ¶Ð°",
        markups: "Ð½Ð°ÑÐµÐ½ÐºÐ¸",
        mass: "Ð¼Ð°ÑÑÐ°",
        match: "Ð¿Ð¾Ð´Ð¾Ð±ÑÐ°ÑÑ",
        measure: "Ð¸Ð·Ð¼ÐµÑÐ¸ÑÑ",
        measurement: "Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ðµ",
        measurementUnits: "ÐµÐ´ÐµÐ½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        melody: "Ð¼ÐµÐ»Ð¾Ð´Ð¸Ñ",
        message: "ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ",
        minimal: "Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹",
        minolta: "Minolta",
        minus: "Ð¼Ð¸Ð½ÑÑ",
        minutes: "Ð¼Ð¸Ð½ÑÑÑ",
        misura: "Misura",
        ml: "Ð¼Ð»",
        mode: "ÑÐµÐ¶Ð¸Ð¼",
        model: "Ð¼Ð¾Ð´ÐµÐ»Ñ",
        modification: "Ð¼Ð¾Ð´Ð¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ",
        modify: "Ð¼Ð¾Ð´Ð¸ÑÐ¸ÑÐ¸ÑÐ¾Ð²Ð°ÑÑ",
        monthly: "ÐµÐ¶ÐµÐ¼ÐµÑÑÑÐ½Ð¾",
        moreInfo: "Ð±Ð¾Ð»ÑÑÐµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        movableTable: "Ð¿Ð¾Ð²Ð¾ÑÐ¾ÑÐ½ÑÐ¹ ÑÑÐ¾Ð»",
        move: "Ð´Ð²Ð¸Ð³Ð°ÑÑ",
        music: "Ð¼ÑÐ·ÑÐºÐ°",
        myOrders: "Ð¼Ð¾Ð¸ Ð·Ð°ÐºÐ°Ð·Ñ",
        name: "Ð¸Ð¼Ñ",
        naming: "Ð½Ð°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ",
        nano: "Nano",
        navigation: "Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ñ",
        new: "Ð½Ð¾Ð²ÑÐ¹",
        nextDriver: "NextDriver",
        night: "Ð½Ð¾ÑÑ",
        nixPro: "Nix Pro",
        notes: "Ð¿ÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ñ",
        notification: "ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ðµ",
        number: "Ð½Ð¾Ð¼ÐµÑ",
        off: "Ð²ÑÐºÐ»ÑÑÐ¸ÑÑ",
        open: "Ð¾ÑÐºÑÑÑÑ",
        order: "Ð·Ð°ÐºÐ°Ð·",
        ordering: "ÑÐ°Ð·Ð¼ÐµÑÐµÐ½Ð¸Ðµ Ð·Ð°ÐºÐ°Ð·Ð°",
        overfill: "Ð¿ÐµÑÐµÐ»Ð¸Ð²",
        overview: "Ð¾Ð±Ð·Ð¾Ñ",
        overwrite: "Ð¿ÐµÑÐµÐ¿Ð¸ÑÐ°ÑÑ",
        own: "ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½ÑÐ¹",
        pCPDriver: "PCPDriver",
        package: "ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        packagePrice: "ÑÐµÐ½Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        packages: "ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        panels: "Ð¿Ð°Ð½ÐµÐ»Ð¸",
        parameter: "Ð¿Ð°ÑÐ°Ð¼ÐµÑÑ",
        path: "Ð¿ÑÑÑ",
        pc: "pc",
        phone: "ÑÐµÐ»ÐµÑÐ¾Ð½",
        phoneNumber: "Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°",
        picture: "ÐºÐ°ÑÑÐ¸Ð½ÐºÐ°",
        place: "Ð¼ÐµÑÑÐ¾",
        placement: "ÑÐ°Ð·Ð¼ÐµÑÐµÐ½Ð¸Ðµ",
        plug: "ÑÐ°Ð·ÑÑÐ¼",
        plugger: "Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ",
        plugging: "Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ",
        plugin: "Ð¿Ð»Ð°Ð³Ð¸Ð½",
        plus: "Ð¿Ð»ÑÑ",
        pointOfSale: "ÑÐ¾ÑÐºÐ° Ð¿ÑÐ¾Ð´Ð°Ð¶",
        popUp: "Ð²ÑÐ¿Ð»ÑÐ²Ð°ÑÑÐ¸Ð¹",
        pos: "ÑÐ¾ÑÐºÐ° Ð¿ÑÐ¾Ð´Ð°Ð¶",
        present: "Ð½Ð°ÑÑÐ¾ÑÑÐ¸Ð¹",
        preview: "Ð¿ÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ",
        price: "ÑÐµÐ½Ð°",
        priceExport: "ÐµÐºÑÐ¿Ð¾ÑÑ ÑÐµÐ½Ñ",
        priceGroup: "ÑÐµÐ½Ð¾Ð²Ð°Ñ Ð³ÑÑÐ¿Ð¿Ð°",
        priceImport: "Ð¸Ð¼Ð¿Ð¾ÑÑ ÑÐµÐ½Ñ",
        prices: "ÑÐµÐ½Ñ",
        pricing: "ÑÐµÐ½Ð¾Ð¾Ð±ÑÐ°Ð·Ð¾Ð²Ð°Ð½Ð¸Ðµ",
        primaryCurrency: "Ð¾ÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð²Ð°Ð»ÑÑÐ°",
        print: "Ð¿ÐµÑÐ°ÑÐ°ÑÑ",
        printer: "Ð¿ÑÐ¸Ð½ÑÐµÑ",
        printing: "Ð¿ÐµÑÐ°ÑÑ",
        problem: "Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ð°",
        product: "Ð¿ÑÐ¾Ð´ÑÐºÑ",
        productPrice: "ÑÐµÐ½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        profiledValues: "Ð¿ÑÐ¾ÑÐ¸Ð»ÑÐ½ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ ",
        punch: "Ð½Ð°ÑÐ¾Ñ",
        puncher: "Ð¿Ð¾ÑÑÐµÐ½Ñ",
        punching: "Ð¿ÑÐ¾Ð±Ð¸Ð²ÐºÐ°",
        purge: "Ð¿ÑÐ¾Ð´ÑÑÑ",
        purgeType: "ÑÐ¸Ð¿ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸",
        purgeVolume: "Ð¾Ð±ÑÑÐ¼ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸",
        quality: "ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        quick: "Ð±ÑÑÑÑÐ¾",
        quickTint: "Ð±ÑÑÑÑÐ°Ñ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ°",
        rM: "RM",
        raise: "Ð¿Ð¾Ð²ÑÑÐµÐ½Ð¸Ðµ",
        rcc: "rcc",
        reader: "ÑÐ·ÐµÐ» ÑÑÐ¸ÑÑÐ²Ð°Ð½Ð¸Ñ",
        reboot: "Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·Ð¸ÑÑ",
        receive: "Ð¿Ð¾Ð»ÑÑÐ¸ÑÑ",
        recirculate: "ÑÐµÑÐ¸ÑÐºÑÐ»Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        recirculation: "ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ",
        redlike: "Redlike",
        refill: "Ð¿Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÑ",
        registration: "ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ",
        regular: "ÑÐµÐ³ÑÐ»ÑÑÐ½ÑÐ¹",
        removal: "ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ðµ",
        remove: "ÑÐ´Ð°Ð»Ð¸ÑÑ",
        report: "Ð¾ÑÑÑÑ",
        reset: "Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·Ð¸ÑÑ",
        resolution: "ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸Ðµ",
        restart: "Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÑ",
        rgb: "rgb",
        rights: "Ð¿ÑÐ°Ð²Ð°",
        rounding: "Ð¾ÐºÑÑÐ³Ð´ÐµÐ½Ð¸Ðµ",
        rules: "Ð¿ÑÐ°Ð²Ð¸Ð»Ð°",
        sanTint: "SanTint",
        save: "ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ",
        scale: "ÑÐºÐ°Ð»Ð°",
        scan: "ÑÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        scope: "Ð´Ð¸Ð°Ð¿Ð°Ð·Ð¾Ð½",
        screen: "ÑÐºÑÐ°Ð½",
        screensaver: "ÑÑÐ°Ð½Ð¸ÑÐµÐ»Ñ ÑÐºÑÐ°Ð½Ð°",
        search: "Ð¸ÑÐºÐ°ÑÑ",
        secondaryCurrency: "Ð²ÑÐ¿Ð¾Ð¼Ð¾Ð³Ð°ÑÐµÐ»ÑÐ½Ð°Ñ Ð²Ð°Ð»ÑÑÐ°",
        select: "Ð²ÑÐ±ÑÐ°ÑÑ",
        selectedFormula: "ÐÑÐ±ÑÐ°Ð½Ð½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        sell: "Ð¿ÑÐ¾Ð´Ð°ÑÑ",
        sensor: "ÑÐµÐ½ÑÐ¾Ñ",
        serialNumber: "ÑÐµÑÐ¸Ð¹Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ",
        server: "ÑÐµÑÐ²ÐµÑ",
        servers: "ÑÐµÑÐ²ÐµÑÑ",
        service: "ÑÐµÑÐ²Ð¸Ñ",
        serviceAction: "ÑÐµÑÐ²Ð¸ÑÐ½Ð¾Ðµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ",
        serviceActions: "ÑÐµÑÐ²Ð¸ÑÐ½ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ",
        serviceSoftware: "ÑÐµÑÐ²Ð¸ÑÐ½Ð¾Ðµ ÐÐ",
        serviceWindow: "ÑÐµÑÐ²Ð¸ÑÐ½Ð¾Ðµ Ð¾ÐºÐ½Ð¾",
        settings: "Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        shelf: "Ð¿Ð¾Ð»ÐºÐ°",
        shortcuts: "Ð³Ð¾ÑÑÑÐ¸Ðµ ÐºÐ»Ð°Ð²Ð¸ÑÐ¸",
        shot: "Ð¿Ð¾Ð¿ÑÑÐºÐ°",
        show: "Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ",
        shutDown: "Ð¿ÑÐµÐºÑÐ°ÑÐ°ÑÑ ÑÐ°Ð±Ð¾ÑÑ",
        shutdown: "Ð²ÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ",
        silent: "Ð¢Ð¸ÑÐ¸Ð¹",
        simple: "Ð¿ÑÐ¾ÑÑÐ¾Ð¹",
        simulation: "ÑÐ¸Ð¼ÑÐ»ÑÑÐ¸Ñ",
        size: "ÑÐ°Ð·Ð¼ÐµÑ",
        skip: "Ð¿ÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ",
        smartPurge: "Ð¸Ð½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°",
        software: "Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ðµ Ð¾Ð±ÐµÐ¿ÐµÑÐµÐ½Ð¸Ðµ",
        softwareSupplier: "Ð¿Ð¾ÑÑÐ°Ð²ÑÐ¸Ðº ÐÐ",
        sort: "ÑÐ¾ÑÑ",
        sound: "Ð·Ð²ÑÐº",
        spectro: "ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ",
        spectrophotometer: "ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ",
        speed: "ÑÐºÐ¾ÑÐ¾ÑÑÑ",
        split: "ÑÐ°Ð·Ð´ÐµÐ»Ð¸ÑÑ",
        start: "ÑÑÐ°ÑÑ",
        startup: "Ð·Ð°Ð¿ÑÑÐº",
        statistics: "ÑÑÐ°ÑÐ¸ÑÑÐ¸ÐºÐ°",
        status: "ÑÑÐ°ÑÑÑ",
        stir: "Ð¿ÐµÑÐµÐ¼ÐµÑÐ°ÑÑ",
        stirring: "Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ðµ",
        street: "ÑÐ»Ð¸ÑÐ°",
        support: "Ð¿Ð¾Ð´Ð´ÐµÑÐ¶ÐºÐ°",
        surcharge: "Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÑÐ°ÑÑÐ¾Ð´Ñ",
        tab: "Ð²ÐºÐ»Ð°Ð´ÐºÐ°",
        tabs: "Ð²ÐºÐ»Ð°Ð´ÐºÐ¸",
        task: "Ð·Ð°Ð´Ð°ÑÐ°",
        template: "ÑÐ°Ð±Ð»Ð¾Ð½",
        testing: "ÑÐµÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        time: "Ð²ÑÐµÐ¼Ñ",
        tintingManagementCenter: "ÑÐµÐ½ÑÑ ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ñ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¾Ð¹",
        to: "to",
        toDispense: "Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        tolerance: "Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼Ð¾Ðµ Ð¾ÑÐºÐ»Ð¾Ð½ÐµÐ½Ð¸Ðµ",
        top: "Ð²ÐµÑÑ",
        total: "Ð¸ÑÐ¾Ð³Ð¾",
        translation: "Ð¿ÐµÑÐµÐ²Ð¾Ð´",
        turnOff: "Ð²ÑÐºÐ»ÑÑÐ°ÑÑ",
        turntable: "Ð¿Ð¾Ð²Ð¾ÑÐ¾ÑÐ½ÑÐ¹",
        type: "Ð²Ð²Ð¾Ð´Ð¸ÑÑ",
        uIDD: "UIDD",
        uSGallon: "Ð°Ð¼ÐµÑÐ¸ÐºÐ°Ð½ÑÐºÐ¸Ð¹ Ð³Ð°Ð»Ð»Ð¾Ð½",
        uSQuart: "Ð°Ð¼ÐµÑÐ¸ÐºÐ°Ð½ÑÐºÐ°Ñ ÐºÐ²Ð°ÑÑÐ°",
        unit: "ÐµÐ´Ð¸Ð½Ð¸ÑÐ° Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        up: "Ð²Ð²ÐµÑÑ",
        update: "Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ",
        url: "url",
        user: "Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        userGroups: "Ð³ÑÑÐ¿Ð¿Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "ÐÐÐ¡",
        validate: "Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ",
        validation: "Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ",
        version: "Ð²ÐµÑÑÐ¸Ñ",
        virtual: "Ð²Ð¸ÑÑÑÐ°Ð»ÑÐ½ÑÐ¹",
        volume: "Ð¾Ð±ÑÐµÐ¼",
        weekly: "ÐµÐ´ÐµÐ½ÐµÐ´ÐµÐ»ÑÐ½Ð¾",
        window: "Ð¾ÐºÐ½Ð¾",
        windows: "Windows",
        with: "Ñ",
        without: "Ð±ÐµÐ·",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y value",
        zipCode: "zip ÐºÐ¾Ð´",
        zoom: "ÑÐ²ÐµÐ»Ð¸ÑÐ¸ÑÑ"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ",
        activateNewLicense: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð½Ð¾Ð²ÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ",
        checkLicenseKey: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÐºÐ»ÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
        companyId: "ID ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸",
        contactPerson: "ÐÐ¾Ð½ÑÐ°ÐºÑÐ½Ð¾Ðµ Ð»Ð¸ÑÐ¾",
        copy: "ÐÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        country: "Ð¡ÑÑÐ°Ð½Ð°",
        emptyCity: "ÐÐ¾ÑÐ¾Ð´ ÑÐ²Ð»ÑÐµÑÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÐµÐ¹",
        emptyCountry: "Ð¡ÑÑÐ°Ð½Ð° ÑÐ²Ð»ÑÐµÑÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÐµÐ¹",
        emptyName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¼Ð°Ð³Ð°Ð·Ð¸Ð½Ð° - Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        enterIdentificationKeys: "ÐÐ²ÐµÐ´Ð¸ÑÐµ ÑÐ²Ð¾Ð¹ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ ÐºÐ»ÑÑ",
        expirationDate: "Ð¡ÑÐ¾Ðº Ð³Ð¾Ð´Ð½Ð¾ÑÑÐ¸ %{dateTime}",
        fillRegistration: "ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ Ð´Ð»Ñ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸",
        insertLicense: "ÐÐ²ÐµÐ´Ð¸ÑÐµ ÑÐ³ÐµÐ½ÐµÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐ¹ ÐºÐ»ÑÑ Ð´Ð»Ñ Ð¾ÑÐ»Ð°Ð¹Ð½-Ð°ÐºÑÐ¸Ð²Ð°ÑÐ¸Ð¸",
        invalidEmail: "ÐÐ²Ð¾Ð´ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÑ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÐµÐ½",
        invalidPhone: "ÐÐ²Ð¾Ð´ Ð¿Ð¾ Ð½Ð¾Ð¼ÐµÑÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÐµÐ½",
        itemsMarkedasterisk: "(ÑÐ»ÐµÐ¼ÐµÐ½ÑÑ, Ð¾ÑÐ¼ÐµÑÐµÐ½Ð½ÑÐµ Ð·Ð²ÐµÐ·Ð´Ð¾ÑÐºÐ¾Ð¹, Ð´Ð¾Ð»Ð¶Ð½Ñ Ð±ÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ)",
        lastUpdate: "ÐÐ¾ÑÐ»ÐµÐ´Ð½ÐµÐµ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ %{dateTime}",
        leasedLicense: "ÐÑÐµÐ½Ð´Ð¾Ð²Ð°Ð½Ð½Ð°Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ",
        licenseActivated: "ÐÐ¸ÑÐµÐ½Ð·Ð¸Ñ ÑÐ¶Ðµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°Ð½Ð°",
        licenseStatus: "Ð¡ÑÐ°ÑÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
        licenseWillExpire: "Ð¡ÑÐ¾Ðº Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ ÐÐ°ÑÐµÐ¹ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸ Ð¸ÑÑÐµÐºÐ°ÐµÑ ÑÐµÑÐµÐ· %{dayCount} Ð´Ð½ÐµÐ¹ ",
        licenseWillExpireOneDay: "ÐÐ°ÑÐ° Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ Ð¸ÑÑÐµÐºÐ°ÐµÑ ÑÐµÑÐµÐ· %{dayCount} Ð´Ð½ÐµÐ¹",
        machineInformation: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐµ",
        noLicenseAvailable: "Ð½ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾Ð¹ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
        noProductsForKey: "ÐÐ»Ñ ÑÐºÐ°Ð·Ð°Ð½Ð½ÑÑ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½ÑÑ ÐºÐ»ÑÑÐµÐ¹ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ñ ÑÐ¾Ð²Ð°ÑÑ",
        pointOfSale: "Ð¢Ð¾ÑÐºÐ° Ð¿ÑÐ¾Ð´Ð°Ð¶",
        producer: "ÐÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»Ñ",
        reactivate: "Ð ÐµÐ°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        reactivateLicense: "Reactivate license",
        region: "ÐÐ±Ð»Ð°ÑÑÑ",
        registerLicense: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, ÑÐ´ÐµÐ»Ð°Ð¹ÑÐµ ÐºÐ¾Ð¿Ð¸Ñ Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð½Ð° Ð°ÐºÑÐ¸Ð²Ð°ÑÐ¸Ñ Ð¸ Ð¿ÐµÑÐµÐ¹Ð´Ð¸ÑÐµ Ð¿Ð¾ ÑÑÑÐ»ÐºÐµ:",
        registrationForm: "Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ",
        selectProduct: "ÐÑÐ±ÑÐ°ÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑ",
        serialNumber: "Ð¡ÐµÑÐ¸Ð¹Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ",
        skipNewLicense: "ÐÑÐ»Ð¸ Ð²Ñ ÑÐ¾ÑÐ¸ÑÐµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð½Ð¾Ð²ÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ Ð¿Ð¾Ð·Ð¶Ðµ, Ð²Ñ Ð¼Ð¾Ð¶ÐµÑÐµ Ð½Ð°Ð¶Ð°ÑÑ Ð½Ð° 'ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ'",
        unlimitedLicense: "ÐÐµÐ¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð½Ð°Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ñ",
        userId: "ID Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        uuid: "UUID Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
        versionDetails: "ÐÐµÑÐ°Ð»Ð¸ Ð²ÐµÑÑÐ¸Ð¸ ",
        versionScope: "Ð¡ÑÐµÑÐ° Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð²ÐµÑÑÐ¸Ð¸",
        versionType: "Ð¢Ð¸Ð¿ Ð²ÐµÑÑÐ¸Ð¸",
        zip: "ÐÐ¾ÑÑÐ¾Ð²ÑÐ¹ Ð¸Ð½Ð´ÐµÐºÑ"
    },
    login: {
        authenticate: "ÐÑÑÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ ",
        logIn: "ÐÑÐ¾Ð´",
        loginAs: "ÐÐ¾Ð¹ÑÐ¸ ÐºÐ°Ðº Ð´ÑÑÐ³Ð¾Ð¹ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        messages: {
            incorrectUsername: "ÐÐµÐ²ÐµÑÐ½ÑÐ¹ Ð»Ð¾Ð³Ð¸Ð½ Ð¸Ð»Ð¸ Ð¿Ð°ÑÐ¾Ð»Ñ"
        },
        password: "ÐÐ°ÑÐ¾Ð»Ñ",
        username: "ÐÐ¾Ð³Ð¸Ð½"
    },
    machineActionHistory: {
        actionHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹"
    },
    machineErrors: {
        channel: "Ð¡Ð¾Ð¿Ð»Ð¾",
        code: "ÐÐ¾Ð´",
        machineErrors: "ÐÑÐ¸Ð±ÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        noMachineErrors: "Ð Ð½Ð°ÑÑÐ¾ÑÑÐ¸Ð¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð¾ÑÐ¸Ð±Ð¾Ðº Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½ÐµÑ",
        resetErrors: "Ð¡Ð±ÑÐ¾Ñ Ð¾ÑÐ¸Ð±Ð¾Ðº"
    },
    machineSettings: {
        action: "ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ",
        addAutotask: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°ÑÑ",
        autoCanisterIn: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ ÐºÐ°Ð½Ð¸ÑÑÑÐ° Ð²Ð½ÑÑÑÐ¸",
        autoCanisterOut: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸ ÐºÐ°Ð½Ð¸ÑÑÑÐ° ÑÐ½Ð°ÑÑÐ¶Ð¸",
        automaticRefill: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ðµ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ",
        autotaskSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°Ñ",
        backupConfiguration: "Ð ÐµÐ·ÐµÑÐ²Ð½Ð°Ñ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        brushMaintenance: "ÐÐ±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ ÑÐµÑÐºÐ¸",
        capMaintenance: "ÐÐ±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ ÐºÑÑÑÐºÐ¸",
        checkCanisterBeforeDispense: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ Ð¿ÐµÑÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»ÐµÑÐ¸ÑÑÐµÐ¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        checkOverfill: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð±Ð°Ð»Ð»Ð¾Ð½ Ð¿ÐµÑÐµÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
        checkTotalCntAmounts: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð¾Ð±ÑÐµÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð´Ð»Ñ Ð±Ð°Ð·Ð¾Ð²Ð¾Ð¹ ÐºÑÐ°ÑÐºÐ¸",
        cleanAll: "ÐÑÐ¸ÑÑÐ¸ÑÑ Ð²ÑÐµ",
        computerReboot: "ÐÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        computerShutdown: "ÐÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        connectMachine: "ÐÐ¾Ð´ÐºÐ»ÑÑÐ¸ÑÑ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ",
        days: "ÐÐ½ÐµÐ¹",
        daysOfMonth: "ÐÐ½ÐµÐ¹ Ð² Ð¼ÐµÑÑÑ",
        devices: "ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÑÑÑÐ¸Ðµ",
        disabled: "ÐÑÐºÐ»ÑÑÐµÐ½",
        dispenseAndPurge: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð¸ Ð¿ÑÐ¾Ð´ÑÑÑ",
        dispenseOnly: "Ð¢Ð¾Ð»ÑÐºÐ¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        dispenserCleaning: "ÐÑÐ¸ÑÑÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        dispensingWithErrorsEnabled: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²ÐºÑ, Ð½ÐµÑÐ¼Ð¾ÑÑÑ Ð½Ð° Ð¾ÑÐ¸Ð±ÐºÐ¸",
        editAutotask: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°Ð½Ð¸Ðµ",
        firstRun: "ÐÐµÑÐ²ÑÐ¹ Ð·Ð°Ð¿ÑÑÐº",
        hours: "Ð§Ð°ÑÑ",
        humidifier: "Ð£Ð²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»Ñ",
        humidifierWaterLevelMaintenance: "ÐÐ¾Ð´Ð´ÐµÑÐ¶Ð°Ð½Ð¸Ðµ ÑÑÐ¾Ð²Ð½Ñ Ð²Ð¾Ð´Ñ Ð² ÑÐ²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»Ðµ",
        machineConfigurationNoCanisters: "ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð½Ðµ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        machineName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        machineSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        manualPuncher: "Ð ÑÑÐ½Ð¾Ð¹ Ð¿ÑÐ¾Ð±Ð¾Ð¹Ð½Ð¸Ðº",
        minDispensedAmount: "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð´Ð¾Ð·Ð¸ÑÑÐµÐ¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        minutes: "ÐÐ¸Ð½ÑÑÑ",
        nextRun: "Ð¡Ð»ÐµÐ´ÑÑÑÐ¸Ð¹ Ð·Ð°Ð¿ÑÑÐº",
        noAutotasksSet: "ÐÐ²ÑÐ¾Ð·Ð°Ð´Ð°ÑÐ¸ Ð½Ðµ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ñ",
        noDataAvailable: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð´Ð°Ð½Ð½ÑÑ",
        noMachine: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÑÐ½",
        onStart: "ÐÐ° ÑÑÐ°ÑÑÐµ",
        plugger: "Ð¨ÑÐ¾Ð¿ÑÐµÑ",
        postpone: "ÐÑÐ»Ð¾Ð¶Ð¸ÑÑ ÑÐ°ÑÑ",
        puncher: "ÐÑÐ¾Ð±Ð¾Ð¹Ð½Ð¸Ðº",
        purgeAll: "ÐÑÐ¾Ð´ÑÑÑ Ð²ÑÐµ",
        purgeOnly: "Ð¢Ð¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°",
        recirculateAll: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð²ÑÐµ",
        recirculateChannels: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð¿Ð»Ð°",
        recirculationSpeed: "Ð¡ÐºÐ¾ÑÐ¾ÑÑÑ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ð¸",
        recirculationTime: "ÐÑÐµÐ¼Ñ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ð¸",
        refillAll: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð²ÑÐµ",
        refillCanisters: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        runAt: "ÐÐ¶ÐµÐ´Ð½ÐµÐ²Ð½Ð¾ Ð²",
        runDefinedDaysAt: "Ð Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð½ÑÐµ Ð´Ð½Ð¸ Ð²",
        runEvery: "ÐÐ°Ð¿ÑÑÐºÐ°ÑÑ ÐºÐ°Ð¶Ð´ÑÐ¹",
        runInDays: "ÐÐ°Ð¿ÑÑÐºÐ°ÑÑ ÑÐµÑÐµÐ· Ð´Ð½ÐµÐ¹",
        serialNum: "Ð¡ÐµÑÐ¸Ð¹Ð½ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ",
        settingsMachine: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        smartPurgeAll: "Ð£Ð¼Ð½Ð°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ° Ð²ÑÐµÑ ÑÐ¾Ð¿ÐµÐ»",
        smartPurgeChannels: "Ð£Ð¼Ð½Ð°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ° ÑÐ¾Ð¿ÐµÐ»",
        smartPurgeRules: "ÐÐµÑÐ°Ð½Ð¸Ð·Ð¼ ÑÐ¼Ð½Ð¾Ð¹ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸",
        startType: "Ð¢Ð¸Ð¿ Ð·Ð°Ð¿ÑÑÐºÐ°",
        stirAll: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÑÑ Ð²ÑÐµ",
        stirCanisters: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        stirringSpeed: "Ð¡ÐºÐ¾ÑÐ¾ÑÑÑ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ñ",
        stirringTime: "ÐÑÐµÐ¼Ñ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ñ",
        switchPlateMaintenance: "ÐÐ±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ",
        theCurrentlySelectedMachine: "ÐÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ",
        threshold: "ÐÑÐµÐ´ÐµÐ»",
        turntable: "ÐÐ¾Ð²Ð¾ÑÐ¾ÑÐ½ÑÐ¹ ÑÑÐ¾Ð»",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "ÐÐ±ÑÐµÐ¼",
        weekdays: "ÐÑÐ´Ð½Ð¸Ðµ Ð´Ð½Ð¸"
    },
    mainTab: {
        acceptedFormula: "Ð£ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        addBuildingSite: "Add building site",
        addToFavorites: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ðº Ð¸Ð·Ð±ÑÐ°Ð½Ð½ÑÐ¼",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "ÐÐ´Ð¸Ð½ Ð¸Ð»Ð¸ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð½Ðµ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ñ",
        dispensedPackages: "ÐÐ¾Ð·Ð¸ÑÑÐµÐ¼ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        dispensingInProgress: "ÐÐ´ÐµÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        dispensingIsAborted: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð¿ÑÐµÑÐ²Ð°Ð½Ð¾",
        dispensingIsNotAvailable: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²ÐºÐ° Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾",
        dispensingProgress: "%{done} Ð¸Ð· %{all}",
        editColorant: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        editNote: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿ÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ðµ",
        findCompetitiveColor: "ÐÐ°Ð¹ÑÐ¸ ÑÐ²ÐµÑ ÐºÐ¾Ð½ÐºÑÑÐµÐ½ÑÐ°",
        forceDispensing: "ÐÑÐ¸Ð½ÑÐ´Ð¸ÑÐµÐ»ÑÐ½Ð¾Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        formulaInvalidColorants: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Ð¡ÐºÑÑÑÑÐµ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð¸ ÑÐ²ÐµÑÐ¾Ð²",
        hiddenProducts: "Ð¡ÐºÑÑÑÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑÑ",
        historicalFormulas: "ÐÑÑÐ¾ÑÐ¸ÑÐµÑÐºÐ¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        lowerDeltaNumber: "ÐÐµÐ½ÑÑÐµÐµ Ð´ÐµÐ»ÑÑÐ°-ÑÐ¸ÑÐ»Ð¾ Ð±Ð¾Ð»ÐµÐµ ÑÐ¾ÑÐ½Ð¾Ðµ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ðµ",
        machineError: "ÐÑÐ¸Ð±ÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        machineIsBusy: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½",
        machineNotConnected: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÑÐ½",
        manualColorantAddition: "Ð ÑÑÐ½Ð¾Ðµ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        modifiedFormula: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð°",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "ÐÐ¾Ð²ÑÐ¹ ÑÐ²ÐµÑ Ð¿Ð¾ÑÐ»Ðµ Ð¼Ð°ÑÑÑÐ°Ð±Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        newRgbNotAccuratelyMeasured: "ÐÐ¾Ð²ÑÐ¹ RGB Ð½Ðµ Ð¸Ð·Ð¼ÐµÑÑÐµÑÑÑ ÑÐ¾ÑÐ½Ð¾, ÑÑÐ¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð¾ÑÐ¸ÐµÐ½ÑÐ¸ÑÐ¾Ð²Ð¾ÑÐ½Ð¾",
        noBaseAvailable: "ÐÐ°Ð·Ð° Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "ÐÐµÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        noCustomer: "ÐÐµÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        noCustomers: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð²",
        noDispenseNotesAvailable: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð·Ð°Ð¿Ð¸ÑÐµÐ¹ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ",
        noFormulaAvailable: "ÐÑ Ð²ÑÐ±ÑÐ°Ð»Ð¸ ÐºÐ¾Ð¼Ð±Ð¸Ð½Ð°ÑÐ¸Ñ Ð±ÐµÐ· ÑÐ¾ÑÐ¼ÑÐ»Ñ!",
        noFormulaSelected: "ÐÑ Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        noInternalNotesAvailable: "ÐÐ°Ð¼ÐµÑÐºÐ¸ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ñ",
        noNotesAvailable: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð·Ð°Ð¿Ð¸ÑÐµÐ¹",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð½Ð°",
        noProductAvailable: "No product is available",
        noResultsFound: "Ð ÐµÐ·ÑÐ»ÑÑÐ°ÑÑ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ñ",
        openLocalFile: "ÐÑÐºÑÑÑÑ Ñ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        openOnlineFile: "ÐÑÐºÑÑÑÑ Ð¸Ð· ÐÐ½ÑÐµÑÐ½ÐµÑÐ°",
        order: "ÐÐ°ÐºÐ°Ð·",
        orderingIsNotAvailable: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ Ð·Ð°ÐºÐ°Ð·",
        originalColor: "ÐÑÐ¸Ð³Ð¸Ð½Ð°Ð»ÑÐ½ÑÐ¹ ÑÐ²ÐµÑ",
        overAvailableLevel: "Ð¡Ð²ÐµÑÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾Ð³Ð¾ ÑÑÐ¾Ð²Ð½Ñ",
        package: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        packageIsRequired: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        packaging: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "ÐÐµÑÐ°ÑÑ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð°",
        productFiles: "Ð¤Ð°Ð¹Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        productFilesViewer: "ÐÑÐ¾ÑÐ¼Ð¾ÑÑÑÐ¸Ðº ÑÐ°Ð¹Ð»Ð¾Ð² Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð²",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Ð¡ÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð°Ñ ÑÐµÐ½Ð°",
        resetFormulaData: "ÐÐ¾Ð²Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        rgbOnlyIndicative: "RGB ÑÐ¾Ð»ÑÐºÐ¾ Ð¾ÑÐ¸ÐµÐ½ÑÐ¸ÑÐ¾Ð²Ð¾ÑÐ½ÑÐ¹!",
        saveAsCustom: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ ÐºÐ°Ðº",
        saveToStatsIsNotAvailable: "ÐÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ðµ Ð² Ð¸ÑÑÐ¾ÑÐ¸Ð¸ ",
        searchForCheaper: "ÐÐ°Ð¹ÑÐ¸ Ð´ÐµÑÐµÐ²Ð»Ðµ",
        selectFromCompetitive: "ÐÑ Ð¼Ð¾Ð¶ÐµÑÐµ Ð²ÑÐ±ÑÐ°ÑÑ ÑÐ²ÐµÑ Ð¸Ð· ÐºÐ¾Ð½ÐºÑÑÐ¸ÑÑÑÑÐ¸Ñ ÑÐ²ÐµÑÐ¾Ð².",
        specialPrice: "Ð¡Ð¿ÐµÑÐ¸Ð°Ð»ÑÐ½Ð°Ñ ÑÐµÐ½Ð°",
        specialPriceVip: "Ð¡Ð¿ÐµÑÐ¸Ð°Ð»ÑÐ½Ð°Ñ VIP ÑÐµÐ½Ð°",
        splitFormula: "Ð Ð°Ð·Ð´ÐµÐ»Ð¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        withVAT: "Ñ ÐÐÐ¡",
        withoutVAT: "Ð±ÐµÐ· ÐÐÐ¡"
    },
    marginSettings: {
        allBases: "ÐÑÐµ Ð±Ð°Ð·Ñ",
        allProducts: "ÐÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑÑ",
        editMargin: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð¼Ð°ÑÐ¶Ñ",
        marginAndDiscountWarning: "ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð²Ð°ÑÐ¸Ð°Ð½Ñ ÑÐ°ÑÑÐµÑÐ° ÑÐµÐ½Ñ Ð´Ð»Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸Ñ Ð¼Ð°ÑÐ¶Ð¸ Ð¸ ÑÐºÐ¸Ð´Ð¾Ðº.",
        marginSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¼Ð°ÑÐ¶Ð¸",
        marginsFor: "ÐÐ°ÑÐ¶Ð° Ð½Ð°",
        markupColorants: "ÐÐ°ÑÐµÐ½ÐºÐ° Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        sizeOfPackage: "Ð Ð°Ð·Ð¼ÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        valueBase: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð±Ð°Ð·Ñ",
        valueColorant: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÐµÐ´Ð¸Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        payAttention: "ÐÐ±ÑÐ°ÑÐ¸ÑÐµ Ð²Ð½Ð¸Ð¼Ð°Ð½Ð¸Ðµ!"
    },
    module: {
        productGroups: "ÐÑÑÐ¿Ð¿Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð²"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Ð¤Ð¸Ð»ÑÑÑ Ð¿Ð¾ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð°Ð¼",
            formulasOverLimit: "ÐÐºÐ¾Ð»Ð¾ %{count} ÑÐµÐ·ÑÐ»ÑÑÐ°ÑÐ¾Ð². ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð½Ð°Ð¿Ð¸ÑÐ°ÑÑ Ð±Ð¾Ð»ÑÑÐµ ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð².",
            foundFormulas: "Ð¤Ð¾ÑÐ¼ÑÐ» Ð½Ð°Ð¹Ð´ÐµÐ½Ð¾: %{count} ",
            help: "ÐÐ¾Ð¼Ð¾ÑÑ:",
            helpText:
                "ÐÐ°Ð±Ð¸ÑÐ°Ð¹ÑÐµ  '%{filter}', ÑÑÐ¾Ð±Ñ Ð¸ÑÐºÐ°ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ð°ÑÐ¸Ð½Ð°ÑÑÑÑ Ñ '%{formula}' , Ð¿ÑÐ¾Ð´ÑÐºÑÑ, Ð½Ð°ÑÐ¸Ð½Ð°ÑÑÐ¸ÐµÑÑ Ñ '%{product}' Ð¸ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð¸ '%{fandeck}'",
            productFilter: "Ð¤Ð¸Ð»ÑÑÑ Ð¿Ð¾ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°Ð¼",
            searchInFormulas: "ÐÐ¾Ð¸ÑÐº Ð² ÑÐ¾ÑÐ¼ÑÐ»Ð°Ñ",
            typeMore: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð½Ð°Ð±ÐµÑÐ¸ÑÐµ Ð±Ð¾Ð»ÑÑÐµ ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²"
        },
        menu: {
            actionHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹",
            additionalFormulaTab: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ° ÑÐ¾ÑÐ¼ÑÐ»",
            advancedSettings: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
            autotaskSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°ÑÐ¸",
            availableDatabases: "ÐÐ¾ÑÑÑÐ¿Ð½ÑÐµ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
            availablePrices: "ÐÐµÐ¹ÑÑÐ²ÑÑÑÐ¸Ðµ ÑÐµÐ½Ñ",
            bugReport: "Ð¡Ð¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¾Ð± Ð¾ÑÐ¸Ð±ÐºÐµ",
            canisterBarcodes: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ ÐºÐ°Ð½Ð¸ÑÑÑ",
            canisterDispensingLogic: "ÐÐ¾Ð³Ð¸ÐºÐ° Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            canisterFilling: "ÐÐ°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÐºÐ°Ð½Ð¸ÑÑÑ",
            canisterSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÐºÐ°Ð½Ð¸ÑÑÑ",
            clientServerSettings: "Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ/ÑÐµÑÐ²ÐµÑÐ°",
            closing: "ÐÐ°ÐºÑÑÑÐ¸Ðµ ÑÐ°Ð¹ÑÐ°",
            color: "Ð¦Ð²ÐµÑ",
            colorModification: "ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÐ²ÐµÑÐ°",
            colorPanel: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð°Ð½ÐµÐ»ÐµÐ¹ ÑÐ²ÐµÑÐ¾Ð²",
            colorRepresentation: "ÐÑÐ¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ ÑÐ²ÐµÑÐ° Ð¸ Ð´Ð°Ð½Ð½ÑÐµ",
            colorSearch: "ÐÐ¾Ð¸ÑÐº ÑÐ²ÐµÑÐ°",
            colorant: "ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
            colorantConsumption: "Ð Ð°ÑÑÐ¾Ð´ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
            colorantPricing: "Ð¦ÐµÐ½Ñ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
            colorantRefillHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð´Ð¾Ð·Ð°Ð¿ÑÐ°Ð²ÐºÐ¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
            competitiveSearch: "Ð Ð°ÑÑÐ¸ÑÐµÐ½Ð½ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ ÑÐ²ÐµÑÑ",
            connections: "Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ",
            currency: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð²Ð°Ð»ÑÑÑ",
            customData: "ÐÐ°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
            database: "ÐÐ°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ",
            databaseCheck: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
            databaseConnection: "Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Ñ Ð±Ð°Ð·Ð¾Ð¹ Ð´Ð°Ð½Ð½ÑÑ",
            defaultValues: "ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
            devices: "ÐÑÐ¸Ð±Ð¾ÑÑ",
            dispensingHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            dispensingSettings: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            driverSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°",
            environment: "ÐÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð°",
            environmentConfiguration: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ñ",
            environmentalSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¾ÐºÑÑÐ¶Ð°ÑÑÐµÐ³Ð¾ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ñ",
            favorites: "ÐÐ·Ð±ÑÐ°Ð½Ð½Ð¾Ðµ",
            fileTransfer: "DESO File Transfer",
            formatting: "Ð¤Ð¾ÑÐ¼Ð°ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
            formula: "Formula",
            formulaData: "ÐÐ°Ð½Ð½ÑÐµ",
            formulaModification: "Formula modification",
            formulaPanels: "ÐÐ°Ð½ÐµÐ»Ð¸ ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°Ð¼Ð¸",
            formulaSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»",
            formulaUnit: "ÐµÐ´Ð¸Ð½Ð¸ÑÐ° ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            generalSearch: "ÐÐ»Ð°Ð²Ð½ÑÐ¹ Ð¿Ð¾Ð¸ÑÐº",
            globalSettingsSearch: "ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ Ð³Ð»Ð¾Ð±Ð°Ð»ÑÐ½ÑÐ¼ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ð¼",
            helpItems: "Ð¡Ð¿ÑÐ°Ð²ÐºÐ° Ð¿Ð¾ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ð¼",
            importAndExport: "ÐÐ¼Ð¿Ð¾ÑÑ Ð¸ ÑÐºÑÐ¿Ð¾ÑÑ",
            importAndExportData: "ÐÐ¼Ð¿Ð¾ÑÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÑÐºÐ¸Ñ Ð´Ð°Ð½Ð½ÑÑ",
            importCustomData: "ÐÐ¼Ð¿Ð¾ÑÑ Ð´Ð°Ð½Ð½ÑÑ",
            initialFormulaTab: "ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½Ð°Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ° ÑÐ¾ÑÐ¼ÑÐ»Ñ",
            interfaceSettings: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð¸Ð½ÑÐµÑÑÐµÐ¹ÑÐ°",
            keyboardShortcuts: "ÐÐ¾ÑÑÑÐ¸Ðµ ÐºÐ»Ð°Ð²Ð¸ÑÐ¸",
            language: "Ð¯Ð·ÑÐº",
            languageSettings: "ÐÑÐ±Ð¾Ñ ÑÐ·ÑÐºÐ°",
            layout: "Ð¡ÑÐµÐ¼Ð° ÑÐ°Ð¹ÑÐ°",
            license: "ÐÐ¸ÑÐµÐ½Ð·Ð¸Ñ",
            licenseData: "ÐÐ°Ð½Ð½ÑÐµ Ð¾ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
            licenseIdentification: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
            licenseStatus: "Ð¡ÑÐ°ÑÑÑ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
            licenseSupplier: "ÐÐ¾ÑÑÐ°Ð²ÑÐ¸Ðº Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
            licenseVersion: "ÐÐµÑÑÐ¸Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
            localData: "ÐÐ¾ÐºÐ°Ð»ÑÐ½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ",
            machine: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐµ",
            machineActions: "ÐÐµÐ¹ÑÑÐ²Ð¸Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
            machineAndDevices: "ÐÐ°ÑÐ¸Ð½Ñ Ð¸ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð°",
            machineManagement: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸ÐµÐ¼",
            machineSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
            mainSettings: "ÐÑÐ½Ð¾Ð²Ð½ÑÐµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
            maintenance: "ÐÐ±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ",
            marginAndDiscount: "ÐÐ°ÑÐ¶Ð° Ð¸ ÑÐºÐ¸Ð´ÐºÐ°",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Ð­Ð»ÐµÐ¼ÐµÐ½ÑÑ Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¸",
            newFormulaWindow: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°",
            orderSearch: "ÐÐ¾Ð¸ÑÐº Ð·Ð°ÐºÐ°Ð·Ð°",
            orderSettings: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð·Ð°ÐºÐ°Ð·Ð°",
            packageSurcharge: "ÐÐ°ÑÐµÐ½ÐºÐ° Ð·Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
            popUps: "ÐÑÐ¿Ð»ÑÐ²Ð°ÑÑÐµÐµ Ð¾ÐºÐ½Ð¾",
            posInfo: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ¾ÑÐºÐµ Ð¿ÑÐ¾Ð´Ð°Ð¶",
            price: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐµÐ½",
            priceManagement: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ ÑÐµÐ½Ð°Ð¼Ð¸",
            priceSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐµÐ½",
            pricingOptions: "ÐÐ¿ÑÐ¸Ð¸ ÑÐµÐ½Ð¾Ð¾Ð±ÑÐ°Ð·Ð¾Ð²Ð°Ð½Ð¸Ñ",
            printSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿ÐµÑÐ°ÑÐ¸",
            productPricing: "Ð¦ÐµÐ½Ñ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÑ",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "ÐÑÑÑÑÐ¾Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
            rccConfig: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ RCC",
            rccConnection: "Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ RCC",
            rccSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ RCC",
            refillSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
            refillingLogic: "ÐÐ»Ð³Ð¾ÑÐ¸ÑÐ¼ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
            registration: "Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ",
            searchSettings: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð¿Ð¾Ð¸ÑÐºÐ°",
            serverPlugins: "ÐÐ¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ñ ÑÐµÑÐ²ÐµÑÐ°",
            serviceActions: "Ð¡ÐµÑÐ²Ð¸ÑÐ½ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ",
            settings: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ",
            simplifiers: "Ð¡Ð¸Ð¼Ð¿Ð»Ð¸ÑÐ¸ÐºÐ°ÑÐ¾ÑÑ",
            singleActions: "Ð Ð°Ð·Ð¾Ð²ÑÐµ Ð¾Ð¿ÐµÑÐ°ÑÐ¸Ð¸",
            smartPurgeRules: "ÐÐµÑÐ°Ð½Ð¸Ð·Ð¼ ÑÐ¼Ð½Ð¾Ð¹ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸",
            softwareOptions: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ",
            spectroSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÐ°",
            statistics: "Ð¡ÑÐ°ÑÐ¸ÑÑÐ¸ÐºÐ°",
            switchToFrontdesk: "ÐÐµÑÐµÐ¹ÑÐ¸ Ð½Ð° ÑÐ°Ð±Ð¾ÑÐ¸Ð¹ ÑÑÐ¾Ð»",
            switchToFullRedlike: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº %{name}",
            switchToLight: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº %{name}",
            switchToMachine: "ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð´Ð¾Ð·Ð°ÑÐ¾ÑÑ",
            tabs: "ÐÐºÐ»Ð°Ð´ÐºÐ¸ Ð¸ Ð²ÑÐ¿Ð»ÑÐ²Ð°ÑÑÐ¸Ðµ Ð¾ÐºÐ½Ð°",
            testBarcodes: "Ð¢ÐµÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð¾Ð²",
            updateOptions: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ ",
            userManagemenet: "ÐÐ´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¸Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹",
            visibleUnits: "Ð²Ð¸Ð´Ð¸Ð¼ÑÐµ ÑÐ¸Ð¼Ð²Ð¾Ð»Ñ"
        },
        navBar: {
            barcode: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´",
            help: "ÐÐ¾Ð¼Ð¾ÑÑ",
            hideItems: "Ð¡ÐºÑÑÑÑ Ð¿ÑÐ¾Ð´ÑÐºÑÑ/ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð¸"
        },
        notificationPanel: {
            noNotifications: "ÐÐµÑ Ð½Ð¾Ð²ÑÑ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ð¹"
        },
        tabBar: {
            closeActive: "ÐÐ°ÐºÑÑÑÑ Ð°ÐºÑÐ¸Ð²Ð½ÑÐµ ÑÑÑÐ°Ð½Ð¸ÑÑ",
            closeAll: "ÐÐ°ÐºÑÑÑÑ Ð²ÑÐµ",
            closeAllExceptActive: "ÐÐ°ÐºÑÑÑÑ Ð²ÑÐµ ÐºÑÐ¾Ð¼Ðµ Ð°ÐºÑÐ¸Ð²Ð½ÑÑ ÑÑÑÐ°Ð½Ð¸Ñ",
            customFormula: "Custom Formula",
            dispensingHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
            favorites: "ÐÐ·Ð±ÑÐ°Ð½Ð½Ð¾Ðµ",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "ÐÐ°Ð·Ð½Ð°ÑÐ¸ÑÑ",
        assignment: "ÐÐ°Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ",
        createdDate: "ÐÐ°ÑÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ",
        finishDispensing: "ÐÐ°ÐºÐ¾Ð½ÑÐ¸ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        foundInOrders: "ÐÐ°Ð¹Ð´ÐµÐ½Ð¾ Ð² Ð·Ð°ÐºÐ°Ð·Ð°Ñ",
        inactiveDatabase: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð¸Ð· Ð½ÐµÐ°ÐºÑÐ¸Ð²Ð½Ð¾Ð¹ Ð¸Ð»Ð¸ Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ %{0}",
        inactiveUnknownDatabase: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð¸Ð· Ð½ÐµÐ°ÐºÑÐ¸Ð²Ð½Ð¾Ð¹ Ð¸Ð»Ð¸ Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        newOrderReceived: "ÐÑ Ð¿Ð¾Ð»ÑÑÐ¸Ð»Ð¸ Ð½Ð¾Ð²ÑÐ¹ Ð·Ð°ÐºÐ°Ð·!",
        noOrderSelected: "ÐÐ°ÐºÐ°Ð· Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð½",
        release: "ÐÑÐ¿ÑÑÐº",
        status: {
            accepted: "Ð¿ÑÐ¸Ð½ÑÑÐ¾",
            canceled: "Ð¾ÑÐ¼ÐµÐ½ÐµÐ½Ð¾",
            created: "ÑÐ¾Ð·Ð´Ð°Ð½Ð¾",
            done: "Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¾",
            partlyDone: "ÑÐ°ÑÑÐ¸ÑÐ½Ð¾ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¾",
            preparing: "Ð¿Ð¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ°",
            unknown: "Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð¾"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "ÐÐ´ÑÐµÑ",
        contactName: "ÐÐ¼Ñ ÐºÐ¾Ð½ÑÐ°ÐºÑÐ½Ð¾Ð³Ð¾ Ð»Ð¸ÑÐ°",
        contactPerson: "ÐÐ¾Ð½ÑÐ°ÐºÑÐ½Ð¾Ðµ Ð»Ð¸ÑÐ¾",
        identification: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ",
        machineInformation: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ",
        pos: "Ð¢Ð¾ÑÐºÐ° Ð¿ÑÐ¾Ð´Ð°Ð¶",
        secondAddress: "ÐÑÐ¾ÑÐ¾Ð¹ Ð°Ð´ÑÐµÑ",
        shopIdentification: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        shopName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¼Ð°Ð³Ð°Ð·Ð¸Ð½Ð°",
        url: "Ð¡Ð°Ð¹Ñ",
        zipCode: "ÐÐ¾ÑÑÐ¾Ð²ÑÐ¹ Ð¸Ð½Ð´ÐµÐºÑ"
    },
    priceTypeList: {
        priceBasePurchase: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð±Ð°Ð·Ñ",
        priceBaseSell: "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð½Ð° Ð±Ð°Ð·Ñ",
        priceBaseSellFull: "Ð Ð¾Ð·Ð½Ð¸ÑÐ½Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð½Ð° Ð±Ð°Ð·Ñ",
        priceCntPurchase: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        priceCntPurchaseByColorantName: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° %{0}",
        priceCntPurchaseByName: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð¿Ð¾ Ð½Ð°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ñ",
        priceCntSell: "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
        priceCntSellByColorantName: "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° %{0}",
        priceCntSellByName: "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð¿Ð¾ Ð½Ð°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ñ",
        priceCntSellFull: "Ð Ð¾Ð·Ð½Ð¸ÑÐ½Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
        priceCntSellFullByColorantName: "Ð Ð¾Ð·Ð½Ð¸ÑÐ½Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ %{0}",
        priceCntSellFullByName: "Ð Ð¾Ð·Ð½Ð¸ÑÐ½Ð°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð¿Ð¾ Ð½Ð°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ñ",
        priceGroupBarcode: "Ð¨ÑÑÐ¸Ñ ÐºÐ¾Ð´ ÑÐµÐ½Ð¾Ð²Ð¾Ð¹ Ð³ÑÑÐ¿Ð¿Ñ",
        priceMarginAll: "ÐÐ°ÑÐ¶Ð° Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceMarginPerPkg: "ÐÐ°ÑÐ¶Ð° Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        priceSellPriceAll: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð²ÑÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº",
        priceSellPricePerKg: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼Ð¼",
        priceSellPricePerL: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° Ð»Ð¸ÑÑ",
        priceSellPricePerPkg: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        priceSurchargeAll: "ÐÐ°ÑÐµÐ½ÐºÐ° Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceSurchargePerPkg: "ÐÐ°ÑÐµÐ½ÐºÐ° Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        priceTintPurchaseAll: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceTintPurchasePerPkg: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        priceTintSellFullAll: "Ð¦ÐµÐ½Ð° ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceTintSellFullAllPerPackage: "Ð¦ÐµÐ½Ð° ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð·Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        priceTotalPurchaseAll: "ÐÐ±ÑÐ°Ñ ÑÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceTotalPurchasePerKg: "ÐÐ±ÑÐ°Ñ ÑÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼Ð¼",
        priceTotalPurchasePerL: "ÐÐ±ÑÐ°Ñ ÑÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð·Ð° Ð»Ð¸ÑÑ",
        priceTotalPurchasePerPkg: "ÐÐ±ÑÐ°Ñ ÑÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        priceTotalSellFullAll: "ÐÐ±ÑÐ°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceTotalSellFullPerKg: "ÐÐ±ÑÐ°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼Ð¼ ",
        priceTotalSellFullPerLiter: "ÐÐ±ÑÐ°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° Ð·Ð° Ð»Ð¸ÑÑ",
        priceTotalSellFullPerPackage: "ÐÐ±ÑÐ°Ñ ÑÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° Ð·Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ"
    },
    pricing: {
        allBases: "ÐÑÐµ Ð±Ð°Ð·Ñ",
        allPackages: "ÐÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        backup: "Backup",
        basesOfProduct: "ÐÐ°Ð·Ð° %{productName}",
        colorantPricing: "Ð¦ÐµÐ½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        export: "Ð­ÐºÑÐ¿Ð¾ÑÑ",
        import: "ÐÐ¼Ð¿Ð¾ÑÑ",
        packagePricing: "Ð¦ÐµÐ½Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        packageSurcharge: "ÐÐ¾Ð¿Ð»Ð°ÑÐ° Ð·Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        packages: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        packagesOfProduct: "Ð£Ð¿Ð°Ð¾Ð²ÐºÐ° %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "ÐÑÑÐ¿Ð¿Ð¾Ð²Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° Ð»Ð¸ÑÑ",
        priceGroups: "Ð¦ÐµÐ½Ð¾Ð²ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ",
        pricePerLiter: "Ð¦ÐµÐ½Ð° Ð·Ð° Ð»Ð¸ÑÑ",
        productPricing: "Ð¦ÐµÐ½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        purchasePrice: "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð°",
        purchasePricePerLiter: "ÐÐ°ÐºÑÐ¿Ð¾ÑÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° Ð»Ð¸ÑÑ",
        sellPrice: "Ð¦ÐµÐ½Ð° ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸",
        surcharge: "ÐÐ¾Ð¿Ð»Ð°ÑÐ°"
    },
    print: {
        adminRightsRequired: "ÐÐ»Ñ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð¸Ð»Ð¸ ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ Ð½Ð¾Ð²Ð¾Ð³Ð¾ ÑÐ°Ð±Ð»Ð¾Ð½Ð° ÑÑÐµÐ±ÑÑÑÑÑ Ð¿ÑÐ°Ð²Ð° Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÐ°",
        allowAutomaticPrint: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ Ð¿ÐµÑÐ°ÑÑ",
        allowPrintAfterDispensing: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿ÐµÑÐ°ÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        allowPrintBeforeDispensing: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ Ð¿ÐµÑÐ°ÑÑ Ð¿ÐµÑÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼",
        automaticPrint: "ÐÐµÑÐ°ÑÐ°ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸",
        choosePrinter: "ÐÑÐ¸Ð½ÑÐµÑ",
        chooseSettings: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        chooseTemplate: "Ð¨Ð°Ð±Ð»Ð¾Ð½",
        copies: "ÐÐ¾Ð¿Ð¸Ð¸",
        createTemplate: "Ð¡Ð¾Ð·Ð´Ð°ÑÑ ÑÐ°Ð±Ð»Ð¾Ð½",
        createTemplateHint: "Ð¡Ð¾Ð·Ð´Ð°Ð¹ÑÐµ Ð½Ð¾Ð²ÑÐ¹ ÑÐ°Ð±Ð»Ð¾Ð½, ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÐµ ÐµÐ³Ð¾ Ð² Ð¿Ð°Ð¿ÐºÐµ ÑÐ°Ð±Ð»Ð¾Ð½Ð¾Ð² Ð¸ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÐµ RCC ",
        defaultPrinter: "ÐÑÐ¸Ð½ÑÐµÑ",
        defaultSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
        defaultTemplate: "Ð¨Ð°Ð±Ð»Ð¾Ð½ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
        editTemplate: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ°Ð±Ð»Ð¾Ð½",
        editTemplateHint: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ %{name} ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð±ÑÐ´ÑÑ Ð²Ð¸Ð´Ð½Ñ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÐºÐ° RCC ",
        noEditTemplate: "Ð¨Ð°Ð±Ð»Ð¾Ð½ Ð´Ð»Ñ Ð²Ð²Ð¾Ð´Ð° Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ",
        noPrinterSelected: "ÐÑÐ¸Ð½ÑÐµÑ Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð½",
        noPrintersAvailable: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð¿ÑÐ¸Ð½ÑÐµÑÐ¾Ð²",
        noTemplateSelected: "Ð¨Ð°Ð±Ð»Ð¾Ð½ Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð½",
        noTemplatesAvailable: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ ÑÐ°Ð±Ð»Ð¾Ð½Ð¾Ð²",
        numberOfCopies: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð¿Ð¸Ð¹",
        openTemplateEditor: "ÐÑÐºÑÑÑÑ ÑÐµÐ´Ð°ÐºÑÐ¾Ñ ÑÐ°Ð±Ð»Ð¾Ð½Ð¾Ð²",
        printAfterDispensing: "ÐÐµÑÐ°ÑÐ°ÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        printAsImage: "ÐÐµÑÐ°ÑÐ°ÑÑ ÐºÐ°Ðº Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ ",
        printBeforeDispensing: "ÐÐµÑÐ°ÑÐ°ÑÑ Ð¿ÐµÑÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼",
        printOnRequest: "ÐÐµÑÐ°ÑÐ°ÑÑ Ð¿Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÑ",
        printOptions: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð¿ÐµÑÐ°ÑÐ¸",
        printPagesAfterDispensing: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð¿Ð¸Ð¹ Ð¿Ð¾ÑÐ»Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð² ÑÐ°ÑÑ",
        printPagesBeforeDispensing: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð¿Ð¸Ð¹ Ð¿ÐµÑÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼ Ð² ÑÐ°ÑÑ",
        printPreview: "ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ Ð¿ÐµÑÐ°ÑÐ¸",
        printSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿ÐµÑÐ°ÑÐ¸",
        printTaskLinkVariable: "ÐÑÐ¸Ð²ÑÐ·Ð°ÑÑ Ðº Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½Ð¾Ð¹",
        printVariable: "Ð Ð°ÑÐ¿ÐµÑÐ°ÑÐ°ÑÑ Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½ÑÑ",
        printerName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
        printerOptions: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
        printerSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
        quickTintTemplate: "Ð¨Ð°Ð±Ð»Ð¾Ð½ Ð±ÑÑÑÑÐ¾Ð¹ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ ",
        setDefaultPrinter: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¿ÑÐ¸Ð½ÑÐµÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
        setDefaultTemplate: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÐ°Ð±Ð»Ð¾Ð½ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ",
        setQuickTintTemplate: "ÐÐ°ÑÑÑÐ¾Ð¸ÑÑ ÑÐ°Ð±Ð»Ð¾Ð½ Ð±ÑÑÑÑÐ¾Ð¹ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ ",
        showPreviewDialogBeforePrint: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð´Ð¸Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ðµ Ð¾ÐºÐ½Ð¾ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ° Ð¿ÐµÑÐµÐ´ Ð¿ÐµÑÐ°ÑÑÑ",
        template: "Ð¨Ð°Ð±Ð»Ð¾Ð½",
        templateName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ°Ð±Ð»Ð¾Ð½Ð°",
        templateSettings: "ÐÐ°ÑÐ°Ð¼ÐµÑÑÑ ÑÐ°Ð±Ð»Ð¾Ð½Ð°"
    },
    printTemplate: {
        baseCode: "ÐÐ¾Ð´ Ð±Ð°Ð·Ñ",
        baseName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð±Ð°Ð·Ñ",
        bfs: "ÐÐ°Ð¼ÑÑÐºÐ° Ð¤ÐµÐ´ÐµÑÐ°Ð»ÑÐ½Ð¾Ð¹ Ð°ÑÑÐ¾ÑÐ¸Ð°ÑÐ¸Ð¸ Ð¿Ð¾ Ð·Ð°ÑÐ¸ÑÐµ ÑÐ°ÑÐ°Ð´Ð¾Ð² (BFS)",
        colorantType: "Colorant type",
        customerCity: "ÐÐ¾ÑÐ¾Ð´ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerEmail: "Ð­Ð»ÐµÐºÑÑÐ¾Ð½Ð½Ð°Ñ Ð¿Ð¾ÑÑÐ° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerPhone: "Ð¢ÐµÐ»ÐµÑÐ¾Ð½ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerStreet: "Ð£Ð»Ð¸ÑÐ° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerZipCode: "ÐÐ¾ÑÑÐ¾Ð²ÑÐ¹ Ð¸Ð½Ð´ÐµÐºÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "ÐÐ»Ð°ÑÑ BFS",
        orderQrCode: "QR ÐºÐ¾Ð´",
        packageOrderCount: "Ð¡ÑÑÑÑÐ¸Ðº Ð·Ð°ÐºÐ°Ð·Ð¾Ð²",
        posAddress: "ÐÐ´ÑÐµÑ ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        posAddressSecond: "ÐÑÐ¾ÑÐ¾Ð¹ Ð°Ð´ÑÐµÑ ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        posCity: "ÐÐ¾ÑÐ¾Ð´, Ð² ÐºÐ¾ÑÐ¾ÑÐ¾Ð¼ ÑÐ°ÑÐ¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð° ÑÐ¾ÑÐºÐ° Ð¿ÑÐ¾Ð´Ð°Ð¶",
        posContact: "ÐÐ¾Ð½ÑÐ°ÐºÑ ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        posEmail: "Ð­Ð»ÐµÐºÑÑÐ¾Ð½Ð½Ð°Ñ Ð¿Ð¾ÑÑÐ° ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        posPhone: "Ð¢ÐµÐ»ÐµÑÐ¾Ð½ ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        posUrl: "Ð¡Ð°Ð¹Ñ ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        posZipCode: "ÐÐ¾ÑÑÐ¾Ð²ÑÐ¹ Ð¸Ð½Ð´ÐµÐºÑ ÑÐ¾ÑÐºÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶",
        priceBasePurchaseWithTax: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð±Ð°Ð·Ñ Ñ ÐÐÐ¡",
        priceBaseSellWithTax: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð±Ð°Ð·Ñ Ñ ÐÐÐ¡",
        priceCntPurchaseWithTax: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ñ ÐÐÐ¡",
        priceCntTotalSellWithTax: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ñ ÐÐÐ¡",
        priceMarginAllWithTax: "ÐÐ°ÑÐ¶Ð° Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceMarginPerPkgWithTax: "ÐÐ°ÑÐ¶Ð° Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ Ñ ÐÐÐ¡",
        priceSellPriceAllWithTax: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceSellPricePerKgWithTax: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼Ð¼ Ñ ÐÐÐ¡",
        priceSellPricePerLWithTax: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° Ð»Ð¸ÑÑ Ñ ÐÐÐ¡",
        priceSellPricePerPkgWithTax: "ÐÑÐ¿ÑÑÐºÐ½Ð°Ñ ÑÐµÐ½Ð° Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ Ñ ÐÐÐ¡",
        priceSurchargeAllWithTax: "ÐÐ°ÑÐµÐ½ÐºÐ° Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceSurchargePerPkgWithTax: "ÐÐ°ÑÐµÐ½ÐºÐ° Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ Ñ ÐÐÐ¡",
        priceTintPurchaseAllWithTax: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð·Ð° Ð²ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceTintPurchasePerPkgWithTax: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸ Ð·Ð° Ð¾Ð´Ð½Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ Ñ ÐÐÐ¡",
        priceTotalPurchaseAllWithTax: "ÐÐ±ÑÐ°Ñ ÑÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð²ÑÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²Ð¾Ðº Ñ ÐÐÐ¡",
        priceTotalPurchasePerKgWithTax: "ÐÐ±ÑÐ°Ñ ÑÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼Ð¼ Ñ ÐÐÐ¡",
        priceTotalPurchasePerLWithTax: "ÐÐ±ÑÐ°Ñ ÑÐµÐ±ÐµÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð·Ð° Ð»Ð¸ÑÑ Ñ ÐÐÐ¡",
        priceTotalPurchasePerPkgWithTax: "ÐÐ±ÑÐ°Ñ ÑÑÐ¾Ð¸Ð¼Ð¾ÑÑÑ Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        productAltName: "ÐÑÐ¾Ð´ÑÐºÑ",
        recipeInline: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°"
    },
    products: {
        bases: "ÐÐ°Ð·Ñ",
        numberOfProducts: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¾Ð²",
        packagesFor: "Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ð´Ð»Ñ",
        sizeOfPackage: "Ð Ð°Ð·Ð¼ÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸"
    },
    purgeModal: {
        purgeAll: "ÐÑÐ¾Ð´ÑÑÑ Ð²ÑÐµ",
        purgeAllChannels: "ÐÑÐ¸ÑÑÐ¸ÑÑ Ð²ÑÐµ ÐºÐ°Ð½Ð°Ð»Ñ",
        purgeVolume: "ÐÐ±ÑÐµÐ¼ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸",
        startPurge: "ÐÐ°ÑÐ°ÑÑ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÑ"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "ÐÐ´ÐµÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ",
        dispensingIsNotAvailable: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾",
        machineNotConnected: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½",
        noColorantsSelected: "ÐÐµ Ð²ÑÐ±ÑÐ°Ð½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
        noPrinterAvailable: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸ÑÑ Ð¿ÐµÑÐ°ÑÑ, Ð¿Ð¾ÑÐºÐ¾Ð»ÑÐºÑ Ð¿ÑÐ¸Ð½ÑÐµÑ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½",
        noTemplateAvailable: "ÐÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸ÑÑ Ð¿ÐµÑÐ°ÑÑ, Ð¿Ð¾ÑÐºÐ¾Ð»ÑÐºÑ ÑÐ°Ð±Ð»Ð¾Ð½ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½",
        overMaxCanisterSize: "ÐÐ´Ð½Ð¾ Ð¸Ð»Ð¸ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ² ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð½ÐµÐ´Ð¾Ð¿ÑÑÑÐ¸Ð¼Ð¾"
    },
    quickTintSettings: {
        alphabetically: "ÐÐ¾ Ð°Ð»ÑÐ°Ð²Ð¸ÑÑ",
        byCanister: "ÐÐ¾ ÐºÐ°Ð½Ð¸ÑÑÑÐ°Ð¼",
        closeAfterDispensing: "ÐÐ°ÐºÑÑÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ",
        closeBeforeDispensing: "ÐÐ°ÐºÑÑÑÑ Ð¿ÐµÑÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼",
        quickTintSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð±ÑÑÑÑÐ¾Ð³Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        sorting: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²ÐºÐ°",
        windowClosingRules: "ÐÑÐ°Ð²Ð¸Ð»Ð° Ð·Ð°ÐºÑÑÑÐ¸Ñ Ð¾ÐºÐ¾Ð½"
    },
    rccButtons: {
        abort: "Ð¿ÑÐµÑÐ²Ð°ÑÑ",
        all: "Ð²ÑÐµ",
        cancel: "Ð¾ÑÐ¼ÐµÐ½Ð°",
        continue: "Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        help: "Ð¿Ð¾Ð¼Ð¾ÑÑ",
        ignore: "Ð¸Ð³Ð½Ð¾ÑÐ¸ÑÐ¾Ð²Ð°ÑÑ",
        no: "ÐÐµÑ",
        noToAll: "Ð½Ðµ Ð´Ð»Ñ Ð²ÑÐµÑ",
        ok: "ÐÐ",
        postpone: "Ð¾ÑÐ»Ð¾Ð¶Ð¸ÑÑ",
        resume: "Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        retry: "Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ",
        skip: "Ð¿ÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ",
        yes: "Ð´Ð°",
        yesToAll: "Ð´Ð° Ð´Ð»Ñ Ð²ÑÐµÑ"
    },
    rccDialog: {
        98: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ Ð±Ð°Ð·Ñ %{0} Ð¿Ð¾ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ",
        99: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾ÑÑÐ°Ð²ÑÑÐµ Ð±Ð°Ð·Ñ %{0} Ð¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ (Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ OK)",
        100: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ð°ÑÐ¾Ð´Ð¸ÑÑÑ Ð² ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ð¸ Ð¾ÑÐ¸Ð±ÐºÐ¸, ÑÐ±ÑÐ¾ÑÐ¸ÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸?",
        101: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ð°ÑÐ¾Ð´Ð¸ÑÑÑ Ð² ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ð¸ Ð¾ÑÐ¸Ð±ÐºÐ¸, Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        102: "Ð¡Ð±ÑÐ¾Ñ Ð¿ÑÐ¾ÑÐµÐ» Ð½ÐµÑÐ´Ð°ÑÐ½Ð¾, Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        103: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ: %{0}",
        104: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ: %{0}",
        105: "Ð£ÑÐ¾Ð²ÐµÐ½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°: %{0} Ð½Ð¸Ð¶Ðµ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÑÑÐµÐ³Ð¾",
        106: "Ð£ÑÐ¾Ð²ÐµÐ½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²: %{0} Ð½Ð¸Ð¶Ðµ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´Ð°ÑÑÐµÐ³Ð¾",
        107: "Ð£ÑÐ¾Ð²ÐµÐ½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°: %{0} Ð½Ð¸Ð¶Ðµ ÐºÑÐ¸ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾",
        108: "Ð£ÑÐ¾Ð²ÐµÐ½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²: %{0} Ð½Ð¸Ð¶Ðµ ÐºÑÐ¸ÑÐ¸ÑÐµÑÐºÐ¾Ð³Ð¾",
        109: "ÐÐ¾ÑÑÐ°Ð²ÑÑÐµ ÑÐ°ÑÑ",
        110: "ÐÐ¾ÑÑÐ°Ð²ÑÑÐµ ÑÐ°ÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹: %{0} Ð´Ð»Ñ ÑÐ¾ÑÐ¼ÑÐ»Ñ: %{1}",
        111: "Ð£Ð±ÐµÑÐ¸ÑÐµ ÑÐ°ÑÑ",
        112: "ÐÑÐ¾Ð±Ð¸ÑÑ ÑÐ°ÑÑ? ",
        113: "Ð¡Ð±ÑÐ¾Ñ Ð¾ÑÐ¸Ð±Ð¾Ðº, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        114: "ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð´Ð²Ð¸Ð³Ð°ÐµÑÑÑ Ð¿Ð¾Ð»ÐºÐ°",
        115: "ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¸Ð´ÐµÑ Ð¿ÑÐ¾Ð±Ð¸Ð²ÐºÐ° ÑÐ°ÑÑ",
        116: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ %{0}, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ | Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°: %{1} Ð¸Ð· %{2} | ÐÑÐ¾Ð´ÑÐºÑ: %{3} | ÐÐ°Ð·Ð°: %{4} | Ð Ð°Ð·Ð¼ÐµÑ ÑÐ°ÑÑ: %{5}",
        117: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ %{0}, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ | Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°: %{1} Ð¸Ð· %{2} | ÐÑÐ¾Ð´ÑÐºÑ: %{3} | ÐÐ°Ð·Ð°: %{4} | Ð Ð°Ð·Ð¼ÐµÑ ÑÐ°ÑÑ: %{5}",
        118: "ÐÐ´ÐµÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ | Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°: %{0} Ð¸Ð· %{1}",
        119: "ÐÐ´ÐµÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ | Ð£Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°: %{0} Ð¸Ð· %{1}",
        120: "ÐÑÐ¼ÐµÐ½Ð° Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        121: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´ ÑÐ°ÑÑ",
        122: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´ ÑÐ°ÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹ | ÐÑÐ¾Ð´ÑÐºÑ: %{0} | ÐÐ°Ð·Ð°: %{1} | Ð Ð°Ð·Ð¼ÐµÑ ÑÐ°ÑÑ: %{2}",
        123: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð±ÑÐ»Ð¾ Ð¿ÑÐµÑÐ²Ð°Ð½Ð¾ ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ?",
        124: "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° %{0}: %{1} ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ?",
        125: "Ð£Ð±ÐµÐ´Ð¸ÑÐµÑÑ, ÑÑÐ¾ ÑÐ°Ð·Ð¼ÐµÑÐµÐ½Ð° ÑÐ°ÑÐ°, Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð²ÑÐ°ÑÑÑ ÑÐ°Ð½ÐµÐµ",
        126: "Ð£Ð±ÐµÐ´Ð¸ÑÐµÑÑ, ÑÑÐ¾ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐµÑÐµ Ð½Ð¾Ð²ÑÑ ÑÐ°ÑÑ, ÑÐ°Ðº ÐºÐ°Ðº Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð½Ð°ÑÐ½ÐµÑÑÑ Ñ Ð½ÑÐ»Ñ",
        127: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°: %{0} Ð¼ÐµÐ½ÑÑÐµ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ, Ð½ÐµÑÐ¼Ð¾ÑÑÑ Ð½Ð° ÑÑÐ¾ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ?",
        128: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²: %{0} Ð¼ÐµÐ½ÑÑÐµ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ, Ð½ÐµÑÐ¼Ð¾ÑÑÑ Ð½Ð° ÑÑÐ¾ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ?",
        129: "ÐÑÐ±ÑÐ°Ð½Ð½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð½Ð°ÑÑÑÐ°ÐµÑ ÑÐ»ÐµÐ´ÑÑÑÐ¸Ðµ Ð¿ÑÐ°Ð²Ð¸Ð»Ð°: ÐÐ±ÑÐµÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²: %{0} %{1}, Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²: %{2} %{3} ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ, Ð½ÐµÑÐ¼Ð¾ÑÑÑ Ð½Ð° ÑÑÐ¾ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ?",
        130: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ð°ÑÐ¾Ð´Ð¸ÑÑÑ Ð² ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ð¸ Ð¾ÑÐ¸Ð±ÐºÐ¸, ÑÐ±ÑÐ¾ÑÐ¸ÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸?",
        131: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ð°ÑÐ¾Ð´Ð¸ÑÑÑ Ð² ÑÐ¾ÑÑÐ¾ÑÐ½Ð¸Ð¸ Ð¾ÑÐ¸Ð±ÐºÐ¸, Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        132: "Ð¡Ð±ÑÐ¾Ñ Ð¿ÑÐ¾ÑÐµÐ» Ð½ÐµÑÐ´Ð°ÑÐ½Ð¾, Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        133: "ÐÑÐ°Ð²Ð¸Ð»Ð° Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸ Ð½Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ñ, Ð½ÐµÐ²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        134: "ÐÑÐ°Ð²Ð¸Ð»Ð° Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸ ÑÐ¾Ð´ÐµÑÐ¶Ð°Ñ ÑÐ»ÐµÐ¼ÐµÐ½ÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ðµ Ð¿Ð¾Ð´Ð´Ð°ÑÑÑÑ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐµ. Ð¥Ð¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ?",
        135: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ ÑÐ°ÑÑ Ð´Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸",
        136: "Ð£Ð±ÐµÑÐ¸ÑÐµ ÑÐ°ÑÑ Ð´Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸",
        137: "Ð¡Ð±ÑÐ¾Ñ Ð¾ÑÐ¸Ð±Ð¾Ðº, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        138: "ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð´Ð²Ð¸Ð³Ð°ÐµÑÑÑ Ð¿Ð¾Ð»ÐºÐ°",
        139: "ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¸Ð´ÐµÑ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°",
        140: "ÐÐ¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¸Ð´ÐµÑ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°",
        141: "ÐÐ´ÐµÑ Ð¾ÑÐ¼ÐµÐ½Ð° Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        142: "ÐÑÑÑÑÑÑÐ²ÑÐµÑ ÑÐ°ÑÐ° Ð´Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ, Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾ Ð»Ð¸ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð° ÑÐ°ÑÐ°",
        143: "ÐÑÐ°Ð²Ð¸Ð»Ð° Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸ ÑÐ¾Ð´ÐµÑÐ¶Ð°Ñ ÑÐ»ÐµÐ¼ÐµÐ½ÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ðµ Ð¿Ð¾Ð´Ð´Ð°ÑÑÑÑ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐµ. Ð¥Ð¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ?",
        144: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ ÑÐ°ÑÑ Ð´Ð»Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ¸",
        145: "ÐÐ´ÐµÑ Ð¿Ð¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        146: "ÐÐ°Ð²ÐµÑÑÐµÐ½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        150: "ÐÐ´ÐµÑ Ð¾ÑÐ¸ÑÑÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        151: "ÐÐ´ÐµÑ Ð¾ÑÐ¸ÑÑÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        152: "ÐÑÐ¼ÐµÐ½ÑÐµÑÑÑ Ð¾ÑÐ¸ÑÑÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        160: "ÐÐ´ÐµÑ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        161: "ÐÐ´ÐµÑ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        162: "ÐÑÐ¼ÐµÐ½ÑÐµÑÑÑ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        170: "ÐÐ´ÐµÑ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        171: "ÐÐ´ÐµÑ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        172: "ÐÑÐ¼ÐµÐ½ÑÐµÑÑÑ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        180: "ÐÑÐ¿Ð¾Ð»Ð½ÑÐµÑÑÑ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ñ Ðº Ð´Ð¾Ð·Ð°ÑÐ¾ÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        181: "ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ðº Ð´Ð¾Ð·Ð°ÑÐ¾ÑÑ %{0}: %{1}",
        182: "ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ðº Ð´Ð¾Ð·Ð°ÑÐ¾ÑÑ ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð² Ð»Ð¾Ð³-ÑÐ°Ð¹Ð»Ð°Ñ",
        183: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°: %{0}, ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½ Ð² Ð²Ð°ÑÐµÐ¹ Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ",
        184: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²: %{0}, ÐºÐ¾ÑÐ¾ÑÑe Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ñ Ð² Ð²Ð°ÑÐµÐ¹ Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ",
        185: "ÐÐ°Ð²ÐµÑÑÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ñ Ðº Ð´Ð¾Ð·Ð°ÑÐ¾ÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        190: "ÐÐ°ÐºÑÐ¾Ð¹ÑÐµ ÑÐµÑÐ²Ð¸ÑÐ½Ð¾Ðµ Ð¾ÐºÐ½Ð¾, ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ",
        200: "ÐÐ´ÐµÑ ÑÐ±ÑÐ¾Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        201: "ÐÐ´ÐµÑ Ð°Ð¿Ð¿Ð°ÑÐ°ÑÐ½ÑÐ¹ ÑÐ±ÑÐ¾Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        202: "ÐÐ´ÐµÑ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        203: "ÐÐ´ÐµÑ ÑÐ±ÑÐ¾Ñ Ð¾ÑÐ¸Ð±Ð¾Ðº, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        205: "ÐÑÐºÑÑÐ²Ð°ÐµÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ°Ñ ÐºÑÑÑÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        206: "ÐÐ°ÐºÑÑÐ²Ð°ÐµÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ°Ñ ÐºÑÑÑÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        207: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÐµÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ°Ñ ÐºÑÑÑÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        210: "ÐÐ´ÐµÑ Ð¿ÑÐ¾Ð±Ð¸Ð²ÐºÐ° ÑÐ°ÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        211: "ÐÐ´ÐµÑ Ð·Ð°ÐºÑÐ¿Ð¾ÑÐ¸Ð²Ð°Ð½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        215: "ÐÐ¾Ð»ÐºÐ° Ð´Ð²Ð¸Ð³Ð°ÐµÑÑÑ Ð²Ð²ÐµÑÑ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        216: "ÐÐ¾Ð»ÐºÐ° Ð´Ð²Ð¸Ð³Ð°ÐµÑÑÑ Ð²Ð½Ð¸Ð·, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        217: "ÐÐ²Ð¸Ð³Ð°ÐµÑÑÑ Ð¿Ð¾Ð»ÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        220: "Ð¡ÑÐ¾Ð» Ð¿ÐµÑÐµÐ¼ÐµÑÐ°ÐµÑÑÑ Ð² Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð´Ð»Ñ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑÑ: %{0}, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        221: "Ð¡ÑÐ¾Ð» Ð¿ÐµÑÐµÐ¼ÐµÑÐ°ÐµÑÑÑ Ð² Ð¸ÑÑÐ¾Ð´Ð½Ð¾Ðµ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        222: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÐµÑÑÑ ÑÑÐ¾Ð», Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        230: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        240: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ %{0} ",
        241: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ %{0} ",
        242: "ÐÐ´ÐµÑ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¾Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÐºÐ°Ð½Ð¸ÑÑÑÑ: %{0} (%{1}) Ð² Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð´Ð»Ñ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ",
        243: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ %{0} Ñ Ð¿Ð¾Ð¼Ð¾ÑÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð°",
        244: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ %{0} Ñ Ð¿Ð¾Ð¼Ð¾ÑÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð°",
        250: "Ð¡Ð½Ð¸Ð¼Ð¸ÑÐµ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð´Ð»Ñ ÑÐµÑÐºÐ¸, Ð²ÑÐ¼Ð¾Ð¹ÑÐµ ÐµÐ³Ð¾ Ð¸ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ Ð²Ð¾Ð´Ð¾Ð¹ Ð² ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ð¸ Ñ Ð¸Ð½ÑÑÑÑÐºÑÐ¸ÑÐ¼Ð¸",
        251: "ÐÐ¾ÑÑÐ°Ð²ÑÑÐµ Ð½Ð° Ð¼ÐµÑÑÐ¾ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð´Ð»Ñ ÑÐµÑÐºÐ¸",
        254: "ÐÑÐºÑÑÑÐ¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ ÐºÑÑÑÐºÐ¸",
        255: "ÐÑÐ¼Ð¾Ð¹ÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÑÑ ÐºÑÑÑÐºÑ Ð² ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ð¸ Ñ Ð¸Ð½ÑÑÑÑÐºÑÐ¸ÑÐ¼Ð¸",
        256: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ, ÐºÐ¾Ð³Ð´Ð° Ð¾ÑÐ¸ÑÑÐºÐ° Ð·Ð°Ð²ÐµÑÑÐ¸ÑÑÑ Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ°Ñ ÐºÑÑÑÐºÐ° ÑÐ½Ð¾Ð²Ð° Ð±ÑÐ´ÐµÑ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð° Ð½Ð° Ð¼ÐµÑÑÐ¾",
        257: "ÐÐ°ÐºÑÑÑÐ¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ ÐºÑÑÑÐºÐ¸",
        260: "Ð¡Ð½Ð¸Ð¼Ð¸ÑÐµ Ð¿Ð°Ð½ÐµÐ»Ñ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ Ð¸ Ð¾ÑÐ¸ÑÑÐ¸ÑÐµ ÐµÐµ",
        261: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÐµ Ð¾Ð±ÑÐ°ÑÐ½Ð¾ Ð¿Ð°Ð½ÐµÐ»Ñ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ",
        265: "ÐÑÐ¾ÑÑÐ¸ÑÐµ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ ÑÐºÐ°Ð½ÑÑ Ð¸ ÑÐ´Ð°Ð»Ð¸ÑÐµ Ð²ÑÐµ Ð¿ÑÐ¾Ð»Ð¸ÑÑÐµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ Ð¸Ð»Ð¸ Ð´ÑÑÐ³ÑÑ Ð¶Ð¸Ð´ÐºÐ¾ÑÑÑ",
        266: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ, ÐºÐ¾Ð³Ð´Ð° Ð·Ð°ÐºÐ¾Ð½ÑÐ¸ÑÐµ",
        270: "ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ ÐµÐ¼ÐºÐ¾ÑÑÑ Ð´Ð»Ñ ÑÐ²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»Ñ Ð¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ, ÐºÐ¾Ð³Ð´Ð° ÑÑÐ¾ Ð±ÑÐ´ÐµÑ ÑÐ´ÐµÐ»Ð°Ð½Ð¾",
        271: "ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ ÐµÐ¼ÐºÐ¾ÑÑÑ Ð´Ð»Ñ ÑÐ²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»Ñ Ð¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ, ÐºÐ¾Ð³Ð´Ð° ÑÑÐ¾ Ð±ÑÐ´ÐµÑ ÑÐ´ÐµÐ»Ð°Ð½Ð¾",
        272: "Ð£ÑÐ¾Ð²ÐµÐ½Ñ Ð²Ð¾Ð´Ñ Ð²ÑÐµ ÐµÑÐµ Ð½Ð¸Ð·ÐºÐ¸Ð¹, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ ÐµÑÐµ ÑÐ°Ð·",
        273: "Ð£ÑÐ¾Ð²ÐµÐ½Ñ Ð²Ð¾Ð´Ñ Ð²ÑÐµ ÐµÑÐµ Ð½Ð¸Ð·ÐºÐ¸Ð¹, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ ÐµÑÐµ ÑÐ°Ð·",
        274: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÑÑÐ¾Ð²ÐµÐ½Ñ Ð²Ð¾Ð´Ñ Ð² ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐµ ÑÐ²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»Ñ Ð¸ Ð´Ð¾Ð»ÐµÐ¹ÑÐµ Ð² ÑÐ»ÑÑÐ°Ðµ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸",
        275: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        280: "ÐÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        281: "ÐÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        300: "ÐÑÑÑÑÑÑÐ²ÑÐµÑ ÑÐ°ÑÐ° Ñ Ð±Ð°Ð·Ð¾Ð¹, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ, Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾ Ð»Ð¸ ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð° ÑÐ°ÑÐ°",
        301: "ÐÐ´ÐµÑ Ð¿Ð¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        302: "ÐÐ°Ð²ÐµÑÑÐµÐ½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        303: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð°, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð¾Ð½Ð° ÑÐ¾Ð´ÐµÐ¶Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ: %{0} Ð² ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ðµ ÑÐ²ÑÑÐµ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð¸Ð· ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        304: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð°, Ð¿Ð¾ÑÐ¾Ð¼Ñ ÑÑÐ¾ Ð¾Ð½Ð° ÑÐ¾Ð´ÐµÐ¶Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ: %{0} Ð² ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ðµ ÑÐ²ÑÑÐµ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ Ð¸Ð· ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        305: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ: %{0} Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¾ÑÐ´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½ Ð·Ð° Ð¾Ð´Ð¸Ð½ ÑÐ°Ð·, ÐÑ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ°Ð·Ð´Ð»ÐµÐ»Ð¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ?",
        306: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ: %{0} Ð½Ðµ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ Ð¾ÑÐ´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ñ Ð·Ð° Ð¾Ð´Ð¸Ð½ ÑÐ°Ð·, ÐÑ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ°Ð·Ð´Ð»ÐµÐ»Ð¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ?",
        307: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ: %{0} Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð±ÑÑÑ Ð¾ÑÐ´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ¾Ð¼, ÐÑ ÑÐ¾ÑÐ¸ÑÐµ  Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ Ð¸ Ð²Ð½ÐµÑÑÐ¸ ÐµÐ³Ð¾ Ð²ÑÑÑÐ½ÑÑ?",
        308: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ: %{0} Ð½Ðµ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ Ð¾ÑÐ´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ¾Ð¼, ÐÑ ÑÐ¾ÑÐ¸ÑÐµ  Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ Ð¸ Ð²Ð½ÐµÑÑÐ¸ Ð¸Ñ Ð²ÑÑÑÐ½ÑÑ?",
        309: "ÐÑÐ±ÑÐ°Ð½Ð½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð¿ÑÑÑÐ°Ñ, Ð¸ÑÐ¿Ð¾Ð»ÑÐ·ÑÐ¹ÑÐµ Ð±Ð°Ð·Ð¾Ð²ÑÑ ÐºÑÐ°ÑÐºÑ Ð² ÑÐ¸ÑÑÐ¾Ð¼ Ð²Ð¸Ð´Ðµ",
        310: "ÐÐ¸ Ð¾Ð´Ð¸Ð½ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ Ð½Ðµ Ð±ÑÐ´ÐµÑ Ð¾ÑÐ´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½, Ð¿Ð¾Ð´Ð³Ð¾ÑÐ¾Ð²ÑÑÐµ ÑÐ°ÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹ Ð´Ð»Ñ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð²ÑÑÑÐ½ÑÑ",
        311: "Ð£Ð±ÐµÑÐ¸ÑÐµ ÑÐ°ÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹ Ð¸ Ð¿Ð¾Ð´Ð³Ð¾ÑÐ¾Ð²ÑÑÐµ ÐµÐµ Ð´Ð»Ñ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð²ÑÑÑÐ½ÑÑ",
        312: "ÐÐ¾Ð±Ð°Ð²ÑÑÐµ Ð²ÑÑÑÐ½ÑÑ %{0} %{1} ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°: %{2}, Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ, ÐºÐ¾Ð³Ð´Ð° Ð·Ð°ÐºÐ¾Ð½ÑÐ¸ÑÐµ",
        313: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð»ÑÐ½ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        314: "ÐÑÐ±ÑÐ°Ð½Ð½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð½Ð°ÑÑÑÐ°ÐµÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð¿ÐµÑÐµÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ, Ð¾Ð±ÑÐµÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹: %{0} %{1}, Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾ Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÐºÑÐ°ÑÐ¸ÑÐµÐ»ÐµÐ¹: %{2} %{3} Ð¥Ð¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ, Ð½ÐµÑÐ¼Ð¾ÑÑÑ Ð½Ð° ÑÑÐ¾ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ?",
        315: "ÐÑÑÐºÐ°Ð½Ð¸ÑÑÐ¹ÑÐµ Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ UFI ÐºÐ¾Ð´ ÑÐ°ÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹",
        316: "ÐÑÑÐºÐ°Ð½Ð¸ÑÑÐ¹ÑÐµ Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ UFI ÐºÐ¾Ð´ ÑÐ°ÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹|Product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "ÐÑÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐµÐ½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°",
        401: "ÐÑÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐµÐ½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°",
        405: "ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° Ð´Ð»Ñ ÑÐµÑÐ¾Ðº",
        406: "ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° Ð´Ð»Ñ ÑÐµÑÐ¾Ðº",
        410: "ÐÑÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐµÐ½Ð¾ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ ÐºÑÑÑÐºÐ¸",
        411: "ÐÑÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐµÐ½Ð¾ Ð¾Ð±ÑÐ»ÑÐ¶Ð¸Ð²Ð°Ð½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¾Ð¹ ÐºÑÑÑÐºÐ¸",
        415: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¾ÑÐ¸ÑÑÐºÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ",
        416: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¾ÑÐ¸ÑÑÐºÐ° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð¿ÐµÑÐµÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ",
        420: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¾ÑÐ¸ÑÑÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        421: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¾ÑÐ¸ÑÑÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        425: "ÐÑÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐµÐ½Ð¾ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÐºÐ°Ð½Ð¸ÑÑÑ",
        426: "ÐÑÐ´ÐµÑ Ð·Ð°Ð¿ÑÑÐµÐ½Ð¾ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÐºÐ°Ð½Ð¸ÑÑÑ",
        430: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð° Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐºÐ° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        431: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð° Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐºÐ° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        435: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾ Ð²ÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        436: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾ Ð²ÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        440: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð° Ð¾ÑÐ¸ÑÑÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        441: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð° Ð¾ÑÐ¸ÑÑÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        445: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð° ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ",
        446: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð° ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ",
        450: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ðµ",
        451: "ÐÐ°Ð¿Ð»Ð°Ð½Ð¸ÑÐ¾Ð²Ð°Ð½Ð¾ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ðµ",
        990: "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° %{0}: %{1} ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð·Ð°Ð´Ð°ÑÑ?",
        991: "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð²Ð½ÑÑÑÐµÐ½Ð½ÑÑ Ð¾ÑÐ¸Ð±ÐºÐ°: %{0}",
        200000001: "ÐÐ¾ÑÑÐ°Ð²ÑÑÐµ ÑÐ°ÑÑ",
        200000002: "Ð£Ð±ÐµÑÐ¸ÑÐµ ÑÐ°ÑÑ",
        200000003: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ '%{0}' Ð½Ð¸Ð¶Ðµ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ, Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ Ð±ÐµÐ· Ð³Ð°ÑÐ°Ð½ÑÐ¸Ð¸?",
        200000004: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÑ %{0}"
    },
    rccDriverSettings: {
        databasePath: "ÐÑÑÑ Ðº Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ",
        dispenser: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ",
        dispenserConfigurationFile: "Ð¤Ð°Ð¹Ð» ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        driverPath: "ÐÑÑÑ Ðº Ð´ÑÐ°Ð¹Ð²ÐµÑÑ",
        extensionPath: "ÐÑÑÑ Ðº ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð¸Ñ",
        folder: "ÐÐ°Ð¿ÐºÐ°",
        formulaPath: "ÐÑÑÑ Ðº ÑÐ¾ÑÐ¼ÑÐ»Ð°Ð¼",
        host: "Ð¥Ð¾ÑÑ",
        iddPath: "ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐ¹ ÑÐ°Ð¹Ð» IDD",
        italtintoPath: "ÐÑÑÑ Ðº ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¸ Italtinto",
        lldPath: "ÐÑÑÑ Ðº LLD",
        machineType: "Ð¢Ð¸Ð¿ Ð¼Ð°ÑÐ¸Ð½Ñ",
        noMachineAvailable: "Ð£ÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ Ð½Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾",
        protocolVersion: "ÐÐµÑÑÐ¸Ñ Ð¿ÑÐ¾ÑÐ¾ÐºÐ¾Ð»Ð°",
        rccDriverSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°",
        resultPath: "ÐÑÑÑ Ðº ÑÐµÐ·ÑÐ»ÑÑÐ°ÑÑ",
        save: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        saveSettingsWarning: "ÐÐ½Ð¸Ð¼Ð°Ð½Ð¸Ðµ! ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ Ð² ÑÑÐ¾Ð¼ ÑÐ°Ð·Ð´ÐµÐ»Ðµ Ð¼Ð¾Ð³ÑÑ Ð¿ÑÐ¸Ð²ÐµÑÑÐ¸ Ðº ÑÐ±Ð¾ÑÐ¼ Ð² ÑÐ°Ð±Ð¾ÑÐµ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        serviceSwPath: "ÐÑÑÑ Ðº ÑÐµÑÐ²Ð¸ÑÐ½Ð¾Ð¼Ñ ÐÐ",
        simulationPath: "ÐÑÑÑ Ð¼Ð¾Ð´ÐµÐ»Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÑÑÑÐ½Ð¾Ðµ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        ask: "Ð¡Ð¿ÑÐ¾ÑÐ¸ÑÑ",
        canHandlingOptions: "ÐÐ¿ÑÐ¸Ð¸ ÑÐ°Ð±Ð¾ÑÑ Ñ ÑÐ°ÑÐ¾Ð¹",
        checkCanBeforeDispense: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÑÐ°ÑÑ Ð¿ÐµÑÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸ÐµÐ¼",
        checkOverfill: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð¸Ð·Ð±ÑÑÐ¾ÑÐ½Ð¾Ðµ Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ",
        colorantBatchNumbers: "ÐÐ¾Ð¼ÐµÑÐ° Ð¿Ð°ÑÑÐ¸Ð¹ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        colorantPackageValidation: "ÐÑÐ¾Ð²ÐµÑÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        disable: "ÐÑÐºÐ»ÑÑÐ¸ÑÑ",
        dispenseInvalidColorants: "ÐÐ¾Ð·Ð¸ÑÑÐµÑÐµ Ð½ÐµÐ¿ÑÐ¸Ð³Ð¾Ð´Ð½ÑÐµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ",
        dispensingOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        enable: "ÐÐºÐ»ÑÑÐ¸ÑÑ",
        enableUserIdentification: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        fullValidation: "ÐÐ¾Ð»Ð½Ð°Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ°",
        machineAccuracyWarning: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð¾ ÑÐ¾ÑÐ½Ð¾ÑÑÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        machineOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        machineUnit: "ÐÐ´Ð¸Ð½Ð¸ÑÐ° Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        minimalDispenseAmount: "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½Ð¾Ðµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð´Ð»Ñ Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ",
        placeCanSensor: "Ð Ð°Ð·Ð¼ÐµÑÑÐ¸ÑÐµ Ð´Ð°ÑÑÐ¸Ðº ÑÐ°ÑÑ",
        placeCanSensorDelay: "Ð Ð°Ð·Ð¼ÐµÑÑÐ¸ÑÐµ Ð·Ð°Ð´ÐµÑÐ¶ÐºÐºÑ Ð´Ð°ÑÑÐ¸ÐºÐ° ÑÐ°ÑÑ",
        rccMachineSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        refillBarcodeValidation: "ÐÑÐ¾Ð²ÐµÑÐºÐ° ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð° Ð´Ð¾Ð·Ð°Ð¿ÑÐ°Ð²ÐºÐ¸",
        refillBarcodeValidationCanisterAndColorant: "ÐÑÐ¾Ð²ÐµÑÑÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ Ð¸ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        refillBarcodeValidationColorant: "ÐÑÐ¾Ð²ÐµÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        refillSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð´Ð¾Ð·Ð°Ð¿ÑÐ°Ð²ÐºÐ¸",
        removeCanSensor: "Ð¡Ð½Ð¸Ð¼Ð¸ÑÐµ Ð´Ð°ÑÑÐ¸Ðº ÑÐ°ÑÑ",
        removeCanSensorDelay: "Ð¡Ð½Ð¸Ð¼Ð¸ÑÐµ Ð·Ð°Ð´ÐµÑÐ¶ÐºÑ Ð´Ð°ÑÑÐ¸ÐºÐ° ÑÐ°ÑÑ",
        save: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        sec: "ÑÐµÐº.",
        skipPlaceCanDialog: "ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ Ð´Ð¸Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ðµ Ð¾ÐºÐ½Ð¾ (ÑÑÑÐ°Ð½Ð¾Ð²ÐºÐ° ÑÐ°ÑÑ) ",
        skipRemoveCanDialog: "ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ Ð´Ð¸Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¾Ðµ Ð¾ÐºÐ½Ð¾ (ÑÐ½ÑÑÐ¸Ðµ ÑÐ°ÑÑ) ",
        splitFormula: "Ð Ð°Ð·Ð´ÐµÐ»Ð¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        tmcEnabled: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ¾Ð²Ð°ÑÑ TMC",
        ufiCode: "UFI ÐºÐ¾Ð´",
        validateBarcodeBaseCan: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´ Ð±Ð°Ð·Ñ",
        validateBarcodeRefill: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð¾Ð²",
        validateColorantsDuringInit: "ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÑ Ð²Ð¾ Ð²ÑÐµÐ¼Ñ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸"
    },
    rccPanel: {
        actionsRunningOnDispenser: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐµÑ Ð½ÐµÐºÐ¾ÑÐ¾ÑÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ",
        addLevel: "ÐÐÐÐÐÐÐ¢Ð¬ Ð£Ð ÐÐÐÐÐ¬",
        addManually: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð²ÑÑÑÐ½ÑÑ",
        barcodeNotSet: "ÐÐ°Ð½Ð¸ÑÑÑÐ° %{colorantName} (%{canisterName}) Ð½Ðµ Ð¸Ð¼ÐµÐµÑ Ð¿ÑÐ¸ÑÐ²Ð¾ÐµÐ½Ð½Ð¾Ð³Ð¾ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ð°",
        cancel: "ÐÐ¢ÐÐÐÐ",
        dispenseFormula: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð´Ð¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ ",
        dispenserIdle: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð¿ÑÐ¾ÑÑÐ°Ð¸Ð²Ð°ÐµÑ",
        dispenserIsBusy: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½",
        dispenserIsIdle: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð¿ÑÐ¾ÑÑÐ°Ð¸Ð²Ð°ÐµÑ",
        dispenserIsReady: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð³Ð¾ÑÐ¾Ð² Ðº Ð´Ð°Ð»ÑÐ½ÐµÐ¹ÑÐ¸Ð¼ Ð·Ð°Ð´Ð°ÑÐ°Ð¼",
        dispensingFormula: "ÐÐ¾Ð·Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        errorCode: "ÐÐ¾Ð´ Ð¾ÑÐ¸Ð±ÐºÐ¸",
        explanation: "ÐÐ±ÑÑÑÐ½ÐµÐ½Ð¸Ðµ",
        fillToMax: "ÐÐ°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð´Ð¾ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»ÑÐ½Ð¾Ð¹ Ð¾ÑÐ¼ÐµÑÐºÐ¸",
        finished: "ÐÐ°Ð²ÐµÑÑÐµÐ½Ð¾",
        inProgress: "Ð Ð¿ÑÐ¾ÑÐµÑÑÐµ",
        machineIsReady: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð³Ð¾ÑÐ¾Ð²",
        moveToFill: "ÐÐµÑÐµÐ¼ÐµÑÑÐ¸ÑÐµ, ÑÑÐ¾Ð±Ñ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ",
        noMachineDialog: "ÐÐ¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½",
        of: "Ð¸Ð·",
        packageSize: "Ð Ð°Ð·Ð¼ÐµÑ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        placeBaseCan: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ ÑÐ°ÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹",
        pleaseCheckYourMachineConnection: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÐÐ°ÑÐµÐ³Ð¾ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° ",
        pleaseRefill: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµ ",
        solution: "Ð ÐµÑÐµÐ½Ð¸Ðµ",
        subErrors: "ÐÐ¾Ð´Ð¾ÑÐ¸Ð±ÐºÐ¸",
        timeToEnd: "ÐÑÐµÐ¼Ñ Ð´Ð¾ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¸Ñ:",
        tintingFormula: "ÑÐ¾ÑÐ¼ÑÐ»Ð° ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ¸",
        tintingPleaseWait: "ÐÐ´ÐµÑ ÐºÐ¾Ð»ÐµÑÐ¾Ð²ÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        validateBaseCan: "ÐÑÐ¾Ð²ÐµÑÑÑÐµ ÑÐ°ÑÑ Ñ Ð±Ð°Ð·Ð¾Ð¹",
        waiting: "ÐÐ¶Ð¸Ð´Ð°Ð¹ÑÐµ"
    },
    rccSettigns: {
        rccSettigns: "Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Ñ RCC",
        rccUrl: "Ð¡Ð°Ð¹Ñ RCC"
    },
    rccSpectroDialog: {
        100: "ÐÐ´ÐµÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ðº ÐÐ°ÑÐµÐ¼Ñ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ñ ÑÐµÑÐµÐ· Bluetooth Ð£Ð±ÐµÐ´Ð¸ÑÐµÑÑ, ÑÑÐ¾ ÐÐ°Ñ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð²ÐºÐ»ÑÑÐµÐ½ Ð¸ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½ Bluetooth",
        101: "ÐÐ½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ðµ Ð¾Ð±Ð½Ð°ÑÑÐ¶ÐµÐ½ ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ?",
        110: "Ð£Ð±ÐµÐ´Ð¸ÑÐµÑÑ, ÑÑÐ¾ Nano Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½, Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°, ÑÑÐ¾Ð±Ñ Ð½Ð°ÑÐ°ÑÑ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ",
        111: "Nano Ð½Ðµ Ð¾Ð±Ð½Ð°ÑÑÐ¶ÐµÐ½ ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ?",
        112: "ÐÑÐºÐ»ÑÑÐ¸ÑÐµ Nano, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ 10 ÑÐµÐºÑÐ½Ð´, Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ¸ÑÐµ ÐµÐ³Ð¾ ÑÐ½Ð¾Ð²Ð° Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð°Ð¹ÑÐµ",
        120: "ÐÐ´ÐµÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ðº ÐÐ°ÑÐµÐ¼Ñ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        121: "ÐÐ½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ðµ Ð¾Ð±Ð½Ð°ÑÑÐ¶ÐµÐ½ ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ?",
        200: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° ÑÐµÑÐ½ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ Ð¸Ð»Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        201: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° ÑÐµÑÐ½ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ",
        202: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° ÑÐµÑÐ½ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        205: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð±ÐµÐ»ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ Ð¸Ð»Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        206: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð±ÐµÐ»ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ",
        207: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð±ÐµÐ»ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        210: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐµÑÐºÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ Ð¸Ð»Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        211: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐµÑÐºÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ",
        212: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐµÑÐºÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        215: "ÐÐ°ÐºÑÐ¾Ð¹ÑÐµ ÐºÑÑÑÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ Ð¸Ð»Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        216: "ÐÐ°ÐºÑÐ¾Ð¹ÑÐµ ÐºÑÑÑÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ",
        217: "ÐÐ°ÐºÑÐ¾Ð¹ÑÐµ ÐºÑÑÑÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        220: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð½ÑÐ»ÐµÐ²ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ Ð¸Ð»Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        221: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð½ÑÐ»ÐµÐ²ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ",
        222: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð½ÑÐ»ÐµÐ²ÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        224: "Ð Ð°Ð·Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð¾ÑÐ½ÑÐ¹ ÑÑÐ¾Ð» Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ Ð¸Ð»Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ",
        225: "Ð Ð°Ð·Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð¾ÑÐ½ÑÐ¹ ÑÑÐ¾Ð» Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ",
        226: "Ð Ð°Ð·Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð¾ÑÐ½ÑÐ¹ ÑÑÐ¾Ð» Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ",
        227: "Ð Ð°Ð·Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð¾ÑÐ½ÑÐ¹ ÑÑÐ¾Ð» Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ",
        295: "ÐÐ°Ð²ÐµÑÑÐ¸ÑÐµ ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÑ Ð² Ð¾ÐºÐ½Ðµ Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°",
        296: "ÐÐ½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ðµ Ð¾Ð±Ð½Ð°ÑÑÐ¶ÐµÐ½, ÑÐ¾ÑÐ¸ÑÐµ Ð¾ÑÐºÑÑÑÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ðº Ð½ÐµÐ¼Ñ?",
        297: "ÐÐ´ÐµÑ Ð¿Ð¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ° Ðº ÑÐ°Ð³Ñ ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÐ¸, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        298: "ÐÐ´ÐµÑ ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        299: "ÐÐ°Ð²ÐµÑÑÐ°ÐµÑÑÑ ÑÐ°Ð³ ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÐ¸, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        300: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð¾Ð±ÑÐ°Ð·ÐµÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ Ð¸Ð»Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        301: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð¾Ð±ÑÐ°Ð·ÐµÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÐµ",
        302: "ÐÐ¾Ð¼ÐµÑÑÐ¸ÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ð° Ð¾Ð±ÑÐ°Ð·ÐµÑ Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        303: "ÐÐ½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ðµ Ð¾ÑÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð°Ð½, ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð²ÐµÑÑÐ¸ ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÑ?",
        304: "ÐÐ½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ðµ Ð¾Ð±Ð½Ð°ÑÑÐ¶ÐµÐ½, ÑÐ¾ÑÐ¸ÑÐµ Ð¾ÑÐºÑÑÑÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ðº Ð½ÐµÐ¼Ñ?",
        390: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐµÐ¶Ð¸Ð¼ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        395: "ÐÐ°Ð²ÐµÑÑÐ¸ÑÐµ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ðµ Ð² Ð¾ÐºÐ½Ðµ Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°",
        397: "ÐÐ´ÐµÑ Ð¿Ð¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ° Ðº Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        398: "ÐÐ´ÐµÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        399: "ÐÐ°Ð²ÐµÑÑÐ°ÐµÑÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ðµ, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        498: "ÐÐ´ÐµÑ Ð·Ð°Ð³ÑÑÐ·ÐºÐ° Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ð¹, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        499: "ÐÐ´ÐµÑ Ð·Ð°Ð³ÑÑÐ·ÐºÐ° Ð²ÑÐµÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ð¹, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ",
        900: "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° %{0}: %{1} ÐÑ ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð·Ð°Ð´Ð°ÑÑ?",
        901: "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð²Ð½ÑÑÑÐµÐ½Ð½Ñ Ð¾ÑÐ¸Ð±ÐºÐ°: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "ÐÐ¾Ð¼Ð¿ÑÑÑÐµÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð¸Ð¼ÐµÑÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Bluetooth. Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð² Ð¿Ð°ÑÐµ Ñ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ¾Ð¼. Ð¢ÑÐµÐ±ÑÐµÑÑÑ Windows 10 Ñ 2018 Ð³. Ñ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¼ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸ÐµÐ¼.",
        DatacolorSilent:
            "ÐÐ¾ Ð²ÑÐµÐ¼Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸Ñ Silent mode, Datacolor Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð¾ÑÐ¾Ð±ÑÐ°Ð¶Ð°ÑÑÑÑ Ð² %{name}. Ð ÑÑÐ¸Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ°Ñ Ð½ÐµÐ»ÑÐ·Ñ Ð¸Ð·Ð¼ÐµÐ½ÑÑÑ Ð´Ð°Ð½Ð½ÑÐµ ÑÐ¿ÐµÐºÑÑÐ¾Ð¼ÐµÑÑÐ°.",
        DatacolorUseDiagnosticTile: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐµÑÐºÐ¾Ð¹ Ð¿Ð»Ð¸ÑÐºÐ¸ ÑÐ»ÑÑÑÐ°ÐµÑ ÐºÐ°ÑÐµÑÑÐ²Ð¾ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        comPort: "ÐÐ¾ÑÐ»ÐµÐ´Ð¾Ð²Ð°ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿Ð¾ÑÑ",
        diagnosticTile: "ÐÑÐ¿Ð¾Ð»ÑÐ·ÑÐ¹ÑÐµ Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐµÑÐºÑÑ Ð¿Ð»Ð¸ÑÐºÑ Ð´Ð»Ñ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ñ Ð´Ð°Ð½Ð½ÑÑ Ð¾ ÑÐ²ÐµÑÐµ",
        measureModes: "Ð ÐµÐ¶Ð¸Ð¼Ñ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        measureModesOrder: "ÐÐ¾ÑÑÐ´Ð¾Ðº ÑÐµÐ¶Ð¸Ð¼Ð¾Ð² Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        model: "ÐÐ¾Ð´ÐµÐ»Ñ",
        noSpectroAvailable: "Ð¡Ð¿ÐµÐºÑÑÐ¾Ð¼ÐµÑÑ Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ",
        rccSpectroSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÐ°",
        save: "Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        silent: "Datacolor Silent",
        simulationPath: "Ð ÐµÐ¶Ð¸Ð¼ ÑÐ¼ÑÐ»ÑÑÐ¸Ð¸",
        spectroType: "Ð¢Ð¸Ð¿ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÐ°",
        useProfiledValues: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð»Ð¾Ð²Ð°ÑÑ Ð¿ÑÐ¾ÑÐ¸Ð»Ð¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ"
    },
    recirculateChannels: {
        recirculateAllChannels: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð²ÑÐµ ÑÐ¾Ð¿Ð»Ð°",
        recirculateChannels: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð¿Ð»Ð°",
        recirculatingSpeed: "Ð¡ÐºÐ¾ÑÐ¾ÑÑÑ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ð¸",
        recirculatingTime: "ÐÑÐµÐ¼Ñ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ð¸",
        startRecirculating: "ÐÐ°Ð¿ÑÑÑÐ¸ÑÑ ÑÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ"
    },
    redlikeLight: {
        finishPreviousSteps: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð·Ð°Ð²ÐµÑÑÐ¸ÑÐµ Ð¿ÑÐµÐ´ÑÐ´ÑÑÐ¸Ðµ ÑÐ°Ð³Ð¸",
        searchBySpectro: "ÐÐ¾Ð¸ÑÐº Ð¿Ð¾ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÑ",
        searchFormula: "ÐÑÐºÐ°ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        selectBase: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð±Ð°Ð·Ñ",
        selectColor: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ²ÐµÑ",
        selectCustomer: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        selectFandeck: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ñ",
        selectPackage: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        selectProduct: "ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑ",
        startSelectFandeck: "ÐÐ°ÑÐ°ÑÑ Ñ Ð²ÑÐ±Ð¾ÑÐ° ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð°",
        startSelectProduct: "ÐÐ°ÑÐ°ÑÑ Ñ Ð²ÑÐ±Ð¾ÑÐ° Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        stepByStepProgress: "ÐÑ Ð¼Ð¾Ð¶ÐµÑÐµ Ð¿ÑÐ¾Ð´Ð²Ð¸Ð³Ð°ÑÑÑÑ ÑÐ°Ð³ Ð·Ð° ÑÐ°Ð³Ð¾Ð¼",
        typeHereToSearch: "ÐÐ°Ð±ÐµÑÐ¸ÑÐµ Ð·Ð´ÐµÑÑ Ð´Ð»Ñ Ð¿Ð¾Ð¸ÑÐºÐ°",
        typeToFilter: "ÐÐ°Ð±ÐµÑÐ¸ÑÐµ, ÑÑÐ¾Ð±Ñ ÑÐ¸Ð»ÑÑÑÐ¾Ð²Ð°ÑÑ"
    },
    restartModal: {
        computerNeedsRestart: "ÐÐ¾Ð¼Ð¿ÑÑÑÐµÑ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ¶ÐµÐ½",
        notCompletelyTranslated:
            "ÐÐ»Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ ÑÐ·ÑÐºÐ° ÑÑÐµÐ±ÑÐµÑÑÑ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÐº ÐÐ. ÐÐµÐºÐ¾ÑÐ¾ÑÑÐµ ÑÐ°ÑÑÐ¸ ÐÐ Ð¼Ð¾Ð³ÑÑ Ð±ÑÑÑ Ð¿ÐµÑÐµÐ²ÐµÐ´ÐµÐ½Ñ Ð½Ðµ Ð¿Ð¾Ð»Ð½Ð¾ÑÑÑÑ.",
        restartIsRequired: "ÐÐ¾ÑÐ»Ðµ Ð²Ð½ÐµÑÐµÐ½Ð¸Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ ÑÑÐµÐ±ÑÐµÑÑÑ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ° Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½Ð¾Ð³Ð¾ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸Ñ.",
        softwareNeedsRestart: "%{name} Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÑÑÐ¸ÑÑ!"
    },
    searchPanel: {
        basePlaceholder: "Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð±Ð°Ð·Ñ",
        baseStartPlaceholder: "ÐÐ°ÑÐ½Ð¸ÑÐµ Ñ Ð²Ð²Ð¾Ð´Ð° Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ Ð±Ð°Ð·Ñ",
        colorCodeNamePlaceholder: "Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ ÐºÐ¾Ð´/Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        colorCodeNameStartPlaceholder: "ÐÐ²ÐµÐ´Ð¸ÑÐµ ÐºÐ¾Ð´/Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        colorCodePlaceholder: "Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ ÐºÐ¾Ð´ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        colorCodeStartPlaceholder: "ÐÐ°ÑÐ½Ð¸ÑÐµ Ñ Ð²Ð²Ð¾Ð´Ð° ÐºÐ¾Ð´Ð° ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        colorNameCodePlaceholder: "Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ/ÐºÐ¾Ð´ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        colorNameCodeStartPlaceholder: "ÐÐ°ÑÐ½Ð¸ÑÐµ Ñ Ð²Ð²Ð¾Ð´Ð° Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ/ÐºÐ¾Ð´Ð° ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        colorNamePlaceholder: "Ð¸Ð»Ð¸ Ð½Ð°Ð±ÐµÑÐ¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        colorNameStartPlaceholder: "ÐÐ°ÑÐ½Ð¸ÑÐµ Ð½Ð°Ð±Ð¸ÑÐ°ÑÑ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸",
        fandeckStartPlaceholder: "ÐÐ°ÑÐ½Ð¸ÑÐµ Ñ Ð²Ð²Ð¾Ð´Ð° Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ ÐºÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸",
        formulaByColor: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð¿Ð¾ ÑÐ²ÐµÑÑ",
        noResultsFound: "Ð ÐµÐ·ÑÐ»ÑÑÐ°Ñ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½",
        packagePlaceholder: "Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÑ",
        packageStartPlaceholder: "ÐÐ°ÑÐ½Ð¸ÑÐµ Ñ Ð²Ð²Ð¾Ð´Ð° ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        productPlaceholder: "Ð¸Ð»Ð¸ Ð²Ð²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        productStartPlaceholder: "ÐÐ°ÑÐ½Ð¸ÑÐµ Ñ Ð²Ð²Ð¾Ð´Ð° Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        standard: "Ð¡ÑÐ°Ð½Ð´Ð°ÑÑ ",
        typeFandeckToFilter: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð°",
        typeProductToFilter: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ°"
    },
    sendOrderModal: {
        customNote: "ÐÐ°Ð¿Ð¸ÑÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        noCompatibleServers: "Ð Ð²Ð°ÑÐµÐ¹ ÑÐµÑÐ¸ Ð½ÐµÑ ÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼ÑÑ ÑÐµÑÐ²ÐµÑÐ¾Ð²",
        orderOverview: "ÐÐ±Ð·Ð¾Ñ Ð·Ð°ÐºÐ°Ð·Ð°",
        selectTargetMachine: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐµÐ»ÐµÐ²Ð¾Ð¹ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ",
        sendOrder: "ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð·Ð°ÐºÐ°Ð·",
        sendOrderTo: "ÐÐ°Ñ Ð·Ð°ÐºÐ°Ð· Ð±ÑÐ´ÐµÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½ Ð½Ð° %{serverName}",
        targetMachine: "Ð¦ÐµÐ»ÐµÐ²Ð°Ñ Ð¼Ð°ÑÐ¸Ð½Ð°"
    },
    server: {
        computerId: "ID ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        ip: "IP-ÐÐÐ ÐÐ¡",
        selectServer: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¾Ð´Ð¸Ð½ Ð¸Ð· Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ ÑÐµÑÐ²ÐµÑÐ¾Ð²",
        server: "Ð¡ÐµÑÐ²ÐµÑ"
    },
    serverDialog: {
        1: "ÐÑÐ¸Ð±ÐºÐ° Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸Ð¸ Ð±ÑÐµÐ½Ð´Ð° Ð´Ð»Ñ Ð²Ð°ÑÐµÐ¹ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸. ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, ÑÐ²ÑÐ¶Ð¸ÑÐµÑÑ Ñ Ð²Ð°ÑÐ¸Ð¼ Ð¿ÑÐ¾Ð²Ð°Ð¹Ð´ÐµÑÐ¾Ð¼.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ Ð¼Ð¾Ð´ÑÐ»Ð¸ Ð°ÐºÑÐ¸Ð²Ð½Ð¾Ð³Ð¾ ÑÐµÑÐ²ÐµÑÐ°",
        currentlyActive: "Ð Ð´Ð°Ð½Ð½ÑÐ¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð°ÐºÑÐ¸Ð²Ð½ÑÐµ Ð¼Ð¾Ð´ÑÐ»Ð¸",
        plugin: "ÐÐ»Ð°Ð³Ð¸Ð½",
        pluginName: "ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¿Ð»Ð°Ð³Ð¸Ð½Ð°",
        statusActive: "ÐÐºÑÐ¸Ð²Ð½ÑÐ¹",
        statusInactive: "ÐÐµ Ð°ÐºÑÐ¸Ð²Ð½ÑÐ¹"
    },
    serviceActionsSettings: {
        canisterLevel: "Ð£ÑÐ¾Ð²Ð½Ñ Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        capClose: "ÐÐ°ÐºÑÑÑÑ",
        capMiddle: "Ð¡ÐµÑÐµÐ´Ð¸Ð½Ð°",
        capOpen: "ÐÑÐºÑÑÑÑ",
        cleanAllChannels: "ÐÑÐ¸ÑÑÐ¸ÑÑ Ð²ÑÐµ ÑÐ¾ÑÑÑÐ½ÐºÐ¸",
        cleanChannels: "ÐÑÐ¸ÑÑÐ¸ÑÑ ÑÐ¾ÑÑÑÐ½ÐºÐ¸",
        computer: "ÐÐ¾Ð¼Ð¿ÑÑÑÐµÑ",
        computerReboot: "ÐÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ° ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        computerShutdown: "ÐÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ°",
        connectMachine: "ÐÐ¾Ð´ÐºÐ»ÑÑÐ¸ÑÐµ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ",
        general: "ÐÐ±ÑÐµÐµ",
        initialize: "ÐÐ½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ",
        noMachineIsConnected: "ÐÐ¸ Ð¾Ð´Ð¸Ð½ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½",
        plug: "ÐÑÐ¾Ð±ÐºÐ°",
        plugger: "Ð¨ÑÐ¾Ð¿ÑÐµÑ",
        punch: "ÐÑÐ¾Ð±Ð¸ÑÑ",
        puncher: "ÐÑÐ¾Ð±Ð¾Ð¹Ð½Ð¸Ðº",
        purgeChannels: "ÐÑÐ¾Ð´ÑÑÑ ÑÐ¾Ð¿Ð»Ð°",
        recirculate: "Ð ÐµÑÐ¸ÑÐºÑÐ»ÑÑÐ¸Ñ",
        recirculateAllChannels: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð²ÑÐµ ÑÐ¾Ð¿Ð»Ð°",
        recirculateChannels: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð¸ÑÐ¾Ð²Ð°ÑÑ ÑÐ¾Ð¿Ð»Ð°",
        serviceActions: "Ð¡ÐµÑÐ²Ð¸ÑÐ½ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ",
        setCanisterLevel: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÑÑÐ¾Ð²ÐµÐ½Ñ Ð½Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        shelfDown: "ÐÐ¿ÑÑÑÐ¸ÑÑ Ð¿Ð¾Ð»ÐºÑ",
        shelfUp: "ÐÐ¾Ð´Ð½ÑÑÑ Ð¿Ð¾Ð»ÐºÑ",
        showServiceWindow: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ ÑÐµÑÐ²Ð¸ÑÐ½Ð¾Ðµ Ð¾ÐºÐ½Ð¾",
        smartPurgeAllChannels: "ÐÐ½ÑÐµÐ»Ð»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ° Ð²ÑÐµÑ ÐºÐ°Ð½Ð°Ð»Ð¾Ð²",
        smartPurgeChannels: "ÐÐ½ÑÐµÐ»ÐµÐºÑÑÐ°Ð»ÑÐ½Ð°Ñ Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ° ÐºÐ°Ð½Ð°Ð»Ð¾Ð²",
        startErrorReset: "ÐÐ°ÑÐ°ÑÑ ÑÐ±ÑÐ¾ÑÐ° Ð¾ÑÐ¸Ð±ÐºÐ¸ ",
        startHardReset: "ÐÐ°ÑÐ°ÑÑ Ð¿Ð¾Ð»Ð½ÑÐ¹ ÑÐ±ÑÐ¾Ñ",
        startReset: "ÐÐ°ÑÐ°ÑÑ ÑÐ±ÑÐ¾Ñ",
        stirAllCanisters: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÑÑ",
        stirCanisters: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        stirCanistersMore: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Ð¡ÑÐ°Ð²Ð½Ð¸ÑÑ Ð¾Ð±ÑÐ°Ð·ÐµÑ ÑÐ¾ ÑÑÐµÐ¿ÐµÐ½ÑÑ Ð±Ð»ÐµÑÐºÐ° Ð¸ Ð²ÑÐ±ÑÐ°ÑÑ ÑÑÐµÐ¿ÐµÐ½Ñ",
        semiGloss: "ÐÐ¾Ð»ÑÐ³Ð»ÑÐ½ÑÐµÐ²ÑÐ¹"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "ÐÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð°ÑÑ",
        calibrateInstrument: "ÐÑÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð°ÑÑ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ",
        connectDevice: "ÐÐ¾Ð´ÐºÐ»ÑÑÐ¸ÑÑ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾",
        connectedTo: "ÐÐ¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¾ Ðº",
        connectingDevice: "ÐÐ°ÑÐµ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ°ÐµÑÑÑ",
        deselectAll: "ÐÑÐ¼ÐµÐ½Ð¸ÑÑ Ð²ÑÐµ",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "ÐÐ°ÑÐµ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ Ð½Ðµ Ð¾ÑÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð°Ð½Ð¾",
        eraseResult: "ÐÑÐ¸ÑÑÐ¸ÑÑ ÑÐµÐ·ÑÐ»ÑÑÐ°Ñ",
        filter: "Ð¤Ð¸Ð»ÑÑÑ",
        foundInFormulas: "ÐÐ°Ð¹Ð´ÐµÐ½Ð¾ Ð² ÑÐ¾ÑÐ¼ÑÐ»Ð°Ñ",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "ÐÐ°Ñ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½ÑÐ¶Ð½Ð¾ Ð¾ÑÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð°ÑÑ.",
        manualInput: "Ð ÑÑÐ½Ð¾Ð¹ Ð²Ð²Ð¾Ð´",
        measure: "ÐÐ·Ð¼ÐµÑÐµÐ½Ð¸Ðµ",
        measurementResult: "Ð ÐµÐ·ÑÐ»ÑÑÐ°Ñ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        noFilters: "ÐÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ ÑÐ¸Ð»ÑÑÑÐ¾Ð²",
        noFormulas: "Ð¤Ð¾ÑÐ¼ÑÐ»Ñ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ñ",
        noSelectedSpectro: "ÐÐµ Ð²ÑÐ±ÑÐ°Ð½ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ",
        notSelected: "ÐÐµ Ð²ÑÐ±ÑÐ°Ð½Ð¾",
        pressConnectButton: "Ð£Ð±ÐµÐ´Ð¸ÑÐµÑÑ, ÑÑÐ¾ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¾, Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ ÐºÐ½Ð¾Ð¿ÐºÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ñ",
        searchFormulas: "ÐÑÐºÐ°ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        selectSpectro: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐºÐ¾Ð¿Ð¸Ñ",
        showDetails: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð¿Ð¾Ð´ÑÐ¾Ð±Ð½Ð¾ÑÑÐ¸",
        skipCalibration: "ÐÑÐ¾Ð¿ÑÑÑÐ¸ÑÑ ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÑ",
        spectroIsConnected: "Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½",
        spectroIsReady: "Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑ Ð³Ð¾ÑÐ¾Ð²",
        spectroReady: "Ð£ÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ Ð³Ð¾ÑÐ¾Ð²Ð¾ Ðº Ð´Ð°Ð»ÑÐ½ÐµÐ¹ÑÐ¸Ð¼ Ð·Ð°Ð´Ð°ÑÐ°Ð¼",
        startCalibrateNow: "ÐÐ°ÑÐ°ÑÑ ÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²ÐºÑ",
        startMeasureText: "ÐÐ°ÑÐµ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ Ð¾ÑÐºÐ°Ð»Ð¸Ð±ÑÐ¾Ð²Ð°Ð½Ð¾, Ð¸ ÐÑ Ð¼Ð¾Ð¶ÐµÑÐµ Ð½Ð°ÑÐ°ÑÑ Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ",
        tolerance: "ÐÐµÐ»ÑÑÐ° Ð (CIE 2000)",
        toleranceOfDevitation: "ÐÐ¾Ð¿ÑÑÐº Ð¿Ð¾ Ð´ÐµÐ»ÑÑÐµ Ð (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Ð¡Ð¾Ð±ÑÑÐ²ÐµÐ½Ð½Ð°Ñ ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ° %{1} %{2}",
        deleteSelectedRecords: "Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐµ Ð·Ð°Ð¿Ð¸ÑÐ¸",
        exportHistory: "Ð­ÐºÑÐ¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¸ÑÑÐ¾ÑÐ¸Ñ",
        finishFormula: "ÐÐ°Ð²ÐµÑÑÐ¸ÑÑ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        foundInFormulas: "ÐÐ°Ð¹Ð´ÐµÐ½Ð¾ Ð² ÑÐ¾ÑÐ¼ÑÐ»Ð°Ñ",
        hideHiddenRecords: "ÐÐµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ ÑÐºÑÑÑÑÐµ Ð·Ð°Ð¿Ð¸ÑÐ¸",
        hideSelectedRecord: "Ð¡ÐºÑÑÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ",
        historicalFormula: "ÐÑÑÐ¾ÑÐ¸ÑÐµÑÐºÐ¸Ðµ ÑÐ¾ÑÐ¼ÑÐ»Ñ",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "ÐÐ¾ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ Ð·Ð°Ð¿Ð¸ÑÑ",
        showAllRecords: "ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð²ÑÐµ Ð·Ð°Ð¿Ð¸ÑÐ¸",
        standardFormula: "Standard formula",
        unknownFormula: "ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð°Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð°"
    },
    stirCanisters: {
        selectCanisters: "ÐÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        startStirring: "ÐÐ°ÑÐ°ÑÑ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ðµ",
        stirAllCanisters: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÑÑ",
        stirCanisters: "ÐÐµÑÐµÐ¼ÐµÑÐ°ÑÑ ÐºÐ°Ð½Ð¸ÑÑÑÑ",
        stirringSpeed: "Ð¡ÐºÐ¾ÑÐ¾ÑÑÑ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ñ",
        stirringTime: "ÐÑÐµÐ¼Ñ Ð¿ÐµÑÐµÐ¼ÐµÑÐ¸Ð²Ð°Ð½Ð¸Ñ"
    },
    stock: {
        addColorant: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ...",
        addColorantPackagesToStock: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð² ÑÐºÐ»Ð°Ð´",
        addPackagesToStock: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÑ Ð² ÑÐºÐ»Ð°Ð´",
        addedToStock: "ÐÐ¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¾ Ð² ÑÐºÐ»Ð°Ð´",
        allDatabases: "ÐÑÐµ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        checkStockPackageInventory:
            "ÐÑÐ»Ð¸ Ð²Ñ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð»ÑÐ·ÑÐµÑÐµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÑ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°, Ð¿Ð¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, ÑÐ±ÐµÐ´Ð¸ÑÐµÑÑ ÑÑÐ¾ ÑÐ¿Ð¸ÑÐ¾Ðº Ð´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹.",
        clearAllItems: "ÐÑÐ¸ÑÑÐ¸ÑÑ Ð²ÑÑ",
        colorantInventory: "ÐÐµÑÐµÑÐµÐ½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð²",
        colorantsStockInventory: "ÐÐµÑÐµÑÐµÐ½Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¾Ð² Ð½Ð° ÑÐºÐ»Ð°Ð´Ðµ",
        confirmSendingOrder: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÑ Ð·Ð°ÐºÐ°Ð·Ð°",
        consumptionPrediction: "ÐÑÐ¾Ð³Ð½Ð¾Ð·Ð¸ÑÑÐµÐ¼Ð¾Ðµ Ð¿Ð¾ÑÑÐµÐ±Ð»ÐµÐ½Ð¸Ðµ Ð¿Ð¾ÑÐ»ÐµÐ´ÑÑÑÐ¸Ðµ %{weeks} Ð½ÐµÐ´ÐµÐ»Ñ",
        createOrder: "Ð¡Ð¾Ð·Ð´Ð°ÑÑ Ð·Ð°ÐºÐ°Ð· (%{sum})",
        expirationDate: "Ð¡ÑÐ¾Ðº Ð³Ð¾Ð´Ð½Ð¾ÑÑÐ¸",
        inDelivery: "Ð Ð¿Ð¾ÑÑÐ°Ð²ÐºÐµ",
        manualOrder: "Ð ÑÑÐ½Ð¾Ð¹ Ð·Ð°ÐºÐ°Ð·",
        manualOrderProgress: "Ð¨Ð°Ð³ %{step}/%{total}",
        noPackagesFoundInStockForColorant: "ÐÐµÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ¾Ð² Ð´Ð°Ð½Ð½Ð¾Ð³Ð¾ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð½Ð° ÑÐºÐ»Ð°Ð´Ðµ.",
        onStock: "ÐÐ° ÑÐºÐ»Ð°Ð´Ðµ",
        orderSummary: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¿Ð¾ Ð·Ð°ÐºÐ°Ð·Ñ",
        prediction: "ÐÑÐ¾Ð³Ð½Ð¾Ð·",
        removePackageFromStock: "Ð£Ð´Ð°Ð»Ð¸ÑÑ %{colorantName} ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑ ÑÐ¾ ÑÐºÐ»Ð°Ð´Ð°",
        removePackageNameFromStock: "ÐÑ ÑÐ¾ÑÐ½Ð¾ ÑÐ¾ÑÐ¸ÑÐµ ÑÐ´Ð°Ð»Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑ %{packageName} ÑÐ¾ ÑÐºÐ»Ð°Ð´Ð°?",
        scanBarcodeOrSelectColorant: "ÐÑÑÐºÐ°Ð½Ð¸ÑÑÐ¹ÑÐµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ° Ð¸Ð»Ð¸ Ð²ÑÐ±ÐµÑÐµÑÐµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        selectPackageToRemove: "ÐÑÐ±ÑÐ°ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑ Ð´Ð»Ñ ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ñ",
        sendConfirmed: "ÐÑÐ¿ÑÐ°Ð²ÐºÐ° Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð°",
        setAmountsByPrediction: "Ð£ÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¿Ð¾ Ð¿ÑÐ¾Ð³Ð½Ð¾Ð·Ñ",
        sortByColorantName: "ÐÑÑÐ¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        sortByOrderNeed: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾ Ð¿ÑÐ¸Ð¾ÑÐ¸ÑÐµÑÐ½Ð¾ÑÑÐ¸",
        sortByStockLevel: "Ð¡Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾ ÐºÐ¾Ð»-Ð²Ñ Ð½Ð° ÑÐºÐ»Ð°Ð´Ðµ",
        toOrder: "ÐÐ°ÐºÐ°Ð·Ð°ÑÑ"
    },
    testBarcode: {
        noItemAssigned: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ Ð½Ðµ Ð¿ÑÐ¸ÑÐ²Ð¾ÐµÐ½ Ð½Ð¸ Ð¾Ð´Ð½Ð¾Ð¼Ñ ÑÐ»ÐµÐ¼ÐµÐ½ÑÑ %{code}",
        pleaseScanBarcode: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¾ÑÑÐºÐ°Ð½Ð¸ÑÑÐ¹ÑÐµ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ Ð±Ð°Ð·Ñ, Ð¿ÑÐ¾Ð´ÑÐºÑÐ°, ÑÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ð¸Ð»Ð¸ Ð´Ñ",
        testBarcodes: "Ð¢ÐµÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ ÑÑÑÐ¸Ñ-ÐºÐ¾Ð´Ñ"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "ÐÑÐµÐ´ÑÐ´ÑÑÐ¸Ð¹",
        next: "Ð¡Ð»ÐµÐ´ÑÑÑÐ¸Ð¹"
    },
    ufiCodeModal: {
        currentStatus: "Ð¢ÐµÐºÑÑÐ¸Ð¹ ÑÑÐ°ÑÑÑ",
        detailedInfoForColorant: "ÐÐµÑÐ°Ð»ÑÐ½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð´Ð»Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° %{colorantName}",
        userSetUfiCode: "ÐÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÐµÑÐºÐ¸Ð¹ ÐºÐ¾Ð´ UFI, ÑÐµÐºÑÑÐµÐµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð±Ð°Ð·Ð¾Ð²Ð¾Ð³Ð¾ ÐºÐ¾Ð´Ð° UFI",
        confirmColorantRefilling: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ Ð¿Ð¾Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        enableUfiCodes: "Ð Ð°Ð·ÑÐµÑÐ¸ÑÑ ÐºÐ¾Ð´Ñ UFI",
        printUfiCode: "ÐÐµÑÐ°ÑÐ°ÑÑ ÐµÑÐ»Ð¸ Ð¾Ð±ÑÐµÐ¼ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð½ÐµÐ´Ð¾ÑÑÐ°ÑÐ¾ÑÐµÐ½",
        printUfiCodePercentage: "ÐÐµÑÐ°ÑÐ°ÑÑ Ð´Ð¾Ð»Ñ Ð² Ð¿ÑÐ¾ÑÐµÐ½ÑÐ°Ñ ÐµÑÐ»Ð¸ Ð¾Ð±ÑÐµÐ¼ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð½ÐµÐ´Ð¾ÑÑÐ°ÑÐ¾ÑÐµÐ½",
        scanOrTypeUfiCode: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð¸Ð»Ð¸ Ð¿ÐµÑÐ°ÑÐ°ÑÑ UFI ÐºÐ¾Ð´",
        scanOrTypeUfiCodeOfBase: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ¾Ð²Ð°ÑÑ Ð¸Ð»Ð¸ Ð¿ÐµÑÐ°ÑÐ°ÑÑ UFI ÐºÐ¾Ð´ Ð±Ð°Ð·Ñ",
        ufiCodesByPercentage: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÐºÐ¾Ð´ UFI Ð² Ð¿ÑÐ¾ÑÐµÐ½ÑÐ°Ñ",
        ufiCodesFromDatabase: "ÐÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÐºÐ¾Ð´ UFI Ð¸Ð· Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        ufiCodesFromLastFilling: "ÐÑÐºÐ¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÑ ÐºÐ¾Ð´ UFI Ð¸Ñ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ñ"
    },
    userSettings: {
        addUser: "ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        assignedUserGroups: "ÐÐ°Ð·Ð½Ð°ÑÐµÐ½Ð½ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹",
        availableUserGroups: "ÐÐ¾ÑÑÑÐ¿Ð½ÑÐµ Ð³ÑÑÐ¿Ð¿Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹",
        barcode: "Ð¨ÑÑÐ¸Ñ-ÐºÐ¾Ð´",
        confirmNewPassword: "ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð¿Ð°ÑÐ¾Ð»Ñ",
        editPassword: "ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð¿Ð°ÑÐ¾Ð»Ñ",
        editUser: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        enableAutoLogin: "ÐÐºÐ»ÑÑÐ¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ Ð²ÑÐ¾Ð´ Ð² ÑÐ¸ÑÑÐµÐ¼Ñ",
        newPassword: "ÐÐ¾Ð²ÑÐ¹ Ð¿Ð°ÑÐ¾Ð»Ñ",
        noChange: "ÐÐµÑ Ð½Ð¸ÐºÐ°ÐºÐ¸Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð±Ñ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ",
        oldPassword: "Ð¡ÑÐ°ÑÑÐ¹ Ð¿Ð°ÑÐ¾Ð»Ñ",
        password: "ÐÐ°ÑÐ¾Ð»Ñ",
        passwordsDoNotMatch: "ÐÐ°ÑÐ¾Ð»Ð¸ Ð½Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´Ð°ÑÑ",
        restoreUser: "Ð­ÑÐ¾Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÐ´Ð°Ð»ÑÐµÑÑÑ Ð¢Ñ ÑÐ¾ÑÐµÑÑ Ð²Ð¾ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ ÐµÐ³Ð¾?",
        userGroup: "User Group",
        userGroups: "ÐÑÑÐ¿Ð¿Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÐµÐ¹",
        userManagement: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÐ¼Ð¸",
        userSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        username: "ÐÐ¼Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ",
        usernameIsMissing: "ÐÐ¼Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ"
    },
    warningMissingDataModal: {
        continue: "ÐÐµÐºÐ¾ÑÐ¾ÑÑÐµ Ð´Ð°Ð½Ð½ÑÐµ Ð¾ÑÑÑÑÑÑÐ²ÑÑÑ, ÑÐ¾ÑÐ¸ÑÐµ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ?",
        notFoundBase:
            "Ð¢Ð°ÐºÐ°Ñ Ð±Ð°Ð·Ð° Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð°. ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ Ð¸ Ð²ÑÐ±ÐµÑÐ¸ÑÐµ cÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼ÑÑ Ð±Ð°Ð·Ñ Ð¸Ð· Ð¿Ð¾Ð»ÐºÐ¸ Ð¸Ð»Ð¸ Ð¾ÑÐ¼ÐµÐ½Ð¸ÑÐµ ÑÑÐ¾Ñ Ð·Ð°ÐºÐ°Ð·.",
        notFoundProduct:
            "Ð¢Ð°ÐºÐ¾Ð¹ Ð¿ÑÐ¾Ð´ÑÐºÑ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½. ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ Ð¸ Ð²ÑÐ±ÐµÑÐ¸ÑÐµ cÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼ÑÐ¹ Ð¿ÑÐ¾Ð´ÑÐºÑ Ð¸Ð· Ð¿Ð¾Ð»ÐºÐ¸ Ð¸Ð»Ð¸ Ð¾ÑÐ¼ÐµÐ½Ð¸ÑÐµ ÑÑÐ¾Ñ Ð·Ð°ÐºÐ°Ð·."
    },
    weekdays: {
        friday: "ÐÑÑÐ½Ð¸ÑÐ°",
        monday: "ÐÐ¾Ð½ÐµÐ´ÐµÐ»ÑÐ½Ð¸Ðº",
        saturday: "Ð¡ÑÐ±Ð±Ð¾ÑÐ°",
        sunday: "ÐÐ¾ÑÐºÑÐµÑÐµÐ½ÑÐµ",
        thursday: "Ð§ÐµÑÐ²ÐµÑÐ³",
        tuesday: "ÐÑÐ¾ÑÐ½Ð¸Ðº",
        wednesday: "Ð¡ÑÐµÐ´Ð°"
    },
    welcome: {
        availableDatabase:
            "Ð¡ÐµÑÐ²ÐµÑ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ¸ÑÑÑÑ Ðº Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ. ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ ÐÐ°ÑÐµÐ¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ.",
        availableDatabaseLocalError:
            "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸ Ðº Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ (Ð½ÐµÐ²ÐµÑÐ½ÑÐ¹ ÑÐ°Ð¹Ð», Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿Ð°ÑÐ¾Ð»Ñ).",
        availableDatabaseLocalMissing: "ÐÑÑÑÑÑÑÐ²ÑÐµÑ ÑÐ°Ð¹Ð» Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ.",
        availableDatabaseLocalUpdate: "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÑ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ð±Ð¾Ð»ÐµÐµ Ð½Ð¾Ð²Ð¾Ð¹ Ð²ÐµÑÑÐ¸Ð¸",
        availableDatabaseMainAndLocalError:
            "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸ Ðº Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð¸ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ Ð±Ð°Ð·Ð°Ð¼ Ð´Ð°Ð½Ð½ÑÑ (Ð½ÐµÐ²ÐµÑÐ½ÑÐ¹ ÑÐ°Ð¹Ð», Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿Ð°ÑÐ¾Ð»Ñ)",
        availableDatabaseMainAndLocalMissing: "ÐÑÑÑÑÑÑÐ²ÑÑÑ ÑÐ°Ð¹Ð»Ñ Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð¸ Ð»Ð¾ÐºÐ°Ð»ÑÐ½Ð¾Ð¹ Ð±Ð°Ð· Ð´Ð°Ð½Ð½ÑÑ",
        availableDatabaseMainAndLocalUpdate:
            "Ð¢ÑÐµÐ±ÑÐµÑÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ Ð¾ÑÐ½Ð¾Ð²Ð½ÑÑ Ð¸ Ð»Ð¾ÐºÐ°Ð»ÑÐ½ÑÑ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ð´Ð¾ Ð±Ð¾Ð»ÐµÐµ Ð½Ð¾Ð²Ð¾Ð¹ Ð²ÐµÑÑÐ¸Ð¸",
        availableDatabaseMainError:
            "ÐÐ¾Ð·Ð½Ð¸ÐºÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ð¸ Ðº Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð±Ð°Ð·Ðµ Ð´Ð°Ð½Ð½ÑÑ (Ð½ÐµÐ²ÐµÑÐ½ÑÐ¹ ÑÐ°Ð¹Ð», Ð½ÐµÐ´ÐµÐ¹ÑÑÐ²Ð¸ÑÐµÐ»ÑÐ½ÑÐ¹ Ð¿Ð°ÑÐ¾Ð»Ñ)",
        availableDatabaseMainMissing: "ÐÑÑÑÑÑÑÐ²ÑÐµÑ ÑÐ°Ð¹Ð» Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Ð¢ÑÐµÑÐ±ÐµÑÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ð¾ÑÐ½Ð¾Ð²Ð½Ð¾Ð¹ Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ Ð´Ð¾ Ð±Ð¾Ð»ÐµÐµ Ð½Ð¾Ð²Ð¾Ð¹ Ð²ÐµÑÑÐ¸Ð¸",
        closing: "ÐÐ°Ð²ÐµÑÑÐµÐ½Ð¸Ðµ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ñ",
        compatibility:
            "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ Ð²ÐµÑÑÐ¸Ñ ÐÐ°ÑÐµÐ³Ð¾ ÑÐµÑÐ²ÐµÑÐ° ÐÐ°Ñ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼ ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÑÐµÑÐ²ÐµÑÐ¾Ð¼ %{0} Ð¸ Ð²ÑÑÐµ",
        compatibilityCheck: "ÐÑÐ¿Ð¾Ð»Ð½ÑÐµÑÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° ÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼Ð¾ÑÑÐ¸",
        compatibilityDatabase:
            "ÐÐ°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ Ð½ÐµÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼Ð° Ñ ÑÐµÑÐ²ÐµÑÐ¾Ð¼ ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÑÐ¾Ð²ÐµÑÑÑÐµ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ ÐÐ°ÑÐµÐ¹ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        connectingServer: "ÐÐ¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ðº ÑÐµÑÐ²ÐµÑÑ %{ip}",
        databaseCompatibility: "ÐÐ°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ Ð½ÐµÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼Ð° Ñ ÑÐµÐºÑÑÐ¸Ð¼ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½ÑÐ¼ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸ÐµÐ¼",
        databasesCompatibility: "ÐÐ°ÑÐ¸ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ð½ÐµÑÐ¾Ð²Ð¼ÐµÑÑÐ¸Ð¼Ñ Ñ ÑÐµÐºÑÑÐ¸Ð¼ Ð¿ÑÐ¾Ð³ÑÐ°Ð¼Ð¼Ð½ÑÐ¼ Ð¾Ð±ÐµÑÐ¿ÐµÑÐµÐ½Ð¸ÐµÐ¼",
        licenseVerification: "ÐÑÐ¿Ð¾Ð»Ð½ÐµÑÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¸",
        loading: "ÐÐ°Ð³ÑÑÐ·ÐºÐ°",
        lostConnection: "Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Ñ ÑÐµÑÐ²ÐµÑÐ¾Ð¼ Ð¿ÑÐµÑÐ²Ð°Ð½Ð¾",
        moduleMessage:
            "ÐÐ±ÑÐ°ÑÐ¸ÑÐµ Ð²Ð½Ð¸Ð¼Ð°Ð½Ð¸Ðµ Ð½Ð° Ð²ÑÐ±Ð¾Ñ Ð¼Ð¾Ð´ÑÐ»Ñ, ÑÐ°Ðº ÐºÐ°Ðº Ð² Ð±ÑÐ´ÑÑÐµÐ¼ ÑÐ¼ÐµÐ½Ð° Ð¼Ð¾Ð´ÑÐ»Ñ Ð±ÑÐ´ÐµÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ð° ÑÐ¾Ð»ÑÐºÐ¾ Ð¿ÑÐ¸Ð²Ð¸Ð»ÐµÐ³Ð¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐ¼ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»ÑÐ¼",
        refresh: "ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ",
        restoring: "ÐÐ¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ",
        selectModule: "ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¾Ð´Ð¸Ð½ Ð¸Ð· Ð´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð¼Ð¾Ð´ÑÐ»ÐµÐ¹",
        stopUpdate: "ÐÑÑÐ°Ð½Ð¾Ð²Ð¸ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ",
        updateDatabase: "ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ",
        updatingDatabase: "ÐÐ°Ð·Ð° Ð´Ð°Ð½Ð½ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÐµÑÑÑ",
        updatingDatabases: "ÐÐ°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÑÑÑÑ",
        updatingWarning: "Ð¡ÑÑÑÐºÑÑÑÐ° Ð±Ð°Ð·Ñ Ð´Ð°Ð½Ð½ÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÐµÑÑÑ Ð´Ð¾ Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ¹ Ð²ÐµÑÑÐ¸Ð¸, Ð¿Ð¾Ð´Ð¾Ð¶Ð´Ð¸ÑÐµ ",
        updatingWarningInfo: "ÐÐµ Ð·Ð°ÐºÑÑÐ²Ð°Ð¹ÑÐµ ÑÑÐ¾ Ð¾ÐºÐ½Ð¾, ÑÐ°Ðº ÐºÐ°Ðº ÑÑÐ¾ Ð¿ÑÐ¸Ð²ÐµÐ´ÐµÑ Ðº Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÑÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ðµ Ñ Ð½ÑÐ»Ñ "
    }
};
